'use strict';

export function appMessages () {
        return {
            restrict: 'EA',
            templateUrl: 'ktdirectivetemplates/appmsg.html',
            //replace: true,
           // transclude:true,
            scope: {
               messageList : '='

            },
            controller: function($scope,$sce,MessagingService)
            {
                 $scope.msvc = MessagingService;
                  $scope.messageList = $scope.msvc.getMessages();
            
            $scope.showMessageList= false;
            
            /*
             $scope.showMessageListFunction = function(){
                var visibility=false;
                for(var i=0;i<$scope.messageList.length;i++)
                {
                  
                  visibility = $scope.messageList[i].show; 
                }
                return visibiity;
            };
            
            
            $scope.showMessages=function(){
              
              
              };
           */
            
            $scope.closeAllClicked = function(){
             
                $scope.closeAllClickedVar = true;
                $scope.msvc.removeAllMessages();
               setTimeout(function(){$scope.closeAllClickedVar=false},2000);
        
            };
            
             $scope.closeAlert = function(id){
             
                $scope.messageList[id].show = false;
             
                var visible = $scope.msvc.checkForVisibleMessages();
             
                if (visible==0) $scope.msvc.removeAllMessages();
        
            };
            
            $scope.countVisible = function(){
              
                var countVisibleMsg=0;
                for (var i=0;i< $scope.messageList.length;i++)
                {
                  if ($scope.messageList[i].show) countVisibleMsg++;
                  
                }
                return countVisibleMsg;
            }
            
            
             $scope.convertToHtml = function(msg){
               return $sce.trustAsHtml(msg);
            };
            },
            link: function (scope, element, attrs) {
            
            
          
            
           


            }
        };
};

'use strict';


export function ktActionButtons () {

        return {
            restrict: 'A',
            
            controller: function($scope,UserService,ResourcesDataService,TaskDataService,MessagingService,WidgetDataExchangeService,$rootScope,GridsterService,CODES_CONST,$stateParams,$state,KatalyoStateManager,$templateCache,$compile,$element)
            {
                $scope.gsrvc= GridsterService;
                
                if ($scope.localVars == undefined) $scope.localVars={};
                
                 if ($scope.taskDefinition!=undefined)
                {
                  $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
                  $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
                  $scope.localVars.taskDefinition = $scope.taskDefinition;
                }
                
                let widgetDefinition = {name: 'actionBtns',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.localVars.taskDefinition.ResourceDefId };
                $scope.fd.LocalId=WidgetDataExchangeService.registerWidget(widgetDefinition);
                
                $scope.ksm = KatalyoStateManager;
      
                let update_presentation_id = function(data)
                {
                   if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
                    //unsubscribe here later after implementing unsubscribe - ToDo   
                }
                if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
                {
                   
                   let dependent_field = $scope.fd.LocalId;
                   let subscribedSubject = "formDefinitionState"+$scope.localVars.taskDefinition.ResourceDefId+$scope.localVars.taskDefinition.form_type;
                   let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
            
                }                        
                
                $scope.GetOutcomes = function(){
                                
                              var lang=$rootScope.globals.currentUser.lang;               
                              var outcomeId = 0                /*MIGOR provjeriti jos*/  
                             
                              if ($scope.localVars.taskDefinition.TaskOutcomeHeadId_id !=undefined) outcomeId = $scope.localVars.taskDefinition.TaskOutcomeHeadId_id;
                              

                              if (!$scope.outcomesDownloaded && outcomeId>0)
                               {   
                                    TaskDataService.GetTaskOutcomes( $scope.localVars.taskDefinition.ResourceDefId_id,outcomeId,lang).then(function(data) {            
                                               
                                            $scope.outcomes = data.data;
                                            $scope.outcomesDownloaded = true;
                                             
                                             
                                    },function(error){
                                             
                                             MessagingService.addMessage(error.msg,'error');
                                    });
                               }
                               else
                               {
                                $scope.loadingActions=false;      
                               }
                 
                }//GetOutcomes
                
                if ($scope.outcomes!=undefined)
                {
                  $scope.localVars.outcomes = $scope.outcomes;
                }else
                {
                    $scope.GetOutcomes();
                    
                }
                $scope.localVars.loadedTasks = [];
                $scope.localVars.actionButtonProps = 0;
                $scope.localVars.formType=$scope.taskDefinition.form_type;
                //var taskDefId = $stateParams.id;
                var lang=$rootScope.globals.currentUser.lang;
                $scope.localVars.taskListParameters = {placeholder:'Select or search task...',label:$scope.fd.placeholder,name:'task',
                  paddingLeft:true,selectedItem:null,hideLabel:true,columnSizeLabel:'col-lg-24',dropdownSize:'col-lg-24',onSelectFunction:''};
              
                if ($scope.fd.selectedButtons==undefined) $scope.fd.selectedButtons = [];
                $scope.localVars.selectedTaskIndex=-1;
                if ($scope.fd.ElementType!='rlist')
                {
                  if ($scope.fd.wItemValue!=null) {
                     $scope.fd.selectedButtons= $scope.fd.wItemValue;
                  }else
                  {
                    $scope.fd.wItemValue = [];
                  	
                  }
                }else
                  {
                    if ($scope.fd.tItemValue!=null) {
                     $scope.fd.selectedButtons = $scope.fd.tItemValue;
                    }else
                    {
                    $scope.fd.tItemValue = [];
                  	
                    } 
                    
                  }
                
                let process_event_task_initiated = function()
                {
                    for (let i=0;i<$scope.fd.selectedButtons.length;i++)
                    {
                        if ($scope.fd.selectedButtons[i].hideButtonAfterInitiate) $scope.fd.selectedButtons[i].hideButton = true;
                        if ($scope.fd.selectedButtons[i].showButtonAfterInitiate) $scope.fd.selectedButtons[i].hideButton = false;
                    }
                    
                }
                  
                let dependent_field = "Field"+$scope.fd.PresentationId;
                let subscribedSubject = "task"+$scope.taskDefinition.transaction_id
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"task_initiated",process_event_task_initiated);
                                            
                  $scope.$on('InlineTaskClosed',function(event,data){
                    //var index=data;
                    //$scope.localVars.loadedTasks.splice(index,1);
                    var taskId=data;
                    var pos = $scope.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos>=0)
                    {
                      $scope.localVars.loadedTasks.splice(pos,1);  
                    }
                });
                  
                  
                $scope.localVars.LoadTask=function(taskId,outcomeId,previousTask,openTaskType)
                {
                    
                    var localVars = {'isInlineTask':$scope.localVars.isInlineTask,'OpenTaskType':openTaskType,'taskIndex':$scope.localVars.loadedTasks.length,'loadTaskDirect' : true,'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,};
                    
                    if (openTaskType!="newPage") localVars.ShowCloseBtn = true;
                    else localVars.ShowReturnBtn = true;
                    var pos = $scope.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos<0 && openTaskType=="current")
                    {
                        $scope.localVars.loadedTasks.splice(0,0,{'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        
                    }else if (openTaskType=="inline")
                    {
                        $scope.localVars.loadedTasks.length=0;
                        $scope.localVars.loadedTasks.push({'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                    }
                    if (openTaskType=="newPage") {
                        $scope.gsrvc.setTaskDataInNewPage({'localVars':localVars,'taskDefinition':$scope.taskDefinition});
                    }
                    $scope.gsrvc.setOpenTaskType(openTaskType);
                    
                }
                  
                
                $scope.localVars.ProcessOutcome = function (outcome,form){
                
                    for (var i=0;i<outcome.actions.length;i++) {
                      if (outcome.actions[i].type==1 || outcome.actions[i].type==2)
                      {
                         $scope.localVars.InitiateTaskFromOutcome(outcome.actions[i].taskId,outcome.id1,outcome.actions[i].type,outcome.actions[i].actionParams,$scope.formData,outcome.actions[i].actionParams.OpenTaskType);
                             
                      }
                     
                    }
                    if (outcome.actions.length==0)
                    {
                       $scope.$emit("ExecuteTask"+$scope.taskDefinition.task_execute_id,{form:form,outcomeId:outcome.id1}); 
                      
                    }
                     
                };
                 
                 
                 
              $scope.localVars.InitiateTaskFromOutcome = function (taskDefId,outcomeId,type,actionParams,exeForm,openInNewPage){
                      //save task instance form for later processing
                     
                      if (openInNewPage==undefined) openInNewPage='inline';
                      if ($scope.taskDefinition.task_execute_id!=undefined)
                      {
                      TaskDataService.saveTaskFormData($scope.taskDefinition.id,exeForm).then(function(data) {
                               if (type==2)
                               {
                                       $state.go('app.menu.tasks.proc',{id: taskDefId,fromStateName:$state.current.name,
                                      fromStateParams:$state.params,prev_task_execute_id:$scope.taskDefinition.task_execute_id,outcome_id:outcomeId,presentation_id:0});
                               }
                               if (type==1)
                               {
                
                                
                                  $scope.localVars.fromOutcome=true;
                                  if (taskDefId!=undefined &&  taskDefId>0) $scope.localVars.LoadTask(taskDefId,outcomeId,$scope.taskDefinition.task_execute_id,openInNewPage);          
                               }
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');

                             });

                      }else
                      {
                         MessagingService.addMessage("Invalid task data --> Task execution object is undefined",'error');
                      }
                };
                 
                
             
               
                $scope.localVars.ProcessButtonAction=function(button,event,previousTask)
                {
                    var localVars = {};
                    if (button.action=='completetask')
                    {
                     
                      $scope.localVars.ProcessOutcome(button.outcome,event.target.form);
                     // $scope.$emit("ExecuteTask"+$scope.taskDefinition.task_execute_id,{form:event.target.form,outcomeId:button.outcome.id1}); 
                    }
                    else if (button.action=='runtask')
                    {
                       $scope.localVars.LoadTask(button.taskId,0,previousTask);
                    }
                    else if (button.action=='closeform')
                    {
                       
                       let taskStateName = "task"+$scope.taskDefinition.prev_task_transaction_id;
                         
                       $scope.ksm.executeAction(taskStateName,"task_closed");
                       $scope.$emit("CloseTaskForm"+$scope.taskDefinition.transaction_id,$scope.taskDefinition.ResourceDefId_id);
                       
                        
                    }
                    else if (button.action=='refreshtask')
                    {
                       $scope.localVars.taskInitiated=false;
                       $scope.$emit("RefreshTask"+$scope.taskDefinition.transaction_id,$scope.taskDefinition.ResourceDefId_id); 
                    }
                    else if (button.action=='taskstatus')
                    {
                        
                    }
                    else if (button.action=='backbutton')
                    {
                        $window.history.back();
                    }
                
                  
                };
                
                 $scope.addNewActionButton = function()
                  {
                    
                    
                    $scope.localVars.selectedButtonIndex=-1;
                    $scope.localVars.selectedButton = {};
                    $scope.localVars.selectedButton.action="initiatetask";
                    //$scope.localVars.selectedButton.id = $scope.localVars.taskListParameters.selectedItem.id;
                    // $scope.localVars.selectedButton.name = $scope.localVars.taskListParameters.selectedItem.name;
                    $scope.localVars.selectedButton.btnLabel = "Enter button label";
                    $scope.localVars.selectedButton.btnClass = "btn-primary";
                    $scope.localVars.selectedButton.size = "";
                    //if ($scope.localVars.actionButtonProps == 1) $scope.localVars.actionButtonProps=0;
                    //else
                    $scope.localVars.actionButtonProps =1;
                  };
                  $scope.localVars.taskSelected = function(item,model)
                  {
                    $scope.localVars.taskListParameters.selectedItem = item;
                    $scope.localVars.selectedTask={};
                  };
                  
                   $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  };
                 
                   $scope.showButtonDefinition = function (index){
                    
                    
                        $scope.localVars.selectedButtonIndex=index;
                        $scope.localVars.selectedButton = $scope.fd.selectedButtons[index];
                        $scope.localVars.actionButtonProps =1;   
                    
                   };
                  
                  $scope.addButtonToList = function (){
                 
                 
                       //Can't copy! Making copies of Window or Scope instances is not supported
                       $scope.fd.selectedButtons.push(angular.copy($scope.localVars.selectedButton));
                       //$scope.fd.selectedButtons.push($scope.localVars.selectedButton);
                      
                      if ($scope.fd.ElementType!='rlist')
                      {
                        $scope.fd.wItemValue = $scope.fd.selectedButtons;
                      }else
                      {
                            $scope.fd.tItemValue = $scope.fd.selectedButtons;
                
                      
                      }
                     // $scope.localVars.ShowButtonDefinition($scope.localVars.selectedButton.id);
                    
                    
                 };
                  
                  
                     
                   $scope.localVars.RemoveButtonFromList = function (index){
                 
                  
                   if (index>=0){
             
                             $scope.fd.selectedButtons.splice(index,1);
                                  
                   }
                            
                      
                  if ($scope.fd.ElementType!='rlist')
                    {
                      $scope.fd.wItemValue = $scope.selectedButtons;
                    }else
                    {
                    $scope.fd.tItemValue = $scope.selectedButtons;
                
                      
                    }
                    
                 }
          
          
                 $scope.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.menu.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
                                                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
             if   ($scope.gsrvc.getFormViewType()==1 || $scope.fd.ElementType=='itask')
             {
                ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                    
                                  $scope.localVars.taskList = data.data;
                                                               
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
                }
            let template;
            if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktActionButtons.html');
            else template = $templateCache.get('ktdirectivetemplates/ktActionButtonsExe.html');
          
            $element.append($compile(template)($scope));  

                },
            link: function (scope, elem, attrs) {
                
        }
    }
              
};
'use strict';

export function ktActionInitiateTask () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktActionInitiateTask.html',
             
             controller: function($scope,$rootScope,ResourcesDataService,MessagingService){
              
              $scope.taskListParameters = {placeholder:'Select or search task...',label:'Initiate task',name:'task',
              paddingLeft:false,selectedItem:null,hideLabel:false,columnSizeLabel:'col-auto',dropdownSize:'col',selectedItem:null};
              
              $scope.taskListParameters.label = $scope.act.name1;
                        
               
              $scope.setInitiateTaskAction = function(item,model)
                        {
                      //  $scope.taskListParameters.label = $scope.$parent.act.name;
                        //$scope.$parent.act.taskId = item.id;
                        
                        $scope.act.taskId = item.id;
                        $scope.taskListParameters.selectedItem = item;
                        
 
                        };
                        
              
                var lang = $rootScope.globals.currentUser.lang;
               
               $scope.setTask = function(){
                if ($scope.act!=null && $scope.act!=undefined)
                {
                if ($scope.act.taskId!=null) {
                                  var pos = $scope.taskList.map(function(e) { return e.id; }).indexOf($scope.$parent.act.taskId);
                                  if (pos>-1) {
                                     $scope.taskListParameters.selectedItem = $scope.taskList[pos];
                                         
                                   }
                                  
                  }
                }
             };
             
             $scope.getTaskList = function()
             {
                if ($scope.taskList==undefined)
                {
                   ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                   
                                     $scope.taskList = data.data;
                                     $scope.setTask();
                                  
                                    
                                  },function(error){
                                   
                                     MessagingService.addMessage(error.msg,'error');
                               });
                }else  $scope.setTask();
                
              }; 
                
                 $scope.$watch('act.taskId', function(oldValue,newValue){
                     
                     $scope.getTaskList();
                   });
               
            
             
             $scope.getTaskList(); 
             
             },
             link: function (scope, elem, attrs) {
            
     
        }
    }
};

//export {ktActionInitiateTask};
'use strict';

export function ktActionSendNotification () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktActionSendNotification.html',
             
             controller: function($scope,$rootScope,ResourcesDataService,MessagingService){
              
              $scope.notificationSelected = function(item,model)
                        {
                            $scope.act.actionParams.notificationId = item.id;
                            
                        };
                        
              
                var lang = $rootScope.globals.currentUser.lang;
               
               $scope.setNotification = function(){
                if ($scope.act!=null && $scope.act!=undefined)
                {
                if ($scope.act.actionParams.notificationId!=null) {
                                  var pos = $scope.notificationList.map(function(e) { return e.id; }).indexOf($scope.act.actionParams.notificationId);
                                  if (pos>-1) {
                                     $scope.act.actionParams.notification = $scope.notificationList[pos];
                                         
                                   }
                                  
                  }
                }
             }; 
             $scope.getNotificationList = function()
             {
                if ($scope.notificationList==undefined)
                {
                   ResourcesDataService.getResourceDefListByType(lang,'notification').then(function(data) {
                                   
                                     $scope.notificationList = data.data;
                                     $scope.act.notificationsLoaded = true;
                                     $scope.setNotification();
                                  
                                    
                                  },function(error){
                                   
                                     MessagingService.addMessage(error.msg,'error');
                               });
                }else $scope.setNotification();
                
              }; 
                
                /*
                 $scope.$watch('act.notificationId', function(oldValue,newValue){
                     
                     $scope.getNotificationList();
                   });
               */
            
             
             $scope.getNotificationList(); 
             
             },
             link: function (scope, elem, attrs) {
            
     
        }
    }
};

//export {ktActionInitiateTask};

'use strict';

export function ktActivity() {
       
                return {
                    restrict: 'EA',
                    controller: function(){},
                    templateUrl: 'ktdirectivetemplates/processing.html',
                    scope: {
                        message: '=',
                        //showMsg: '=',
                    },
                     controller: function($scope,PROCESSING_CONST){
                                $scope.showMsg=false;
                                $scope.showMsgObj={};     
                                $scope.$on(PROCESSING_CONST._START_REQUEST_, function (event,data) {
                                // got the request start notification, show the element
                                $scope.showMsgObj[data] = true;
                                $scope.showMsg=true;
                                });
             
                         $scope.$on(PROCESSING_CONST._END_REQUEST_, function (event,data) {
                             // got the request end notification, hide the element
                             delete $scope.showMsgObj[data];
                             var ol = Object.keys($scope.showMsgObj);
                             if (ol.length==0) $scope.showMsg=false;
                         });
                     },
                   link: function (scope, element, attrs) {
        
                       
             
                        
                        }
                   }
        
};
'use strict';

export function ktAdjustContentToNavbar(){
   
   var directive = {
		restrict 	: 'EA',
        link: function (scope, element, attrs) {
            
                
        },
        controller: function ($scope,$element,GridsterService)
        {
            $scope.gsrvc = GridsterService;
            $scope.$watch(function(){
               if ($element[0].offsetHeight>0)
               {
                $scope.gsrvc.setNavbarHeight($element[0].offsetHeight);
               }
            }); 
            
        }
	};
	return directive;

};
'use strict';

export function ktAppNavbar () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktAppNavbar.html',
            scope:{
            navbarItemsLeft:'=',
            navbarItemsRight:'=',
            application:'=',
            },
            controller: ['$scope','dragulaService','$rootScope','$element','UserService','ResourcesDataService','TaskDataService','MessagingService','GridsterService','CODES_CONST','$stateParams','$state','$timeout',
          
            function($scope,dragulaService,$rootScope,$element,UserService,ResourcesDataService,TaskDataService,MessagingService,GridsterService,CODES_CONST,$stateParams,$state,$timeout){
               
                $scope.gsrvc = GridsterService;      

                
                 if ($scope.localVars == undefined) $scope.localVars={};
                 $scope.localVars.pagesLoaded=false;    
                 let lang = $rootScope.globals.currentUser.lang;
                
                if ($scope.navbarItemsLeft==undefined) $scope.navbarItemsLeft = [];
                if ($scope.navbarItemsRight==undefined) $scope.navbarItemsRight = [];
                
                let widgetHandle = 'element-drag-handle';
                let setupDragula = $scope.gsrvc.setupDragula('app-menu-bag','app-menu-task-list',widgetHandle);
                let dragula_bag="app-menu-bag";
              //  let setupDragulaPage = $scope.gsrvc.setupDragula('app-menu-bag','app-menu-page-list',widgetHandle);
                let source_container_task = 'app-menu-task-list';
                let source_container_page = 'app-menu-page-list';
                
                let bag = dragulaService.find($rootScope, dragula_bag);
                if (!bag) {
                   //   dragulaService.destroy($rootScope, dragula_bag)         
               
                
                   dragulaService.options($rootScope, dragula_bag, {
                                     revertOnSpill: true,
                                     removeOnSpill: false,
                                     direction:'horizontal',
                                     copy:function (el,source){
                                       return source.id==source_container_task || source.id==source_container_page;
                                      },
                                     accept:function (el,target, source) {
                                         return target.id!= source_container_task && target.id!= source_container_page;
                                        
                                     },
                                     moves: function (el, container, handle) {
                                               return handle.classList.contains(drag_handle);
                                     }
                   
                   });
                    
                }
                
                
                 $scope.$on(dragula_bag+'.drop-model', function (el, target, source) {
                        el.addClass('drop');
                 });
                 
                  $element.on('$destroy', function() {
                    dragulaService.destroy($rootScope, dragula_bag);
                  });
     
            $scope.$watch('localVars.selectedNavbar.NoSideMenu',function(newValue,oldValue){
              
              if (newValue!=oldValue)
              {
               $scope.selectedField="miro";
               
              }
             
            }); 
                
                
                $scope.localVars.getNavbarDetails = function(navbar,index)
                {
                  $scope.localVars.showNavbarDetails = false;
                  $scope.localVars.selectedNavbar  = navbar[index];
                  $scope.localVars.selectedNavbar.index=index;
                  $scope.localVars.showNavbarDetails = true;
                  $scope.localVars.showNavbarDetailsFirst = true;
                  $scope.localVars.showMenuDetails = false;
                  if ($scope.localVars.selectedNavbar.layout==undefined) $scope.localVars.selectedNavbar.layout = [];
                    
                };
                
                
                $scope.localVars.getMenuDetails = function(menu,index)
                {
                  $scope.localVars.showMenuDetails = false;
                  $scope.localVars.selectedMenu  = menu[index];
                  $scope.localVars.selectedMenu.index=index;
                  $scope.localVars.showMenuDetails = true;
                  $scope.localVars.showNavbarDetails = false;
                  //if ($scope.localVars.selectedNavbar.layout==undefined) scope.localVars.selectedNavbar.layout = [];
                    
                };
                
                $scope.activeLinkEditNavbarLeft = function(index) {
                   
                   for (let i=0;i<$scope.navbarItemsLeft.length;i++)
                   {
                    if (i==index)    return "active";
                    else "";
                
                   }
                   
                  };
                
                $scope.buildDataset = function(e)
                {
                   // e.target.tooltip("dispose");
                    $state.go("app.menu.resources.new",{'navbar_id':9,'sidemenu_id':19,'resource_type':'dataset'});
                };
                //get pages
                ResourcesDataService.getResourceDefListByType(lang,'page').then(function(data) {
										
					$scope.localVars.pageList = data.data;
                    for (let i=0;i<$scope.localVars.pageList.length;i++)
                    {
                       $scope.localVars.pageList[i].PopulateType="navbar"; 
                    }
                    $scope.localVars.pagesLoaded=true;    
											 
                    },function(error){    
                    MessagingService.addMessage(error.msg,'error');
				});
                //get pages
            
            }],
            link: function (scope, elem, attrs) {
                
            }
        }
  
};
'use strict';

export function ktBoolean () {
        return {
                restrict: 'A',
                controller: function ($scope,GridsterService,KatalyoStateManager) {
                        
                        $scope.gsrvc = GridsterService;
                         $scope.showProperties = function()
                          {
                             $scope.gsrvc.setFieldProperties($scope.fd);
                          };
                      
                        },
        templateUrl: 'ktdirectivetemplates/ktBoolean.html',
        link: function (scope, elem, attrs) {
				
           if (scope.formData===undefined) scope.formData = [{'Field':0}];
          if (scope.formParams===undefined) scope.formParams = {formViewType:1};
          if (scope.formParamsParent===undefined) scope.formParamsParent = {formViewType:1};
          
          if (scope.fd.ParametersLang===undefined) scope.fd.ParametersLang={format1:'HH:mm'};
          
          scope.colLength = [];
          for (var i=0;i<24;i++) scope.colLength.push('col-lg-'+(i+1));
             
          scope.fd.timeFormatList = [{id:1,name:'HH:mm',mask:'99:99'},{id:2,name:'HH:mm:ss',mask:'99:99:99'},{id:3,name:'HH:mm'},{id:4,name:'HH:mm:ss:sss'}];
          
          if (scope.fd.ParametersLang!=undefined && scope.fd.ParametersLang!=null)
          {
             
              var posFormatTime = scope.fd.timeFormatList.map(function(e) { return e.name.toString(); }).indexOf(scope.fd.ParametersLang.format1);
                  
              if (posFormatTime>=0){
                 
                scope.fd.ParametersLang.format1=scope.fd.timeFormatList[posFormatTime];
                                      
              }
                 
              scope.localVars.format = scope.fd.ParametersLang.format1;           
          }  
        }
    };

}

'use strict';

export function ktBootstrapTooltip () {

        return {
            restrict: 'A',
         
            link: function (scope, elem, attrs) {
                
                 attrs.$observe('title',function(title){
                    // Destroy any existing tooltips (otherwise new ones won't get initialized)
                    elem.tooltip('dispose');
                    // Only initialize the tooltip if there's text (prevents empty tooltips)
                    if (jQuery.trim(title)) elem.tooltip();
                  });
              
                  elem.on('$destroy', function() {
                    elem.tooltip('dispose');
                    delete attrs.$$observers['title'];
                  });
    
              
               
            
            }
        }
  
};
'use strict';

export function ktBroadcastLastRepeaterElement () {
  
  return{
  
            priority: -1000, // a low number so this directive loads after all other directives have loaded. 
            restrict: "A", // attribute only
            controller: function($rootScope)
            {},
            link: function(scope, elem, attrs) {
              if (scope.$last){
    
                  setTimeout(function(){
                  $rootScope.$broadcast('LastRepeaterElement');
                });
    
      }
    }
  }
};
'use strict';

export function ktCalculatedField () {
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCalculatedField.html',
             controller: function($scope,GridsterService)
                {
                         $scope.gsrvc = GridsterService;
        if ($scope.localVars==undefined) $scope.localVars={};
        if ($scope.fd==undefined) $scope.fd={};
        if ($scope.formData==undefined) $scope.formData = [{}];
        $scope.colLength = ['col-lg-2','col-lg-4','col-lg-6','col-lg-8','col-lg-10','col-lg-12','col-lg-14','col-lg-16','col-lg-18','col-lg-20','col-lg-22','col-lg-24'];
        
			             
              $scope.showProperties = function(event)
                {
                  $scope.gsrvc.setFieldProperties($scope.fd,event);
       
                };
             //$scope.formData[0]={Field256:2,Field257:3};
             $scope.localVars.Calculate=function(){
              var scopeVar = $scope.formData[0];
            $scope.fd.sItemValue=math.eval($scope.fd.Label,scopeVar);
              
              };
                        
                        },
             link: function (scope, elem, attrs) {
				
       
             
              
            }
        };
    };
'use strict';

export function ktCodesActions () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesActions.html',
              controller: function(dragulaService)
                {}, 
             link: function (scope, elem, attrs) {
             
             scope.actions = [
                {id1:1,type:1,name1:'Initiate task',taskId:null,actionParams:{}},
                {id1:2,type:2,name1:'Send notification',notificationId:null,actionParams:{}},                
              ];
              
              
               scope.getSeqNoForNewAction = function(){
                  var seqNo=0;
                  var actLen=0;
                  for (var i=0;i<scope.codesActions.length;i++) {
                    
                    
                    if (scope.codesActions[i].actions!= undefined)
                    {
                                          
                      actLen = scope.codesActions[i].actions.length;
                      
                    }
                    
                    seqNo = seqNo+actLen;
                    
                  }
                  
                  return seqNo;
        
     
              
             
               }   
               
            }
    }
};
'use strict';

export function ktCodesDefActions () {
        
           var controller = ['$scope', '$stateParams','$state','CodesService','MessagingService','TaskDataService','$rootScope','$timeout','dragulaService','GridsterService',
                             function ($scope,$stateParams,$state,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragulaService,GridsterService) {
          
        
        $scope.firstTime=true;
                 
        CodesService.CodesList().then(function(data) {
            
                            $scope.codesList = data.data;
                  
                      },function(error){
                        
                          MessagingService.addMessage(error.msg,'error');
               });

          $scope.codesActions.codesDownloaded=false;
          
          $scope.GetCodesByName = function()
          {
                     var lang=$rootScope.globals.currentUser.lang;
                    // $scope.loadingActions=true; 
                     CodesService.getCodesByName($scope.defaultCode,lang).then(function(data) {
                             $scope.codes = data.data;
                      //      $scope.loadingActions=false;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
          };
    
         
                $scope.gsrvc= GridsterService;
                
                $scope.setupDragula = function()
                {
                     var widgetHandleResource = 'element-drag-handle';
                     
                     var bag = dragulaService.find($rootScope, 'bag-actions');
                     if (!bag)
                     {
                        $scope.gsrvc.setupDragula('bag-actions','codeActionsDragula',widgetHandleResource);    
                     }
                     else
                     {
                          $scope.gsrvc.destroyDragula('bag-actions');
                          $scope.gsrvc.setupDragula('bag-actions','codeActionsDragula',widgetHandleResource); 
                           
                      }
                };  
                    
                 

                    $scope.fillTransitionCounters=function(codeActions) {
                        codeActions.transitionList={};
                        var transition='';
                        
                        for (var i=0;i<codeActions.codesActionsList.length;i++)
                        {
                            transition=codeActions.codesActionsList[i].value1+codeActions.codesActionsList[i].value2;
                            if (codeActions.transitionList[transition] === undefined )
                            {
                                 codeActions.transitionList[transition]=1; 
                            }
                                 else codeActions.transitionList[transition]++;
                        }
                            

                    };
                   
                  $scope.removeCodeItem = function(pindex){
                    //scope.task.TaskOutcomeCodeId = null;
                     $scope.codesActions.codesActionsList.splice(pindex,1);
                      };
                      
       
                  $scope.removeAction = function(pindex,index){
                    //scope.task.TaskOutcomeCodeId = null;
                     $scope.codesActions.codesActionsList[pindex].actions.splice(index,1);
                      };
                      
                  $scope.GetCodesClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    scope.GetCodes();
                      };
                  $scope.GetCodesByNameClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    scope.GetCodesByName();
                      };
                                    
                  $scope.AddAction = function(){
                    
                      var found=false;
                      //dodati kontrole da se ne može dodati dupli
                      for (var i=0;i<$scope.codesActions.codesActionsList.length;i++)
                      {
                        if ($scope.codesActions.codesActionsList[i].id1==$scope.statusFrom.id && $scope.codesActions.codesActionsList[i].id2==$scope.statusTo.id) found=true;
                        
                      }
                      if (!found)
                      {
                        
                        $scope.codesActions.codesActionsList.push({id1:$scope.statusFrom.id,name1:$scope.statusFrom.name,value1:$scope.statusFrom.name,id2:$scope.statusTo.id,name2:$scope.statusTo.name,value2:$scope.statusTo.name,actions:[]});        
                        $scope.codesActions.selectedActionIndex=$scope.codesActions.codesActionsList.length-1;
                 
                      }
                    
                  };
                      
                $scope.GetCodes = function(){
                   // var lang=$rootScope.globals.currentUser.lang;
                  $scope.loadingActions=true; 
                    var lang=$rootScope.globals.currentUser.lang;
                    //$scope.codesActions.codesActionsList.length = 0;
                   
                      if (!$scope.codesActions.codesDownloaded)
                      {                      
                         TaskDataService.GetTaskCodesActionsByName($scope.task.ResourceDefId,lang,$scope.defaultCode).then(function(data) {            
                                    
                                   $scope.codesActions.codesActionsList = data.data;
                                   $scope.codesActions.codesDownloaded=true;
                                   $scope.firstTime=false;
                                   $scope.fillTransitionCounters($scope.codesActions);  //MIGOR
                                   $scope.findSelectedTransition();
                                   $scope.loadingActions=false;
                                   
                              },function(error){
                                
                                  $scope.loadingActions=false;
                                  MessagingService.addMessage(error.msg,'error');
                            });
                      
                      }else
                      {
                       $scope.findSelectedTransition();
                       $scope.loadingActions=false;      
                      }
                      
                     
                };
              
                
                
                 //find selected transition
                  $scope.findSelectedTransition= function(){
                     var found=false;
                      for (var i=0;i<$scope.codesActions.codesActionsList.length;i++)
                      {
                            if ($scope.codesActions.codesActionsList[i].value1 == $scope.statusFrom.name && $scope.codesActions.codesActionsList[i].value2 == $scope.statusTo.name && !found)
                        {
                                    //  $scope.codesActions.codesActionsList.push(angular.copy($scope.codesActions.codesActionsListOriginal[i]));
                                   $scope.codesActions.selectedActionIndex=i;
                                   found=true;
         
                        }  
                      }
                      if (!found) $scope.AddAction();
                      $scope.setupDragula();
                  };
                $scope.$watch('codesActions.selectedTransition', function(newValue,oldValue){
                  
                  
                  if (newValue!=oldValue || $scope.firstTime)
                  {
                    
                   if (!!$scope.defaultCode)
                   {
                       $scope.GetCodesByName();
                   }
               
                   $scope.GetCodes();
                  // $timeout(function(){$scope.loadingActions.loading=false;});
                  }
                  /*else{
                    $scope.loadingActions.loading=false;
                    
                  }*/
                 
                });
                
                /*               
               if (!!$scope.defaultCode)
               {
                       $scope.GetCodesByName();
               }
               else{  
                   $scope.GetCodes();
               }
                */
                
          }];
          
          
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesDefActions.html',
              scope:{
                codes: '=',
                selectCode: '=',
                defaultCode: "@",
                task: "=",
                actionsList: "@",
                codesActions: "=",
                statusFrom: "=",
                statusTo: "=",
                },
                controller:controller,
             link: function (scope, elem, attrs) {
              
               
            }
        }
        
};
'use strict';

export function ktCodesDetailList () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesDetailList.html',
              scope:{
                //codeId: '=',
                codeChanged : '&',
                },
                controller:function($scope,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragularService)
                {
                     $scope.removeCode = function(index){
                  
                  $scope.codesDetails.splice(index,1);
              }
                $scope.getCodesDetails = function(codeId,codeName){
                  
                    
                    var lang=$rootScope.globals.currentUser.lang;
                    
                     $scope.codeId = codeId;
                     $scope.codeName = codeName;
                       
                    if ($scope.codeId>0)
                    {
                      
                    CodesService.getCodesDetails($scope.codeId,lang).then(function(data) {
                                
                                  
                                   $scope.codesDetails = data.data;
                                   $scope.codesLoaded = true;
                                   
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
                    }else
                    {
                      
                      $scope.codesDetails.length = 0;
                      $scope.codesLoaded = false;
                    }
                }
                
                   $scope.saveCodesDetails = function(){
                  
                  var lang=$rootScope.globals.currentUser.lang;
                    
                    
                       
                    if ($scope.codeId>0)
                    {
                      
                    CodesService.saveCodesDetails($scope.codeId,$scope.codesDetails,lang).then(function(data) {
                                
                                   MessagingService.addMessage(data.msg,'success');
                                   $scope.codesDetails = data.data;
                                  
                                   
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
                    }else
                    {
                      
                      $scope.codesDetails.length = 0;
                    }
                }
                $scope.addEmptyCodeItem = function(){
                  
                  
                  var lang=$rootScope.globals.currentUser.lang;
                    
                   $scope.codesDetails.push({id:null,Name:null,Value:null,Active:true,CodesDetailLang:[{Value:null,Lang:lang}]});
                }
                
                $scope.codeChanged({theDirFn: $scope.getCodesDetails});
                if ($scope.codeId!=undefined)
                  {
                    $scope.getCodesDetails();
                  
                    if ($scope.codeId==0) $scope.codesLoaded = false;
                  }else $scope.codesLoaded = false;
                  
                    },
             link: function (scope, elem, attrs) {
              
              
             
            }   
        }
    };
'use strict';

export function ktCodesDropdown  () {
          
          var controller = ['$scope', '$stateParams','$state','CodesService','MessagingService','TaskDataService','$rootScope','$timeout','dragularService',function ($scope,$stateParams,$state,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragularService) {
          
                  $scope.GetCodesByName = function()
                  {
                     var lang=$rootScope.globals.currentUser.lang;
                  
                     CodesService.getCodesByName($scope.codeName,lang).then(function(data) {
                             $scope.codeList = data.data;
                           
                             var pos;
                             if ($scope.selectedCodeId!=undefined)
                             {
                              pos = $scope.codeList.map(function(e) { return e.id; }).indexOf($scope.selectedCodeId);
                             }
                             
                             /*
                              if (scope.selectedCodeValue!=undefined)
                             {
                              pos = scope.codeList.map(function(e) { return e.value; }).indexOf(scope.selectedCodeValue);
                             } */ 
                             if (pos>-1) {
                              
                              $scope.selectedCode = $scope.codeList[pos];
                                        
                              }
                                      
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
                  };
                  
                   $scope.GetCodes= function()
                  {
                     var lang=$rootScope.globals.currentUser.lang;
                  
                     CodesService.getCodesByName($scope.codeName,lang).then(function(data) {
                             $scope.codeList = data.data;
       
                                        
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
       
                  };
        
                  $scope.GetCodesClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    scope.GetCodes();
                      };
                  $scope.GetCodesByNameClick = function(){
                    //scope.task.TaskOutcomeCodeId = null;
                    $scope.GetCodesByName();
                      };
                 
                   if (!!$scope.codeName)
                    {
                      $scope.GetCodesByName();
                    }
                else{
            
                      $scope.GetCodes();
                    }
          
          
          }];
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktCodesDropdown.html',
              scope:{
                //codeList: '=',
                selectedCodeId: '=',
                codeId: "=",
                codeName: "@",
                valueLength:"@",
                labelLength:"@",
                name:"@",
                label:"@",
                searchText:"@",
                required:"=",
                sizeXs: "=",
                //errorText:"@",
                
                
                },
             controller:controller,
             link: function (scope, elem, attrs) {
              
                  if (scope.selectedCode == undefined) scope.selectedCode=null;
                  
                 /*
                  scope.$watch('selectedCodeId',function(newValue, oldValue){
                    
                        if (scope.codeList!=undefined)
                        {
                             var pos = scope.codeList.map(function(e) { return e.id; }).indexOf(scope.selectedCodeId);
                             if (pos>-1) {
                              
                              scope.selectedCode = scope.codeList[pos];
                                        
                              }
                    
                        }
                    });
                    */
                  scope.clear = function(event,selected){
                    
                   scope.selectedCode = null;
                    
                    
                  };
                  
                   scope.onSelectUniqueCallback = function (item, model){
                      
                      if (item!=undefined)
                      {
                      scope.selectedCode = item;
                      scope.selectedCodeId = item.id;
                      
                      }else {
                        
                        scope.selectedCode = null;
                        scope.selectedCodeId=null;
                      }
                    };
                           
        }
      }
    };
'use strict';



export function ktDatasetMapper  () {

        return {
             restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDatasetMapper.html',
             scope:{
                	 localVars : "=",
                       fd : "=",
             },
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService,dragularService,$timeout,CODES_CONST,MessagingService)
             {
                $scope.fd.formPriority='e';
              $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_NEW_;
              $scope.fd.RelatedPopulateType=1;
              if ($scope.fd.Parameters==undefined) $scope.fd.Parameters ={};              
              if ($scope.fd.PopulateType!=null && $scope.fd.PopulateType!="")
              {
                var pType = $scope.fd.PopulateType;
                var formPriority = pType.toString().substr(1,1);
                $scope.fd.RelatedPopulateType=pType.toString().substr(0,1);
                if (formPriority=="i" || formPriority=="e")
                {
                  
                  $scope.fd.formPriority = formPriority;
                }
              }

              if ($scope.localVars.selectedResourceItem!=undefined)
              {
                $scope.localVars.selectedResourceItem.src_type_text = $scope.localVars.src_type_text[$scope.fd.RelatedPopulateType];
              }else
              {
                $scope.localVars.selectedResourceItem = {src_type_text:$scope.localVars.src_type_text[$scope.fd.RelatedPopulateType]};
              }
              
              $scope.localVars.selectedResource=[];
              if ($scope.localVars.selectedResourceItem != undefined)
              {
                 $scope.localVars.selectedResource.push($scope.localVars.selectedResourceItem);
                
              }

				  
	if ($scope.localVars.resourceList==undefined) $scope.localVars.getResources();
          
           $scope.localVars.changePriority= function(fp){
             
             $scope.fd.formPriority =fp;
             
            };
         
          
         $scope.localVars.confirm= function(){
               
               $timeout(function(){
               $scope.localVars.selectedResourceItem.src_type_text = $scope.localVars.src_type_text[$scope.fd.RelatedPopulateType];
               $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem_c.name +' ('+$scope.localVars.selectedResourceItem_c.id +')'
               $scope.fd.PopulateType=$scope.fd.RelatedPopulateType+$scope.fd.formPriority;
               
             /*
               if ($scope.fd.Related!=$scope.localVars.selectedResourceItem_c.id)
               {
                  $scope.fd.Related=$scope.localVars.selectedResourceItem_c.id;
                  $scope.localVars.getFormResourceOriginal();
                  if ($scope.fd.Parameters.PresentationType=='card') $scope.localVars.getDatasetCardLayoutOriginal();
               
               }else
               {
               */
                $scope.fd.Related=$scope.localVars.selectedResourceItem_c.id;
                $scope.localVars.getFormResource();
                if ($scope.fd.Parameters.PresentationType=='card') $scope.localVars.getDatasetCardLayout();
                
              // }
               //retrieve form
                
               
               $scope.localVars.isCollapsedMapper = !$scope.localVars.isCollapsedMapper;
               });
               
            };
				  
              
               // FUNCTION ONSELECT DATASET CALLBACK
              $scope.localVars.onSelectDatasetCallback = function (item, model){
                  	var eventResultId=item.id;
                  	var eventResultName=item.name;
                    var eventResultParentElementId =item.parentElementId;
                    if (item.id!=$scope.localVars.selectedResourceItem.id && $scope.localVars.relatedPopulateType!=1){
                      $scope.localVars.getFormWidgets(item.id,$scope.fd.RelatedPopulateType);
                      
                    }
              
                	  $scope.localVars.selectedResourceItem_c = {id:eventResultId, name : eventResultName,parentElementId:eventResultParentElementId};
                    
                    
              }//ONSELECT DATASET CALLBACK
            
             $scope.localVars.setSelectedSource = function(source_id){
             
                  if (source_id==-1)
                  {
                    
                    $scope.fd.RelatedPopulateType = '3';
                    $scope.fd.formPriority = 'e';
                    
                  }else
                  {
                   
                    $scope.fd.RelatedPopulateType = '2';
                    $scope.fd.formPriority = source_id.form_type;
                    $scope.fd.SrcWidgetId = source_id.parentElementId;
                    if (source_id.type=='rlist') $scope.fd.RelatedPopulateType = '4';
                    
                  }
             };
              
             $scope.localVars.getFormWidgets = function(resource_id){
          

                  var lang=$rootScope.globals.currentUser.lang;
                  if ($scope.fd.PresentationId == undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
                  ResourcesDataService.getFormWidgets(resource_id,$scope.localVars.taskId,$scope.fd.PresentationId,1,lang).then(function(data) {
                               
                             
                                 
                                    $scope.localVars.currentTaskInitiateDatasets = data.data.initiate_widgets;
                                    
                                    $scope.localVars.currentTaskExecuteDatasets = data.data.execute_widgets;
                                  
                                    $scope.localVars.currentDownloaded = true;
                                  
                                  
                                  
                                    $scope.localVars.previousTaskInitiateDatasets = data.data.initiate_widgets;
                                    $scope.localVars.previousTaskExecuteDatasets = data.data.execute_widgets;
                                 
                                    $scope.localVars.previousDownloaded = true;
                                  
                                  
                                  
                                     },function(error){
                                       MessagingService.addMessage(error.msg,'error');
                                });
             };
           
           
              $scope.localVars.setPopulateMethod= function(populateMethod){
                        
                       $scope.fd.PopulateMethod=populateMethod;
                       
                       if (populateMethod=='A')
                        {
                          if ($scope.localVars.selectedResourceItem_c!=undefined)
                          {
                                 var id=$scope.localVars.selectedResourceItem_c.id;
                                 if (id==undefined) id=$scope.localVars.selectedResourceItem_c.relatedId;
                                 if (id!=undefined) $scope.localVars.getFormWidgets($scope.localVars.selectedResourceItem_c.id);
                          }
                          
                        }
                  };
                  
              $scope.localVars.setPopulateMethod($scope.fd.PopulateMethod);
              
              $scope.localVars.setPopulateType= function(populateType){
                        
                       $scope.fd.RelatedPopulateType=populateType;
                       
                       
                          if ($scope.localVars.selectedResourceItem_c!=undefined)
                          {
                            $scope.localVars.getFormWidgets($scope.localVars.selectedResourceItem_c.relatedId);
                          }
                          
                        
                  }
          
               },
             link: function (scope, elem, attrs) {
                       
             
             }
        }
};
'use strict';



export function ktDatasetMapperParent () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDatasetMapperParent.html',
              controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService,dragularService,$timeout,CODES_CONST,MessagingService){
               
                 $scope.fd.formPriorityParent='e';
              $scope.fd.ParentSearchPriority='d';
              $scope.src_type_text_parent=CODES_CONST._POPULATE_TYPE_NEW_;
              $scope.fd.PopulateTypeParentLocal=1;
              
              if ($scope.fd.PopulateTypeParent!=null)
              {
                var rpType = $scope.fd.PopulateTypeParent;
                var formPriorityParent = rpType.toString().substr(1,1);
                var parentSearchPriority = rpType.toString().substr(2,1);
                $scope.fd.PopulateTypeParentLocal=rpType.toString().substr(0,1);
              
                if (formPriorityParent=="i" || formPriorityParent=="e")
                {
                  
                  $scope.fd.formPriorityParent = formPriorityParent;
                }
                
                if (parentSearchPriority=="i" || parentSearchPriority=="d")
                {
                  
                  $scope.fd.ParentSearchPriority = parentSearchPriority;
                }
              }

              $scope.fd.selectedResourceItemParent={}
              $scope.fd.selectedResourceItemParent.src_type_text_parent = $scope.src_type_text_parent[$scope.fd.PopulateTypeParent];
              $scope.fd.selectedResourceParent=[];
              if ($scope.fd.selectedResourceItemParent != undefined)
              {
                 $scope.fd.selectedResourceParent.push($scope.fd.selectedResourceItemParent);
                
              }

            $scope.fd.datasetListParent=[];
            
            $scope.fd.SetSelectedDatasetParent = function(id)  {
              
              
              var pos = $scope.fd.datasetListParent.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.fd.selectedResourceItemParent.id = $scope.fd.datasetListParent[pos].id;
                $scope.fd.selectedResourceItemParent.name = $scope.fd.datasetListParent[pos].name;
                $scope.fd.selectedDatasetParent = $scope.fd.datasetListParent[pos];
                $scope.fd.selectedResourceItemParent.name_confirmed = $scope.fd.selectedResourceItemParent.name +' ('+$scope.fd.selectedResourceItemParent.id +')'
                $scope.fd.selectedResourceItemParent_c=$scope.fd.selectedResourceItemParent;
                }
					}
          
           $scope.localVars.setSelectedSource = function(source_id){
             
                  if (source_id==-1)
                  {
                    
                    $scope.fd.PopulateTypeParentLocal = '3';
                    $scope.fd.formPriorityParent = 'e';
                    
                  }else
                  {
                   
                    $scope.fd.PopulateTypeParentLocal = '2';
                    $scope.fd.formPriorityParent = source_id.form_type;
                    $scope.fd.SrcParentWidgetId =  source_id.parentElementId;
                    if (source_id.type=='rlist') $scope.fd.PopulateTypeParentLocal = '4';
                    
                  }
             }; 
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST) - get only potential parents
					$scope.fd.getDatasetsParent = function()  {
						var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
						function(data) {
										
											  $scope.fd.datasetListParent = data.data;
                       if ($scope.fd.ParentDatasetId!=null && $scope.fd.ParentDatasetId!=0)
                       {
                        $scope.fd.SetSelectedDatasetParent($scope.fd.ParentDatasetId);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
				  
          
          
				  $scope.fd.getDatasetsParent();
          
           $scope.fd.changePriorityParent= function(id){
             
             $scope.fd.formPriorityParent = id;
            
            };
           $scope.fd.changeParentSearchPriority= function(id){
             
              $scope.fd.ParentSearchPriority = id;
            };     
         $scope.fd.confirmParent= function(){
               
          
               if  ($scope.fd.selectedResourceItemParent_c!=undefined){
                
                      if ($scope.fd.ParentDatasetId!=$scope.fd.selectedResourceItemParent_c.id && $scope.fd.PopulateTypeParent!=null && $scope.fd.PopulateTypeParent!=undefined)
                      {
                          $scope.fd.ParentDatasetId=$scope.fd.selectedResourceItemParent_c.id;
                       
                      }
                      $scope.fd.selectedResourceItemParent.name_confirmed = $scope.fd.selectedResourceItemParent_c.name +' ('+$scope.fd.selectedResourceItemParent_c.id +')'

                 }
               
               $scope.fd.selectedResourceItemParent.src_type_text = $scope.src_type_text_parent[$scope.fd.PopulateTypeParentLocal];
               
               $scope.fd.PopulateTypeParent=$scope.fd.PopulateTypeParentLocal+$scope.fd.formPriorityParent+$scope.fd.ParentSearchPriority;
               
            };
				  
              
               // FUNCTION ONSELECT DATASET CALLBACK
              $scope.fd.onSelectDatasetParentCallback = function (item, model){
                  	var eventResultId=item.id;
                  	var eventResultName=item.name;
                    var eventResultParentElementId =item.parentElementId;
                    if (item.id!=$scope.fd.selectedResourceItemParent.id && $scope.fd.PopulateTypeParentLocal!=1){
                      $scope.localVars.getFormWidgetsParent(item.id,$scope.fd.PopulateTypeParentLocal);
                      
                    }
              
                	  $scope.fd.selectedResourceItemParent_c = {id:eventResultId, name : eventResultName,parentElementId:eventResultParentElementId};
                    
                    
              }//ONSELECT DATASET CALLBACK
            
             $scope.localVars.getFormWidgetsParent = function(resource_id,type){
          

                  var lang=$rootScope.globals.currentUser.lang;
          
                  ResourcesDataService.getFormWidgets(resource_id,$scope.localVars.taskId,$scope.fd.PresentationId,1,lang).then(function(data) {
                                 $scope.fd.currentTaskInitiateDatasetsParent = data.data.initiate_widgets;
                                 $scope.fd.currentTaskExecuteDatasetsParent = data.data.execute_widgets;
                                 $scope.fd.currentDownloadedParent = true;
                                  
                                  
                    },function(error){
                                 MessagingService.addMessage(error.msg,'error');
                      });
             };
           
           
              
                  $scope.fd.SetPopulateTypeParent= function(populateType){
                        
                       $scope.fd.PopulateTypeParentLocal=populateType;
                       
                      // if (populateType!=1)
                       // {
                         /* if ($scope.selectedResourceItemParent_c!=undefined)
                          {
                            $scope.getFormWidgetsParent($scope.selectedResourceItemParent_c.id,$scope.relatedPopulateTypeParent);
                          }
                          */
                        //}
                  }
                       
              $scope.fd.getDatasetSources= function(){
                        
                        var radio = $scope.fd.PopulateTypeParentLocal;
                        
                       }
                       
             },
             link: function (scope, elem, attrs) {
             
            
             
            
             //$scope.getDatasetSources();
          
             }
        }
};
'use strict';

export function ktDatasetToDatasetMapper () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDatasetToDatasetMapper.html',
             controller: function ($scope,CodesService,ResourcesDataService,GridsterService,$rootScope,ProcessingService,dragulaService,$timeout,CODES_CONST,MessagingService){
                 $scope.gsrvc = GridsterService;  
              $scope.fd.selectedPackages=$scope.fd.DatasetMapping;
             
              $scope.dataset1Fields = [];
              $scope.dataset2Fields = [];
             
              if ($scope.fd.selectedPackages==undefined) $scope.fd.selectedPackages=[];
             
  
            $scope.localVars.confirmDataset2Dataset= function(){
               
               $timeout(function(){
               
                //$scope.fd.selectedPackages =$scope.localVars.gridApi.selection.getSelectedRows();
                
                if ($scope.fd.selectedPackages!=undefined)
               {
                $scope.fd.DatasetMapping = [];
                  for (var i=0;i<$scope.fd.selectedPackages.length;i++)
                  {
                    $scope.fd.DatasetMapping.push($scope.fd.selectedPackages[i].id)
                      
                  
                  }
               }

               });
               
            };
  
  
    //setup dragula
    $scope.setupDragula = function()
    {
         var widgetHandle = "element-drag-handle";
         var bag = dragulaService.find($rootScope, 'bag-dataset-mapping');
         if (bag) dragulaService.destroy($rootScope, 'bag-dataset-mapping');
         
         dragulaService.options($rootScope, 'bag-dataset-mapping', {
                       revertOnSpill: true,
                       removeOnSpill: false,
                       copy:function (el,source){
                        
                        return source.id=='dataset1-mapping';
                       
                        },
                       //direction:'vertical',
                       accept:function (el,target, source) {
                          return target.id!='dataset1-mapping';
                       },
                       moves: function (el, container, handle) {
                                 return handle.classList.contains(widgetHandle);
                       }
                   });     
              
    };
        
        // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
		$scope.localVars.getDatasets = function()  {
			var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
						function(data) {			
							$scope.datasetList = data.data;
                            //console.log($scope.datasetList);
				 
							},function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					};
     $scope.getDatasetMappings = function (datasetId) {
    
         var lang = $rootScope.globals.currentUser.lang;
         
         ResourcesDataService.getDatasetMappings(datasetId,lang).then(function(data) {
                               
                             $scope.dataset2Fields = data.data;
                             
                             $scope.setupDragula();
                             $scope.dataset1Loaded=true;
                             
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };  
    
    
  
     $scope.getResourceFields = function (item,type) {
    
         var lang = $rootScope.globals.currentUser.lang;
         
         ResourcesDataService.getResourceFields(item.Dataset1.id,lang).then(function(data) {
                               
                             
                              if (type==1){
                                  $scope.dataset1Fields = data.data;

                               }
         
                              else{
                                $scope.dataset2Fields = data.data;

                                }
                               
                                $scope.getDatasetMappings(item.id);
                                
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
        
    $scope.localVars.showMappingDetailsFn = function (item) {
        $scope.dataset1Loaded=false;
         if ($scope.dataset1Fields!=undefined) $scope.dataset1Fields.length=0;
         if ($scope.dataset2Fields!=undefined) $scope.dataset2Fields.length=0;
        
        $scope.selectedDataset1 = {id:item.Dataset1.id,name: item.Dataset1.resourcedeflang_set[0].Name};
        $scope.selectedDataset2 = {id:item.Dataset2.id,name: item.Dataset2.resourcedeflang_set[0].Name};
        $scope.getResourceFields(item,1);
        
        $scope.tmpMappingFields={}
        $scope.tmpMappingFields.dataset1=$scope.selectedDataset1;
        $scope.tmpMappingFields.dataset2=$scope.selectedDataset2;
        $scope.tmpMappingFields.mappingType= {id:item.MappingType.id,name:item.MappingType.Value,value:item.MappingType.Name};  
        $scope.tmpMappingFields.mappingDisplayName=item.DatasetMappingHeadLang_datasetmappingheadid[0].Name
        $scope.tmpMappingFields.mappingName=item.MappingName;
       
        $scope.localVars.showMappingData(item);
    
    };
        $scope.localVars.showMappingData = function (selectedResource) {
         
        $scope.showMappingDetails=true;
          
         if (selectedResource==false || selectedResource==undefined) 
          {
             $scope.mappingFields={};
             $scope.saveDatasetMappingHeadStatus='createMapping';
          } else  
          {
              $scope.saveDatasetMappingHeadStatus='updateMapping';
              $scope.mappingFields= $scope.tmpMappingFields;
          }
          
         $scope.localVars.getDatasets();//puni datasetList
         var lang = $rootScope.globals.currentUser.lang;
         CodesService.getCodesByName('dmt',lang).then(function (data) {
                                $scope.codeList = data.data;           
            }); 
        };
        
        $scope.removeItem=  function(pindex,index)
        {
            $scope.dataset2Fields[pindex].fields.splice(index,1);
        };
        $scope.cancelMapping = function () {
            $scope.saveDatasetMappingHeadStatus='CancelOrInit';
            $scope.showMappingDetails=false;
        };
        $scope.localVars.getMappingPackages = function () {
    
            var lang = $rootScope.globals.currentUser.lang;
            var fromDs = 0;
            var toDs = $scope.localVars.selectedResourceItem.id;
        
            ResourcesDataService.getMappingPackages(fromDs,toDs,lang).then(function(data) {
               
                $scope.mappingList = data.data;
                $scope.mappingsLoaded=true;
                
            },function(error){
                  
                MessagingService.addMessage(error.msg,'error');  
            });
        };
         $scope.localVars.getMappingPackages();   
    },

    link: function (scope, elem, attrs) {
             
    }
  }      
};
'use strict';

export function ktDate () {

	var datePickerCtrl = ['$scope','GridsterService','$compile','$element','$templateCache', function ($scope,GridsterService,$compile,$element,$templateCache) {
        
        
        $scope.gsrvc = GridsterService;
              
       if ($scope.fd.ParametersLang==undefined || $scope.fd.ParametersLang==null) $scope.fd.ParametersLang={};
        //console.log("u datepickerctrl");
		$scope.fd.isOpen=false;
        if ($scope.localVars==undefined) $scope.localVars={};
		$scope.search = [
		{id:1,filter:'gt',name:"From date",icon:"fa fa-chevron-right"},
		{id:2,filter:'lt',name:"To date",icon:"fa fa-chevron-left"},
		{id:3,filter:'eq',name:"Exact date",icon:"fa fa-bars"},
		{id:4,filter:'between',name:"Between <date1> and <date2>",icon:"fa fa-expand"}
    ];
	
  if ($scope.fd.Search==undefined)	$scope.fd.Search=$scope.search[2];

	
 $scope.fd.refreshSearchValue = function() {
         if ($scope.fd.Search && $scope.formData !=undefined && $scope.formData.length>0) $scope.fd.Search.value=$scope.formData[0]['Field'+$scope.fd.ItemId];      
        } 
	  $scope.applyDateFilters = function(index) {//ovo je aktivna funkcija!!

		$scope.fd.Search=$scope.search[index];
      
        if ($scope.formData !=undefined && $scope.formData.length>0)
        {
            if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=undefined) $scope.fd.Search.value=$scope.formData[0]['Field'+$scope.fd.ItemId];// ponovno dodaj value
        }    
		if ($scope.fd.Search.id==4)  $scope.fd.Search.ShowSecondDate=true // kad je  between
		else  $scope.fd.Search.ShowSecondDate=false
        
        //if ($scope.fd.Search.name=="eq") $scope.fd.Search=null;
            
		//$scope.fd.isOpen=false;		
	  };

    $scope.showHideProperties = function(value)
    {
        $scope.gsrvc.setFieldPropertiesOpened(value);
        $scope.localVars.showFieldProperties=$scope.gsrvc.getFieldPropertiesOpened();
        if (value) $scope.gsrvc.setPropertiesPosition();
    };

 $scope.fd.today = function() {
    $scope.fd.dt = new Date();
  };
  $scope.fd.today();

  $scope.fd.clear = function() {
    $scope.fd.dt = null;
  };

  $scope.fd.inlineOptions = {
    customClass: getDayClass,
    minDate: new Date(),
    showWeeks: true
  };

  $scope.fd.dateOptions = {
    dateDisabled: disabled,
    formatYear: 'yyyy',
    maxDate: new Date(2999, 12, 31),
    minDate: new Date(),
    startingDay: 1
  };

  // Disable weekend selection
  function disabled(data) {
    var date = data.date,
      mode = data.mode;
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  }

  $scope.fd.toggleMin = function() {
    $scope.fd.inlineOptions.minDate = $scope.fd.inlineOptions.minDate ? null : new Date();
    $scope.fd.dateOptions.minDate = $scope.fd.inlineOptions.minDate;
  };

  $scope.fd.toggleMin();

  $scope.fd.open1 = function() {
    $scope.fd.popup1.opened = true;
  };

  $scope.fd.open2 = function() {
    $scope.fd.popup2.opened = true;
  };

  $scope.fd.setDate = function(year, month, day) {
    $scope.fd.dt = new Date(year, month, day);
  };

  $scope.fd.formats = [{id:1,name:'dd-MMMM-yyyy HH:mm:ss:sss'}, {id:2,name:'yyyy/MM/dd HH:mm:ss:sss'}, {id:3,name:'dd.MM.yyyy HH:mm:ss:sss'}];
  $scope.fd.formatsTime = [{id:1,name:'HH:mm:ss'}, {id:2,name:'HH:mm:ss:sss'}, {id:2,name:'HH:mm'}];
  $scope.fd.formatsDate = [{id:1,name:'dd-MMMM-yyyy'}, {id:2,name:'yyyy/MM/dd'}, {id:3,name:'dd.MM.yyyy'}, {id:4,name:'shortDate'}];
 
  $scope.fd.setFormat = function()
      {
      $scope.fd.format="";
      if  ($scope.fd.ParametersLang.format1!=undefined && $scope.fd.ParametersLang.format1!=null)
      {
        $scope.fd.format = $scope.fd.ParametersLang.format1.name;
      }
      
      if  ($scope.fd.ParametersLang.format2!=undefined && $scope.fd.ParametersLang.format2!=null)
      {
        if ($scope.fd.format!="")
        {
         $scope.fd.format = $scope.fd.format+" "+$scope.fd.ParametersLang.format2.name;
        }else
        {
          $scope.fd.format = $scope.fd.ParametersLang.format2.name;
          
        
        }
      }
      
      if ($scope.fd.format =="")
      {
        $scope.fd.format = $scope.fd.formats[2];
      }
  }
  $scope.fd.altInputFormats = ['M!/d!/yyyy'];

  $scope.fd.popup1 = {
    opened: false
  };

  $scope.fd.popup2 = {
    opened: false
  };

  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  var afterTomorrow = new Date();
  afterTomorrow.setDate(tomorrow.getDate() + 1);
  $scope.fd.events = [
    {
      date: tomorrow,
      status: 'full'
    },
    {
      date: afterTomorrow,
      status: 'partially'
    }
  ];

  function getDayClass(data) {
    var date = data.date,
      mode = data.mode;
    if (mode === 'day') {
      var dayToCheck = new Date(date).setHours(0,0,0,0);

      for (var i = 0; i < $scope.fd.events.length; i++) {
        var currentDay = new Date($scope.fd.events[i].date).setHours(0,0,0,0);

        if (dayToCheck === currentDay) {
          return $scope.fd.events[i].status;
        }
      }
    }
    return '';
  }
  
   let template;
                if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktDate2.html');
                else template = $templateCache.get('ktdirectivetemplates/ktDate2Exe.html');
          
                $element.append($compile(template)($scope)); 
}];//datepickerCtrl

      // console.log("u direktivi kt-date ");
        return {
            restrict: 'A',
			controller: datePickerCtrl,
            
             link: function (scope, elem, attrs) {
              
              
              scope.colLength=[];
              for (var i=0;i<24;i++) scope.colLength.push('col-lg-'+(i+1));
              
             scope.fd.dateFormatList = [{id:1,name:'dd.MM.yyyy'},{id:2,name:'dd-MM-yyyy'},{id:3,name:'dd/MM/yyyy'},{id:4,name:'dd.MM.yy'}];
       
        
             scope.fd.timeFormatList = [{id:1,name:'HH:mm',mask:'99:99'},{id:2,name:'HH:mm:ss'},{id:3,name:'HH:mm'},{id:4,name:'HH:mm:ss:sss'}];
         
               
            var posFormatDate = scope.fd.dateFormatList.map(function(e) { return e.name.toString(); }).indexOf(scope.fd.ParametersLang.format1);
              
                           if (posFormatDate>=0){
             
                             scope.fd.format1=scope.fd.dateFormatList[posFormatDate];
                                  
                            }
            var posFormatTime = scope.fd.timeFormatList.map(function(e) { return e.name.toString(); }).indexOf(scope.fd.ParametersLang.format2);
              
                           if (posFormatTime>=0){
             
                             scope.fd.ParametersLang.format2=scope.fd.timeFormatList[posFormatTime];
                                  
                            }
            scope.fd.setFormat(); 
               //find object
             scope.fd.showProperties = function()
                {
                  scope.localVars.showFieldProperties = true;
                  scope.gsrvc.setFieldProperties(scope.fd,scope.inputArray);
       
                };   
               //console.log("u direktivi kt-date link funkcija");
          scope.fd.setSystemDate=function(){
                if (scope.fd.UseSystemDate) {
                  //code
                  if (scope.formData !=undefined && scope.formData.length>0)
                  {
                      scope.formData[0]['Field'+scope.fd.ItemId]=new Date();
                  }
                 
               
               }
                
          }
               /*
               if (scope.fd.sItemValue!= null && scope.fd.sItemValue!="")
               {
                  scope.fd.sItemValue = new Date (scope.fd.sItemValue);

               }
               */
              if (scope.formData !=undefined && scope.formData.length>0)
               {
                    if (scope.formData[0]['Field'+scope.fd.ItemId]!= null && scope.formData[0]['Field'+scope.fd.ItemId]!="")
                   
                   {
                      scope.formData[0]['Field'+scope.fd.ItemId] = new Date (scope.formData[0]['Field'+scope.fd.ItemId]);
    
                   }
               }
               if (scope.fd.UseSystemDate) scope.fd.setSystemDate();
            
               
            }
        };
    };
function DatePickerCtrl2 ($scope) {

  		$scope.CTRLNAME='DatePickerCtrl2';
        $scope.search=[                     /*  MIGOR TODO - VIDJETI DA LI OVO TREBA zaKOMENTIRATI ILI NE */
		{id:1,filter:'gt',name:"From <date>",icon:"fa fa-chevron-right"},
		{id:2,filter:'lt',name:"To <date>",icon:"fa fa-chevron-left"},
		{id:3,filter:'eq',name:"On <date>",icon:"fa fa-bars"},      // MIGOR TODO - vidjeti zasto se pokazuje na pocetku od datePicker2 kontrolera umjesto prvog
		{id:4,filter:'between',name:"Between <date> and <date>",icon:"fa fa-expand"} ];
 
    if ($scope.fd.ParametersLang==undefined || $scope.fd.ParametersLang==null) $scope.fd.ParametersLang={};
 
    if ($scope.fd.Search==undefined) $scope.fd.Search=$scope.search[2];
        $scope.CTRL='datepicker2';

        
        $scope.refreshSearchValue = function() {
                 if ($scope.fd.Search) $scope.fd.Search.value=$scope.fd.sItemValue;      
        } 
        
	  $scope.applyDateFilters = function(index) {
      
           // $scope.fd.Search=$scope.search[index]; // ovo pregazi value      // MIGOR TODO  - mozda treba ovdje dodati jer postoji u ktdate
          // if ($scope.fd.sItemValue!=undefined) $scope.fd.Search.value=$scope.fd.sItemValue;// ponovno dodaj value  // MIGOR TODO  - mozda treba ovdje dodati jer postoji u ktdate
           
		  var i=$scope.search.selected.id; 

		  if ($scope.search.selected.id==4)  $scope.search.showSecondDate=true // if (scope.fd.search.name=="Equals") scope.fd.search=null;
		  else  $scope.search.showSecondDate=false
		  		
	  };

  $scope.today = function() {
    $scope.dt = new Date();
  };
  $scope.today();

  $scope.clear = function() {
    $scope.dt = null;
  };

  $scope.inlineOptions = {
    customClass: getDayClass,
    minDate: new Date(),
    showWeeks: true
  };

  $scope.dateOptions = {
    dateDisabled: disabled,
    formatYear: 'yy',
   // maxDate: new Date(2020, 5, 22),
    minDate: new Date(),
    startingDay: 1
  };

  // Disable weekend selection
  function disabled(data) {
    var date = data.date,
      mode = data.mode;
    return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
  }

  $scope.toggleMin = function() {
    $scope.inlineOptions.minDate = $scope.inlineOptions.minDate ? null : new Date();
    $scope.dateOptions.minDate = $scope.inlineOptions.minDate;
  };

  $scope.toggleMin();

  $scope.open1 = function() {
    $scope.popup1.opened = true;
  };

  $scope.open2 = function() {
    $scope.popup2.opened = true; //DatePickerCtrl2
  };
  
  $scope.applyDateFilters = function() {
	  var sc=$scope;
	  var t=sc.fd;
	
    $scope.popup2.opened = true;
  };
   
  

  $scope.setDate = function(year, month, day) {
    $scope.dt = new Date(year, month, day);
  };

  $scope.fd.formats = [{id:1,name:'dd-MMMM-yyyy HH:mm:ss:sss'}, {id:2,name:'yyyy/MM/dd HH:mm:ss:sss'}, {id:3,name:'dd.MM.yyyy HH:mm:ss:sss'}];
  $scope.fd.formatsTime = [{id:1,name:'HH:mm:ss'}, {id:2,name:'HH:mm:ss:sss'}, {id:2,name:'HH:mm'}];
  $scope.fd.formatsDate = [{id:1,name:'dd-MMMM-yyyy'}, {id:2,name:'yyyy/MM/dd'}, {id:3,name:'dd.MM.yyyy'}, {id:4,name:'shortDate'}];
 
  $scope.setFormat = function()
      {
      $scope.format="";
      if  ($scope.fd.ParametersLang.format1!=undefined && $scope.fd.ParametersLang.format1!=null)
      {
        $scope.format = $scope.fd.ParametersLang.format1.name;
      }
      
      if  ($scope.fd.ParametersLang.format2!=undefined && $scope.fd.ParametersLang.format2!=null)
      {
        if ($scope.format!="")
        {
         $scope.format = $scope.format+" "+$scope.fd.ParametersLang.format2.name;
        }else
        {
          $scope.format = $scope.fd.ParametersLang.format2.name;
          
        
        }
      }
      
      if ($scope.format =="")
      {
        $scope.format = $scope.formats[2];
      }
  }
  $scope.altInputFormats = ['M!/d!/yyyy'];

  $scope.popup1 = {
    opened: false
  };

  $scope.popup2 = {
    opened: false
  };

  var tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  var afterTomorrow = new Date();
  afterTomorrow.setDate(tomorrow.getDate() + 1);
  $scope.events = [
    {
      date: tomorrow,
      status: 'full'
    },
    {
      date: afterTomorrow,
      status: 'partially'
    }
  ];

  function getDayClass(data) {
    var date = data.date,
      mode = data.mode;
    if (mode === 'day') {
      var dayToCheck = new Date(date).setHours(0,0,0,0);

      for (var i = 0; i < $scope.events.length; i++) {
        var currentDay = new Date($scope.events[i].date).setHours(0,0,0,0);

        if (dayToCheck === currentDay) {
          return $scope.events[i].status;
        }
      }
    }
    return '';
  }
};
'use strict';

export function ktDateExtendedProperties () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDateExtendedProperties.html',
             controller: function(CodesService,ResourcesDataService,$rootScope,ProcessingService){},
             link: function (scope, elem, attrs) {
      
              }
        }
  
};
'use strict';

export function ktDeleteElement () {
        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktDeleteElement.html',
             link: function (scope, elem, attrs) {
  
            }
        };
};

export function ktChartWidget () {
   
   var controller = ['$scope',function ($scope) {
        
         if ($scope.fd==undefined)  $scope.fd= {};
                   $scope.fd.chartType="pie";
    
    $scope.colLength = ['col-lg-2','col-lg-4','col-lg-6','col-lg-8','col-lg-10','col-lg-12','col-lg-14','col-lg-16','col-lg-18','col-lg-20','col-lg-22','col-lg-24'];
        
                    $scope.localVars={
                              showForm: false,
                              data:[34,45,43],
                              labels:['miro','pero','ante'],
                              formLoaded:true
           
                    };
        }];

  return {
          restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktDirectiveChartWidget.html',
            controller: controller,
            link: function (scope, elem, attrs) {

                  
                   
          }
  };
};
'use strict';

export function ktDropdown ($timeout) {

        return {
            restrict: 'EA',
            require:['^form','ngModel'],
            templateUrl: 'ktdirectivetemplates/ktDropdown.html',
            controller: function($scope)
            {
               
                $scope.processKeyboardEntry = function(ev,index)
                {
                    let code = ev.keyCode || ev.which;
                    let key = ev.key;

                    //enter
                    if (code==13 && (ev.currentTarget.type=="button" || ev.currentTarget.type=="text")){
                        //move focus to next element
                        ev.preventDefault();
                        let next=index+1;
                        let id=$scope.parentFormId+"."+$scope.dropdownId+".DropdownItem"+next;
                        let elem = document.getElementById(id);
                        if (elem!=null) elem.focus(); 
                    }
                    //keydown
                    if (code==40){
                      //move focus to next element
                       ev.preventDefault();
                       let next=index+1;
                       let id=$scope.parentFormId+"."+$scope.dropdownId+".DropdownItem"+next;
                       let elem = document.getElementById(id);
                       if (elem!=null) elem.focus(); 
                    }
                    //keyup
                    if (code==38){
                      //move focus to previous element
                       ev.preventDefault();
                       let prev=index-1;
                       let elemDef = $scope.parentFormId+"."+$scope.dropdownId+".DropdownItem"+prev;
                       if (prev==-1) elemDef = $scope.parentFormId+"."+$scope.dropdownId+"search";
                       let elem = document.getElementById(elemDef);
                       
                       if (elem!=null) elem.focus(); 
                    }
                }
                
                /*
                $scope.$watch('selectedItems',function(newValue,oldValue){
                    if (newValue!=oldValue)
                    {
                            $scope.selectItem(null,newValue);    
                    
                    }
                });
                */
                $scope.selectItem = function(ev,item)
                {
                    if (item!=undefined)
                    {
                        if (!$scope.isMultiple){
                          $scope.selectedItem= item;
                          $scope.ngModel.$setViewValue($scope.selectedItem);
                          //ngModel.$validate();
                          let elemBtn = document.getElementById($scope.parentFormId+"."+$scope.dropdownId)
                          if (ev!=undefined) elemBtn.focus();
                          $scope.onSelectFn({item:$scope.selectedItem,model:$scope.ngModel});
                        }else
                        {
                          if (ev!=undefined) ev.stopPropagation();
                          if ($scope.selectedItems==null || $scope.selectedItems==undefined || !Array.isArray($scope.selectedItems)) $scope.selectedItems=[];
                          let pos = $scope.selectedItems.map(function(e) { return e.id; }).indexOf(item.id);
                          if (pos<0) $scope.selectedItems.push(item);
                          else $scope.selectedItems.splice(pos,1);
                          $scope.ngModel.$setViewValue($scope.selectedItems);
                          $scope.onSelectFn({item:$scope.selectedItems,model:$scope.ngModel});
                        }
                        
                    }
                }
                
                 $scope.dropdownBlurred = function()
                {
                    let elemBtn = document.getElementById($scope.parentFormId+"."+$scope.dropdownId)
                    
                    $scope.ngModel.$setTouched();
                                      
                    let elemSearch = document.getElementById($scope.parentFormId+"."+$scope.dropdownId+"search")
                    if (elemSearch!=null) elemSearch.focus();
                  
                }
                
                $scope.removeItem = function(index)
                {
                    $scope.selectedItems.splice(index,1);
                    $scope.ngModel.$setViewValue($scope.selectedItems); 
                
                }
                
                $scope.clearOnly = function()
                {
                    
                        $scope.selectedItem = null;
                        //set ngModel to null
                        $scope.ngModel.$setViewValue(null);
                   
                }
                
                
                $scope.loadItems = function(items)
                {
                    if (items!=undefined)
                    {
                        $scope.dropdownItems = items;
                        if ($scope.search.searchFilter!=undefined && $scope.search.searchFilter!="") $scope.dropdownItemsFiltered = $scope.filterItems();
                        else $scope.dropdownItemsFiltered = angular.copy($scope.dropdownItems.slice(0,50));
                    }                      
                   
                }
                 $scope.loadItemsOnChange = function()
                {
                    if ($scope.dropdownItems!=undefined)
                    {
                        if ($scope.search.searchFilter!=undefined && $scope.search.searchFilter!="") $scope.dropdownItemsFiltered = $scope.filterItems();
                        else $scope.dropdownItemsFiltered = angular.copy($scope.dropdownItems.slice(0,50));
                    }  
                   
                }
                $scope.filterItems = function()
                {
                    if ($scope.search.searchFilter=="") return angular.copy($scope.dropdownItems.slice(0,50));
                    else{
                        $scope.dropdownItemsFiltered=[];
                        let temp = [];
                        for (let i=0;i<$scope.dropdownItems.length;i++)
                        {
                            if ($scope.dropdownItems[i].name.toLowerCase().indexOf($scope.search.searchFilter.toLowerCase())>-1) temp.push($scope.dropdownItems[i]);
                        }
                        return angular.copy(temp);
                    }
                }
                $scope.clear = function(ev)
                {
                    if (!$scope.isMultiple){
                        if (ev!=undefined) ev.preventDefault();
                        $scope.clearOnly();
                    }
                }
               
          
                /*
                $scope.clearMultiple = function()
                {
      
                  $scope.formData[0]['Field'+$scope.fd.ItemId] = null;
                   $scope.fd.Search.value.length=0;
                }
                */ 
                
            },
            scope:{
            
            dropdownItems:'=',
            dropdownId:'=',
            parentFormId:'=',
            searchText:'=',
            isMultiple:'=',
            selectedItems:'=?',
            onSelectFn:'&',
            clearFn: '&',
            selectItemFn:'&',
            loadItemsFn:'&',
            size:'=?',
            },
             
            link: function (scope, elem, attrs,ctrls) {
                
                scope.form = ctrls[0];
                scope.ngModel= ctrls[1];
                scope.selectedItem = null; //{id:null,name:scope.searchText};
                scope.clearCloseLink="Clear";
                scope.search={};
                
                if (scope.dropdownItems!=undefined) scope.dropdownItemsFiltered = angular.copy(scope.dropdownItems.slice(0,50));
                
                scope.clearFn({theDirFn: scope.clearOnly});
                scope.selectItemFn({theSelectItemFn: scope.selectItem});
                scope.loadItemsFn({theLoadItemsFn: scope.loadItems});
                
                if (!scope.isMultiple)
                {
                    if (scope.selectedItems!="" && scope.selectedItems!=undefined && scope.selectedItems!=null) scope.selectedItem=scope.selectedItems;
                    scope.ngModel.$setViewValue(scope.selectedItem); 
                }else
                {
                    scope.ngModel.$setViewValue(scope.selectedItems);
                }
                
                scope.showSearchInput = false;
                if (scope.isMultiple) scope.clearCloseLink="Close";
                
                let dropdownShow = elem[0].getElementsByClassName("dropdown");
                
                
                angular.element(dropdownShow).on("shown.bs.dropdown", function(event){
                   $timeout(function(){
                     scope.showSearchInput = true;
                     let elementId = scope.parentFormId+"."+scope.dropdownId+"search";
                     let searchInput = document.getElementById(elementId);
                     if (searchInput!=null) searchInput.focus();
                    });
                });
                
                angular.element(dropdownShow).on("hidden.bs.dropdown", function(event){
                   $timeout(function(){
                     scope.showSearchInput = false;
                    
                    });
                });
               
                 $timeout(function(){
                            scope.showSearchInput = false;
                           
                        });
               
                 scope.isSelectedMultiple = function(item)
                {
                 
                    //let items = ngModel.$modelValue;
                    if (item!=undefined)
                    {
                        if (item.id!=undefined)
                        {
                            let items = scope.ngModel.$modelValue;
                            if (items!=undefined)
                            {
                                for (let i=0;i<items.length;i++)
                                {
                                    if (items[i]!=undefined)
                                    {
                                        if (items[i].id==item.id) return true;
                                    }
                                }
                            }
                        }
                    }
                    
                    return false;
                }
            }
        }
  
};
'use strict';

export function ktDropdownStandard ($timeout) {

        return {
            restrict: 'EA',
            require:['^form','ngModel'],
            templateUrl: 'ktdirectivetemplates/ktDropdownStandard.html',
            controller: function($scope,$element,$timeout)
            {
               
                $scope.search={searchFilter:''};
                $scope.model = {selectedItems:$scope.selectedItems};
                if ($scope.dropdownItems==undefined) $scope.dropdownItems=[];     
                $scope.selectItem = function()
                {
                    
                        if (!$scope.isMultiple && $scope.model.selectedItems!=undefined && $scope.model.selectedItems!=null){
                          if ($scope.model.selectedItems.id!==undefined && $scope.model.selectedItems.id===null)
                            {
                                $scope.model.selectedItems=null;
                                $scope.ngModel.$setViewValue(null);
                                let element = $element[0].getElementsByClassName('form-control');
                                $timeout(function(){
                                    element[0].selectedIndex =-1;
                                });
                            }
                          else $scope.ngModel.$setViewValue($scope.model.selectedItems);
                         
                        }else
                        {
                          if ($scope.model.selectedItems==null || $scope.model.selectedItems==undefined || !Array.isArray($scope.model.selectedItems)) $scope.model = {selectedItems:[]};
                          $scope.ngModel.$setViewValue($scope.model.selectedItems);
                          
                        }
                        $scope.onSelectFn({item:$scope.model.selectedItems,model:$scope.ngModel});
                        
                }
                
                $scope.setItem = function(item)
                {
                    if (item.id!=undefined && item.id==null) $scope.model.selectedItems=item.id;
                    else $scope.model.selectedItems=item;
                         
                }
                
                
                
                $scope.removeItem = function(index)
                {
                    $scope.model.selectedItems.splice(index,1);
                    $scope.ngModel.$setViewValue($scope.model.selectedItems); 
                
                }
                
                $scope.clearOnly = function()
                {
                    
                        $scope.selectedItems = null;
                        //set ngModel to null
                        $scope.ngModel.$setViewValue(null);
                   
                }
                
                
                $scope.loadItems = function(items)
                {
                    if (items!=undefined)
                    {
                        $scope.dropdownItems = items;
                        if ($scope.search.searchFilter!=undefined && $scope.search.searchFilter!="") $scope.dropdownItemsFiltered = $scope.filterItems();
                        else $scope.dropdownItemsFiltered = angular.copy($scope.dropdownItems.slice(0,50));
                    }                      
                   
                }
                
                $scope.selectItemsOnLoad = function()
                {
                    let pos;
                    if ($scope.selectedItems!=undefined)
                    {
                        if ($scope.isMultiple)
                        {
                           $scope.model.selectedItems=[];
                           for(let j=0;j<$scope.selectedItems.length;j++)
                           {
                                if ($scope.selectedItems[j]!==null)
                                {
                                 pos = $scope.dropdownItems.map(function(e) { return e.id; }).indexOf($scope.selectedItems[j].id);
                                
                  
                                    if (pos>=0 && $scope.dropdownItems[pos].id!=null){
                                        $scope.model.selectedItems.push($scope.dropdownItems[pos]);
                                    }
                                    if ($scope.model.selectedItems.length==0) $scope.model.selectedItems = null;
                                }
                           }
                           
                        }
                        else
                        {
                            if ($scope.selectedItems!==null)
                            {
                                pos = $scope.dropdownItems.map(function(e) { return e.id; }).indexOf($scope.selectedItems.id);
                  
                                if (pos>=0 && $scope.dropdownItems[pos].id!=null){
                                    
                                    $scope.model.selectedItems = $scope.dropdownItems[pos];
                                }
                                else
                                {
                                
                                    $scope.model.selectedItems = null;
                                    
                                }
                            }
                        }
                        
                    }                      
                   
                };
                
            
               $scope.selectItemsOnLoad(); 
            },
            scope:{
            
            dropdownItems:'=',
            dropdownId:'=',
            parentFormId:'=',
            searchText:'=',
            isMultiple:'=',
            selectedItems:'=?',
            requiredField:'=?',
            onSelectFn:'&',
            clearFn: '&',
            selectItemFn:'&',
            loadItemsFn:'&',
            setItemFn:'&',
            size:'=?',
            showId:'=?',
            modelType:'=?',
            },
             
            link: function (scope, elem, attrs,ctrls) {
                
                scope.form = ctrls[0];
                scope.ngModel= ctrls[1];
                scope.selectedItem = null; //{id:null,name:scope.searchText};
                
                
                scope.clearFn({theDirFn: scope.clearOnly});
                scope.selectItemFn({theSelectItemFn: scope.selectItem});
                scope.loadItemsFn({theLoadItemsFn: scope.loadItems});
                scope.setItemFn({theSetItemFn: scope.setItem});
                
                 scope.isSelectedMultiple = function(item)
                {
                 
                    //let items = ngModel.$modelValue;
                    if (item!=undefined)
                    {
                        if (item.id!=undefined)
                        {
                            let items = scope.ngModel.$modelValue;
                            if (items!=undefined)
                            {
                                for (let i=0;i<items.length;i++)
                                {
                                    if (items[i]!=undefined)
                                    {
                                        if (items[i].id==item.id) return true;
                                    }
                                }
                            }
                        }
                    }
                    
                    return false;
                }
            }
        }
  
};
'use strict';

export function ktExecuteSmartContract () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     
      $scope.localVarsWidget = {};
      //$scope.fd = {};
      $scope.localVarsWidget.searchFormDownloaded = false;
      $scope.localVarsWidget.formLoaded=false;
      $scope.localVarsWidget.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.localVarsWidget.animationsEnabled = true;
      $scope.localVarsWidget.widgetType = 3;
      $scope.gsrvc = GridsterService;
      $scope.localVarsWidget.formParams={formViewType:1,showGridNavigation:true};
      $scope.fd.contractDatasets = true;
      if ($scope.formData==undefined) $scope.formData={};
      if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
      
      $scope.localVarsWidget.datasetMapperType=0;
      
      if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";
      
      $scope.localVarsWidget.openModal = function (size,template,ctrl,selectedType) {
     
         var modalInstance = $uibModal.open({
            animation: $scope.animationsEnabled,
            templateUrl: template,
            controller: ctrl,
            size: size,
            resolve: {
              selectedResourceItem: function () {
                return $scope.localVarsWidget.selectedResourceItem;
                },
              type: function () {
                return $scope.localVarsWidget.selectDatasetType;
                }
            }
         });
         modalInstance.result.then(function (selectedItem,windex,index) {
      
          if ($scope.localVarsWidget.selectDatasetType==1){
            $scope.localVarsWidget.selectedResourceItem = selectedItem;
            $scope.fd.Related =  $scope.selectedResourceItem.relatedId;
            $scope.fd.PopulateType=selectedItem.src_type_id;
            $scope.fd.ParentElementId = $scope.selectedResourceItem.parentElementId;
            $scope.fd.PresentationId = $scope.selectedResourceItem.presentationId;
            $scope.localVarsWidget.getFormResourceOriginal();
          
          }else if ($scope.localVarsWidget.selectDatasetType==2)
          {
            $scope.localVarsWidget.selectedRelatedResourceItem = selectedItem;
            $scope.fd.HasParentDataset =  $scope.selectedResourceItem.relatedId;
            $scope.fd.PopulateTypeParent=selectedItem.src_type_id;
            //$scope.fd.ParentElementId = $scope.selectedResourceItem.parentElementId;
            //$scope.fd.PresentationId = $scope.selectedResourceItem.presentationId;
          }
         
         }, function () {
        //$log.info('Modal dismissed at: ' + new Date());
         });
         
      };
     
      $scope.localVarsWidget.openModalSelectResource = function(){
        $scope.localVarsWidget.selectDatasetType  = 1;
        $scope.localVarsWidget.openModal('lg','selectResourceModal.html','SelectResourceModalCtrl',$scope.localVarsWidget.selectDatasetType);
        
      };
     
      $scope.localVarsWidget.openModalSelectRelatedResource = function(){
        $scope.localVarsWidget.selectDatasetType  = 2;
        $scope.localVarsWidget.openModal('lg','selectDatasetModal.html','SelectDatasetModalCtrl',$scope.localVarsWidget.selectDatasetType);
      };
      
     
      $scope.localVarsWidget.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
      $scope.localVarsWidget.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: []
      } ;
        
    
  
      //$scope.taskId=$stateParams.id;
      $scope.taskId=$scope.taskDefinition.ResourceDefId;
      if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.localVarsWidget.taskId=$scope.taskId;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
      $scope.localVarsWidget.formType=$scope.taskDefinition.form_type;
      $scope.source_type=$scope.taskDefinition.source_type;
      $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
      $scope.formDefinition = $scope.taskDefinition.form_definition;
        
      if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
      $scope.localVarsWidget.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
      {
        $scope.taskInitiateId =0;
      
      }
      if ($scope.taskExecuteId==undefined)
      {
         $scope.taskExecuteId =0;  
      }
        if ($scope.prevTaskExeId==undefined)
        {
            $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId'];
      //if ($scope.fd.LocalId==undefined || $scope.fd.LocalId==null || $scope.fd.LocalId==0)
      //{
         var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVarsWidget.selectedResource, output:out_fields, };
         $scope.localVarsWidget.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
         $scope.localVarsWidget.LocalId=$scope.localVarsWidget.localWidgetId;
         $scope.fd.LocalId=$scope.localVarsWidget.localWidgetId;
         //$scope.fd.LocalId=UtilityService.uuidNow();
         
      //}
      $scope.ksm = KatalyoStateManager;
      
      let update_presentation_id = function(data)
      {
         if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
      }
      if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
      {
         
         let dependent_field = $scope.fd.LocalId;
         let subscribedSubject = "formDefinitionState"+$scope.taskId+$scope.taskDefinition.form_type;
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
  
      }        
      
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               if (data != $scope.localVarsWidget.resourceRecordId)
               {
                  if (typeof data ==='number') $scope.localVarsWidget.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                     if (data.length>0)
                     {
                      $scope.localVarsWidget.resourceRecordId= data[0].id  
                     }
                  }else
                  {
                     $scope.localVarsWidget.resourceRecordId = data.id;
                  }
                  do_refresh = true;
               }
            }
            //get selectedRecord
            if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
            if ($scope.localVarsWidget.resourceRecordId>0 && do_refresh) $scope.localVarsWidget.getFormResourceWithData();
            
            
        };
        
      
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.PresentationId;
         let subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.taskDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         $scope.localVarsWidget.resourceRecordId= val.id;
            
            //get selectedRecord
         if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
         if ($scope.localVarsWidget.resourceRecordId>0) $scope.localVarsWidget.getFormResourceWithData();
      }
      
      //subscribe observer
      if ($scope.fd.PopulateType.toString().substr(0,1)=="4")
      {
           /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
        /*
        $scope.itemValue = {val:null};
        
        let valueState= $scope.ksm.addSubject('datasetValueStateName'+$scope.fd.ItemId,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        */
       
       
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "rlistValueStateName"+$scope.fd.SrcWidgetId+$scope.taskDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
      let refresh_widget_data = function()
      
      {
         $scope.localVarsWidget.getFormResourceWithData();    
         
      }
      if ($scope.fd.Parameters.EventName!=undefined)
      {
         if ($scope.fd.Parameters.EventName!="")
         {
            let dependent_field2 = "Field"+$scope.fd.PresentationId;
            let subscribedSubject2 = "task"+$scope.taskDefinition.transaction_id;
            let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,refresh_widget_data);
         }
      }
      
      $scope.localVarsWidget.showProperties=function(datasetMapperType)
      {
            
            if ($scope.localVarsWidget.datasetMapperType==undefined)
            {
               $scope.localVarsWidget.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVarsWidget.datasetMapperType==0 || $scope.localVarsWidget.datasetMapperType!=datasetMapperType) $scope.localVarsWidget.datasetMapperType = datasetMapperType;
               else $scope.localVarsWidget.datasetMapperType=0;
            }
            
      };
           
      $scope.localVarsWidget.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  
      
      $scope.localVarsWidget.getResourceAll = function () {
          
            ResourcesDataService.getResourceDefAll($scope.fd.Related).then(function(data) {
                               
                             // MessagingService.addMessage(data.msg,'success');
                              $scope.fd.resource = data.data;
                              $scope.localVarsWidget.resourceLoaded = true;
                              
                                },function(error){
                              
                              MessagingService.addMessage(error.msg,'error');  
                            });
        };
      $scope.localVarsWidget.getResourceAll();
      
       $scope.fd.loadBlockchainDataset = function (dataset) {
           
           if (dataset.DatasetId==undefined) dataset.DatasetId = {id:0}; 
           $scope.fd.selectedDataset = dataset;
           if (dataset.DatasetId.id>0) $scope.localVarsWidget.getFormResourceOriginal(dataset.DatasetId.id);
            
        };
        $scope.fd.loadBlockchainFunction = function (func)
        {
           if (func.InputDatasetId==undefined) func.DatasetId = {id:0}; 
           $scope.fd.selectedFunction = func;
           if (func.InputDatasetId.id>0) $scope.localVarsWidget.getFormResourceOriginal(func.InputDatasetId.id);
        }
        
         $scope.fd.executeBlockchainFunction = function (func)
        {
            var lang=$rootScope.globals.currentUser.lang;
              
               //$scope.localVarsWidget.formLoading=true;
              let limit =  100;
              $scope.fd.datasetLoaded=false;
              $scope.fd.gridOptions.columnDefs=[];
              if ($scope.fd.BlockChainPrimaryKey==undefined) $scope.fd.BlockChainPrimaryKey="";
              ResourcesDataService.executeBlockchainFunction($scope.fd.resource.Parameters.ContractId,$scope.fd.selectedFunction.FunctionName,$scope.formData[$scope.fd.PresentationId][0]).then(function(data) {
                  
                  MessagingService.addMessage(data.data,'success'); 

               },function(error){
                                   MessagingService.addMessage(error.msg,'error');   
         
               });
        }
      $scope.localVarsWidget.getFormResourceOriginal = function(datasetId){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              $scope.localVarsWidget.formLoaded=false;
              ResourcesDataService.getResourceForm(datasetId,"i",lang).then(function(data) {
                            
                                $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                
                                if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                           /*
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.PresentationId,'row-'+$scope.localVarsWidget.gridsterType+'-hadle',true);
                             */   
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.ResourceRecordId}]}]});
						
                                  $scope.localVarsWidget.searchFormDownloaded = true;
                                  //$timeout(function(){$scope.localVarsWidget.formLoaded=true});
                                  $scope.localVarsWidget.formLoaded=true;
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      $scope.fd.gridOptions = {
         
         showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: false,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enableColumnReordering: true,
        //useExternalPagination: false,
        paginationPageSizes: [10, 25, 50,100,200,500,1000,5000,10000],
      }
        $scope.fd.GetBlockchainDatasetRecords = function(){
              var lang=$rootScope.globals.currentUser.lang;
              
               //$scope.localVarsWidget.formLoading=true;
              let limit =  100;
              $scope.fd.datasetLoaded=false;
              $scope.fd.gridOptions.columnDefs=[];
              if ($scope.fd.BlockChainPrimaryKey==undefined) $scope.fd.BlockChainPrimaryKey="";
              ResourcesDataService.getBlockchainDatasetRecords($scope.fd.selectedDataset.DatasetId.id,$scope.fd.selectedDataset.DatasetName,$scope.fd.resource.Parameters.ContractId,limit,$scope.fd.BlockChainPrimaryKey,lang).then(function(data) {
                  
                  $scope.fd.datasetLoaded=true;
                  
                  $scope.fd.gridOptions.data = data.data.data.rows;
                  
                  //$scope.fd.gridOptions.columnDefs = data.data.columns;
                  
                  //$scope.localVarsWidget.formLoading=false;
                  
               
               },function(error){
                                   MessagingService.addMessage(error.msg,'error');   
                             });
        }
        $scope.localVarsWidget.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               $scope.localVarsWidget.formLoaded=false;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.localVarsWidget.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.localVarsWidget.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                  
                                 if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                $scope.localVarsWidget.searchFormDownloaded = true;
                                
                                $timeout(function(){    
                                   $scope.localVarsWidget.formLoaded=true;
                                   $scope.localVarsWidget.formLoading=false;
                                });
                                  
                               
                              //  $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVarsWidget.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVarsWidget.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.localVarsWidget.formLoaded=false;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }
              
              
              
              
               if ($scope.localVarsWidget.resourceRecordId==undefined || $scope.localVarsWidget.resourceRecordId==0)
               {
                
                  if ($scope.localVarsWidget.previousTaskData['datasetRecordId']!=undefined && $scope.localVarsWidget.previousTaskData['datasetRecordId']!="" && $scope.localVarsWidget.previousTaskData['datasetId']==$scope.fd.Related) $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.previousTaskData['datasetRecordId'];
                
               }
               if (typeof $scope.localVarsWidget.resourceRecordId !=='number' && typeof $scope.localVarsWidget.resourceRecordId !=='string')
               {
                  
                  if (Array.isArray($scope.localVarsWidget.resourceRecordId))
                  {
                     if ($scope.localVarsWidget.resourceRecordId.length>0)
                     {
                        $scope.localVarsWidget.resourceRecordId= $scope.localVarsWidget.resourceRecordId[0].id  
                     
                     }
                  }
                  else $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.resourceRecordId.id;                 
               }
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVarsWidget.formType,$scope.localVarsWidget.widgetType,$scope.localVarsWidget.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                 
                                  if ($scope.formData[$scope.fd.PresentationId].length>0)
                                  {
                                    $scope.localVarsWidget.resourceRecordId = $scope.formData[$scope.fd.PresentationId][0]['id'];
                                  }
                                  $scope.localVarsWidget.datasetRecordId=$scope.localVarsWidget.resourceRecordId;
                                  if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                    //$scope.fd.wItemValue=data.data.widgets;
                               
                                  // $timeout(function() {
                                     $scope.localVarsWidget.formLoaded=true;
                                    // $scope.localVarsWidget.initiateFormLoaded=true;
                                     $scope.localVarsWidget.formLoading=false;
                                     $scope.localVarsWidget.searchFormDownloaded = true;
                                      
                                  //  });   
                                  
                                   
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - VIEW_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVarsWidget.resourceRecordId}]}]});
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
           $scope.localVarsWidget.setSelectedDataset = function(id)  {
              
              if ($scope.localVarsWidget.selectedResourceItem==undefined) $scope.localVarsWidget.selectedResourceItem={};
              var pos = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVarsWidget.selectedResourceItem.id = $scope.localVarsWidget.resourceList[pos].id;
                $scope.localVarsWidget.selectedResourceItem.name = $scope.localVarsWidget.resourceList[pos].name;
                $scope.localVarsWidget.selectedDataset = $scope.localVarsWidget.resourceList[pos];
                $scope.localVarsWidget.selectedResourceItem.name_confirmed = $scope.localVarsWidget.selectedResourceItem.name +' ('+$scope.localVarsWidget.selectedResourceItem.id +')'
                $scope.localVarsWidget.selectedResourceItem_c=$scope.localVarsWidget.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.localVarsWidget.getResources = function()  {
						
            if ($scope.localVarsWidget.resourceList==undefined) $scope.localVarsWidget.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'smartcontract').then(
						function(data) {
										
											  $scope.localVarsWidget.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
   
   

$scope.localVarsWidget.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData;
      var pTaskDataRet = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
      if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0) pTaskData = pTaskDataRet[0];
            var datasetId=0,datasetRecordId=0;
            if (pTaskData!=undefined)
            {
               if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
               {
               for (var i=0;i<pTaskData.DEI.length;i++)
               {
                 if (pTaskData.DEI[i].name==linkType)
                 {
                   if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                   {
                     for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                     {
                      if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                      if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                      
                       
                     }
                        
                       
                   }
                     
                 }
                   
                 }
               }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
   
  $scope.localVarsWidget.previousTaskData=$scope.localVarsWidget.getPreviousTaskWidget("resourceLinkDatasetList");
 
          
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVarsWidget.searchFormDownloaded)
  {
    
     $scope.localVarsWidget.getFormResourceWithData();
    // $scope.localVarsWidget.getDatasets();
    // $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  }else if ($scope.fd.Related!=null)
  {
     //$scope.localVarsWidget.getFormResource();
     $scope.localVarsWidget.getResources();
     //$scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  } 

  
      //novi FILE CONNECTOR - view resource widget
      $scope.openWidgetConnector  = function(){
             $scope.localVarsWidget.showWidgetConnector= !$scope.localVarsWidget.showWidgetConnector;
             if ($scope.localVarsWidget.showWidgetConnector) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'smartcontract').then(
                                function(data) {
                                                  $scope.resourceList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.localVarsWidget.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.localVarsWidget.listOfConnectors.length;i++) {
                                                                   //var p = $scope.resourceList.map(function(e) { return e.id; }).indexOf($scope.localVarsWidget.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf($scope.localVarsWidget.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.localVarsWidget.listOfConnectors[i].parentDatasetName = $scope.resourceList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.localVarsWidget.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.localVarsWidget.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.localVarsWidget.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.localVarsWidget.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.localVarsWidget.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.localVarsWidget.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.localVarsWidget.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.localVarsWidget.listOfConnectors.length;i++) {
                                                     if ($scope.localVarsWidget.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.localVarsWidget.listOfConnectors[i].DEI.length;j++) {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.localVarsWidget.listOfConnectors[i].DEI[j].value!=false) && ($scope.localVarsWidget.listOfConnectors[i].DEI[j].value!=true) ) $scope.localVarsWidget.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                
                                                             };
                                                        newlist.push($scope.localVarsWidget.listOfConnectors[i]);
                                               }
                                }//if
							  $scope.localVarsWidget.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
			
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - VIEW
    

            $scope.localVarsWidget.okWidgetConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.localVarsWidget.listOfConnectors;
                $scope.localVarsWidget.showWidgetConnector=false;  
                
                });
            };

          $scope.localVarsWidget.cancelWidgetConnector = function () {
                $timeout(function() {
                
                $scope.localVarsWidget.showWidgetConnector=false;  
                
                });
            };

       
        $scope.localVarsWidget.processWidgetDependencies = function() { //-----                
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                              //  console.log("view "+ $scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.localVarsWidget.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.localVarsWidget.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              $scope.localVarsWidget.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:$scope.fd.linkedResourceDefId,resource_id:$scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  $scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
          $scope.localVarsWidget.formType=$scope.taskDefinition.form_type;
          TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.localVarsWidget.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                                $scope.localVarsWidget.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                              
    
            let template;
            //if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskViewResource.html');
            //else template = $templateCache.get('ktdirectivetemplates/ktTaskViewResourceExe.html');
            template = $templateCache.get('ktdirectivetemplates/ktExecuteSmartContract.html');
            $element.append($compile(template)($scope)); 

  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};
'use strict';

export function ktExecuteTaskWidget () {

        return {
            restrict: 'A',
          controller:function($scope,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$stateParams,$cookies,
                              WidgetDataExchangeService,$state,TaskDataService,MessagingService,GridsterService,$templateCache,$compile,$element){
          
           if ($scope.localVars==undefined) $scope.localVars = {};
                $scope.localVars.executeTaskDataLoaded=false;
                if ($scope.localVarsExecuteTask==undefined) $scope.localVarsExecuteTask = {};
                var lang=$rootScope.globals.currentUser.lang;
                //$scope.localVarsExecuteTask = angular.copy($scope.localVars);
                if ($scope.localVarsExecuteTask.taskDefinition==undefined) $scope.localVarsExecuteTask.taskDefinition = {};
      	
                //WidgetDataExchangeService.deRegisterAllWidgets();//MIGOR TODO - dodao ovo ali gdje je registerTASK i da li treba ovdje????
                $scope.gsrvc = GridsterService;
                
                $scope.localVarsExecuteTask.fromStateName=$stateParams.fromStateName;
                $scope.localVarsExecuteTask.fromStateParams=$stateParams.fromStateParams;
                $scope.localVarsExecuteTask.cookieFromStateName=$cookies.getObject('executeTaskFromStateName');
                $scope.localVarsExecuteTask.cookieFromStateParams=$cookies.getObject('executeTaskFromStateParams');
                $scope.localVarsExecuteTask.noBackbutton = false;
                $scope.localVarsExecuteTask.backBtnFromCookie=false;
                $scope.localVarsExecuteTask.initiateFormLoaded = false;
                $scope.localVarsExecuteTask.taskInitiateInstance=[];
                $scope.localVarsExecuteTask.taskExecuteInstance=[];
                $scope.localVarsExecuteTask.dashboard = {widgets : [],data:{}};

      
                if ($scope.localVarsExecuteTask.fromStateName==undefined || $scope.localVarsExecuteTask.fromStateName=="")
                {
                    if ($scope.localVarsExecuteTask.cookieFromStateName==undefined || $scope.localVarsExecuteTask.cookieFromStateName=="")
                    {
                      $scope.localVarsExecuteTask.noBackButton = true;
                    }else
                    {
                      $scope.localVarsExecuteTask.fromStateName =  $scope.localVarsExecuteTask.cookieFromStateName;
                      $scope.localVarsExecuteTask.backBtnFromCookie = true;
                    }
                    
                  
                }else{
                  $cookies.putObject('executeTaskFromStateName',$scope.localVarsExecuteTask.fromStateName);
                  
                }
      
                if ($scope.localVarsExecuteTask.fromStateParams==undefined)
                {
                    if ($scope.localVarsExecuteTask.cookieFromStateParams!=undefined)
                    {
                        if ($scope.localVarsExecuteTask.backBtnFromCookie)
                        {
                          $scope.localVarsExecuteTask.fromStateParams =  $scope.localVarsExecuteTask.cookieFromStateParams;
                        }
                    }
                    
                }else if ($scope.localVarsExecuteTask.cookieFromStateParams==undefined)
                {
                  $cookies.putObject('executeTaskFromStateParams',$scope.localVarsExecuteTask.fromStateParams);
                  
                }else
                {
                    if ($scope.localVarsExecuteTask.backBtnFromCookie)
                    {
                  
                      $scope.localVarsExecuteTask.fromStateParams =  $scope.localVarsExecuteTask.cookieFromStateParams;
                  
                    }else
                    {
                        $cookies.putObject('executeTaskFromStateParams',$scope.localVarsExecuteTask.fromStateParams);    
                    }
                }
      
                $scope.localVarsExecuteTask.gridsterType="task";
              //  $scope.localVarsExecuteTask.gridsterExeFormOpts = GridsterService.getGridsterOptions();
                $scope.localVarsExecuteTask.formType="e";
               
                $scope.localVarsExecuteTask.isCollapsedTaskDetails=true;
                  $scope.localVarsExecuteTask.FormLockUnlock = function()
                {
                  $scope.localVarsExecuteTask.resourceDefinition.formParams.formLocked=!$scope.localVarsExecuteTask.resourceDefinition.formParams.formLocked;
                };
                
                $scope.localVarsExecuteTask.goBack = function(){
                                    $state.go($scope.localVarsExecuteTask.fromStateName,$scope.localVarsExecuteTask.fromStateParams);
                             
                };
                
                
                $scope.localVars.setTaskExecuteData = function(inputData){
                                              
                                             $scope.localVarsExecuteTask.resourceDefinition= inputData.data.resourceDefinition;
                                             $scope.localVarsExecuteTask.dashboard.widgets.layout = inputData.data.widgets;
                                             $scope.localVarsExecuteTask.dashboard.data = inputData.data.form_data;
                                             $scope.localVarsExecuteTask.taskDefinition = inputData.data.taskdef[0];
                                             $scope.localVarsExecuteTask.taskDefinition.transaction_id = inputData.data.transactionId;
                                             $scope.localVarsExecuteTask.taskDefinition.fd = $scope.fd;
                                             $scope.localVarsExecuteTask.taskId = $scope.localVarsExecuteTask.taskDefinition.ResourceDefId_id;
                                             if ($scope.inlineTaskDefinition!=undefined) $scope.localVarsExecuteTask.taskDefinition.prev_task_id = $scope.inlineTaskDefinition.prev_task_id;
                                             
                                             $scope.localVarsExecuteTask.taskInitiateInstance = inputData.data.taskInitiateInstance;
                                             $scope.localVarsExecuteTask.taskExecuteInstance = inputData.data.taskExecuteInstance;
                                             if (!$scope.localVarsExecuteTask.OpenTaskInNewPage) $scope.localVarsExecuteTask.ShowCloseBtn=true;
                                      
                                             $scope.localVarsExecuteTask.initiateFormLoaded = true;
                                             $scope.localVarsExecuteTask.isCollapsed3 =false;
                                             $scope.localVarsExecuteTask.resourceDefinition.formParams={formLocked:true,formViewType:2};
                                             
                                                
                                             if ($scope.localVarsExecuteTask.taskExecuteInstance.length>0)
                                             {
                                                $scope.localVarsExecuteTask.taskDefinition.task_execute_id = $scope.localVarsExecuteTask.taskExecuteInstance[0].id;
                                                $scope.localVarsExecuteTask.taskDefinition.taskExecuteInstance=$scope.localVarsExecuteTask.taskExecuteInstance[0];
                                             
                                             }
                                             else
                                             {
                                              
                                              $scope.localVarsExecuteTask.taskDefinition.task_execute_id = 0;
                                             }
                                             
                                             if ($scope.localVarsExecuteTask.taskInitiateInstance.length>0)
                                             {
                                                $scope.localVarsExecuteTask.taskDefinition.task_initiate_id = $scope.localVarsExecuteTask.taskInitiateInstance[0].id;
                                                $scope.localVarsExecuteTask.taskDefinition.taskInitiateInstance=$scope.localVarsExecuteTask.taskInitiateInstance[0];
                                             
                                             }
                                             else
                                             {
                                              $scope.localVarsExecuteTask.taskDefinition.task_initiate_id = 0;
                                              
                                             }
                                             $scope.localVarsExecuteTask.taskDefinition.form_type="e";
                                            
                                            if ($scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id==undefined || $scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id==null)
                                            {
                                              $scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id = 0;
                                              
                                            }
                                            
                                             $scope.$on('ExecuteTaskPostProcess'+ $scope.localVarsExecuteTask.taskDefinition.task_execute_id,function(event,data1){
                                                $scope.localVars.getTaskExecuteData($scope.localVarsExecuteTask.taskDefinition.task_initiate_id,$scope.localVarsExecuteTask.taskDefinition.task_execute_id);
                                            });
                                            $scope.$on('InlineTaskClosed',function(event,data){
                                                if (data==$scope.localVarsExecuteTask.taskId) $scope.localVars.executeTaskDataLoaded=false;
                                            });
                  
                   
                                            $scope.$on('RefreshData'+ $scope.localVarsExecuteTask.taskDefinition.task_execute_id,function(event,data2){
                                              
                                               $scope.localVars.getTaskExecuteData($scope.localVarsExecuteTask.taskDefinition.task_initiate_id,$scope.localVarsExecuteTask.taskDefinition.task_execute_id,data2);
                                            });
                                            
                                            /*
                                            $scope.$on('ExecuteTask'+$scope.localVarsExecuteTask.task_execute_id,function(event,data){
                                                $scope.localVars.ExecuteTask(data.form,data.outcomeId);
                                            });
                                              */                            
                                            TaskDataService.GetTaskOutcomes($scope.localVarsExecuteTask.taskDefinition.ResourceDefId_id,$scope.localVarsExecuteTask.taskDefinition.TaskOutcomeHeadId_id,lang).then(function(data3) {            
                                              
                                                $scope.localVarsExecuteTask.taskOutcomes = data3.data;
                                                    
                                                   
                                                $scope.localVars.executeTaskDataLoaded=true;
                                              
                                             
                                            
                                              },function(error){
                                          
                                                  MessagingService.addMessage(error.msg,'error');
                                              });
                }
      
                $scope.localVars.getTaskExecuteData = function(initiate_id,execute_id,inData){
                      var lang=$rootScope.globals.currentUser.lang;
                     
                        $scope.localVarsExecuteTask.task_initiate_id = initiate_id;
                      
                        
                        $scope.localVarsExecuteTask.task_execute_id = execute_id;
                        $scope.localVars.executeTaskDataLoaded=false;                       
                      TaskDataService.preExecuteTask(initiate_id,execute_id,lang).then(function(data) {
                                             
                                                                        
                                      $scope.localVars.setTaskExecuteData(data);       
                          
                                        },function(error){
                                          
                                      
                                            MessagingService.addMessage(error.msg,'error');
                                      });
                   
                 };
                $scope.localVars.ExecuteTaskAction = function(action){
                     
                     
                        var lang=$rootScope.globals.currentUser.lang;
                      
                       TaskDataService.ExecuteTaskAction($scope.localVarsExecuteTask.task_initiate_id,$scope.localVarsExecuteTask.task_execute_id,action,lang).then(function(data) {
                 
                                             
                                              $scope.localVarsExecuteTask.taskInitiateInstance =data.data.data.taskInitiateInstance;
                                              $scope.localVarsExecuteTask.taskExecuteInstance =data.data.data.taskExecuteInstance;
                                              if ($scope.localVarsExecuteTask.taskExecuteInstance!=undefined)
                                                {
                                                $scope.localVarsExecuteTask.taskDefinition.task_execute_id = $scope.localVarsExecuteTask.taskExecuteInstance.id;
                                             
                                                }
                                                
                                              if (action=="claim")
                                              
                                              {
                                                $scope.localVars.pageChanged();
                                                $scope.localVarsExecuteTask.enableActions=true;
                                                $rootScope.$broadcast('RefreshData0',data.data.ret_value);
                                                
                                              }
                                              
                                              MessagingService.addMessage(data.data.msg,'success');
                                             
               
                                        },function(error){
                                          
                                      
                                            MessagingService.addMessage(error.msg,'error');
                                      });
                }
                
                
      
                $scope.localVars.ExecuteTask = function(form,outcomeId){
                        
                        
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      if (form.$submitted) $scope.localVars.setSubmitted(form);
                      if (form.$valid) {
                      
                      
                          TaskDataService.executeTask($scope.localVarsExecuteTask.task_execute_id,$scope.localVarsExecuteTask.dashboard.data,outcomeId,lang).then(function(data) {
                                      
                                  MessagingService.addMessage(data.data.msg,'success');
                                  $rootScope.$broadcast('ExecuteTaskPostProcess',data.data.ret_value);
                          },function(error){
                                  
                                  MessagingService.addMessage(error.msg,'error');           
                                            
                          });
                          
                    } // if (isValid)
                    else
                    {
                      MessagingService.addMessage("Please enter required data",'warning');
                      
                    }
                }; 
     
            $scope.localVars.setSubmitted = function (form) {
               form.$setSubmitted();
               angular.forEach(form, function(item) {
               if(item && item.$$parentForm === form && item.$setSubmitted) {
                   $scope.localVars.setSubmitted(item);
               }
           });
       }; 
         
          let template;
                        if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktExecuteTaskWidget.html');
                        else template = $templateCache.get('ktdirectivetemplates/ktExecuteTaskWidgetExe.html');
                      
                        $element.append($compile(template)($scope));  
          
          
          },
             link: function (scope, elem, attrs) {
                 
                 
               
 
    
    
                  
              }
        }             
};
'use strict';

export function ktFieldExtendedProperties () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktFieldExtendedProperties.html',
             controller: function($scope,CodesService,ResourcesDataService,$rootScope,ProcessingService){
                
                },
             link: function (scope, elem, attrs) {
                
                
              
                
              }
        }
  
};
'use strict';

export function ktFile () {
        return {
            restrict: 'A', 
			controller: function ($scope, $rootScope,$element,ResourcesDataService,ProcessingService,$timeout,MessagingService,CODES_CONST,GridsterService,WidgetDataExchangeService,KatalyoStateManager) {
	
        
        $scope.gsrvc = GridsterService;
        $scope.org_id = $rootScope.globals.currentUser.organisation.id;
        if ($scope.localVars==undefined) $scope.localVars={};        
        if ($scope.formData == undefined) $scope.formData=[{}];
        if ($scope.formData.length == 0) $scope.formData.push({});
        let newValueSingle,newValueMultiple;
        $scope.ctrl = this;
        
        if ($scope.fd.PresentationType==1)
        {
                $scope.setDropdownValue=function(theSelectItemFn)
                {
                        $scope.setItemValueDropdown = theSelectItemFn;
                
                }
                 $scope.setLoadDropdown = function(directiveFn) {
                        $scope.loadDropdown = directiveFn;
            
                };
                $scope.setClearDropdown = function(directiveFn) {
                        $scope.clearDropdown = directiveFn;
                }
        }
        
       
        var widgetDefinition = {DEI: [{'name':'resourceLinkFile','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'datasetListWidget',widgetId: $scope.fd.PresentationId,taskId:  $scope.lTaskId,
                                resourceDefId : $scope.fd.Related, //resourceDefId : $scope.selectedResource
                                resourceRecordId:$scope.localVars.resourceRecordId,task_initiate_id:$scope.taskDefinition.task_initiate_id,task_execute_id:$scope.taskDefinition.task_execute_id, output:null };
        $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        
        $scope.ksm = KatalyoStateManager;
        
        $scope.populateValue = function(newValue)
        {
                if ($scope.fd.MaxLength!=1)
                {
                 newValueMultiple = newValue;
                 newValueSingle="";
                }
                else
                {
                 newValueMultiple = [];
                 newValueSingle=newValue;
                }
               
                $scope.itemValue.val = newValue;
                if ($scope.fd.PresentationType==1 && $scope.setItemValueDropdown!=undefined) $scope.setItemValueDropdown(null,$scope.itemValue.val);
                $scope.formData[0]['Field'+$scope.fd.ItemId] = $scope.itemValue.val;
                $scope.fd.Search.value = $scope.formData[0]['Field'+$scope.fd.ItemId];
                $scope.ksm.executeAction(valueStateName,"valueChanged", newValue);
                if (newValue && $scope.setItemValueDropdown!=undefined) $scope.setItemValueDropdown(null,newValue);
                else if ($scope.clearDropdown!=undefined) $scope.clearDropdown();
                WidgetDataExchangeService.setData({
                    DEI: [{name:'resourceLinkFile',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:newValueSingle}
                        ,{name:'resourceRecordIds',value:newValueMultiple},{name:'resourceRecordsAll',value:$scope.fd.datasetItems}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});   
                
        }
      
      /*  
         $scope.setDropdownValue = function(fnSetValue) {
            $scope.setDropdown = fnSetValue;
        };
        */
         /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
       
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
        $scope.itemValue = {val:null};
        
        let valueState= $scope.ksm.addSubject($scope.fd.ElementType+'ValueStateName'+$scope.fd.ItemId+$scope.taskDefinition.transaction_id,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        
        let apply_value = function(data)
        {
            let local_data;        
            if ($scope.itemValue.val!=data)
            {
                local_data = data;
                if ($scope.fd.Parameters.DependentFieldFilter!=undefined)
                {
                        if ($scope.fd.Parameters.DependentFieldFilter!="" || $scope.fd.Parameters.DependentFieldElement!="")
                        {
                                if (Array.isArray(data))
                                {
                                        if (data.length>0) local_data = data[0];
                                        else local_data = null;
                                        
                                }
                                else
                                {
                                     local_data = data;
                                }
                                if ($scope.fd.datasetItems==undefined)
                                {
                                        $scope.fd.refreshDatasetDataList("",true,local_data);
                                        local_data=null;
                                }
                                else
                                {
                                        let element1,element2;
                                        if ($scope.fd.Parameters.DependentFieldFilter!="")
                                        {
                                                element1 = $scope.fd.Parameters.DependentFieldFilter;
                                                element2 = "id";
                                        }
                                        else
                                        {
                                                element1 = "id";
                                                element2 = $scope.fd.Parameters.DependentFieldElement;
                                        }
                                        let pos = $scope.fd.datasetItems.map(function(e) { return e[element1]; }).indexOf(local_data[element2]);

                                        if (pos>=0) local_data = $scope.fd.datasetItems[pos];
                                        else local_data = null;
                                }
                        }
                }
                $scope.populateValue(local_data);
            }
        }; 
       
        if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
        
        {
            if ($scope.fd.Parameters.DependentFieldId!="")
            {
                let dependent_field = "Field"+$scope.fd.ItemId;
                let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId+$scope.taskDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value,true);
                let val = $scope.ksm.getState(subscribedSubject);
                $scope.populateValue(val.state);
            }
        }
        
          /************ Get selected records for dropdown **************/
        $scope.fd.getDatasetList = function()
        {
                if ($scope.formData[0]['Field'+$scope.fd.ItemId+'l']!=undefined && $scope.formData[0]['Field'+$scope.fd.ItemId+'l'].length>0 && $scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined)
                {
                  ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,{'id__in': $scope.formData[0]['Field'+$scope.fd.ItemId+'l']}).then(function(data) {
                             
                             if ($scope.formData===undefined) $scope.formData = [{}];
                             if ($scope.fd.MaxLength==1) $scope.formData[0]['Field'+$scope.fd.ItemId] = data.data[0];
                             else $scope.formData[0]['Field'+$scope.fd.ItemId] = data.data;
                             $scope.populateValue($scope.formData[0]['Field'+$scope.fd.ItemId]);
                             WidgetDataExchangeService.setSearch($scope.fd.PresentationId,$scope.taskExecuteId);
                             //$scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0]['Field'+$scope.fd.ItemId]);
                             //$scope.itemValue.val = $scope.formData[0]['Field'+$scope.fd.ItemId];
                      },function(error){    
                      MessagingService.addMessage(error.msg,'error');
                  });
                }
        }
        
      
      
        $scope.$watch('itemValue.val',function(newValue,oldValue){
                if (newValue!=oldValue)
                {
                        $scope.populateValue(newValue);    
                
                }
        });
        
        
        $scope.search=[
                            {id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
                            {id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                      ];
				
        if ($scope.fd!=undefined) {
                  if ($scope.fd.Search==undefined)
                  {
                    $scope.fd.Search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                  }
        } 

			  $scope.applySearchFilters = function(index) {
                   
				  $scope.fd.Search=$scope.search[index];
                            $scope.fd.Search.value = [ $scope.formData[0]['Field'+$scope.fd.ItemId] ];
                            $scope.fd.isOpen=false;		
			  };
       
       
        $scope.src_type_text=CODES_CONST._POPULATE_TYPE_  
      
        
        var lang = $rootScope.globals.currentUser.lang;
        
        $scope.localVars.isResourceSelected = false;
 
				$scope.localVars.selectedDataRecord=false;
 
				$scope.taskId=0;
       
        			   
					   
	$scope.fd.gridOptionsFile = {
                data:[],
                showGridFooter: false,
                showColumnFooter: false,
                enableRowSelection: true,
                multiSelect: false,
                enableHorizontalScrollbar : true, 
                enableVerticalScrollbar : true,
                enableRowHeaderSelection: false, //false
                showHeader:true,
                enableColumnResizing: true,
                autoResize:true,
                minRowsToShow: 4,
                displayselectionCheckbox:false,
                enableGridMenu: true,
        }
					   
        $scope.fd.RelationshipType = $scope.fd.MaxLength;
     
						
         
           $scope.colLength=[];
           for (var i=0;i<24;i++) $scope.colLength.push('col-'+(i+1));
          
        // $scope.fd.showSearchForm = false;
        
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        if ($scope.taskDefinition!=undefined)
        {
          $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
          $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
          $scope.formType=$scope.taskDefinition.form_type;
          $scope.source_type=$scope.taskDefinition.source_type;
          $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
          $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
          $scope.formDefinition = $scope.taskDefinition.form_definition;
          
         
        
        }
        
         $scope.fd.gridsterType = "resource";
          
          $scope.localVars.resourceDashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: [],
          data:{}
				} ;
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.fd.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        if ($scope.fd.PresentationType==null)
        {
              $scope.fd.PresentationType = 1;
        }
            
          $scope.fd.tItemValue = $scope.fd.FormDef;
          if (typeof $scope.fd.tItemValue=="string") $scope.fd.tItemValue=[]; 
          $scope.fd.resourcesList=[];
          $scope.fd.resourceListLength=0;
          $scope.fd.selectedFile = 0;
          //$scope.fd.selectedFileDropdown = 0;
          //if ($scope.fd.Related!=null) $scope.fd.selectedFile = $scope.fd.Related;
					
          
          
           $scope.setItemFn = function(directiveFn) {
            $scope.SetFileId = directiveFn;
            
        };
          //*********************************************************************************************
          //************************************ GET DATASET LIST ***************************************
					//*********************************************************************************************
       $scope.fd.getResources = function(search)  {
						var lang=$rootScope.globals.currentUser.lang;
              ResourcesDataService.getResourceDefListByTypeFilter(lang,'file',search,$scope.fd.selectedFile).then(
			function(data) {
										
       			$scope.fd.resourcesList = data.data;
                            
                            if (!Array.isArray($scope.fd.resourcesList))   $scope.fd.resourcesList=[];            
                        
                            if ($scope.fd.Related!=null)
                            {
                                   $scope.fd.resourceId = $scope.fd.Related;
                                   $scope.fd.resourceListLength = $scope.fd.resourcesList.length;
                                   //select dataset from dropdown
                                    var pos = $scope.fd.resourcesList.map(function(e) { return e.id; }).indexOf($scope.fd.resourceId);

                                   if (pos>=0){
                                       $scope.fd.selectedResource=$scope.fd.resourcesList[pos];
                                      
                                       $scope.fd.isResourceSelected=true;
                                       $scope.localVars.pickButtonLabel="Choose "+$scope.fd.selectedResource.name+" record...";
                                       //$scope.fd.onSelectCallback()
                                   }
                         
                            }
                             $scope.fd.RelatedLoaded=true;
											 
                     },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
       };	  
          
          
          
				  $scope.fd.getResources();
				  $scope.fd.resourceDataRecordSelected=false;
				  
         
	
 
                $scope.fd.gridOptionsFile.onRegisterApi = function (gridApi) {
                        
                        $scope.fd.gridApiFile = gridApi;
                     
                        if ($scope.fd.resGridState) $scope.fd.gridApiFile.saveState.restore($scope,$scope.fd.GridState);
                        gridApi.selection.on.rowSelectionChanged($scope,function(row){
                             
                                $scope.fd.fileSelected=row.isSelected;
                                $scope.fd.SelectedFile = row.entity;

                        });
                };
        
        $scope.fd.rowSelectionChanged = function(row){
                             
                                $scope.fd.fileSelected=row.isSelected;
                                $scope.fd.SelectedFile = row;

        };
               
           $scope.fd.getResourceDataRefresh = function (retValue) 
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
              ResourcesDataService.getResourceDataWithRelated($scope.parentDatasetDefId,$scope.resourceId,$scope.datasetRecordId,$scope.taskId,$scope.fd.ItemId,lang).then(function(data) {
                            $scope.formData[0]['Field'+$scope.fd.ItemId] = data.m2m; 
                            $scope.setupGrid(data);                
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
									});
                      
            }
            
            $scope.linkedWidgetId = 0;
            
            if ($scope.fd.Search!=undefined) $scope.linkedWidgetId = $scope.fd.Search.WidgetId;
            
            var refresh_list_from_callback=function(data)
            {
                $scope.fd.refreshDatasetDataList("",true,$scope.lData);
                
            }
              
        $scope.fd.downloadFile = function(fileId,fileName){
                ResourcesDataService.downloadFile(fileId,$scope.fd.Related).then(function(data) {
                       
                            MessagingService.addMessage('File downloaded','info');
                            var url = URL.createObjectURL(new Blob([data.data]));
                            $scope.fd.DownloadedImageUrl = url;
                            var a = document.createElement('a');
                            a.href = url;
                            a.download = fileName;
                            a.target = '_blank';
                            a.click();
                        },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                         
                        
                     });
        };// dowload file END


        $scope.fd.previewFile = function(fileId,fileType){
                      
                ResourcesDataService.downloadFile(fileId,$scope.fd.Related).then(function(data) {
                         
                              var url = URL.createObjectURL(new Blob([data.data],{type:fileType}));
                              $scope.fd.DownloadedImageUrl = url;
                              window.open(url,"_blank");
                            
                          },function(error){    
                          MessagingService.addMessage(error.msg,'error');
                           
                          
                });
        };// preview file END
      
            $scope.fd.refreshDatasetDataList = function(search,apply,val)
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
              $scope.lData = val;
               if ($scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined)
                {
                        var ctrl = this;
                        this.l_apply = apply;
                        this.l_val = val;
                        let fromCache=true;
                   //ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,search).then(function(data) {
                   ResourcesDataService.getResourceDataListAll($scope.fd.Related,$scope.fd.PresentationId,lang,fromCache,refresh_list_from_callback).then(function(data) {
                   
                           $scope.fd.datasetItems = data.data;
                           $timeout(function(){
                                //if (!$scope.fd.ReadOnly) $scope.loadDropdown($scope.fd.datasetItems);
                                if (ctrl.l_apply) apply_value(ctrl.l_val);
                           });
                    },function(error){    
                    MessagingService.addMessage(error.msg,'error');
									});
              
                }
            };
           
          
          
          
          $scope.fd.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.fd.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.formType,$scope.fd.PresentationId,"n",lang).then(function(data) {
                               
                                  $scope.fd.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.fd.resourceDashboard.widgets =  data.data.widgets;
                                   $scope.fd.selectedResourceItem = {'name':$scope.fd.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related,'presentationId':$scope.fd.PresentationId,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                               
                              
                                $scope.fd.fItemValue=data.data.widgets;
                               
                                
                                 // $scope.pickResourceData();
                                 
                                   $timeout(function() {
                                      $scope.fd.formLoaded=true;
                                      $scope.fd.formLoading=false;
                                       $scope.fd.searchFormDownloaded = true;
                                      /*  if  ($scope.fd.autoSearch)
                                        {
                                          $scope.getResourceDataFiltered();
                                          
                                        }*/
                                  });
                                   
                                  
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.formLoading=false;
                                 
                                
                             });
                              
          };
            
      
         //**********************************************************
         //           GET FORM FIELDS Files
         //**********************************************************      
            
          $scope.fd.getFormFields = function(){
              
              
              var lang=$rootScope.globals.currentUser.lang;
           
                         
              ResourcesDataService.getFormFields($scope.fd.Related,lang).then(function(data) {
                               
                                  $scope.fd.presentationElements= data.data;
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
                              
          };
      
        $scope.fd.setupGrid= function(data)
        {
              $scope.fd.gridOptionsFile.columnDefs = data.columnsDef;
              
              $timeout(function(){
                $scope.fd.restoreGridState();
               
               });
              
              
        }
            
              $scope.fd.setupGridNew= function(data)
              {
                $scope.fd.gridOptionsFile.data = data.data;
                $scope.fd.gridOptionsFile.columnDefs = data.columnsDef;
                $scope.showGrid=true;
              
              }
              
              $timeout(function(){
                $scope.fd.restoreGridState();
               
               });
              
              
            
            //  Popuni listu gridOptions.data sa listom svih resursa odabranog tipa
						
            
        $scope.fd.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.fd.selectedResource==null) {
            $scope.fd.selectedResourceId = $scope.fd.Related;
          }else
          {
             $scope.fd.selectedResourceId = $scope.fd.selectedResource.id;
            
          }
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.Related,lang,$scope.filter).then(function(data) {//MIGOR
                ResourcesDataService.getResourceDataFiltered($scope.fd.selectedResourceId,$scope.taskId,lang,$scope.fd.resourceDashboard.widgets).then(function(data) {//MIGOR
                            
                            $scope.fd.setupGrid(data);
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        }
		
						
             
        $scope.fd.getResourceData = function () 
	{
                // $scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+$scope.resourceId);
                 var lang = $rootScope.globals.currentUser.lang;
                 ResourcesDataService.getResourceData($scope.resourceId,$scope.taskId,lang).then(function(data) {
                                                 
                                                                $scope.fd.setupGridNew(data);
        
                },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                });
	};
                
     //**********************************************************
     //           GET DATASET DIRECT FILTER
     //**********************************************************      
      $scope.fd.getDatasetDirect = function (relatedDatasetId,items) {
        
        let items_ids=[];
        for (let i=0;i<items.length;i++)
        {
                items_ids.push(items[i].ResourceRelatedId);
        }
        ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,0,"i",lang,{id__in: items_ids}).then(function(data) {
                                
                                    $scope.fd.setupGridNew(data);
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
                
             	 $scope.fd.saveGridState= function() {
                    var state = $scope.fd.gridApiFile.saveState.save();
                   $scope.fd.GridState = state;
                  MessagingService.addMessage("To make changes stick please save form",'info');
      
                  }
  
              $scope.fd.restoreGridState= function() {
                   if ($scope.fd.GridState!=null)
                   {
                      if ($scope.fd.gridApiFile!=undefined)
                      {
                     
                       $scope.fd.gridApiFile.saveState.restore($scope,$scope.fd.GridState);
                       
                      }else
                      {
                      
                           $scope.fd.resGridState = true;
                      }
                   }
                 }
            
            // Resource is selected
              $scope.fd.onSelectCallback = function (item, model){
                var eventResultId=item.id;
                $scope.fd.eventResultName=item.name;
                $scope.fd.pickButtonLabel="Choose "+$scope.fd.eventResultName+" record...";
						 
                //console.log("onSelectCallback :" +  $scope.eventResultName+ ' ' + eventResultId);

                 $scope.fd.resourceId=eventResultId;
                 $scope.fd.isResourceSelected=true;
					
               	$scope.fd.Related=$scope.fd.resourceId;
                if ($scope.fd.Related!=undefined && $scope.fd.Related!=null) $scope.fd.getFormFields();
              }
              
              
              $scope.fd.onSelectSearchForm= function (item, model){
               
               if ($scope.fd.Search==undefined) $scope.fd['search']={taskId:item};
               else $scope.fd.Search.taskId = item;
                //$scope.fd.Search.widgetId=0; //ovo treba na serveru dohvatiti widgetId
                
                
              } 
            //ako ima odabranih dohvati ih i setupiraj
            if (($scope.formData!=undefined && $scope.formData.length>0))
            {
                if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=undefined){
                   if ($scope.fd.PresentationType==0)
                  {
                    $scope.fd.getDatasetDirect($scope.fd.Related,$scope.formData[0]['Field'+$scope.fd.ItemId]);
                  }
                  else
                  {
                   if  ($scope.fd.OverrideType!="f") $scope.fd.getDatasetList();
                  }
                } else if ($scope.fd.PresentationType==0 && $scope.formParams.formViewType==1)
                {
                if ($scope.formParamsParent != undefined)
                if  ($scope.formParamsParent.formViewType!=2) $scope.fd.getDatasetDirect($scope.fd.Related,{});
                }
            }else if ($scope.fd.PresentationType==0 && $scope.formParams.formViewType==1)
            
            {
                if ($scope.formParamsParent != undefined)
                if  ($scope.formParamsParent.formViewType!=2) $scope.fd.getDatasetDirect($scope.fd.Related,{});
            }
          if ($scope.fd.Related!=undefined && $scope.fd.Related!=null) $scope.fd.getFormFields();
          
				},//...controller
				
            templateUrl: 'ktdirectivetemplates/ktFile.html',
            link: function (scope, elem, attrs) {
				  
          
          
            }
    
    }
};
'use strict';

export function ktFileUpload($timeout,WidgetDataExchangeService,ResourcesDataService,TaskDataService) {
        return {
        restrict: 'A', 
             templateUrl: 'ktdirectivetemplates/ktFileUpload.html',
             controller: function ($scope, $element,$rootScope,$uibModal,MessagingService,ProcessingService,$log,GridsterService,$timeout,$cookies,$stateParams) {

                //console.log("U kontroleru");
                $scope.gsrvc = GridsterService;
                $scope.fd.ReadOnly=false;
                $scope.animationsEnabled = true;
                $scope.showFileMetaData=false;
                $scope.taskId=$scope.taskDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;  
                if ($scope.localVars==undefined)  $scope.localVars = {datasetMapperType:0};
                $scope.fd.files = [];              
                $scope.localVars.showProperties=function(datasetMapperType)
                {
                 
                 if ($scope.localVars.datasetMapperType==undefined)
                 {
                    $scope.localVars.datasetMapperType = datasetMapperType;
                 }else
                 {
                    if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                    else $scope.localVars.datasetMapperType=0;
                 }
                 
                };
            
            
             $scope.localVars.okFileConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.fd.listOfConnectors;
                $scope.localVars.showProperties(0);
                
                });
            };
            
             $scope.localVars.cancelFileConnector = function () {
                $timeout(function() {
                $scope.fd.listOfConnectors=angular.copy($scope.fd.tItemValue);
                $scope.localVars.showProperties(0);
                
                });
            };

            
		  $scope.okModal = function (windex,index) {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };

		  $scope.cancelModal = function () {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };
		  
       
        
		 $scope.showMetadata = function(fileIndex,fileId){ 
		 
				   var lang=$rootScope.globals.currentUser.lang;
				   var file_resource_type = "file";
				    $scope.taskId=$stateParams.id;
				   
				    //ResourcesDataService.getResourceFormextended(id resursa ,task-id, i, $scope.fd.presentationId,lang)
					
				   ResourcesDataService.getResourceForm(fileId,"i",lang).then(function(data) {
                               
                                 var sc=$scope;
                                  //$scope.gridOptions.data = data.data;
								  //$scope.fd.files[fileIndex].dashboard=[];
								  $scope.fd.files[fileIndex].dashboard=data.data;
								  //files[$index].dashboard.widgets
								  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
						});
                            
		

			  };
     
           
			// OPEN MODAL filehelper
			 $scope.openModal = function (size,fileIndex) {
                  var modalInstance = $uibModal.open({
                  animation: $scope.animationsEnabled,
                  templateUrl: 'filehelper.html',
                  controller: 'FileModalInstanceCtrl',
                  size: size,
                  resolve: {
                    retValue: function () {
                      return {resourceId:$scope.resourceId,fileIndex:fileIndex,files:$scope.fd.files,headline:'Enter file metadata'};
                    }
                  }
            });
			
			
            modalInstance.result.then(function (retValue,windex,index) {
             // $scope.getResourceForm ();
             
         
          }, function () {
          //$log.info('Modal dismissed at: ' + new Date());
          });
       
		};
        
      
      //novi FILE CONNECTOR - UPLOADER
      $scope.localVars.openFileConnector  = function(){
             //$scope.fd.showFileConnector= !$scope.fd.showFileConnector;
            $scope.localVars.showProperties(1);
             if ($scope.localVars.datasetMapperType==1) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                                function(data) {
                                                  $scope.datasetList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.fd.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                                   //var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.fd.listOfConnectors[i].parentDatasetName = $scope.datasetList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.fd.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.fd.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.fd.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.fd.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.fd.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.fd.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                     if ($scope.fd.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.fd.listOfConnectors[i].DEI.length;j++) {
                                                             if ($scope.fd.listOfConnectors[i].DEI[j].name=='resourceLink') {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.fd.listOfConnectors[i].DEI[j].value!=false) && ($scope.fd.listOfConnectors[i].DEI[j].value!=true) ) $scope.fd.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                 newlist.push($scope.fd.listOfConnectors[i]);
                                                             };						 						  						   					      
                                                    }
                                               }
                                }//if
							  $scope.fd.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
							  //return {selectedItemFromServer:$scope.fd.tItemValue,listOfConnectors: $scope.fd.listOfConnectors,headline:'Choose required interfaces',selectedFileConnector:$scope.selectedFileConnector};
						
				  
				/* interfaceModal.result.then(function (selectedItem) { 
							//$scope.fd.tItemValue=selectedItem; // //MIGOR TODO vidjet da li treba angular.copy(selectedItem);
                            $scope.fd.tItemValue=angular.copy(selectedItem); // MIGOR TODO - TEST SA ANGULAR COPY
                            
                            
							// MIGOR  TODO -
							//selektirani widget ima "resourceID" interface" -  registriramo se na njegov "event"
							
							$scope.$on('resourceId:'+selectedItem,
								function(event, data){
									console.log('resourceID uhvacen u ktUploader! data:' +  data);
							})
							
							//$scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredInterfaces(selectedItem); 
							
							
				}*/
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - UPLOADER
                    
      
					
				 	// FUNCTION ONSELECT CALLBACK II
					$scope.onSelectCallback2 = function (item, model,fileIndex){
						var eventResultId=item.id;
						$scope.eventResultName=item.Name;
						
						 //console.log("onSelectCallback II:" +  $scope.eventResultName+ ' ' + eventResultId);

						  $scope.resourceId=eventResultId;
						  $scope.isResourceSelected=true;
						 	
								$scope.fd.filetype=$scope.resourceId; 						
					}//onSelectCallback II
				 
				 
				 
				 
					// FUNCTION - ON_SELECT_FILETYPE 
					// NAKON TO SE ZA POJEDINAÈNI FILE ODABERE FILE-TYPE  --> $scope.resourceId
					
					$scope.onSelectFileType = function (item,fileIndex){
						var selectedFileTypeId=item.id;
						$scope.resourceId=selectedFileTypeId;
						 $scope.isResourceSelected=true;
			             if ($scope.fd.files[fileIndex].fileResourceID!=selectedFileTypeId) {
			              $scope.fd.files[fileIndex].fileResourceID = selectedFileTypeId;
			              $scope.fd.files[fileIndex].formLoaded = false;
			             }
					
					
						 
						console.log("onSelectFileType :" + selectedFileTypeId);
		
						$scope.fileIndex=fileIndex;
						
								//if ($scope.fd.files[fileIndex].fileResourceID== undefined) {
								//	$scope.getResourceForm ();
								//	}
									
								//if ($scope.resourceId != undefined) {	
									//$scope.getResourceForm ();
								//}
						 		
						//$scope.fd.related=$scope.resourceId; // ovo viska??? MIGOR
						
						$scope.showMetadata(fileIndex,$scope.fd.files[fileIndex].fileResourceID );
						
						var err=$scope.testRules();
				
					}//onSelectFileType
				 
				 
				    
				var lang = $rootScope.globals.currentUser.lang;
				var type="file"; // PROMJENITI - ZASAD JE HARD-CODED !!!!! MIGOR
					 
					 
					// poziva se iz ktUploader.html
					$scope.remove = function (index) {
						
						$scope.fd.MetaData.splice(index,1);
						$scope.isOpen=true;
						var err=$scope.testRules();	
					}
					 
					 
			// POPUNI LISTU  lIST OF FILE TYPES
            ResourcesDataService.getResourceDefByType(lang,type).then(
						function(data) {
											  $scope.listOfFileTypes = data.data;
											 
							},function(error){
											 MessagingService.addMessage(error.msg,'error');
							
						});
                	            
            
	
      
     
			 },// controler_ktUploader_END
			

			//  ***************************************************  KT- UPLOADER   LINK FUNKCIJA *****************************
			require: '^form', // MIGOR  - NOVO DODAO 
			link: function (scope, elem, attrs,formCtrl) { //MIGOR NOVO
                        
                        
                                
                                //console.log("U post-link");
		  
                                //var element = elem[0].getElementsByClassName('fileElement');
                                 //scope.fd.uiUploader = uiUploader;
                                 //scope.fd.uiUploader.createUploader(scope.fd.PresentationId);
                                
                                				
                                //MIGOR TODO - prilagoditi widgetdefinition za uploader da salje i povezani related dataset
                                var out_fields = ['resourceId'];
                                var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.LocalId,widgetId: scope.fd.PresentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
                                //var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':false}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.localId,widgetId: scope.fd.presentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
		  
                                scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition); //zamijeniti gdje se sve pojavljujue i staviti LOCAL TODO
                                scope.fd.LocalId=scope.localWidgetId;         
      
                               // scope.fd.uiUploader.removeAll(scope.fd.PresentationId); //MIGOR TEMP- TREBA nekako obrisati inicijalne fajlove kod reigstracija ali ovdje ne radi !!!
                                //console.log(element.files);

                      /*
                                var element = elem[0].getElementsByClassName('fileElement');
            
                                element[0].addEventListener('change', function(e) {
                
                                        $timeout(function() {
                                                var files = e.target.files;
                                                scope.fd.uiUploader.addFiles(files,scope.fd.PresentationId);				
                                                scope.fd.files =scope.fd.uiUploader.getFiles(scope.fd.PresentationId);  
                          
                                                var err=scope.testRules();
                                        });
                                });    
    	
                                */
        var fileCounter = 0;
			//scope.rules=[];
			if (scope.fd.MetaData==undefined)  scope.fd.MetaData=[];        
			scope.rules =  scope.fd.MetaData;
				
				// ADD RULE DEFINITION - poziva se iz ktUploader.html
				scope.addRuleDefinition=function(name,min,max,minTotal){
					
					if (min==undefined) min=0;			
					
					for (var i=1, l=scope.rules.length; i<l; i++) 
								if (scope.rules[i].name==name) name='';
							
					if (name!=undefined && name != '') {
						scope.rules.push({'name':name,'min':min,'max':max});
						//scope.rules.minTotal=minTotal;	
					}
				}
            
                scope.btn_remove = function(index,file) {
                                
                        //$log.info('deleting=' + file);
                        //var s=scope;
                        //var f=formCtrl;
                       // scope.fd.uiUploader.removeFile(file,scope.fd.PresentationId);
                        scope.fd.files.splice(index,1);
                        var err=scope.testRules();
                                
                };      
			

                scope.btn_clean = function() {
                   //scope.fd.uiUploader.removeAll(scope.fd.PresentationId);
                   scope.fd.files.length = 0;

                };


        scope.testRules = function(){
					
                var errMsg=null;
                for (var i=1; i < scope.rules.length; i++) { //search rules
                        var filesFound=0;
                        for(var j = 0; j < scope.fd.files.length; j++ ) {//search files
                                if (scope.fd.files[j].fileResourceID == scope.rules[i].name) filesFound=filesFound+1;
                        }
                        
                        if (filesFound < scope.rules[i].min) {formCtrl.uploaderForm.$setValidity('Not enough file types', false);
                        }	 else formCtrl.uploaderForm.$setValidity('Not enough file types', true);
                        
                        if (filesFound > scope.rules[i].max) {formCtrl.uploaderForm.$setValidity('Too many file types', false);
                                }	 else formCtrl.uploaderForm.$setValidity('Too many file types', true);
                 
                }
					
		if (scope.rules.length>0) {
                        if (scope.fd.files.length < scope.rules[0].min) formCtrl.uploaderForm.$setValidity('Minimum files needed', false); 
                        else formCtrl.uploaderForm.$setValidity('Minimum files needed', true); }
  
					//errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                return errMsg;
					
         }//test_RULES
               
	scope.checkForChanges = function(files) {
                //scope.fd.files = files;
                scope.files = files;
        };
     	//*******************************************************************************************************
		// 											 kt-UPLOADER BTN_UPLOAD
		//*******************************************************************************************************
        scope.btn_upload = function() {
            				
        // CHECK THE RULES FIRST
		var errMsg=scope.testRules();
                errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
					
		if (errMsg==null) {
	
        		var csrf_token = $cookies.get('csrftoken'); //'miro';//$cookieStore.get('csrftoken');
			
                        Upload.upload({
                            url: '../api/file-upload/',
                            headers: {'X-CSRFToken' : csrf_token },
                            file: scope.fd.files,
                            data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
                        }).then(function (resp) {
                                console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
                                file.uploadSuccess=true;
                        }, function (resp) {
                                console.log('Error status: ' + resp.status);
                                file.uploadError=true;
                                file.status=resp;
                        }, function (evt) {
                                var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                                console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
                                file.status='Uploading...';
                        });
                        
                        /*
        		// ZA svaki FAJL pojedinaèno !
        		scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
				url: '../api/file-upload/', 
				headers: {'X-CSRFToken' : csrf_token },
					concurrency: 3,
					// u data napuniti podatke vezane za fajl - fileType , ID resursa
					data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
					onProgress: function(file) {
						$log.info(file.name + '=' + file.humanSize);
                                                $timeout(function() { file.status='Uploading...'; });
                                        },
					onCompleted: function(file, response,status) {

                                                //$log.info(file + 'response' + response);
                                                response=JSON.parse(response); //convertiram string u JSON objekt
								
						if (status==201) {// NAKON SMO USPJESNO UPLOADALI FILE , POTREBAN METADATA UPLOAD

                                                        // response.... ID fajla
                                                        // file.fileResourceID ... je file_type 
                                                        // scope.resourceData .. spremljeni meta podaci
								
                                                        $timeout(function() { file.uploadSuccess=true;  });
									

                        				//OUTPUT: data.savedResourceId .. ID meta-resursa koji je pridruen fajlu (unutar 11-ice ili 12-ice)
									
                                        		 file.resourceData={};
									
                                                        //MessagingService.addMessage("File upload successful! "+response,'success');
									
                                                        //PRIPREMA scope.resourceData  ZA UPLOAD 
                                                        if (file.dashboard!=undefined)
                                                        {
                                                                //code
                                                                var fieldId="";
                                                                var sc=scope;
                                                                          
                                                                for (var i=0;i<file.dashboard.widgets.length;i++) {//idem po gridROW
                                                                        for (var j=0;j<file.dashboard.widgets[i].layout.length;j++)
                                                                                for (var k=0;k<file.dashboard.widgets[i].layout[j].layout.length;k++)	
                                                                                {
                                                                                        fieldId='Field'+file.dashboard.widgets[i].layout[j].layout[k].itemId;
                                                                                        if (file.dashboard.widgets[i].layout[j].layout[k].dbtype=='id') {
                                                                                                fieldId=fieldId+'_id'//code
                                                                                                fieldId='id'//code
                                                                                        }
                                                                                        file.resourceData[fieldId] = file.dashboard.widgets[i].layout[j].layout[k].sItemValue	
                                                                                }
                                                                }//for
                                                                
                                                                                                                 
                                                                //  ********************************* METAUPLOAD ************************
                                        
                                                                if (file.resourceData)
                                                                {
                                                                        // ovdje je sve i update modela i insert meta pddataka - napravljena posebna DRF funkcija
                                                                        file.metaStatus='Saving metadata...'
                                                                        //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
                                                                        //ResourcesDataService.fileMetaUpload(response,file.fileResourceID,scope.fd.linkedResourceId,scope.fd.linkedResourceDefId, file.resourceData).then(
                                                                        ResourcesDataService.fileMetaUpload(response,file.fileResourceID,scope.fd.linkedResourceId,scope.fd.linkedResourceDefId, file.dashboard.widgets).then(
                                                                                                
                                                                        // service.fileMetaUpload= function (fileId,fileMetaId,resourceId,resourceDefId,fileResourceData) {
                                                                                function(data) {
                                                                                                                                                        
                                                                                // MessagingService.addMessage(data.msg,'success');
                                                                                                file.metaSuccess=true;
                                                                                                scope.showFileMetaData=false;
                                                                    
                                                                                                //$log.info('data savedresourceid:' + data.savedResourceId);
                                                                                                                                 
                                                                                },function(error){
                                                                                        //MessagingService.addMessage(error.msg,'error');
                                                                                        file.metaError=true;
                                                                                        file.metaStatus = error.msg;
                                                                                                                                                        
                                                                                                                                                                         
                                                                                });
                                                                } //IF
                                                        }
                                                        else
                                                        {
                                                                $timeout(function() {
                                                                        file.noMeta = true;
                                                                        //file.metaSuccess=true;
                                                                });
                                                        }
                                                                                                         // });
                                                        fileCounter++;
                                                        if (scope.fd.files.length == fileCounter){ //MIGOR -Ovaj se okida a onaj drugi na 123 izgleda na
                                                           $rootScope.$broadcast('InitiateTaskFilesUploaded',{'resource_id':scope.fd.linkedResourceId,'resource_def_id': scope.fd.linkedResourceDefId})
                                                        }
                                                
                                                }        
                                                else { 
                                                        //if file upload error
                                                        $timeout(function() {
                                                                file.uploadError=true;
                                                                file.status=response;
                                                        });
                                                                                                                 
                                                }
                                                                   
                                                        
                                        }//on_completed
                                }); //startUpload
                                */
		} else {
                        //scope.ac.alerts = 'Min Total!!';
			//$log.info(errMsg);
		}
        }; // FUNCTION b.n_up1oad

       
        scope.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name=='resourceLink') && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("uploader "+scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                //console.log("uploader "+ scope.fd.PresentationId+" dobio event " + event.name);
                                scope.ProcessEvent(data);
                               
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                             var data = WidgetDataExchangeService.getDataByWidgetId(scope.taskDefinition.task_execute_id,scope.taskDefinition.task_initiate_id,scope.taskDefinition.prev_task_id,linkedWidgetId,linkedItem);
                             scope.ProcessEvent(data);
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktUploader
      scope.ProcessEvent=function(data)
      {
         for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId') scope.fd.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                  if (data[k].name=='resourceId') scope.fd.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                  if (scope.fd.linkedResourceDefId>0 && scope.fd.linkedResourceId>0) scope.fd.uploadReady = true;
                                }
                          
         
         if (scope.fd.files.length>0 && scope.fd.uploadReady) scope.btn_upload();  // poziva UPLOAD - MIGOR TODO - upload treba samo ako ima fajl !!!
                                
        
      };
            
        
        	
      			
	
     	  // ne znam da li ce u ovoj link funkciji widget vec imati resource_id
          //ILJU treba dohvatit sa servera tItemValue
          
          scope.formType=scope.taskDefinition.form_type;
          if (scope.fd.PresentationId!=undefined && scope.fd.PresentationId!=null)
          {
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.PresentationId,scope.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;

                                  //ovo je da trenutno radi
                               // WidgetDataExchangeService.setData(scope.fd.tItemValue);
                                scope.processWidgetDependencies();
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                              
    
          }
          //MIGOR - poèisti fajlove kad dobije InitateTask event
		  scope.$on('ProcessTaskWidgets',function(event, data){
           //scope.btn_clean(); // MIGOR - PRIVREMENO MAKNUO JER CE BITI VISAK KAD PRORADI OVO GORE
           if (scope.fd.files.length>0 && scope.fd.uploadReady) scope.btn_upload();
          });

		  
		  
		  //MIGOR NOVO TODO
		  scope.interfaceHandler= function (event,data) {
							scope.test=0;
				
			 // scope.fd.linkedResourceId = data.resource_id;
			   //scope.fd.linkedResourceDefId = data.resource_def_id;
			  
			   //scope.btn_upload();  
		  }
		  
                        
        
                               
       
     } //link directive 'ktUploader'
    };
};
'use strict';

export function ktFormElementProperties () {
    return {
        restrict: 'A',
        replace: true,
        template: '<div ng-include="getTemplateUrl()"></div>',
        scope: {
            fd: '=',
            localVars: '=',
        },
        controller: function($scope){
            
              },
        link: function (scope, element, attr) {
          
          scope.getTemplateUrl = function() {
                
                var template ="";
                if (scope.localVars==undefined) scope.localVars = {};
                if (scope.fd!==undefined)
                {
                    template = 'ktdirectivetemplates/'+scope.fd.DirectiveName+'Properties.html';// MIGOR TODO- Security check !!!
                }else
                {
                    template = 'ktdirectivetemplates/ErrorElementProperties.html';
                }
                return template;
           
            };
        }
    }
};
export function ktFormFieldGenerator () {
    return {
        
        controller:function($scope,$compile,$element){
            
             var generatedTemplate = '<div ' + $scope.fd.AngularDirectiveName + '></div>';
             $element.append($compile(generatedTemplate)($scope));
            
            },
        link: function(scope, element) {
           
        }
    };
};
'use strict';

export function ktFormlayout () {
    
        return {
            restrict: 'A',
           
          controller: ['$scope','dragulaService','$rootScope','GridsterService','$element','$compile','$templateCache',
          
            function($scope,dragulaService,$rootScope,GridsterService,$element,$compile,$templateCache){
               
               
                $scope.gsrvc = GridsterService;      
                var widgetHandleResource = 'element-drag-handle';
                
                var bag = dragulaService.find($rootScope, 'bag-resource');
                if (!bag)
                {
                    
              
                            $scope.gsrvc.setupDragula('bag-resource','dataset-toolbox',widgetHandleResource);    
                }
                else
                {
                    if ($scope.gsrvc.formViewType == 4)
                    {
                       if ($scope.gsrvc.formViewTypeCounterDs==0) $scope.gsrvc.destroyDragula('bag-resource');
                       $scope.gsrvc.setupDragula('bag-resource','dataset-toolbox',widgetHandleResource); 
                       $scope.gsrvc.addFormViewTypeCounterDs(1);
                    }
                    
                    
                 }
                let template;
                if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktFormLayout.html');
                else template = $templateCache.get('ktdirectivetemplates/ktFormLayoutExe.html');
          
                $element.append($compile(template)($scope));  
            }],
          
            link: function (scope, elem, attrs) {
            
            
            scope.hideAnimation=false;
            
            scope.inputArray.countActive=scope.inputArray.length;
            
             scope.countActiveFn = function (){
                scope.countActive=0;
                for (var i=0;i<scope.inputArray.layout.length;i++)
                {
                   if (scope.inputArray.layout[i].Status=='Active') scope.countActive++;
                   
                   if (scope.countActive>0) break;
                    
                }
                return scope.countActive;
             };
              
            scope.removeField = function (index){
						
                if (index > -1) {
							// if (scope.inputArray.layout[index].saved==false) {
                     scope.inputArray.layout[index].Status='Deleted'; //splice(index, 1);
                     scope.inputArray.countActive--;
							// }
				}

            };       
          }
            
        };
    };
'use strict';

export function ktGrid (GridsterService,$timeout,$rootScope,dragulaService) {
     //  console.log("u direktivi kt-textbox ");
        return {
            restrict: 'A',
          
			scope:{
                   allColumns: "=",
                 /*  inputArray: "=",
                   active: '=',*/
                   parent:'=',
                   gridType: '=',
                   formParams:'=',
                   formParamsParent:'=',
                   showSearchFilters:'=',
                   taskDefinition: '=',
                   parentDatasetDefId: '=',
                   datasetRecordId: '=',
                   taskFormLoaded : '=',
                   formData : '=',
                
      			   
            },
            controller: ['$scope','dragulaService','$rootScope','$element','$compile','$templateCache',
          
            function($scope,dragulaService,$rootScope,$element,$compile,$templateCache){
            
                $scope.gsrvc = GridsterService;
                
                /*
                if ($scope.formParams.formViewType!==1)
                
                {
                    $scope.gsrvc.destroyDragula('bag-task');
                    var widgetHandleTask = 'task-element-drag-handle';
                    var bag_task = dragulaService.find($rootScope, 'bag-task');
                    
                    if (!bag_task)
                    {
                        $scope.gsrvc.setupDragula('bag-task','task-toolbox',widgetHandleTask);  
                    }
                }*/
                //var widgetHandleResource = 'element-drag-handle';
                //var setupDragula = $scope.gsrvc.setupDragula('bag-resource','dataset-toolbox',widgetHandleResource);
                
                var widgetHandle = $scope.gridType+'-row-drag-handle';
            
                var bag = dragulaService.find($scope, 'bag-rows-'+$scope.gridType+'-'+$scope.$id);

                if (bag) {
                     dragulaService.destroy($scope, 'bag-rows-'+$scope.gridType+'-'+$scope.$id);   
                }    
                dragulaService.options($scope, 'bag-rows-'+$scope.gridType+'-'+$scope.$id, {
                  revertOnSpill: true,
                  removeOnSpill: false,
                  
                  //direction:'vertical',
                  accept:function (el,target, source) {
                      return false;
                  },
                  moves: function (el, container, handle) {
                            return handle.classList.contains(widgetHandle);
                  }
                });
                
                let template;
                if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktGrid.html');
                else template = $templateCache.get('ktdirectivetemplates/ktGridExe.html');
          
                $element.append($compile(template)($scope));                
                
            
            }],
            link: function (scope, elem, attrs) {

            
                scope.ShowFormView = function(viewId)
                {
                               
                    scope.formParams.formViewType=viewId;
                    scope.gsrvc.setFormViewType(scope.formParams.formViewType);
                   
                };
      
                scope.getClass = function(size)
                    {
                    
                        return "col-lg-"+size;
                    
                    };
          
                
            
                scope.$watch('taskFormLoaded',function(newValue,oldValue){
                    
                    if (newValue!=oldValue || newValue)
                    {
                     scope.formLoaded = scope.taskFormLoaded;
                    }
                });
                
                scope.$watch('formParams.showGridNavigation',function(newValue,oldValue){
                    
                    if (newValue!=oldValue || newValue)
                    {
                     scope.showGridNavigation = scope.formParams.showGridNavigation;
                    }
                });
            
            /*
                scope.$on('LastRepeaterElement',function(event, data){
        
                    $timeout(function(){
              
                        scope.formLoaded=true;
                      
                    },750); 
      
      
                });
            */
      
               
                
             } 
        }
    };
'use strict';

export function ktGridColumn () {
     //  console.log("u direktivi kt-textbox ");
        return {
            restrict: 'A',
             
             scope:{
                   inputArray : '=',
                   allColumns: "=",
                   parent: "=",
                   gridType: '=',
                   formType: '=',
                   taskDefinition: '=', 
                   formParams:'=',
                   formParamsParent:'=',
                   showSearchFilters:'=',
                   parentDatasetDefId: '=',
                   datasetRecordId: '=',
                   taskFormLoaded : '=',
                   formData : '=',
                   index : '=',
      			},
                 controller: ['$scope', '$element','$rootScope','GridsterService','$timeout','dragulaService','KatalyoStateManager','$compile','$templateCache',
                              function ($scope, $element,$rootScope,GridsterService,$timeout,dragulaService,KatalyoStateManager,$compile,$templateCache) {
                        
                        if ($scope.localVars == undefined || $scope.localVars == null) $scope.localVars={};
                        
                        $scope.ksm = KatalyoStateManager;
                        $scope.gsrvc = GridsterService;
                        $scope.localVars.gsrvc = GridsterService;
                        
                        if ($scope.inputArray.Parameters == undefined || $scope.inputArray.Parameters == null) $scope.inputArray.Parameters={};
                        
                       if ($scope.inputArray.Parameters.border == undefined || $scope.inputArray.Parameters.border == null )
                       {
                       
                        $scope.inputArray.Parameters.border = {
                            left: {
                                name: 'Left',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            },
                            right: {
                                name: 'Right',
                                style:'solid',
                                width:0,
                                 color:"#000000"
                            } ,
                            top:{
                                name: 'Top',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            },
                            bottom:{
                                name: 'Bottom',
                                style:'solid',
                                width:0,
                                color:"#000000"
                            }
                        };
                       }
                         
                           
                        if ($scope.inputArray.Parameters.margin ==  undefined ||  $scope.inputArray.Parameters.margin ==  null) {
                                $scope.inputArray.Parameters.margin= {
                                     left: {  
                                        name: 'Left Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                                     right: {  
                                        name: 'Right Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                                     top: {  
                                        name: 'Top Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },
                                     bottom: {  
                                        name: 'Bottom Margin',
                                        value: 0,
                                        units:"px",
                                        auto: true
                                     },        
                                }
                        }
                        if ($scope.inputArray.Parameters.padding ==  undefined ||  $scope.inputArray.Parameters.padding ==  null){
                                $scope.inputArray.Parameters.padding= {
                                 left: {  
                                    name: 'Left Padding',
                                    value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                 right: {  
                                    name: 'Right Padding',
                                     value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                 top: {  
                                    name: 'Top Padding',
                                   value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                 bottom: {  
                                    name: 'Bottom Padding',
                                    value: 0,
                                    units:"px",
                                    auto: true
                                 },
                                     
                                };
                        }
                    

                let columnId = $scope.gridType+'_'+$scope.taskDefinition.ResourceDefId_id+'_'+$scope.inputArray.ElementType+'_'+$scope.parent.id+'_'+$scope.inputArray.id;
                let formChangesSubject = 'datasetFormState'+$scope.taskDefinition.ResourceDefId_id;
                let originalColumn = angular.copy($scope.inputArray);    
                //Add Subject to katalyo state manager (name must be unique)
                //let columnSubject = $scope.ksm.addSubject(columnId,angular.copy($scope.inputArray));
                
                //define fn for applyChange action 
                /*
                let changed_item= function(data)
                {
                
                    //scope.row = data; 
                    if (!$scope.syncFromObserver)
                    {
                        columnSubject.subject.setState = angular.copy($scope.inputArray);
                        columnSubject.subject.notifyObservers();
                    }
         
                };
    
                //add action to subject rowSubject
                let action_change_column = $scope.ksm.addAction(columnSubject.subject.name,"applyChangeToColumn",changed_item);    
                */
                
                //define fn to sync to manager 
                let process_undo = function(data,action)
                {
                    if (data!==undefined)
                    {
                        let columnData = data.oldData;
                        if (data.id===columnId && action==="undoDatasetFormChange")
                        
                        {
                            $scope.parent.layout[$scope.index] = columnData;
                            $scope.ksm.executeAction(formChangesSubject,"undoDatasetFormChangeDone");    
                            $scope.syncFromObserver=true;
                        }
                    }
                };
                
                //define fn to sync to manager 
                let process_redo = function(data,action)
                {
                    if (data!==undefined)
                    {
                        let columnData = data.newData;
                        if (data.id===columnId && action==="redoDatasetFormChange")
                        
                        {
                          
                                $scope.parent.layout[$scope.index] = columnData;
                                $scope.syncFromObserver=true;
                         
                        }
                    }
                };
                
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_undo = $scope.ksm.subscribe(formChangesSubject,columnId,"undoDatasetFormChange",process_undo);
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_redo = $scope.ksm.subscribe(formChangesSubject,columnId,"redoDatasetFormChange",process_redo);
            
          //  if ($scope.formParams.formViewType!==2 && ($scope.formParamsParent.formViewType!==2 || $scope.formParamsParent===undefined))      
           // {
           
        /****************** remove bloody watchers that kill the application START ****************************************
              $scope.$watch('inputArray.layout',function(newValue,oldValue){
               
                //process object change
                if (newValue.length!==oldValue.length && !$scope.syncFromObserver)
                {
                  //$scope.ksm.executeAction(columnSubject.subject.name,'applyChangeToColumn',angular.copy(newValue));
                   $scope.ksm.executeAction(formChangesSubject,"datasetFormChanged",{'id':columnId,'source':columnId,'oldData':angular.copy(oldValue),'newData':angular.copy(newValue)});
                } else $scope.syncFromObserver=false;              
              
                });
            
                $scope.$watch('inputArray',function(newValue,oldValue){
               
                //process object change
                if (newValue.SizeX!==oldValue.SizeX && !$scope.syncFromObserver)
                {
                    //$scope.ksm.executeAction(columnSubject.subject.name,'applyChangeToColumn',angular.copy(newValue));
                    $scope.ksm.executeAction(formChangesSubject,"datasetFormChanged",{'id':columnId,'source':columnId,'oldData':angular.copy(oldValue),'newData':angular.copy(newValue)});
                } else $scope.syncFromObserver=false;              
              
                });
             
            //}
           ***************** remove bloody watchers that kill the application END ****************************************/
        
            $scope.addColumn = function (row,type){
          
                  let lindex = $scope.index+type;
                  let size = $scope.inputArray.SizeX;
                  //let newSize = Math.ceil(size/2);
                  
                 // $scope.inputArray.SizeX = newSize;
                  
                  let newColumn = GridsterService.getEmptyColumnWithId($scope.allColumns);
                  
                  newColumn.SizeX = size;
                  let oldRow = angular.copy(row);
                  row.layout.splice(lindex,0, newColumn);
                  let source = $scope.gridType+'_'+$scope.taskDefinition.ResourceDefId_id+'_'+row.ElementType+'_'+row.ContainerId+'_'+row.id;
                  $scope.ksm.executeAction(formChangesSubject,"datasetFormChanged",{'id':source,'source':source,'oldData':angular.copy(oldRow),'newData':angular.copy(row)});
            };
              
                    
                    
                    
                       if ($scope.gridType=="" || $scope.gridType==undefined) {
                  
                    $scope.gridType="resource";
                }
                 
                  $scope.getClass = function(size)
                  {
                    
                    return "col-lg-"+size;
                    
                  };
                  
                  $scope.setpOpen = function(value)
                  {
                    $scope.pOpen=value;
                  };
                  
                  $scope.setHandle = function (type){
                        return "column-"+type+"-handle";
                 };
                 
                 $scope.addRow = function (){
      
                        $scope.inputArray.layout.push(GridsterService.getEmptyRowWithId($scope.inputArray));
       
                 };
                 
                  $scope.inputArray.BackgroundColorChanged = function (){
      
                        $scope.inputArray.Parameters.BackgroundColorA = "rgba(" + parseInt($scope.inputArray.Parameters.BackgroundColor.slice(-6, -4), 16) + "," + parseInt($scope.inputArray.Parameters.BackgroundColor.slice(-4, -2), 16) + "," + parseInt($scope.inputArray.Parameters.BackgroundColor.slice(-2), 16) + "," + $scope.inputArray.Parameters.BackgroundOpacity + ")";
       
                 };
              
                  
                $scope.showHideProperties = function(value)
                      {
                        $scope.gsrvc.setFieldPropertiesOpened(value);
                        $scope.showFieldProperties=$scope.gsrvc.getFieldPropertiesOpened();
             
                      };
 
               $scope.splitColumn = function (column){
                
                var splitColumn = GridsterService.getNewRowForSplitColumn($scope.allRows,column);
      
                  $scope.parent.layout.splice($scope.parent.layout.indexOf(column),1,splitColumn);
       
              };
                  
                  
                  $scope.remove = function (item){
						
                       if (item.layout.length==0)
                       {
                          if ($scope.parent==undefined){
                            $scope.allColumns.splice($scope.allColumns.indexOf(item), 1);
                          }else
                          {
                          $scope.parent.layout.splice($scope.parent.layout.indexOf(item), 1); 
                            
                          }
                       }
                       
                };
                
                 $scope.inputArray.select = function(selected){
                        $scope.inputArray.selected=selected;
                    }
                    
                    $scope.inputArray.selectBorder = function(selected){
                        $scope.inputArray.selectedBorder=selected;
                    }
                let template;
                if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktGridColumn.html');
                else template = $templateCache.get('ktdirectivetemplates/ktGridColumnExe.html');
          
                $element.append($compile(template)($scope)); 
                         
                }],
                
                
             link: function (scope, elem, attrs) {
            
               
                    
               

        
               
             
        }
    }
};
'use strict';

export function ktGridRow () {
     //  console.log("u direktivi kt-textbox ");
        return {
            restrict: 'A',
              scope:{
                   row : '=',
                   allRows: "=",
                   parent: "=",
                   gridType: '=',
                   formType: '=',
                   taskDefinition: '=', 
                   formParams:'=',
                   formParamsParent:'=',
                   showSearchFilters:'=',
                   parentDatasetDefId: '=',
                   datasetRecordId: '=',
                   taskFormLoaded : '=',
                   formData : '=',
                   
      			},
             controller: ['$scope','GridsterService','$timeout','dragulaService','$rootScope','KatalyoStateManager','$compile','$element','$templateCache',
                          function($scope,GridsterService,$timeout,dragulaService,$rootScope,KatalyoStateManager,$compile,$element,$templateCache){
                        $scope.gsrvc = GridsterService;
                        $scope.ksm = KatalyoStateManager;
                        let originalRow = angular.copy($scope.row);
                let rowId = $scope.gridType+'_'+$scope.taskDefinition.ResourceDefId_id+'_'+$scope.row.ElementType+'_'+$scope.row.ContainerId+'_'+$scope.row.id;
                let formChangesSubject = 'datasetFormState'+$scope.taskDefinition.ResourceDefId_id;
                //define fn to sync to manager 
                let process_undo = function(data,action)
                {
                    if (data!==undefined)
                    {
                        let rowData = data.oldData;
                        if (data.id===rowId && action==="undoDatasetFormChange")
                        
                        {
                            $scope.row = rowData;
                            $scope.ksm.executeAction(formChangesSubject,"undoDatasetFormChangeDone");    
                            $scope.syncFromObserver=true;
                        }
                    }
                };
                
                //define fn to sync to manager 
                let process_redo = function(data,action)
                {
                    if (data!==undefined)
                    {
                        let rowData = data.newData;
                        if (data.id===rowId && action==="redoDatasetFormChange")
                        
                        {
                          
                                $scope.row = rowData;
                                $scope.syncFromObserver=true;
                         
                        }
                    }
                };
                
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_undo = $scope.ksm.subscribe(formChangesSubject,rowId,"undoDatasetFormChange",process_undo);
                 //create observer if change comes from someplace else (e.g. undo or from server)
                let observer_redo = $scope.ksm.subscribe(formChangesSubject,rowId,"redoDatasetFormChange",process_redo);
                
                $scope.addColumn = function (row){
          
                    row.layout.push($scope.gsrvc.getEmptyColumnWithId($scope.parent.layout));
                  
                };
                $scope.addRowAbove = function (row){
      
                  $scope.parent.layout.splice($scope.parent.layout.indexOf(row),0, GridsterService.getEmptyRowWithId($scope.allRows));
       
                };
              
                $scope.addRowBelow = function (row){
      
                 $scope.parent.layout.splice($scope.parent.layout.indexOf(row)+1,0, GridsterService.getEmptyRowWithId($scope.allRows));
       
              };
               $scope.getClass = function(size)
              {
                    
                    return "col-lg-"+size;
                    
              };
              
                $scope.getHandle = function()
              {
                    
                    return "row-"+$scope.gridType+"-handle";
                    
              };
              
               $scope.setHandle = function (type){
                        return type+"-handle";
                 };
                if ($scope.row.Parameters==undefined) $scope.row.Parameters={};
                if ($scope.row.Parameters.BackgroundOpacity==null || $scope.row.Parameters.BackgroundOpacity==undefined ) $scope.row.Parameters.BackgroundOpacity=1;
                $scope.row.BackgroundColorChanged = function (){
                        
                        if ($scope.row.Parameters.BackgroundColor.length>0) $scope.row.Parameters.BackgroundColorA = "rgba(" + parseInt($scope.row.Parameters.BackgroundColor.slice(-6, -4), 16) + "," + parseInt($scope.row.Parameters.BackgroundColor.slice(-4, -2), 16) + "," + parseInt($scope.row.Parameters.BackgroundColor.slice(-2), 16) + "," + $scope.row.Parameters.BackgroundOpacity + ")";
       
                 };
               $scope.row.BackRepeatChanged = function (){
                        
                        if ($scope.row.Parameters.RepeatBackImg) $scope.row.Parameters.RepeatBackText = 'repeat';
                        else $scope.row.Parameters.RepeatBackText = 'no-repeat';
       
                 };
                 
                        $scope.$watch('row',function(newValue,oldValue){
               
                    //process object change
                    if (newValue!==oldValue && !$scope.syncFromObserver)
                    {
                         $scope.ksm.executeAction(formChangesSubject,"addDatasetFormChange",{'id':rowId,'data':angular.copy(oldValue)});
                    } else $scope.syncFromObserver=false;              
              
                });
                
            //}
            
            var widgetHandle = $scope.setHandle($scope.gridType+'-column-drag');
            
            var bag = dragulaService.find($scope, 'bag-columns-'+$scope.gridType);
             
            if (bag) {
                dragulaService.destroy($scope, 'bag-columns-'+$scope.gridType);
            }
            dragulaService.options($scope, 'bag-columns-'+$scope.gridType, {
                    revertOnSpill: true,
                    removeOnSpill: false,
                    direction:'vertical',
                    accept:function (el,target, source) {
                              return false;
                    },
                    moves: function (el, container, handle) {
                              return handle.classList.contains(widgetHandle);
                    }
             });
                
                 let template;
                if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktGridRow.html');
                else template = $templateCache.get('ktdirectivetemplates/ktGridRowExe.html');
          
                $element.append($compile(template)($scope));  
                 
                }],
             link: function (scope, elem, attrs) {
              
              
                
                

          //  if (scope.formParams.formViewType!==2 && (scope.formParamsParent.formViewType!==2 || scope.formParamsParent===undefined))           
          //  {
          
          /*
                scope.$watch('row.layout',function(newValue,oldValue){
               
                  //process object change
                  if (newValue.length!==oldValue.length && !scope.syncFromObserver)
                  {
                    scope.ksm.executeAction(formChangesSubject,"addDatasetFormChange",{'id':rowId,'data':angular.copy(oldValue)});
                  } else scope.syncFromObserver=false;              
              
                },true);
            */
           
         
             
             
            }
        };
    };
'use strict';

export function ktGroup () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktGroup.html',
             controller:function($scope,UserService,$rootScope,GridsterService){
                 
                 $scope.gsrvc = GridsterService;
           if ($scope.localVars==undefined) $scope.localVars={};
              //MIGOR START
              $scope.search=[
                      {id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
                      {id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                ];
				
               if ($scope.fd!=undefined) {
                  if ($scope.fd.search==undefined)
                  {
                    $scope.fd.search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                  }
               } 

			  $scope.applyListFilters = function(index) {
                   
				   $scope.fd.search=$scope.search[index];
                   if( typeof $scope.formData[0]['Field'+$scope.fd.ItemId] === 'string' ) {
                        //$scope.fd.search.value = [ $scope.fd.sItemValue ];
                        $scope.fd.search.value = [ {'id':$scope.formData[0]['Field'+$scope.fd.ItemId]} ];
                    }
                   //if ($scope.fd.search.name=="Equals") $scope.fd.search=null;
				   $scope.isOpen=false;		
			  	};
                
                //MIGOR END
                
             $scope.showProperties = function(event)
            {
                  $scope.gsrvc.setFieldProperties($scope.fd,event);
       
            };    
             $scope.colLength=[];
            for (var i=0;i<24;i++) $scope.colLength.push('col-lg-'+(i+1));
            $scope.groupItem = {selectedGroup : null};
          
             $scope.populateGroup = function (item,model) {
               
           
                  $scope.selectedGroup = item;
                  $scope.fd.codeId = item.id;
                  $scope.formData[0]['Field'+$scope.fd.ItemId]=item.id;
             
               $scope.fd.search.value = [ {'id':$scope.formData[0]['Field'+$scope.fd.ItemId]} ]; //MIGOR TODO - vidjeti da li ovjde siTemValue ( provjeriti i ostale sluèajeve u onselect funkciji)

    				};

              
            $scope.getGroups = function () {
              UserService.getUsersGroups('groups').then(function(data){
              
              $scope.groupList = data.data;
              
              if ($scope.formData!=undefined && $scope.formData.length>0)
              {
                    if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=null) {
                         UserService.getGroupObjectById($scope.formData[0]['Field'+$scope.fd.ItemId]).then(function(data){
                            $scope.selectedGroup = data;
                            $scope.groupItem.selectedGroup=$scope.selectedGroup;
                           
                          });
                       
                         
                      }
                     else if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=null) {
                     
                      if ($scope.formData[0]['Field'+$scope.fd.ItemId].length>0)
                      {
                        if ($scope.formData[0]['Field'+$scope.fd.ItemId][0]!=undefined)
                        {
                         UserService.getGroupObjectById($scope.formData[0]['Field'+$scope.fd.ItemId][0]).then(function(data){
                            $scope.selectedGroup = data;
                            $scope.groupItem.selectedGroup=$scope.selectedGroup;
                            $scope.formData[0]['Field'+$scope.fd.ItemId]=$scope.selectedGroup.id;
                          });
                      }
                         
                      }
                     }
              }
    				});
          
          }
          
          
          $scope.$watch('groupItem.selectedGroup', function(newValue,oldValue){
                    //debugger
                    if ($scope.formData && newValue)  $scope.formData[0]['Field'+$scope.fd.ItemId]=newValue.id;
                });
           $scope.clear = function(event,select)
        {
          $scope.formData[0]['Field'+$scope.fd.ItemId] = null;
          $scope.fd.search.value = null;
          $scope.groupItem.selectedGroup = null;
        }
        
  				$scope.getGroups();
          
         
                
                },
             link: function (scope, elem, attrs) {
          
          
          
          
        
          
              }
        }
  
};
'use strict';

export function ktHeader () {
        return {
            restrict: 'A',
			 controller: function ($scope) {},
             templateUrl: 'ktdirectivetemplates/ktHeader.html',
             link: function (rootScope,scope, elem, attrs) {
              
              scope.colLength = ['col-lg-2','col-lg-4','col-lg-6','col-lg-8','col-lg-10','col-lg-12','col-lg-14','col-lg-16','col-lg-18','col-lg-20','col-lg-22','col-lg-24'];
                 if (scope.fd==undefined) scope.fd={};
                if (scope.fd.Parameters==undefined) scope.fd.Parameters={};
                if (scope.fd.Parameters.BackgroundOpacity==null || scope.fd.Parameters.BackgroundOpacity==undefined ) scope.fd.Parameters.BackgroundOpacity=1;
                scope.fd.BackgroundColorChanged = function (){
                        
                        if (scope.fd.Parameters.BackgroundColor.length>0) scope.fd.Parameters.BackgroundColorA = "rgba(" + parseInt(scope.fd.Parameters.BackgroundColor.slice(-6, -4), 16) + "," + parseInt(scope.fd.Parameters.BackgroundColor.slice(-4, -2), 16) + "," + parseInt(scope.fd.Parameters.BackgroundColor.slice(-2), 16) + "," + scope.fd.Parameters.BackgroundOpacity + ")";
       
                 };
               
            }
        };
};
'use strict';

export function ktIconPicker () {
        return {
            restrict: 'A',
             
             templateUrl: 'ktdirectivetemplates/ktIconPicker.html',
			 link: function (scope, elem, attrs) {
                 
                
                 scope.filteredIcons=[];
                 scope.icons=[];
                 scope.iconsFilter={filter:null,filteringIcons:false};
                 scope.showIcons=false;
                 scope.showButtons=false;
                 scope.itemsLoaded=false;
                 scope.allButtons=['btn-primary','btn-light','btn-dark','btn-success','btn-danger','btn-info','btn-warning','btn-outline-primary','btn-outline-light','btn-outline-dark','btn-outline-success','btn-outline-danger','btn-outline-info','btn-outline-warning','btn-link'];

                 scope.icons=["fab fa-500px",	"fab fa-accessible-icon", "fab fa-accusoft", "fab fa-adn", "fab fa-adversal", "fab fa-affiliatetheme", "fab fa-algolia", "fab fa-alipay", "fab fa-amazon", "fab fa-amazon-pay", "fab fa-amilia", "fab fa-android", "fab fa-angellist", "fab fa-angrycreative", "fab fa-angular", "fab fa-app-store", "fab fa-app-store-ios", "fab fa-apper", "fab fa-apple", "fab fa-apple-pay", "fab fa-asymmetrik", "fab fa-audible", "fab fa-autoprefixer", "fab fa-avianex", "fab fa-aviato", "fab fa-aws",
                    "fab fa-bandcamp", "fab fa-behance", "fab fa-behance-square", "fab fa-bimobject", "fab fa-bitbucket", "fab fa-bitcoin", "fab fa-bity", "fab fa-black-tie", "fab fa-blackberry", "fab fa-blogger", "fab fa-blogger-b", "fab fa-bluetooth", "fab fa-bluetooth-b", "fab fa-btc", "fab fa-buromobelexperte", "fab fa-buysellads", "fab fa-cc-amazon-pay", "fab fa-cc-amex", "fab fa-cc-apple-pay", "fab fa-cc-diners-club", "fab fa-cc-discover", "fab fa-cc-jcb", "fab fa-cc-mastercard", "fab fa-cc-paypal", "fab fa-cc-stripe",
                    "fab fa-cc-visa", "fab fa-centercode", "fab fa-chrome", "fab fa-cloudscale", "fab fa-cloudsmith", "fab fa-cloudversify", "fab fa-codepen", "fab fa-codiepie", "fab fa-connectdevelop", "fab fa-contao", "fab fa-cpanel", "fab fa-creative-commons", "fab fa-creative-commons-by", "fab fa-creative-commons-nc", "fab fa-creative-commons-nc-eu", "fab fa-creative-commons-nc-jp", "fab fa-creative-commons-nd", "fab fa-creative-commons-pd", "fab fa-creative-commons-pd-alt", "fab fa-creative-commons-remix", 
                    "fab fa-creative-commons-sa", "fab fa-creative-commons-sampling", "fab fa-creative-commons-sampling-plus", "fab fa-creative-commons-share", "fab fa-css3", "fab fa-css3-alt", "fab fa-cuttlefish", "fab fa-d-and-d", "fab fa-dashcube", "fab fa-delicious", "fab fa-deploydog", "fab fa-deskpro", "fab fa-deviantart", "fab fa-digg", "fab fa-digital-ocean", "fab fa-discord", "fab fa-discourse", "fab fa-dochub", "fab fa-docker", "fab fa-draft2digital", "fab fa-dribbble", "fab fa-dribbble-square", "fab fa-dropbox", 
                    "fab fa-drupal", "fab fa-dyalog", "fab fa-earlybirds", "fab fa-ebay", "fab fa-edge", "fab fa-elementor", "fab fa-ello", "fab fa-ember", "fab fa-empire", "fab fa-envira", "fab fa-erlang", "fab fa-ethereum", "fab fa-etsy", "fab fa-expeditedssl", "fab fa-facebook", "fab fa-facebook-f", "fab fa-facebook-messenger", "fab fa-facebook-square", "fab fa-firefox", "fab fa-first-order", "fab fa-first-order-alt", "fab fa-firstdraft", "fab fa-flickr", "fab fa-flipboard", "fab fa-fly", "fab fa-font-awesome", "fab fa-font-awesome-alt",
                    "fab fa-font-awesome-flag", "fab fa-fonticons", "fab fa-fonticons-fi", "fab fa-fort-awesome", "fab fa-fort-awesome-alt", "fab fa-forumbee", "fab fa-foursquare", "fab fa-free-code-camp", "fab fa-freebsd", "fab fa-fulcrum", "fab fa-galactic-republic", "fab fa-galactic-senate", "fab fa-get-pocket", "fab fa-gg", "fab fa-gg-circle", "fab fa-git", "fab fa-git-square", "fab fa-github", "fab fa-github-alt", "fab fa-github-square", "fab fa-gitkraken", "fab fa-gitlab", "fab fa-gitter", "fab fa-glide", "fab fa-glide-g", "fab fa-gofore", 
                    "fab fa-goodreads", "fab fa-goodreads-g", "fab fa-google", "fab fa-google-drive", "fab fa-google-play", "fab fa-google-plus", "fab fa-google-plus-g", "fab fa-google-plus-square", "fab fa-google-wallet", "fab fa-gratipay", "fab fa-grav", "fab fa-gripfire",  "fab fa-grunt", "fab fa-gulp", "fab fa-hacker-news", "fab fa-hacker-news-square", "fab fa-hackerrank", "fab fa-hips", "fab fa-hire-a-helper", "fab fa-hooli", "fab fa-hornbill", "fab fa-hotjar", "fab fa-houzz", "fab fa-html5", "fab fa-hubspot", "fab fa-imdb",
                    "fab fa-instagram", "fab fa-internet-explorer", "fab fa-ioxhost", "fab fa-itunes", "fab fa-itunes-note", "fab fa-java", "fab fa-jedi-order", "fab fa-jenkins", "fab fa-joget", "fab fa-joomla", "fab fa-js", "fab fa-js-square", "fab fa-jsfiddle", "fab fa-kaggle",  "fab fa-keybase", "fab fa-keycdn", "fab fa-kickstarter", "fab fa-kickstarter-k", "fab fa-korvue", "fab fa-laravel", "fab fa-lastfm", "fab fa-lastfm-square", "fab fa-leanpub", "fab fa-less", "fab fa-line", "fab fa-linkedin", "fab fa-linkedin-in", "fab fa-linode",
                    "fab fa-linux", "fab fa-lyft", "fab fa-magento", "fab fa-mailchimp", "fab fa-mandalorian", "fab fa-markdown", "fab fa-mastodon", "fab fa-maxcdn", "fab fa-medapps", "fab fa-medium", "fab fa-medium-m", "fab fa-medrt", "fab fa-meetup", "fab fa-megaport", "fab fa-microsoft", "fab fa-mix", "fab fa-mixcloud", "fab fa-mizuni", "fab fa-modx", "fab fa-monero", "fab fa-napster", "fab fa-neos", "fab fa-nimblr", "fab fa-nintendo-switch", "fab fa-node", "fab fa-node-js", "fab fa-npm", "fab fa-ns8", "fab fa-nutritionix", "fab fa-odnoklassniki",
                    "fab fa-odnoklassniki-square", "fab fa-old-republic", "fab fa-opencart", "fab fa-openid", "fab fa-opera", "fab fa-optin-monster", "fab fa-osi", "fab fa-page4", "fab fa-pagelines", "fab fa-palfed", "fab fa-patreon", "fab fa-paypal", "fab fa-periscope",  "fab fa-phabricator", "fab fa-phoenix-framework", "fab fa-phoenix-squadron", "fab fa-php", "fab fa-pied-piper", "fab fa-pied-piper-alt", "fab fa-pied-piper-hat", "fab fa-pied-piper-pp", "fab fa-pinterest", "fab fa-pinterest-p", "fab fa-pinterest-square", 
                    "fab fa-playstation", "fab fa-product-hunt", "fab fa-pushed", "fab fa-python", "fab fa-qq", "fab fa-quinscape", "fab fa-quora", "fab fa-r-project", "fab fa-ravelry", "fab fa-react", "fab fa-readme", "fab fa-rebel", "fab fa-red-river", "fab fa-reddit",  "fab fa-reddit-alien", "fab fa-reddit-square", "fab fa-rendact", "fab fa-renren", "fab fa-replyd", "fab fa-researchgate", "fab fa-resolving", "fab fa-rev", "fab fa-rocketchat", "fab fa-rockrms", "fab fa-safari", "fab fa-sass", "fab fa-schlix", "fab fa-scribd", 
                    "fab fa-searchengin", "fab fa-sellcast", "fab fa-sellsy", "fab fa-servicestack", "fab fa-shirtsinbulk", "fab fa-shopware", "fab fa-simplybuilt", "fab fa-sistrix", "fab fa-sith", "fab fa-skyatlas", "fab fa-skype", "fab fa-slack", "fab fa-slack-hash",  "fab fa-slideshare", "fab fa-snapchat", "fab fa-snapchat-ghost", "fab fa-snapchat-square", "fab fa-soundcloud", "fab fa-speakap", "fab fa-spotify", "fab fa-squarespace", "fab fa-stack-exchange", "fab fa-stack-overflow", "fab fa-staylinked", "fab fa-steam", 
                    "fab fa-steam-square", "fab fa-steam-symbol", "fab fa-sticker-mule", "fab fa-strava", "fab fa-stripe", "fab fa-stripe-s", "fab fa-studiovinari", "fab fa-stumbleupon", "fab fa-stumbleupon-circle", "fab fa-superpowers", "fab fa-supple", "fab fa-teamspeak",  "fab fa-telegram", "fab fa-telegram-plane", "fab fa-tencent-weibo", "fab fa-the-red-yeti", "fab fa-themeco", "fab fa-themeisle", "fab fa-trade-federation", "fab fa-trello", "fab fa-tripadvisor", "fab fa-tumblr", "fab fa-tumblr-square", "fab fa-twitch", 
                    "fab fa-twitter", "fab fa-twitter-square", "fab fa-typo3", "fab fa-uber", "fab fa-uikit", "fab fa-uniregistry", "fab fa-untappd", "fab fa-usb", "fab fa-ussunnah", "fab fa-vaadin", "fab fa-viacoin", "fab fa-viadeo", "fab fa-viadeo-square", "fab fa-viber",  "fab fa-vimeo", "fab fa-vimeo-square", "fab fa-vimeo-v", "fab fa-vine", "fab fa-vk", "fab fa-vnv", "fab fa-vuejs", "fab fa-weebly", "fab fa-weibo", "fab fa-weixin", "fab fa-whatsapp", "fab fa-whatsapp-square", "fab fa-whmcs", "fab fa-wikipedia-w",
                    "fab fa-windows", "fab fa-wix", "fab fa-wolf-pack-battalion", "fab fa-wordpress", "fab fa-wordpress-simple", "fab fa-wpbeginner", "fab fa-wpexplorer", "fab fa-wpforms", "fab fa-xbox", "fab fa-xing", "fab fa-xing-square", "fab fa-y-combinator", "fab fa-yahoo", "fab fa-yandex", "fab fa-yandex-international", "fab fa-yelp", "fab fa-yoast", "fab fa-youtube", "fab fa-youtube-square", "fab fa-zhihu", "far fa-address-book", "far fa-address-card", "far fa-angry", "far fa-arrow-alt-circle-down", "far fa-arrow-alt-circle-left",
                    "far fa-arrow-alt-circle-right", "far fa-arrow-alt-circle-up", "far fa-bell", "far fa-bell-slash", "far fa-bookmark", "far fa-building", "far fa-calendar", "far fa-calendar-alt", "far fa-calendar-check", "far fa-calendar-minus", "far fa-calendar-plus",  "far fa-calendar-times", "far fa-caret-square-down", "far fa-caret-square-left", "far fa-caret-square-right", "far fa-caret-square-up", "far fa-chart-bar", "far fa-check-circle", "far fa-check-square", "far fa-circle", "far fa-clipboard", "far fa-clock",
                    "far fa-clone", "far fa-closed-captioning", "far fa-comment", "far fa-comment-alt", "far fa-comment-dots", "far fa-comments", "far fa-compass", "far fa-copy", "far fa-copyright", "far fa-credit-card", "far fa-dizzy", "far fa-dot-circle", "far fa-edit", "far fa-envelope", "far fa-envelope-open", "far fa-eye", "far fa-eye-slash", "far fa-file", "far fa-file-alt", "far fa-file-archive", "far fa-file-audio", "far fa-file-code", "far fa-file-excel", "far fa-file-image", "far fa-file-pdf", "far fa-file-powerpoint", 
                    "far fa-file-video", "far fa-file-word", "far fa-flag", "far fa-flushed", "far fa-folder", "far fa-folder-open", "far fa-frown", "far fa-frown-open", "far fa-futbol", "far fa-gem", "far fa-grimace", "far fa-grin", "far fa-grin-alt", "far fa-grin-beam",  "far fa-grin-beam-sweat", "far fa-grin-hearts", "far fa-grin-squint", "far fa-grin-squint-tears", "far fa-grin-stars", "far fa-grin-tears", "far fa-grin-tongue", "far fa-grin-tongue-squint", "far fa-grin-tongue-wink", "far fa-grin-wink", "far fa-hand-lizard",
                    "far fa-hand-paper", "far fa-hand-peace", "far fa-hand-point-down", "far fa-hand-point-left", "far fa-hand-point-right", "far fa-hand-point-up", "far fa-hand-pointer", "far fa-hand-rock", "far fa-hand-scissors", "far fa-hand-spock", "far fa-handshake",  "far fa-hdd", "far fa-heart", "far fa-hospital", "far fa-hourglass", "far fa-id-badge", "far fa-id-card", "far fa-image", "far fa-images", "far fa-keyboard", "far fa-kiss", "far fa-kiss-beam", "far fa-kiss-wink-heart", "far fa-laugh", "far fa-laugh-beam",
                    "far fa-laugh-squint", "far fa-laugh-wink", "far fa-lemon", "far fa-life-ring", "far fa-lightbulb", "far fa-list-alt", "far fa-map", "far fa-meh", "far fa-meh-blank", "far fa-meh-rolling-eyes", "far fa-minus-square", "far fa-money-bill-alt", "far fa-moon",  "far fa-newspaper", "far fa-object-group", "far fa-object-ungroup", "far fa-paper-plane", "far fa-pause-circle", "far fa-play-circle", "far fa-plus-square", "far fa-question-circle", "far fa-registered", "far fa-sad-cry", "far fa-sad-tear", "far fa-save", 
                    "far fa-share-square", "far fa-smile", "far fa-smile-beam", "far fa-smile-wink", "far fa-snowflake", "far fa-square", "far fa-star", "far fa-star-half", "far fa-sticky-note", "far fa-stop-circle", "far fa-sun", "far fa-surprise", "far fa-thumbs-down", "far fa-thumbs-up", "far fa-times-circle", "far fa-tired", "far fa-trash-alt", "far fa-user", "far fa-user-circle", "far fa-window-close", "far fa-window-maximize", "far fa-window-minimize", "far fa-window-restore", "fas fa-ad", "fas fa-address-book", 
                    "fas fa-address-card", "fas fa-adjust", "fas fa-air-freshener", "fas fa-align-center", "fas fa-align-justify", "fas fa-align-left", "fas fa-align-right", "fas fa-allergies", "fas fa-ambulance", "fas fa-american-sign-language-interpreting", "fas fa-anchor", "fas fa-angle-double-down", "fas fa-angle-double-left", "fas fa-angle-double-right", "fas fa-angle-double-up", "fas fa-angle-down", "fas fa-angle-left", "fas fa-angle-right", "fas fa-angle-up", "fas fa-angry", "fas fa-ankh", "fas fa-apple-alt",
                    "fas fa-archive", "fas fa-archway", "fas fa-arrow-alt-circle-down", "fas fa-arrow-alt-circle-left", "fas fa-arrow-alt-circle-right", "fas fa-arrow-alt-circle-up", "fas fa-arrow-circle-down", "fas fa-arrow-circle-left", "fas fa-arrow-circle-right", "fas fa-arrow-circle-up", "fas fa-arrow-down", "fas fa-arrow-left", "fas fa-arrow-right", "fas fa-arrow-up", "fas fa-arrows-alt", "fas fa-arrows-alt-h", "fas fa-arrows-alt-v", "fas fa-assistive-listening-systems", "fas fa-asterisk", "fas fa-at", 
                    "fas fa-atlas", "fas fa-atom", "fas fa-audio-description", "fas fa-award", "fas fa-backspace", "fas fa-backward", "fas fa-balance-scale", "fas fa-ban", "fas fa-band-aid", "fas fa-barcode", "fas fa-bars", "fas fa-baseball-ball", "fas fa-basketball-ball", "fas fa-bath", "fas fa-battery-empty", "fas fa-battery-full", "fas fa-battery-half", "fas fa-battery-quarter", "fas fa-battery-three-quarters", "fas fa-bed", "fas fa-beer", "fas fa-bell", "fas fa-bell-slash", "fas fa-bezier-curve", "fas fa-bible", "fas fa-bicycle",
                    "fas fa-binoculars", "fas fa-birthday-cake", "fas fa-blender", "fas fa-blind", "fas fa-bold", "fas fa-bolt", "fas fa-bomb", "fas fa-bone", "fas fa-bong", "fas fa-book", "fas fa-book-open", "fas fa-book-reader", "fas fa-bookmark", "fas fa-bowling-ball",  "fas fa-box", "fas fa-box-open", "fas fa-boxes", "fas fa-braille", "fas fa-brain", "fas fa-briefcase", "fas fa-briefcase-medical", "fas fa-broadcast-tower", "fas fa-broom", "fas fa-brush", "fas fa-bug", "fas fa-building", "fas fa-bullhorn", "fas fa-bullseye", 
                    "fas fa-burn", "fas fa-bus", "fas fa-bus-alt", "fas fa-business-time", "fas fa-calculator", "fas fa-calendar", "fas fa-calendar-alt", "fas fa-calendar-check", "fas fa-calendar-minus", "fas fa-calendar-plus", "fas fa-calendar-times", "fas fa-camera", "fas fa-camera-retro", "fas fa-cannabis", "fas fa-capsules", "fas fa-car", "fas fa-car-alt", "fas fa-car-battery", "fas fa-car-crash", "fas fa-car-side", "fas fa-caret-down", "fas fa-caret-left", "fas fa-caret-right", "fas fa-caret-square-down",
                    "fas fa-caret-square-left", "fas fa-caret-square-right", "fas fa-caret-square-up", "fas fa-caret-up", "fas fa-cart-arrow-down", "fas fa-cart-plus", "fas fa-certificate", "fas fa-chalkboard", "fas fa-chalkboard-teacher", "fas fa-charging-station", "fas fa-chart-area", "fas fa-chart-bar", "fas fa-chart-line", "fas fa-chart-pie", "fas fa-check", "fas fa-check-circle", "fas fa-check-double", "fas fa-check-square", "fas fa-chess", "fas fa-chess-bishop", "fas fa-chess-board", "fas fa-chess-king", 
                    "fas fa-chess-knight", "fas fa-chess-pawn", "fas fa-chess-queen", "fas fa-chess-rook", "fas fa-chevron-circle-down", "fas fa-chevron-circle-left", "fas fa-chevron-circle-right", "fas fa-chevron-circle-up", "fas fa-chevron-down", "fas fa-chevron-left", "fas fa-chevron-right", "fas fa-chevron-up", "fas fa-child", "fas fa-church", "fas fa-circle", "fas fa-circle-notch", "fas fa-city", "fas fa-clipboard", "fas fa-clipboard-check", "fas fa-clipboard-list", "fas fa-clock", "fas fa-clone", "fas fa-closed-captioning",
                    "fas fa-cloud", "fas fa-cloud-download-alt", "fas fa-cloud-upload-alt", "fas fa-cocktail", "fas fa-code", "fas fa-code-branch", "fas fa-coffee", "fas fa-cog", "fas fa-cogs", "fas fa-coins", "fas fa-columns", "fas fa-comment", "fas fa-comment-alt", "fas fa-comment-dollar", "fas fa-comment-dots", "fas fa-comment-slash", "fas fa-comments", "fas fa-comments-dollar", "fas fa-compact-disc", "fas fa-compass", "fas fa-compress", "fas fa-concierge-bell", "fas fa-cookie", "fas fa-cookie-bite", "fas fa-copy",
                    "fas fa-copyright", "fas fa-couch", "fas fa-credit-card", "fas fa-crop", "fas fa-crop-alt", "fas fa-cross", "fas fa-crosshairs", "fas fa-crow", "fas fa-crown", "fas fa-cube", "fas fa-cubes", "fas fa-cut", "fas fa-database", "fas fa-deaf", "fas fa-desktop",  "fas fa-dharmachakra", "fas fa-diagnoses", "fas fa-dice", "fas fa-dice-five", "fas fa-dice-four", "fas fa-dice-one", "fas fa-dice-six", "fas fa-dice-three", "fas fa-dice-two", "fas fa-digital-tachograph", "fas fa-directions", "fas fa-divide", "fas fa-dizzy", 
                    "fas fa-dna", "fas fa-dollar-sign", "fas fa-dolly", "fas fa-dolly-flatbed", "fas fa-donate", "fas fa-door-closed", "fas fa-door-open", "fas fa-dot-circle", "fas fa-dove", "fas fa-download", "fas fa-drafting-compass", "fas fa-draw-polygon", "fas fa-drum", "fas fa-drum-steelpan", "fas fa-dumbbell", "fas fa-edit", "fas fa-eject", "fas fa-ellipsis-h", "fas fa-ellipsis-v", "fas fa-envelope", "fas fa-envelope-open", "fas fa-envelope-open-text", "fas fa-envelope-square", "fas fa-equals", "fas fa-eraser", "fas fa-euro-sign",
                    "fas fa-exchange-alt", "fas fa-exclamation", "fas fa-exclamation-circle", "fas fa-exclamation-triangle", "fas fa-expand", "fas fa-expand-arrows-alt", "fas fa-external-link-alt", "fas fa-external-link-square-alt", "fas fa-eye", "fas fa-eye-dropper", "fas fa-eye-slash",  "fas fa-fast-backward", "fas fa-fast-forward", "fas fa-fax", "fas fa-feather", "fas fa-feather-alt", "fas fa-female", "fas fa-fighter-jet", "fas fa-file", "fas fa-file-alt", "fas fa-file-archive", "fas fa-file-audio", "fas fa-file-code", "fas fa-file-contract", 
                    "fas fa-file-download", "fas fa-file-excel", "fas fa-file-export", "fas fa-file-image", "fas fa-file-import", "fas fa-file-invoice", "fas fa-file-invoice-dollar", "fas fa-file-medical", "fas fa-file-medical-alt", "fas fa-file-pdf", "fas fa-file-powerpoint",  "fas fa-file-prescription", "fas fa-file-signature", "fas fa-file-upload", "fas fa-file-video", "fas fa-file-word", "fas fa-fill", "fas fa-fill-drip", "fas fa-film", "fas fa-filter", "fas fa-fingerprint", "fas fa-fire", "fas fa-fire-extinguisher", 
                    "fas fa-first-aid", "fas fa-fish", "fas fa-flag", "fas fa-flag-checkered", "fas fa-flask", "fas fa-flushed", "fas fa-folder", "fas fa-folder-minus", "fas fa-folder-open", "fas fa-folder-plus", "fas fa-font", "fas fa-football-ball", "fas fa-forward", "fas fa-frog", "fas fa-frown", "fas fa-frown-open", "fas fa-funnel-dollar", "fas fa-futbol", "fas fa-gamepad", "fas fa-gas-pump", "fas fa-gavel", "fas fa-gem", "fas fa-genderless", "fas fa-gift", "fas fa-glass-martini", "fas fa-glass-martini-alt", "fas fa-glasses", "fas fa-globe", 
                    "fas fa-globe-africa", "fas fa-globe-americas", "fas fa-globe-asia", "fas fa-golf-ball", "fas fa-gopuram", "fas fa-graduation-cap", "fas fa-greater-than", "fas fa-greater-than-equal", "fas fa-grimace", "fas fa-grin", "fas fa-grin-alt", "fas fa-grin-beam", "fas fa-grin-beam-sweat",  "fas fa-grin-hearts", "fas fa-grin-squint", "fas fa-grin-squint-tears", "fas fa-grin-stars", "fas fa-grin-tears", "fas fa-grin-tongue", "fas fa-grin-tongue-squint", "fas fa-grin-tongue-wink", "fas fa-grin-wink", "fas fa-grip-horizontal", "fas fa-grip-vertical",
                    "fas fa-h-square", "fas fa-hamsa", "fas fa-hand-holding", "fas fa-hand-holding-heart", "fas fa-hand-holding-usd", "fas fa-hand-lizard", "fas fa-hand-paper", "fas fa-hand-peace", "fas fa-hand-point-down", "fas fa-hand-point-left", "fas fa-hand-point-right", "fas fa-hand-point-up", "fas fa-hand-pointer", "fas fa-hand-rock", "fas fa-hand-scissors", "fas fa-hand-spock", "fas fa-hands", "fas fa-hands-helping", "fas fa-handshake", "fas fa-hashtag", "fas fa-haykal", "fas fa-hdd", "fas fa-heading", "fas fa-headphones", 
                    "fas fa-headphones-alt", "fas fa-headset", "fas fa-heart", "fas fa-heartbeat", "fas fa-helicopter", "fas fa-highlighter", "fas fa-history", "fas fa-hockey-puck", "fas fa-home", "fas fa-hospital", "fas fa-hospital-alt", "fas fa-hospital-symbol", "fas fa-hot-tub", "fas fa-hotel", "fas fa-hourglass", "fas fa-hourglass-end", "fas fa-hourglass-half", "fas fa-hourglass-start", "fas fa-i-cursor", "fas fa-id-badge", "fas fa-id-card", "fas fa-id-card-alt", "fas fa-image", "fas fa-images", "fas fa-inbox", "fas fa-indent",
                    "fas fa-industry", "fas fa-infinity", "fas fa-info", "fas fa-info-circle", "fas fa-italic", "fas fa-jedi", "fas fa-joint", "fas fa-journal-whills", "fas fa-kaaba", "fas fa-key", "fas fa-keyboard", "fas fa-khanda", "fas fa-kiss", "fas fa-kiss-beam", "fas fa-kiss-wink-heart", "fas fa-kiwi-bird", "fas fa-landmark", "fas fa-language", "fas fa-laptop", "fas fa-laptop-code", "fas fa-laugh", "fas fa-laugh-beam", "fas fa-laugh-squint", "fas fa-laugh-wink", "fas fa-layer-group", "fas fa-leaf", "fas fa-lemon",
                    "fas fa-less-than", "fas fa-less-than-equal", "fas fa-level-down-alt", "fas fa-level-up-alt", "fas fa-life-ring", "fas fa-lightbulb", "fas fa-link", "fas fa-lira-sign", "fas fa-list", "fas fa-list-alt", "fas fa-list-ol", "fas fa-list-ul", "fas fa-location-arrow", "fas fa-lock", "fas fa-lock-open", "fas fa-long-arrow-alt-down", "fas fa-long-arrow-alt-left", "fas fa-long-arrow-alt-right", "fas fa-long-arrow-alt-up", "fas fa-low-vision", "fas fa-luggage-cart", "fas fa-magic", "fas fa-magnet", "fas fa-mail-bulk", 
                    "fas fa-male", "fas fa-map", "fas fa-map-marked", "fas fa-map-marked-alt", "fas fa-map-marker", "fas fa-map-marker-alt", "fas fa-map-pin", "fas fa-map-signs", "fas fa-marker", "fas fa-mars", "fas fa-mars-double", "fas fa-mars-stroke", "fas fa-mars-stroke-h", "fas fa-mars-stroke-v", "fas fa-medal", "fas fa-medkit", "fas fa-meh", "fas fa-meh-blank", "fas fa-meh-rolling-eyes", "fas fa-memory", "fas fa-menorah", "fas fa-mercury", "fas fa-microchip", "fas fa-microphone", "fas fa-microphone-alt", 
                    "fas fa-microphone-alt-slash", "fas fa-microphone-slash", "fas fa-microscope", "fas fa-minus", "fas fa-minus-circle", "fas fa-minus-square", "fas fa-mobile", "fas fa-mobile-alt", "fas fa-money-bill", "fas fa-money-bill-alt", "fas fa-money-bill-wave",  "fas fa-money-bill-wave-alt", "fas fa-money-check", "fas fa-money-check-alt", "fas fa-monument", "fas fa-moon", "fas fa-mortar-pestle", "fas fa-mosque", "fas fa-motorcycle", "fas fa-mouse-pointer", "fas fa-music", "fas fa-neuter", "fas fa-newspaper", 
                    "fas fa-not-equal", "fas fa-notes-medical", "fas fa-object-group", "fas fa-object-ungroup", "fas fa-oil-can", "fas fa-om", "fas fa-outdent", "fas fa-paint-brush", "fas fa-paint-roller", "fas fa-palette", "fas fa-pallet", "fas fa-paper-plane", "fas fa-paperclip", "fas fa-parachute-box", "fas fa-paragraph", "fas fa-parking", "fas fa-passport", "fas fa-pastafarianism", "fas fa-paste", "fas fa-pause", "fas fa-pause-circle", "fas fa-paw", "fas fa-peace", "fas fa-pen", "fas fa-pen-alt", "fas fa-pen-fancy", "fas fa-pen-nib",
                    "fas fa-pen-square", "fas fa-pencil-alt", "fas fa-pencil-ruler", "fas fa-people-carry", "fas fa-percent", "fas fa-percentage", "fas fa-phone", "fas fa-phone-slash", "fas fa-phone-square", "fas fa-phone-volume", "fas fa-piggy-bank", "fas fa-pills",  "fas fa-place-of-worship", "fas fa-plane", "fas fa-plane-arrival", "fas fa-plane-departure", "fas fa-play", "fas fa-play-circle", "fas fa-plug", "fas fa-plus", "fas fa-plus-circle", "fas fa-plus-square", "fas fa-podcast", "fas fa-poll", "fas fa-poll-h", 
                    "fas fa-poo", "fas fa-poop", "fas fa-portrait", "fas fa-pound-sign", "fas fa-power-off", "fas fa-pray", "fas fa-praying-hands", "fas fa-prescription", "fas fa-prescription-bottle", "fas fa-prescription-bottle-alt", "fas fa-print", "fas fa-procedures", "fas fa-project-diagram", "fas fa-puzzle-piece", "fas fa-qrcode", "fas fa-question", "fas fa-question-circle", "fas fa-quidditch", "fas fa-quote-left", "fas fa-quote-right", "fas fa-quran", "fas fa-random", "fas fa-receipt", "fas fa-recycle", "fas fa-redo",
                    "fas fa-redo-alt", "fas fa-registered", "fas fa-reply", "fas fa-reply-all", "fas fa-retweet", "fas fa-ribbon", "fas fa-road", "fas fa-robot", "fas fa-rocket", "fas fa-route", "fas fa-rss", "fas fa-rss-square", "fas fa-ruble-sign", "fas fa-ruler", "fas fa-ruler-combined", "fas fa-ruler-horizontal", "fas fa-ruler-vertical", "fas fa-rupee-sign", "fas fa-sad-cry", "fas fa-sad-tear", "fas fa-save", "fas fa-school", "fas fa-screwdriver", "fas fa-search", "fas fa-search-dollar", "fas fa-search-location", "fas fa-search-minus",
                    "fas fa-search-plus", "fas fa-seedling", "fas fa-server", "fas fa-shapes", "fas fa-share", "fas fa-share-alt", "fas fa-share-alt-square", "fas fa-share-square", "fas fa-shekel-sign", "fas fa-shield-alt", "fas fa-ship", "fas fa-shipping-fast",  "fas fa-shoe-prints", "fas fa-shopping-bag", "fas fa-shopping-basket", "fas fa-shopping-cart", "fas fa-shower", "fas fa-shuttle-van", "fas fa-sign", "fas fa-sign-in-alt", "fas fa-sign-language", "fas fa-sign-out-alt", "fas fa-signal", "fas fa-signature", 
                    "fas fa-sitemap", "fas fa-skull", "fas fa-sliders-h", "fas fa-smile", "fas fa-smile-beam", "fas fa-smile-wink", "fas fa-smoking", "fas fa-smoking-ban", "fas fa-snowflake", "fas fa-socks", "fas fa-solar-panel", "fas fa-sort", "fas fa-sort-alpha-down",  "fas fa-sort-alpha-up", "fas fa-sort-amount-down", "fas fa-sort-amount-up", "fas fa-sort-down", "fas fa-sort-numeric-down", "fas fa-sort-numeric-up", "fas fa-sort-up", "fas fa-spa", "fas fa-space-shuttle", "fas fa-spinner", "fas fa-splotch", "fas fa-spray-can", 
                    "fas fa-square", "fas fa-square-full", "fas fa-square-root-alt", "fas fa-stamp", "fas fa-star", "fas fa-star-and-crescent", "fas fa-star-half", "fas fa-star-half-alt", "fas fa-star-of-david", "fas fa-star-of-life", "fas fa-step-backward", "fas fa-step-forward", "fas fa-stethoscope", "fas fa-sticky-note", "fas fa-stop", "fas fa-stop-circle", "fas fa-stopwatch", "fas fa-store", "fas fa-store-alt", "fas fa-stream", "fas fa-street-view", "fas fa-strikethrough", "fas fa-stroopwafel", "fas fa-subscript", "fas fa-subway",
                    "fas fa-suitcase", "fas fa-suitcase-rolling", "fas fa-sun", "fas fa-superscript", "fas fa-surprise", "fas fa-swatchbook", "fas fa-swimmer", "fas fa-swimming-pool", "fas fa-synagogue", "fas fa-sync", "fas fa-sync-alt", "fas fa-syringe", "fas fa-table",  "fas fa-table-tennis", "fas fa-tablet", "fas fa-tablet-alt", "fas fa-tablets", "fas fa-tachometer-alt", "fas fa-tag", "fas fa-tags", "fas fa-tape", "fas fa-tasks", "fas fa-taxi", "fas fa-teeth", "fas fa-teeth-open", "fas fa-terminal", "fas fa-text-height",
                    "fas fa-text-width", "fas fa-th", "fas fa-th-large", "fas fa-th-list", "fas fa-theater-masks", "fas fa-thermometer", "fas fa-thermometer-empty", "fas fa-thermometer-full", "fas fa-thermometer-half", "fas fa-thermometer-quarter", "fas fa-thermometer-three-quarters",  "fas fa-thumbs-down", "fas fa-thumbs-up", "fas fa-thumbtack", "fas fa-ticket-alt", "fas fa-times", "fas fa-times-circle", "fas fa-tint", "fas fa-tint-slash", "fas fa-tired", "fas fa-toggle-off", "fas fa-toggle-on", "fas fa-toolbox", "fas fa-tooth", "fas fa-torah",
                    "fas fa-torii-gate", "fas fa-trademark", "fas fa-traffic-light", "fas fa-train", "fas fa-transgender", "fas fa-transgender-alt", "fas fa-trash", "fas fa-trash-alt", "fas fa-tree", "fas fa-trophy", "fas fa-truck", "fas fa-truck-loading", "fas fa-truck-monster", "fas fa-truck-moving", "fas fa-truck-pickup", "fas fa-tshirt", "fas fa-tty", "fas fa-tv", "fas fa-umbrella", "fas fa-umbrella-beach", "fas fa-underline", "fas fa-undo", "fas fa-undo-alt", "fas fa-universal-access", "fas fa-university", "fas fa-unlink", 
                    "fas fa-unlock", "fas fa-unlock-alt", "fas fa-upload", "fas fa-user", "fas fa-user-alt", "fas fa-user-alt-slash", "fas fa-user-astronaut", "fas fa-user-check", "fas fa-user-circle", "fas fa-user-clock", "fas fa-user-cog", "fas fa-user-edit", "fas fa-user-friends", "fas fa-user-graduate", "fas fa-user-lock", "fas fa-user-md", "fas fa-user-minus", "fas fa-user-ninja", "fas fa-user-plus", "fas fa-user-secret", "fas fa-user-shield", "fas fa-user-slash", "fas fa-user-tag", "fas fa-user-tie", "fas fa-user-times", "fas fa-users",
                    "fas fa-users-cog", "fas fa-utensil-spoon", "fas fa-utensils", "fas fa-vector-square", "fas fa-venus", "fas fa-venus-double", "fas fa-venus-mars", "fas fa-vial", "fas fa-vials", "fas fa-video", "fas fa-video-slash", "fas fa-vihara", "fas fa-volleyball-ball",  "fas fa-volume-down", "fas fa-volume-off", "fas fa-volume-up", "fas fa-walking", "fas fa-wallet", "fas fa-warehouse", "fas fa-weight", "fas fa-weight-hanging", "fas fa-wheelchair", "fas fa-wifi", "fas fa-window-close", "fas fa-window-maximize", "fas fa-window-minimize", 
                    "fas fa-window-restore", "fas fa-wine-glass", "fas fa-wine-glass-alt", "fas fa-won-sign", "fas fa-wrench", "fas fa-x-ray", "fas fa-yen-sign", "fas fa-yin-yang"];
           
                
                for (var i=0;i<scope.icons.length;i++)  scope.filteredIcons.push({full:scope.icons[i],shorty:scope.icons[i].substring(7)});
                scope.itemsLoaded = true;
              
                           
                 scope.showIconsFunc = function (state) {
                      scope.showIcons=state;
                      scope.showButtons=state;  
                      scope.iconsFilter.filter='';
                     
                 };
                 
                  scope.showButtonsFunc = function (state) {
                      scope.showButtons=state;  
                 }
                
                //if (scope.selectedIcon=="" || scope.selectedIcon==undefined) scope.selectedIcon = "fa fa-fw";
                  scope.iconChosen = function (id) {
                    //  scope.showIcons=false;
                      scope.selectedIcon=id.full;
                     //console.log('iconChosen '+id);
                 }
                 
                   scope.setBtnClass = function () {
                    var btnCls ="btn btn-outline-primary btn-sm";
                    if (scope.selectedButton!="" && scope.selectedButton!=undefined)
                    
                    {
                        btnCls = scope.selectedButton+" btn btn-sm";
                    }
                        return btnCls;
                 };
                  
                   
                 scope.pickIcon = function () {
                     scope.showIcons=true;
                     scope.showButtons=false; 
                   // console.log('pickIcon2='+  $scope.selectedIcon);
                 }   

                 scope.pickAll= function () {
                     scope.showIcons=true;
                     scope.showButtons=true;
                     console.log('pick button');
                  }
				 
                scope.pickButton = function () {
                     scope.showButtons=true;
                     scope.showIcons=false;
                     //console.log('pick button='+  $scope.selectedButton);
                 }   
                 
                  scope.buttonChosen = function (id) {
                      //scope.showButtons=false;
                      scope.selectedButton=id;
                    // console.log('ButtonChosen '+id);
                 }
                   

                  scope.filterFn = function(currIcon)
                        {
                          // console.log(scope);
                         //  return true;
                        if (currIcon.indexOf(scope.iconsFilter.filter)!== -1)
                            {
                                return true; // this will be listed in the results
                            }
                            return false; // otherwise it won't be within the results
          
                        };
                
                scope.hideBtns=function()
                  {
                    scope.showButtons=false;
                    
                  };
  
                 scope.colLength = ['col-lg-2','col-lg-4','col-lg-6','col-lg-8','col-lg-10','col-lg-12','col-lg-14','col-lg-16','col-lg-18','col-lg-20','col-lg-22','col-lg-24'];
  
                
                scope.getFilteringStatus=function()
                  {
                    
                    return  scope.iconsFilter.filteringIcons;
                    
                  };

                scope.changed_filter=function () {
                   
                 
                 
                   
                       scope.filteredIcons.length=0;
                          for (var i=0;i<scope.icons.length;i++)  {
                               if (scope.icons[i].indexOf(scope.iconsFilter.filter,7)!== -1) scope.filteredIcons.push({full:scope.icons[i],shorty:scope.icons[i].substring(7)});
                          }                           
                };
                  
                  
                  
                    
             },
             scope:{
                  selectedIcon:'=',
                  selectedButton:'=',
                  btnLabel:'=',
                  selectIcons:'=',
                  selectColors:'=',
                  uniqueId:'=',
                  showIcons:'<',
                  showButtons:'<',
                  designMode:'<',

            
        }
      }
};
'use strict';

export function ktImage () {
        return {
            restrict: 'A',
	  controller: function ($scope,GridsterService) {
                
                if ($scope.localVars==undefined) $scope.localVars={};
                
                $scope.colLength=[];
                for (let i=0;i<24;i++) $scope.colLength.push('col-'+(i+1));
                
                
                $scope.gsrvc= GridsterService;
               
               },
             templateUrl: 'ktdirectivetemplates/ktImage.html',
             link: function (rootScope,scope, elem, attrs) {
              
             
               
            }
        };
};
'use strict';

export function ktInitiateTaskWidget () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktInitiateTaskWidget.html',
             /*scope: {
                inputParameters: '=',
                //selectedItem: '=',
                inputArray: '=',
            },*/
             controller: function($scope,$rootScope,UserService,ResourcesDataService,TaskDataService,MessagingService,KatalyoStateManager,GridsterService) {
                
                 $scope.gsrvc= GridsterService;
                 if (!Array.isArray($scope.fd.selectedTasks)) $scope.fd.selectedTasks=[];
                if ($scope.taskDefinition!=undefined)
                {
                  $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
                }
                if ($scope.localVars == undefined) $scope.localVars={};
                //$scope.localVars.showInlineTaskLocal = false;
                //$scope.fd.InlineTask=true; // ToDo change later when properties become available
                //$scope.localVars.isInlineTask=$scope.fd.InlineTask;
                $scope.localVars.loadedTasks = [];
                $scope.localVars.taskItem = null;
                $scope.localVars.selectedTask = {};
                if ($scope.fd.ElementType=="itask") $scope.localVars.datasetMapperType=0;                
                
                
                
                /*********** SETUP KATALYO STATE MANAGER *************************/
                $scope.ksm = KatalyoStateManager;
                let initiatedTaskId=null;
                let initiateTaskState= $scope.ksm.addSubject('initiateTaskStateName'+$scope.fd.PresentationId,initiatedTaskId);
                let initiateTaskStateName = initiateTaskState.subject.name;
                
                let task_initiated = function(data)
                {
                    initiateTaskState.subject.setStateChanges = data;
                    initiateTaskState.subject.notifyObservers("taskInitiated");
                    
                };
                
                let action_task_initiated = $scope.ksm.addAction(initiateTaskStateName,"taskInitiated",task_initiated);
               
                
                               
                $scope.$on('InlineTaskClosed',function(event,data){
                    //var index=data;
                    //$scope.localVars.loadedTasks.splice(index,1);
                    var taskId=data;
                    var pos = $scope.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos>=0)
                    {
                      $scope.localVars.loadedTasks.splice(pos,1);  
                    }
                });
               
                //var taskDefId = $stateParams.id;
                var lang=$rootScope.globals.currentUser.lang;
                $scope.localVars.taskListParameters = {placeholder:'Select or search task...',label:$scope.fd.placeholder,name:'task',
                  paddingLeft:true,selectedItem:null,hideLabel:true,columnSizeLabel:'col-lg-24',dropdownSize:'col-lg-24',onSelectFunction:''};
              
                if ($scope.fd.selectedTasks==undefined) $scope.fd.selectedTasks = [];
                $scope.localVars.selectedTaskIndex=-1;
                if ($scope.fd.ElementType=='itask')
                {
                  if ($scope.fd.wItemValue!=null) {
                     $scope.fd.selectedTasks = $scope.fd.wItemValue;
                  }else
                  {
                    $scope.fd.wItemValue = [];
                  	
                  }
                }else
                  {
                    if ($scope.fd.tItemValue!=null) {
                     $scope.fd.selectedTasks = $scope.fd.tItemValue;
                    }else
                    {
                    $scope.fd.tItemValue = [];
                  	
                    } 
                    
                  }
                  
                  $scope.localVars.LoadTask=function(taskId,outcomeId,previousTask,openTaskType)
                  {
                    
                    var localVars = {'isInlineTask':$scope.localVars.isInlineTask,'OpenTaskType':openTaskType,'taskIndex':$scope.localVars.loadedTasks.length,'loadTaskDirect' : true,'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,};
                    
                    if (openTaskType!="newPage") localVars.ShowCloseBtn = true;
                    else localVars.ShowReturnBtn = true;
                    var pos = $scope.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos<0 && openTaskType=="current")
                    {
                        $scope.localVars.loadedTasks.splice(0,0,{'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        
                    }else if (openTaskType=="inline")
                    {
                        $scope.localVars.loadedTasks.length=0;
                        $scope.localVars.loadedTasks.push({'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                    }else if (openTaskType=="container")
                    {
                        localVars = {'isInlineTask':$scope.localVars.isInlineTask,'OpenTaskType':'current','taskIndex':0,'loadTaskDirect' : true,'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,};
                    
                         $scope.ksm.executeAction(initiateTaskStateName,"taskInitiated", {'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                                
                    }
                    
                    if (openTaskType=="newPage") {
                        $scope.gsrvc.setTaskDataInNewPage({'localVars':localVars,'taskDefinition':$scope.taskDefinition});
                    }
                    $scope.gsrvc.setOpenTaskType(openTaskType);
                    
                  }
                  
                  $scope.localVars.taskSelected = function(item,model)
                  {
                    $scope.localVars.taskListParameters.selectedItem = item;
                    $scope.localVars.selectedTask={};
                  }
                  
                   $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localVars.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  }
                 
                   $scope.localVars.ShowTaskDefinition = function (taskId){
                    
                    for (var i=0;i<$scope.fd.selectedTasks.length;i++)
                    {
                      if ($scope.fd.selectedTasks[i].id==taskId)
                      {
                        $scope.localVars.selectedTaskIndex=i;
                        break;
                      }
                      
                    }
                    
                   }
                  
                  $scope.localVars.AddTaskToList = function (){
                 
                 
                      $scope.localVars.selectedTask.id = $scope.localVars.taskItem.id;
                      $scope.localVars.selectedTask.name = $scope.localVars.taskItem.name;
                      $scope.localVars.selectedTask.btnLabel = $scope.localVars.selectedTask.name;
                      $scope.localVars.selectedTask.btnClass = "btn-primary";
                   
                      var pos = $scope.fd.selectedTasks.map(function(e) { if (e!=undefined) return e.id; else return null;}).indexOf($scope.localVars.selectedTask.id);
              
                      if (pos<0){
                      
                         $scope.fd.selectedTasks.push(angular.copy($scope.localVars.selectedTask));
                      }
                      if ($scope.fd.ElementType=='itask')
                      {
                        $scope.fd.wItemValue = $scope.fd.selectedTasks;
                      }else
                      {
                            $scope.fd.tItemValue = $scope.fd.selectedTasks;
                
                      
                      }
                      $scope.localVars.ShowTaskDefinition($scope.localVars.selectedTask.id);
                    
                    
                 };
                  
                   $scope.localVars.RemoveTaskFromList = function (index){
                 
                  
                   if (index>=0){
             
                             $scope.fd.selectedTasks.splice(index,1);
                                  
                   }
                            
                      
                  if ($scope.fd.ElementType=='itask')
                    {
                      $scope.fd.wItemValue = $scope.selectedTasks;
                    }else
                    {
                    $scope.fd.tItemValue = $scope.selectedTasks;
                
                      
                    }
                    
                 }
          
          
                 $scope.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.menu.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
                                                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
             if   ($scope.gsrvc.getFormViewType()==1 || $scope.fd.ElementType=='itask')
             {
                ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                    
                                  $scope.localVars.taskList = data.data;
                                                               
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
                }
                
                
                },
             link: function (scope, elem, attrs) {
                
               
        }       
              
    }
  
};
'use strict';

export function ktLabel () {
        return {
            restrict: 'A',
		
             templateUrl: 'ktdirectivetemplates/ktLabel.html',
             controller: function($scope,GridsterService){
                
                $scope.gsrvc = GridsterService;
                
                $scope.colLength=[];
                for (let i=0;i<24;i++) $scope.colLength.push('col-'+(i+1));
                
                $scope.showProperties = function(event)
                {
                  $scope.gsrvc.setFieldProperties($scope.fd,event);
       
                };
                },
             link: function (scope, elem, attrs) {
              
            
            
           
            }
        };
};
'use strict';

export function ktList () {

        return {
            restrict: 'A',
            controller: function ($scope,CodesService,$rootScope,MessagingService,GridsterService,KatalyoStateManager,$compile,$element,$templateCache){
                
                 $scope.gsrvc = GridsterService;
                 let field_name = 'Field'+$scope.fd.ItemId;
                 let elementObject = {};
                 elementObject[field_name]=null;
                 if ($scope.formData==undefined)
                 {
                    $scope.formData=[];
                    $scope.formData.push(elementObject);
                 }
                  if ($scope.formData.length == 0) $scope.formData.push({});
                 // else if ($scope.formData[0][field_name]==undefined) $scope.formData[0][field_name] =null;
                $scope.itemValue = {val:$scope.formData[0][field_name]};
                
                $scope.ksm = KatalyoStateManager;
                if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
               
                
                let listValueState= $scope.ksm.addSubject('listValueStateName'+$scope.fd.ItemId,$scope.itemValue.val);
                let listValueStateName = listValueState.subject.name;
                
                let value_changed = function(data)
                {
                    listValueState.subject.setStateChanges = data;
                    listValueState.subject.notifyObservers("valueChanged");
                };
                
                let action_value_changed = $scope.ksm.addAction(listValueStateName,"valueChanged",value_changed);
               
                
                let apply_value = function(data)
                {
                    if ($scope.formData[0][field_name]!=data) $scope.formData[0][field_name] = data;
                }; 
               
                if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
                
                {
                    if ($scope.fd.Parameters.DependentFieldId!="")
                    {
                        let dependent_field = "Field"+$scope.fd.Parameters.DependentFieldId;
                        let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                        let observer_undo = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value,true);
                        
                    }
                }
        
                
                $scope.search=[
				{id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
				{id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                ];
				
             if ($scope.fd.Search==undefined) $scope.fd.Search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                    
             /*
                if ($scope.showSearchFilters && $scope.formData!=undefined && $scope.fd.Search.value!=undefined)
                {
                  if ($scope.formData.length>0) $scope.formData[0][field_name] = $scope.fd.Search.value;
                }
               */ 
                
                $scope.setDropdownValue=function(theSelectItemFn)
                {
                    $scope.setItemValueDropdown = theSelectItemFn;
                
                }
                
                $scope.setClearDropdown = function(directiveFn) {
                        $scope.clearDropdown = directiveFn;
                }
                
                /*
                $scope.$watch("itemValue.val",function(newValue,oldValue){
                  
                  if (newValue!=oldValue)
                  {
                     //if ($scope.showSearchFilters)
                     $scope.formData[0][field_name] = newValue;
                     if ($scope.setItemValueDropdown!=undefined) $scope.setItemValueDropdown(null,newValue);
                
                     $scope.fd.Search.value = $scope.formData[0][field_name];
                     $scope.fd.DefaultValue = $scope.formData[0][field_name];
                     $scope.ksm.executeAction(listValueStateName,"valueChanged", $scope.formData[0][field_name]);
                  } 
                  });
                  */
                $scope.$watch('itemValue.val',function(newValue,oldValue){
                    if (newValue!=oldValue && newValue==null)
                    {
                        $scope.formData[0][field_name] = null;
                        $scope.fd.Search.value = null;
                        $scope.fd.DefaultValue = null;
                        $scope.ksm.executeAction(listValueStateName,"valueChanged", $scope.formData[0][field_name]);    
                    
                    }
                });
                $scope.onSelect = function (item,model) {
                    
                    $scope.formData[0][field_name] = item;
                    $scope.fd.Search.value = $scope.formData[0][field_name];
                    $scope.fd.DefaultValue = {value:$scope.formData[0][field_name]};
                    $scope.ksm.executeAction(listValueStateName,"valueChanged", $scope.formData[0][field_name]);
                  
                }
            $scope.selection_changed = function () {
                    
                    $scope.fd.Search.value = $scope.formData[0][field_name];
                    $scope.fd.DefaultValue = {value:$scope.formData[0][field_name]};
                    $scope.ksm.executeAction(listValueStateName,"valueChanged", $scope.formData[0][field_name]);
                  
                }
            $scope.removeItem = function(index)
                {
                    $scope.formData[0][field_name].splice(index,1);
                    //$scope.ngModel.$setViewValue($scope.model.selectedItems); 
                
                }
                
             $scope.selectedItemId =  $scope.gsrvc.getSelectedItemId(); 
            $scope.showProperties = function(event)
                {
                  $scope.gsrvc.setFieldProperties($scope.fd,event);
       
                };
                
			  $scope.applyListFilters = function(index) {
                   
				   $scope.fd.Search=$scope.search[index];
                   
                  if( typeof $scope.formData[0]['Field'+$scope.fd.ItemId] === 'string' ) {
                        $scope.fd.Search.value = [ {'id':$scope.formData[0]['Field'+$scope.fd.ItemId]} ];
                    }
                   //if ($scope.fd.Search.name=="Equals") $scope.fd.Search=null;
				   $scope.isOpen=false;		
			  	};
                
                $scope.colLength=[];
                for (var i=0;i<24;i++) $scope.colLength.push('col-lg-'+(i+1));
                        $scope.fd.code={selectedCode:null};
    
                        CodesService.CodesList().then(function(data) {
              
                                  
                                
                           $scope.fd.codesDefinitionList = data.data;
                                             
                           if ($scope.fd.CodeId!=undefined)
                           {
                                var posCodesDef = $scope.fd.codesDefinitionList.map(function(e) { return e.id.toString(); }).indexOf($scope.fd.CodeId.toString());
              
                                if (posCodesDef>=0){
             
                                    $scope.fd.code.selectedCode=$scope.fd.codesDefinitionList[posCodesDef];
                                  
                                }
                           }
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });

                
          
                  $scope.xpopoverIsOpen=true;

        $scope.codeList=[];

       
        $scope.fd.getCodes = function (codeId) {
            var lang = $rootScope.globals.currentUser.lang; 
            
            $scope.fd.CodeId = codeId;
            var searchCode="";
            if (codeId>0)
            {
          
             CodesService.getCodes(codeId,lang).then(function(data){
                $scope.codeListFull = data.data;
                $scope.codeList = [];
                //filter data here
                if ($scope.fd.Parameters.Condition!=undefined)
                {
                    if ($scope.fd.Parameters.Condition!="")
                    {
                        let conditions =  $scope.fd.Parameters.Condition.split(";");
                        
                        for (let i=0;i<conditions.length;i++)
                        {
                           let idx = $scope.codeListFull.map(function(e) { return e.value; }).indexOf(conditions[i]);
                           if (idx>=0) $scope.codeList.push($scope.codeListFull[idx]);
                        }
                    } else $scope.codeList= $scope.codeListFull;
                }else $scope.codeList= $scope.codeListFull;
                
                if ($scope.codeList.length>0)
                {
                    if (!$scope.fd.Required && $scope.codeList[0].id!=null) $scope.codeList.unshift({id:null});   
                }
                $scope.codesLoaded = true;
                
                if ($scope.formData!=undefined && $scope.formData.length>0)
                {
                    if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=null && $scope.formData[0]['Field'+$scope.fd.ItemId]!=undefined)
                    {
                      if (typeof($scope.formData[0]['Field'+$scope.fd.ItemId])=='string')
                      {
                        searchCode = $scope.formData[0]["Field"+$scope.fd.ItemId];
                      }else
                      {
                            searchCode = $scope.formData[0]['Field'+$scope.fd.ItemId].toString();
                      }
                       
                         var pos = $scope.codeList.map(function(e) {
                            if (e.id!=null) return e.id.toString();
                            else return e.id;
                            }).indexOf(searchCode);
                      
                  
                          if (pos>=0){
                   
                             $scope.formData[0]['Field'+$scope.fd.ItemId]=$scope.codeList[pos];
                        
                          }
                      
                    }
                }
            });
          }
        }
        
        
        
		$scope.fd.getCodes($scope.fd.CodeId);
        
                let template;
                if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktListv3.html');
                else template = $templateCache.get('ktdirectivetemplates/ktListv3Exe.html');
          
                $element.append($compile(template)($scope)); 
                 },
            
            link: function (scope, elem, attrs) {

              
      

      }

    }
};
'use strict';

export function ktMenuClick () {

        return {
          restrict: 'A',
          templateUrl: 'ktdirectivetemplates/ktMenuClick.html',
          controller: function($scope,$stateParams){
            
            if ($scope.localVars==undefined) $scope.localVars={};
            if ($scope.fd==undefined) $scope.fd={};
            if ($scope.taskDefinition==undefined) $scope.taskDefinition={};
                   
            $scope.localVars.menuId = $stateParams.id;
            $scope.localVars.previousTask=$stateParams.prev_task_execute_id;
            $scope.localVars.outcomeId=$stateParams.outcome_id;
            $scope.localVars.OpenTaskType = "newPage";
            //$scope.localVars.ShowReturnBtn = true;
            if ($scope.localVars.previousTask==undefined) $scope.localVars.previousTask = 0;
            if ($scope.localVars.outcomeId==undefined) $scope.localVars.outcomeId = 0;
            $scope.initType = $stateParams.init_type;
            $scope.localVars.processMenuClicked = true;
            if ($scope.initType=="t")
            {
              $scope.localVars.processMenuClicked = false;
              $scope.localVars.processStartTask = true;
            }
           
                
            },
          link: function (scope, elem, attrs) {
       
       
       
        
          
      }
      
          
    }
};
'use strict';

export function ktMenuDefinition() {
  
   return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktMenuDefinition.html',
             scope:
             {
            menuItem:'=',
            localVars:'='
            },
            controller: function($scope,$rootScope,$timeout,MenuService,MessagingService,ResourcesDataService){
              let lang = $rootScope.globals.currentUser.lang;
              if ($scope.localVars==undefined) $scope.localVars={};
              $scope.menu_service = MenuService;
              
              if ($scope.menuItem==undefined) $scope.menuItem=$scope.menu_service.getSelectedSidemenu();
              
              $scope.headerLabel="Select users/groups that will have access to this menu item";
              $scope.usersLabel="Users";
              $scope.groupsLabel="Groups";  
              
              $scope.localVars.inputParamsTasks = {placeholder:'Select tasks...',label:'Task',name:'tasks',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label',sizeXs:false};
       
              $scope.localVars.inputParamsPages = {placeholder:'Select page...',label:'Page',name:'pages',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label',sizeXs:false};
              
              $scope.localVars.getTasks = function()
              {
              ResourcesDataService.getResourceDefListByType(lang,'task').then(
                function(data) {
                  $scope.localVars.taskList = data.data;
               
                },function(error){    
                  MessagingService.addMessage(error.msg,'error');
                });
          
              }
              $scope.localVars.getTasks();
              
              
               $scope.localVars.onSelectTask = function(item,model)
               {
                $scope.menuItem.TargetTask = item;
               }
              
               $scope.localVars.getPages = function()
              {
              
                $scope.localVars.pageList = $scope.menu_service.GetAllPages();
                
              }
              $scope.localVars.getPages();
              
              $scope.localVars.onSelectPage = function(item,model)
              {
                $scope.menuItem.TargetPage = item;
              }
              
               
               
               $scope.$watch('menu_service.selectedSideMenu',function(newValue,oldValue){
                  if (newValue!=oldValue)
                  {
                  $scope.menuItem=$scope.menu_service.getSelectedSidemenu();
                  }
               });
               
                $scope.saveSideMenu = function()
            
                {
              
                
                    $scope.menu_service.saveMenu($scope.menu_service.selectedSideMenu,lang).then(function(data) {
                                
                                 
                                 if ($scope.menu_service.selectedSideMenu.id == null || $scope.menu_service.selectedSideMenu.id==undefined)
                                  {
                                    $scope.menu_service.setSelectedSidemenu(data.data,lang);
                                    $scope.menu_service.addNewSideMenuToNavbar($scope.menu_service.selectedSideMenu);
                                  
                                  }
                                  else
                                  {
                                    $scope.menu_service.selectedSideMenu = data.data;
                                    
                                  }
                                  $scope.menu_service.updateNavbarSelectedSideMenu();
                                  
                                    MessagingService.addMessage(data.msg,'success');
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                          
                             });
              };
               
               
               
               
               $scope.localVars.menuLoaded = true;
               },
             link: function (scope, elem, attrs) {
            

             
           
           
      }
    }
  
};
'use strict';

export function multipleList (){ 
   return {
      require: 'ngModel',
      link: function(scope, elem, attr,ngModel) {
        
      //MIGOR START
              scope.search=[
				{id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
				{id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                ];
				
              // if (scope.fd!=undefined) scope.fd.search=scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                 
              //MIGOR END
          var lenList = attr.multipleList;
          scope.doneBlur = false;
          if (lenList == undefined)
          {
            lenList = 0;
          }
        
        scope.updateValues=function(){
         if (scope.fd!=undefined)
         {
           if (scope.formData[0]['Field'+scope.fd.itemId]==undefined || scope.formData[0]['Field'+scope.fd.itemId]==null)
           {
          
             scope.formData[0]['Field'+scope.fd.itemId]=[];
       
           }
           scope.$select.selectedItemsMultipleList= scope.formData[0]['Field'+scope.fd.itemId];
           
           if (scope.formData[0]['Field'+scope.fd.itemId].length>0)
           {
              scope.fd.search.value=scope.formData[0]['Field'+scope.fd.itemId]; //MIGOR
           }
         }else
         {
          scope.$select.selectedItemsMultipleList=scope.selectedItems;
          
         }
         
        };
        
       // scope.updateValues();
        
        scope.$watch('selectedItems', function(){
               
               scope.updateValues();

        });
    
          /*function for multiple list START ILJ*/
          scope.removeItemFromList =  function(index){
              
              if (scope.formData[0]['Field'+scope.fd.itemId]!=undefined)
              {
                scope.formData[0]['Field'+scope.fd.itemId].splice(index,1);
              }else
              {
                
                scope.selectedItems.splice(index,1);
              }
              scope.checkValidity(); 
          if (scope.fd!=undefined) scope.fd.search.value=scope.formData[0]['Field'+scope.fd.itemId]; //MIGOR
        

          };
        
            
       scope.addItemToList =  function(item) {
        
        if (item!=null)
        {
          var pos;
          if (scope.formData[0]['Field'+scope.fd.itemId]!=undefined)
          {
           pos = scope.formData[0]['Field'+scope.fd.itemId].map(function(e) { return e.id; }).indexOf(item.id);
              
              if (pos<0){
              
                 scope.formData[0]['Field'+scope.fd.itemId].push(angular.copy(item));
                 
                
                
              }
          }else
          {
              if (scope.selectedItems==undefined) scope.selectedItems = [];
              pos = scope.selectedItems.map(function(e) { return e.id; }).indexOf(item.id);
              
              if (pos<0){
               
                 scope.selectedItems.push(angular.copy(item));
                
          
              }
          }
              if (scope.doneBlur)
              {
               scope.checkValidity(); 
              }
              if (scope.fd!=undefined) scope.fd.search.value=scope.formData[0]['Field'+scope.fd.itemId]; //MIGOR
        }
   

      };
    scope.checkValidity = function(){
        scope.doneBlur = true;
        var valid;
        if (scope.fd!=undefined)
        {
          valid = (!scope.fd.required) || (scope.formData[0]['Field'+scope.fd.itemId].length >= lenList);
        }else
        {
          valid = (!scope.required) || (scope.selectedItems.length >= lenList);
        }
        ngModel.$setValidity('multipleList', valid);
      
    };
    /*function for multiple list END*/   
      }
   };
};
'use strict';

export function ktNavbarDefinition() {
  
  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktNavbarDefinition.html',
            scope:
            {
            navbarItem:'=',
            localVars:'='
            },
            controller: function($scope,$rootScope,$timeout,MenuService,CodesService,MessagingService,ResourcesDataService){
            
              let lang = $rootScope.globals.currentUser.lang;
               if ($scope.localVars==undefined) $scope.localVars={};
               $scope.menu_service=MenuService;
               
              if ($scope.navbarItem==undefined) $scope.navbarItem=$scope.menu_service.getSelectedNavbar();
              $scope.headerLabel="Select users/groups that will have access to this navigation bar item";
              $scope.usersLabel="Users";
              $scope.groupsLabel="Groups";
          
          
              $scope.localVars.inputParamsTasks = {placeholder:'Select tasks...',label:'Task',name:'tasks',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label',sizeXs:false};
       
              $scope.localVars.inputParamsPages = {placeholder:'Select page...',label:'Page',name:'pages',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label',sizeXs:false};
              
              $scope.localVars.getTasks = function()
              {
              ResourcesDataService.getResourceDefListByType(lang,'task').then(
                function(data) {
                  $scope.localVars.taskList = data.data;
               
                },function(error){    
                  MessagingService.addMessage(error.msg,'error');
                });
          
              }
              $scope.localVars.getTasks();
              
              
               $scope.localVars.onSelectTask = function(item,model)
               {
                $scope.navbarItem.TargetTask = item;
               }
              
               $scope.localVars.getPages = function()
              {
                $scope.localVars.pageList = $scope.menu_service.GetAllPages();
          
              }
              $scope.localVars.getPages();
              
              $scope.localVars.onSelectPage = function(item,model)
              {
                $scope.navbarItem.TargetPage = item;
              }
               
            $scope.$watch('menu_service.selectedNavbar',function(newValue,oldValue){
                  if (newValue!=oldValue)
                  {
                  $scope.navbarItem=$scope.menu_service.getSelectedNavbar();
                  }
               });
            
            $scope.Cancel = function()
            {
               $scope.menu_service.navbarSelected = false;
               
            };              
                                    
              $scope.saveNavbar = function()
            
                {
              
                
                    $scope.menu_service.saveMenu($scope.menu_service.selectedNavbar,lang).then(function(data) {
                                
                                 
                                  if ($scope.menu_service.selectedNavbar.id == 0 || $scope.menu_service.selectedNavbar.id == null || $scope.menu_service.selectedNavbar.id==undefined)
                                  {
                                   $scope.menu_service.selectedNavbar = data.data;
                                   $scope.currentNavbarId = $scope.menu_service.selectedNavbar.id;
                                   $scope.menu_service.selectedNavbar.SideMenus = [];
                                   $scope.menu_service.navbarItems.push(angular.copy($scope.menu_service.selectedNavbar));
                                   //$scope.menu_service.navbarItems.push($scope.menu_service.selectedNavbar);
                                   $scope.menu_service.setCurrentNavbarId($scope.currentNavbarId,lang);
                                  
                                  }
                                  else
                                  {
                                    $scope.menu_service.selectedNavbar = data.data;
                                   $scope.currentNavbarId = $scope.menu_service.selectedNavbar.id;
                                    
                                  }
                                    MessagingService.addMessage(data.msg,'success');
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                          
                             });
              };
               $scope.localVars.navbarLoaded = true;
              },
             link: function (scope, elem, attrs) {
              
                              
              
            
           
      }
    }
  
};
'use strict';

export function ktNotificationList () {
   
    var controller = ['$scope', '$uibModal','$stateParams','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','WidgetDataExchangeService','GridsterService','MessagingService','CODES_CONST','TaskDataService',
                      function ($scope,$uibModal,$stateParams,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,WidgetDataExchangeService,GridsterService,MessagingService,CODES_CONST,TaskDataService) {
      
      
    
    $scope.localVars={};
    $scope.localVars.datasetMapperType=0;
    $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_; 
    $scope.localVars.searchFormDownloaded = false;
    $scope.localVars.showSearchFilters=true;
    $scope.localVars.resourceDataDownloaded = true;
    $scope.taskId=$scope.taskDefinition.ResourceDefId;
    if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
    if ($scope.taskId==undefined) $scope.taskId=0
    $scope.localVars.taskId=$scope.taskId;
    $scope.localVars.widgetType = 4;
    
    $scope.localVars.parentDatasetDefId=$scope.fd.related;
    $scope.localVars.animationsEnabled = true;
    $scope.localVars.gridsterType="resource";
          

     $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: GridsterService.getEmptyDatasetForm()
				} ;
        
        
       $scope.localVars.gridOptionsResourceData = {
           //  columnDefs: colDefs,
        enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: $scope.fd.multiline,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: true,
        enableColumnResizing: true,
        enableColumnReordering: true,
        useExternalPagination: true,
        paginationPageSizes: [10, 25, 50,100,200,500,1000],
        enablePaginationControls: false,
      };

  var paginationOptions = {
    pageNumber: 1,
    pageSize: 10,
    sort: null
    };
    
    
       $scope.localVars.gridOptionsRelated = {
      //  columnDefs: colDefs,
       enableGridMenu: true,
       showGridFooter: true,
       showColumnFooter: true,
       enableRowSelection: false,
       multiSelect: false,
       enableHorizontalScrollbar : 2, 
       nableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
       minRowsToShow: 2,
      
   }
    
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        
        //$scope.fd.populateType=1;
        $scope.fd.parentDatasetDefId=$scope.fd.related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.localVars.formType=$scope.taskDefinition.form_type;
        $scope.localVars.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        $scope.formDefinition = $scope.taskDefinition.form_definition;
        if  ($scope.formDefinition==undefined)
        {
          
          $scope.formDefinition = false;
        }
        
        
        
        
          if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        $scope.localVars.resourceRecordId = 0;
        $scope.fd.parentElementId = 0;
        
        
        
      var out_fields = ['resourceRecordId']
      //resourceLink
      var widgetDefinition = {DEI: [{'name':'resourceLinkDatasetList','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'datasetListWidget',widgetId: $scope.fd.presentationId,taskId:  $scope.lTaskId,
      resourceDefId : $scope.fd.related, //resourceDefId : $scope.selectedResource
      resourceRecordId:$scope.localVars.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId, output:out_fields };
      $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.localVars.localId=$scope.localWidgetId;
      
      
      $scope.localVars.gridOptionsResourceData.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.localVars.gridApi = gridApi;
           
          gridApi.selection.on.rowSelectionChanged($scope,function(row){

            $scope.localVars.datasetRecordSelected=row.isSelected;
            if ($scope.localVars.datasetRecordSelected)
              {
                if (row.entity.id!=$scope.localVars.selectedDatasetRecordId)
                {
                  $scope.localVars.selectedDatasetRecordId = row.entity.id;
                }
              }else
              {
                $scope.localVars.selectedDatasetRecordId = 0;
                
              }
              $scope.localVars.gridOptionsRelated.columnDefs=[];
              $scope.localVars.gridOptionsRelated.data=[];
              $scope.localVars.showGrid=false;
              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.related,records:gridApi.selection.getSelectedRows()}
              
               if (gridApi.selection.getSelectedRows().length>0)
              {
                //$rootScope.$broadcast('EventresourceLink'+$scope.fd.presentationId,$scope.selectedDatasetRecordId);
                WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.presentationId,task_execute_id:$scope.taskExecuteId});
            
              }
              
          });
          
            //external pagination
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,newPage,pageSize);
          });
      
           gridApi.selection.on.rowSelectionChangedBatch($scope,function(row){

              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.related,records:gridApi.selection.getSelectedRows()}
              
          });
     }
     
     
     $scope.localVars.ProcessSearchForm=function (form){
            
            if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('type' in form[i])
                    {
                      if (form[i].type == 'resource' && form[i].autoSearch)
                      {
                        var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(form[i].presentationId);
                        if (pos<0) $scope.localVars.childWidgets.push({widgetId:form[i].presentationId,processed:false})
                        
                      }
                     }
                      if ('layout' in form[i])
                      {
                           
                       $scope.localVars.ProcessSearchForm(form[i].layout);
                      }
              }
          } 
           
      };
      
      $scope.localVars.SearchFormProcessed=false;

      /*
      $scope.localVars.setDatasetMapperType= function(type){
            $scope.localVars.datasetMapperType = type;
          };      
      */
       $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.datasetList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.datasetList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.datasetList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.datasetList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					};
          
       // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
        $scope.localVars.getDatasets = function()  {
						
            if ($scope.localVars.datasetList==undefined) $scope.localVars.datasetList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'notification').then(
						function(data) {
                      $scope.localVars.datasetList = data.data;
                       if ($scope.fd.related!=null)
                       {
                        $scope.localVars.setSelectedDataset($scope.fd.related);
                
                        }     
											 
		 },function(error){    
                                MessagingService.addMessage(error.msg,'error');
	 });
	}
            
      $scope.localVars.GetDatasetData=function(data)

      {

            fromWidget = data.widgetId;
            var allProcessed=true;
            var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(fromWidget);
            //if (pos<0) $scope.fd.childWidgets.push({widgetId:fromWidget,processed:true});
            for (var i=0;i<$scope.localVars.childWidgets.length;i++)
              {
                
                if ($scope.localVars.childWidgets[i].widgetId == fromWidget) $scope.localVars.childWidgets[i].processed = true;
                if (!$scope.localVars.childWidgets[i].processed) allProcessed = $scope.localVars.childWidgets[i].processed;
              }
             // if (!$scope.SearchFormProcessed) $timeout(function() {$scope.GetDatasetData(fromWidget);},1000);
              if($scope.fd.autoSearch && allProcessed && $scope.localVars.SearchFormProcessed) {
                  $scope.localVars.selectedResource=$scope.fd.related;
                  $scope.localVars.getResourceColumns(true);
                                      
                }
      };
       
      if ($scope.localVars!=undefined) $scope.localVars.childWidgets = [];
      else $scope.localVars = {childWidgets : []};
     // $scope.uncaughtWidgets = [];
      var fromWidget=0;
   
 
      $scope.$on('SearchFormReady'+$scope.taskExecuteId,function(event, data){
      
           $scope.localVars.GetDatasetData(data); 
            
      });     
     
   
   //**********************************************************
	//           GET DATASET RELATED RECORDS
	//**********************************************************      
        $scope.localVars.getDatasetRelatedRecords = function (relatedDatasetId,recordId,modelId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataRelated($scope.fd.related,recordId,relatedDatasetId,0,modelId,lang).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                                     $scope.localVars.showGrid=true;
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
        
        
 //**********************************************************
	//           GET DATASET SINGLE RECORD
	//**********************************************************      
      $scope.localVars.getDatasetSingleRecord = function (relatedDatasetId,recordId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,0,lang,{id: recordId}).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
    
        $scope.$on('SearchFormReady'+$scope.taskExecuteId+$scope.fd.presentationId,function(event, data1){
      
                                        $scope.localVars.GetDatasetData(data1); 
            
        });
        
    $scope.localVars.getFormResource = function(){   
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null) {
                $scope.fd.presentationId = 0;
              }
              
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.populateType,$scope.fd.parentElementId,$scope.fd.presentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"f",lang).then(function(data) {
                 
                                    $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                
                             
                                    $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.related,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                              
                               
                                    $scope.fd.fItemValue=data.data.widgets;

                                    $scope.localVars.searchFormDownloaded = true;
                                    $scope.localVars.setField($scope.fd.fItemValue,'required',false);
                                    $scope.localVars.formLoaded=true;
                                   //prepare search form
                                    $scope.localVars.ProcessSearchForm($scope.fd.fItemValue);
                                    $scope.localVars.SearchFormProcessed = true;
                                    if ($scope.localVars.childWidgets.length>0)
                                    {
                                      WidgetDataExchangeService.registerSearch({widgetId:$scope.fd.presentationId,taskExecuteId:$scope.taskExecuteId,prevTaskExeId:$scope.prevTaskExeId,childWidgets:$scope.localVars.childWidgets});
                                    }
                                    else
                                    {
                                       $rootScope.$broadcast('SearchFormReady'+$scope.taskExecuteId,{widgetId:$scope.fd.presentationId});
                                    }
                                    $scope.localVars.dashboard.widgets.layout =  data.data.widgets;    
                                    $scope.formData[$scope.fd.presentationId] =  data.data.form_data;
                                    $scope.fd.search = $scope.formData[$scope.fd.presentationId];
               
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getFormResource_END
    
  $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                 $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.related,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                            
                             
                                $scope.fd.fItemValue=data.data.widgets;
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.presentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                  $scope.localVars.searchFormDownloaded = true;
                                   $timeout(function() {
                                    $scope.localVars.formLoaded=true;
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
   
   $scope.localVars.datasetRecordSelected = false;
   $scope.localVars.selectedDatasetRecordId = 0;
 
     
      $scope.localVars.getResourceData = function () {

        // scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+scope.selectedResource);
        var lang = $rootScope.globals.currentUser.lang;
        $scope.localVars.resourceDataDownloading = true;
        if ($scope.localVars.pageSize==undefined) $scope.localVars.pageSize = paginationOptions.pageSize;
        ResourcesDataService.getResourceData($scope.localVars.selectedResource,$scope.taskId,lang).then(function(data) {
                               
                                     $scope.localVars.gridOptionsResourceData.data = data.data;
                                     $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                     $scope.localVars.restoreGridState();
                                     $scope.localVars.resourceDataDownloaded = true;
                                    
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   
                             });
        };

		 
      //**********************************************************
      //           GET RESOURCE DATA PAGINATED
      //**********************************************************      
    $scope.localVars.getResourceDataPaginated = function (urlNext,urlPrev,newPage,pageSize) {
        
        
        $scope.localVars.resourceDataDownloaded = false;        
        if (Math.ceil($scope.localVars.totalCount/pageSize)<newPage)
        {
          newPage = Math.ceil($scope.localVars.totalCount/pageSize);
        }
         
         var lang = $rootScope.globals.currentUser.lang;
          
         if (pageSize==undefined)
         
         {
          $scope.localVars.pageSize = paginationOptions.pageSize;
          pageSize= $scope.localVars.pageSize;
         }
         
         if ($scope.fd.populateMethod=='M')
         {
          ResourcesDataService.getResourceDataPaginatedFilter($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.search, $scope.localVars.dashboard.widgets.layout).then(function(data) {
                                    
                                    
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data.results;
                                    $scope.localVars.restoreGridState();
                                    $scope.localVars.resourceDataDownloaded = true;
                                    
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.presentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.presentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
         }
         else if ($scope.fd.populateMethod=='A')
         {
          var task_instance=0;  
          if ($scope.localVars.formType=='i') task_instance = $scope.taskInitiateId;
          else task_instance = $scope.taskExecuteId;
    
          ResourcesDataService.getResourceDataPaginatedAuto($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.presentationId,task_instance,$scope.localVars.formType).then(function(data) {
                                    
                                    
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data.results;
                                    $scope.localVars.restoreGridState();
                                    $scope.localVars.resourceDataDownloaded = true;
                                    
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLink',value:[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.presentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.presentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
          
         }
        };


 $scope.localVars.pageChanged = function(){
        $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,$scope.localVars.currentPage,$scope.localVars.pageSize);
         };
   //**********************************************************
	//           GET RESOURCE COLUMNS
	//**********************************************************      
  $scope.localVars.getResourceColumns = function (getData) {
     var lang = $rootScope.globals.currentUser.lang;
     if ($scope.localVars.selectedResource==undefined) $scope.localVars.selectedResource = $scope.fd.related;
     
     if ($scope.localVars.selectedResource!=undefined && $scope.localVars.selectedResource!=null)
     {
     ResourcesDataService.getResourceColumns($scope.localVars.selectedResource,$scope.taskId,lang).then(function(data) {
                                
                $scope.localVars.gridOptionsResourceData.columnDefs = data.data;
                
                if (getData) $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                
         //                            MessagingService.addMessage(data.msg,'success');
         
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
               
     }
  };
     
     $scope.localVars.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.localVars.selectedResource==null) {
            $scope.localVars.selectedResource = $scope.fd.related;
          }
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.related,lang,$scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered($scope.localVars.selectedResource,$scope.taskId,lang,$scope.localVars.dashboard.data).then(function(data) {//MIGOR
                            
                                  $scope.localVars.gridOptionsResourceData.data = data.data;
                                  $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                  
                                    $timeout(function(){
                                      $scope.localVars.resourceDataDownloaded = true;
                                      $scope.localVars.restoreGridState();
                                    });
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        };
		
       $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
          $scope.localVars.showHideSearchForm = function()
        {
     				if ($scope.fd.showSearchForm) $scope.localVars.getFormResource();
        };
       
        
    
  if ($scope.fd.related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded)
  {
    $scope.localVars.getFormResource();
    
  }else if ($scope.fd.related!=null && ($scope.localVars.showForm || $scope.fd.autoSearch))
  {
     $scope.localVars.getFormResource();
     $scope.localVars.getDatasets();
      $scope.localVars.getResourceColumns(false);
    
  }else if(!$scope.localVars.showForm)
  {
     $scope.localVars.showHideSearchForm();
     $scope.localVars.getResourceColumns(false);
     $scope.localVars.getDatasets();
    
  }
  
    
    
		 $scope.localVars.saveGridState= function() {
       var state = $scope.localVars.gridApi.saveState.save();
       $scope.fd.gridState = state;
       MessagingService.addMessage("To make changes stick please save form",'info');
             
    };
  
   $scope.localVars.restoreGridState= function() {
    if ($scope.fd.gridState!=null)
    {
       if ($scope.localVars.gridApi!=undefined)
       {
      
        $scope.localVars.gridApi.saveState.restore($scope,$scope.fd.gridState);
        
       }else
       {
        $timeout(function(){
            $scope.localVars.restoreGridState();
        });
       }
    }
  };
        
}]; //controler_END

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktNotificationList.html',
            controller: controller,
            link: function (scope, elem, attrs) {

            
            
               $rootScope.$broadcast("Widget"+scope.fd.PresentationId+"Ready",null);
                          
            
             }
             
             
  } 
        
};
'use strict';

export function ktNotificationSendWidget () {
   
   var controller = ['$scope', '$uibModal', '$state','$stateParams','$element','dragularService','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','CODES_CONST',
                     function ($scope,$uibModal,$state,$stateParams,$element,dragularService,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,CODES_CONST) {
      
      $scope.localVars = {};
      $scope.localVars.searchFormDownloaded = false;
      $scope.localVars.formLoaded=false;
      $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.localVars.animationsEnabled = true;
      $scope.localVars.widgetType = 1;
      $scope.localVars.hidePopulateMethod = true;
      
      if ($scope.fd!=undefined)
      {
           $scope.fd.populateMethod = "M";
      }else
      {
           $scope.fd={populateMethod : "M"};
      }
      
      $scope.gsrvc = GridsterService;
      $scope.localVars.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
      $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: GridsterService.getEmptyDatasetForm()
				} ;
        
     
  
        //$scope.taskId=$stateParams.id;
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        $scope.localVars.taskId=$scope.taskId;
        $scope.fd.parentDatasetDefId=$scope.fd.related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.localVars.formType=$scope.taskDefinition.form_type;
        $scope.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        $scope.formDefinition = $scope.taskDefinition.form_definition;
        
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.localVars.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
     //register widget 
     var out_fields = ['resourceId']
     var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.presentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVars.selectedResource, output:out_fields, };
      $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
       $scope.localVars.localId=$scope.localVars.localWidgetId;  		
         
        
        
        $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.presentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.populateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.populateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.parentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.presentationId,'row-'+$scope.localVars.gridsterType+'-hadle',true);
                                
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.presentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                  $scope.localVars.searchFormDownloaded = true;
                                  $scope.localVars.formLoaded=true;
                                     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
        
        $scope.localVars.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               if ($scope.fd.presentationId==null)
               {
                    $scope.fd.presentationId=0;
            
               }
               $scope.localVars.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.related,$scope.taskId,$scope.localVars.formType,$scope.fd.presentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                 if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.presentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.populateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.populateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.parentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                                $scope.localVars.searchFormDownloaded = true;
                                  
                                  $scope.localVars.formLoaded=true;
                                  $scope.localVars.formLoading=false;
                                   
                                  var container = $element.children().eq(0).children().eq(1).children().eq(0);
                                  GridsterService.setupDragular($scope.fd.wItemValue,container[0],'rows-'+$scope.fd.presentationId,'row-'+$scope.localVars.gridsterType+'-handle',true);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVars.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVars.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null || $scope.fd.presentationId==undefined)
              {
                $scope.fd.presentationId = 0;
                
              }
              
              if ($scope.fd.parentElementId==null || $scope.fd.parentElementId==undefined)
              {
                $scope.fd.parentElementId = 0;
                
              }

              
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.populateType,$scope.fd.parentElementId,$scope.fd.presentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.presentationId] =  data.data.form_data;
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                  $scope.localVars.resourceRecordId = data.data.resourceRecordId;
                                  $scope.localVars.datasetRecordId=$scope.localVars.resourceRecordId;
                                  if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.presentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.populateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.populateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.parentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.related, 'presentationId':$scope.fd.presentationId  ,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
 
                                }
                                //$scope.fd.wItemValue=data.data.widgets;
                               
                                 //  $timeout(function() {
                                     $scope.localVars.formLoaded=true;
                                     $scope.localVars.formLoading=false;
                                     $scope.localVars.searchFormDownloaded = true;
                                      
                                 //   });   
                                                                          
                                   WidgetDataExchangeService.setData({widgetId:$scope.fd.presentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
	                                 
                                   var container = $element.children().eq(0).children().eq(1).children().eq(0);
                                   GridsterService.setupDragular($scope.fd.wItemValue,container[0],'rows-'+$scope.fd.presentationId,'row-'+$scope.localVars.gridsterType+'-handle',true);
                                   
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
      
        $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
           $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.datasetList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.datasetList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.datasetList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.datasetList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
					$scope.localVars.getDatasets = function()  {
						
            if ($scope.localVars.datasetList==undefined) $scope.localVars.datasetList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'notification').then(
						function(data) {
										
											  $scope.localVars.datasetList = data.data;
                       if ($scope.fd.related!=null)
                       {
                        $scope.localVars.setSelectedDataset($scope.fd.related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
          
  if ($scope.fd.related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded)
  {
     $scope.localVars.getFormResourceWithData();
    // $scope.localVars.getDatasets();
    // $scope.localVars.setSelectedDataset($scope.fd.related);
    
  }else if ($scope.fd.related!=null)
  {
     $scope.localVars.getFormResource();
     $scope.localVars.getDatasets();
     //$scope.localVars.setSelectedDataset($scope.fd.related);
    
  }
  
  
      }];

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktNotificationSendWidget.html',
            controller: controller,
            link: function (scope, elem, attrs) {

           
            
           // scope.resourceData = {};
  
            scope.localVars.prepareResourceData = function(resourceRecordId){

             scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData(scope.localVars.dashboard.widgets.layout,resourceRecordId);
            }
          
           scope.localVars.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name==linkedItem) && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+scope.fd.presentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                               // console.log("view "+ scope.fd.presentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    scope.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    scope.resourceRecordId = scope.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') scope.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              //scope.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if (scope.fd.presentationId==undefined || scope.fd.presentationId==null) scope.fd.presentationId=0;
          
          scope.localVars.formType=scope.taskDefinition.form_type;
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.presentationId,scope.localVars.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;
                                scope.localVars.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
          
            scope.$on('InitiateTaskPostProcess',function(event, data){
              
            if (data!=undefined){
              for(var i=0;i<data.length;i++) {
                if (scope.fd.presentationId==data[i].widgetId) WidgetDataExchangeService.setData(data[i]); 
              }
              //set all elements read-only
            }
              scope.localVars.setField(scope.localVars.dashboard.widgets.layout,'readOnly',true);
          });
  
      }     
    }
        
};
'use strict';

export function ktNumber () {
       //console.log("u direktivi kt-textbox ");
        return {
            restrict: 'A',
			 controller: function ($scope,GridsterService) {
                
                
                 $scope.gsrvc = GridsterService;
                if ($scope.localVars==undefined) $scope.localVars =  {};
                if  ($scope.formData==undefined)  $scope.formData = [{}];
                $scope.colLength=[];
                for (let i=0;i<24;i++) $scope.colLength.push('col-'+(i+1));
               
                if ($scope.fd.Parameters==undefined) $scope.fd.Parameters = {};
                
                $scope.fd.setStep = function() {
                 $scope.fd.stepValue =parseFloat(Math.pow(0.1,$scope.fd.Parameters.NoOfDecimals)).toFixed($scope.fd.Parameters.NoOfDecimals);
                }; 
               
               if ($scope.fd.stepValue==null || $scope.fd.stepValue==undefined) $scope.fd.setStep();
               
               $scope.search=[
				{id:1,filter:'gt',name:"Greater than",icon:"fa fa-chevron-right"},
				{id:2,filter:'between',name:"Between",icon:"fa fa-expand"},
				{id:3,filter:'lt',name:"Lower than",icon:"fa fa-chevron-left"},
				{id:4,filter:'eq',name:"Equals",icon:"fa fa-bars"} ];
                
                $scope.formatNumber = function()
                {
                  if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=undefined)
                  {
                    $scope.formatedNumber = $scope.formData[0]['Field'+$scope.fd.ItemId].toLocaleString(undefined,{minimumFractionDigits:$scope.fd.Parameters.NoOfDecimals,maximumFractionDigits:$scope.fd.Parameters.NoOfDecimals});
                    
                  }else  $scope.formatedNumber = "";
                }
              if ($scope.fd.showSearchForm)  {
                if ($scope.fd.search==undefined)    $scope.fd.search=$scope.search[3];//initialize to equals
                    if ($scope.fd.search) $scope.fd.search.value=$scope.fd.sItemValue; 
              }

          
                },
             templateUrl: 'ktdirectivetemplates/ktNumber.html',
             link: function (scope, elem, attrs) {
  
				scope.isOpen=true;
        
               
                 
                        
                        
                scope.refreshSearchValue = function() {
                         if (scope.fd.search) scope.fd.search.value=scope.fd.sItemValue;      
                }; 
                        
                      if (scope.fd.showSearchForm)  {
                        if (scope.fd.search==undefined)    scope.fd.search=scope.search[3];//initialize to equals
                            if (scope.fd.search) scope.fd.search.value=scope.fd.sItemValue; 
                      }
        
                      
               scope.showProperties = function(event)
               {
                 scope.gsrvc.setFieldProperties(scope.fd,event);
               
               };
             
			  scope.applyNumFilters = function(index) {
				   scope.fd.search=scope.search[index];
                   if (scope.fd.sItemValue) scope.fd.search.value=scope.fd.sItemValue;
                  // if (scope.fd.search.name=="Equals") scope.fd.search=null;
				   scope.isOpen=false;		
			  };
				
           
       
            }
        };
};
'use strict';

export function ktOutcomeActions () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktOutcomeActions.html',
              controller: function($scope,dragularService){
                
               $scope.getSeqNoForNewAction = function(){
                  var seqNo=0;
                  for (var i=0;i<$scope.outcomes.length;i++) {
                     
                     seqNo = seqNo+$scope.outcomes[i].actions.length;
                     
                  }
                  
                  seqNo++;        
                  return seqNo;
      
                  }
                  
              $scope.actions = [
                {id1:1,type:1,name1:'Start task',taskId:null,actionParams:{}},
                {id1:2,type:2,name1:'Send notification',taskId:null,actionParams:{}}
                
              ];
                      
                      
                  $scope.setupDragular = function(){
                            
                                      setTimeout(function(){
                                        // var container = elem.children().eq(0).children().eq(0).children().eq(0).children().eq(2).children().eq(0).children().eq(0).children().eq(1).children().eq(0).children();
                                         var container = document.getElementsByClassName('outcomeActionsDragular');
                                        // var widgets =[$$scope.pTaskInitiateFormResources,$$scope.pTaskExecuteFormResources,$$scope.initiateFormResources,$$scope.selectedResource,$$scope.executeFormResources];
                                                     
                                         dragularService(container,
                                           {
                                          // nameSpace: namespace ,
                                           copy: true,
                                           classes: {
                                           //mirror: 'gu-mirror-empty'
                                               },
                                           revertOnSpill: true,
                                           containersModel: $scope.actions,
                                           //direction:'vertical',
                                         // accepts: accepts,
                                           
                                            moves: function (el, container, handle) {
                                               return handle.classList.contains("element-drag-handle");
                                             }
                                         
                                            }
                                            );
                                          }
                                        );          
                                  
                            }
                 
                 $scope.setupDragular();
                },
             link: function (scope, elem, attrs) {
              
             
              
              /*          
              scope.outcomeDefActionsOptions =
              
              {
                itemMoved: function (event) {
                    event.dest.sortableScope.modelValue[event.dest.index].id = scope.getSeqNoForNewAction();
                },
                clone:true,
              }
              */
             
             
               
        }
    }
};
'use strict';

export function ktOutcomeDefList () {

    return {
                restrict: 'A',
                templateUrl: 'ktdirectivetemplates/ktOutcomeDefList.html',
                scope:{
                        task: '=',
                        localVars: '=',
                        fd: '=',
                },
                controller: function($scope,TaskDefinitionService,CodesService,MessagingService,TaskDataService,$rootScope,$timeout,dragulaService,GridsterService){
                        
                        $scope.parameters = {placeholder:'Select template to load',label:'Outcomes',name:'outcomes',selectedItem:$scope.task.TaskOutcomeCodeId,
                        paddingLeft:true,hideLabel:true,dropdownSize:'col-lg-24'};
                        $scope.showLoadFromTemplate ={};
                        $scope.tds=TaskDefinitionService;
                        $scope.outcomesDownloaded = false;
                        $scope.outcomes=[];
                        var lang=$rootScope.globals.currentUser.lang;
                        
                        $scope.gsrvc=GridsterService;
                        
                         $scope.setupDragula = function()
                         {
                              var widgetHandleResource = 'element-drag-handle';
                              
                              var bag = dragulaService.find($rootScope, 'bag-outcomes');
                              if (!bag)
                              {
                                 $scope.gsrvc.setupDragula('bag-outcomes','outcomesDragula',widgetHandleResource);    
                              }
                              else
                              {
                                   $scope.gsrvc.destroyDragula('bag-outcomes');
                                   $scope.gsrvc.setupDragula('bag-outcomes','outcomesDragula',widgetHandleResource); 
                                    
                               }
                         };  
                        
                        
                        TaskDataService.GetTaskOutcomesDef(lang).then(function(data) {
                       
                                    $scope.outcomeCodes = data.data;
                                    if ($scope.task.TaskOutcomeHeadId!=null)
                                    {
                                         
                                         var pos = $scope.outcomeCodes.map(function(e) { return e.id; }).indexOf($scope.task.TaskOutcomeHeadId);
                                         if (pos>-1) {
                                           $scope.parameters.selectedItem = $scope.outcomeCodes[pos];
                                           $scope.selectedOutcomeId=$scope.parameters.selectedItem.id;
                             
                                           
                                         }
                                         $scope.GetOutcomes(); 
         
         
                                    }   
                                  
                               },function(error){
                                 
                                   MessagingService.addMessage(error.msg,'error');
                               }
                         );
                
                 
                 $scope.showoutcomedetails= function(outcome,index,showLoadFromTemplate){
                                 //transfer child $scope parameters to parents 
                                 $scope.showLoadFromTemplate=showLoadFromTemplate;
                                 $scope.clickedOutcome = outcome;
                                 $scope.selectedOutcomeIndex=index
                                 $scope.showConfirmRemoveOutcome = false;
                                 $scope.setupDragula();
                 };
                 
                 $scope.selectOutcome= function(outcome){
                                 $scope.localVars.selectedButton.outcome=outcome;
                               
                 };
                 
                               
                 $scope.selectedOutcome = function(item,model){
                               $scope.parameters.selectedItem = item;
                               $scope.selectedOutcomeId=item.id;
                               }                     
                        $scope.removeAction = function(index){
                             //$scope.task.TaskOutcomeCodeId = null;
                              $scope.clickedOutcome.actions.splice(index,1);
                        }
                        
                        $scope.removeOutcome = function(index){
                             //$scope.task.TaskOutcomeCodeId = null;
                              $scope.outcomes.splice(index,1);
                        }
            
                            
                    
                          $scope.isSelectedOutcome = function(index) {
                             // if ($scope.selectedIndex==index) return true;
                              //return false;
                              if ($scope.selectedOutcomeIndex==index ) return true;
                              return false;
                              
                          };
                                          
                   
                  $scope.addOutcomeItem = function(newItem){
                                                   
                         if (newItem!=undefined && newItem!=null) {
                           $scope.outcomes.push(newItem);
                         }else {
                            // $timeout(function(){ //MIGOR -može se maknuti timeout
                                 $scope.outcomes.push({id1:null,name1:null,outcomeName:null,icon:null,btnName:'*New Outcome*',btnClass:null,actions:[]});
                                 $scope.selectedOutcomeIndex= $scope.outcomes.length-1;
                                 $scope.clickedOutcome=$scope.outcomes[$scope.selectedOutcomeIndex];
                                 $scope.showLoadFromTemplate[$scope.selectedOutcomeIndex]=true;
                            //});
                          };
                               
                            //$timeout(function(){ //MIGOR -može se maknuti timeout
                                   $scope.showoutcomedetails( $scope.outcomes[$scope.outcomes.length-1],$scope.outcomes.length-1,$scope.showLoadFromTemplate);
                            // });
                             
                            
                             // vidjeti da li ovo dole ima funkciju                   
                      //   if ($scope.parameters.selectedItem) delete $scope.parameters.selectedItem; //reset selected item
                     }
                          
                     $scope.GetOutcomes = function(){
                                
                               var lang=$rootScope.globals.currentUser.lang;               
                               var outcomeId = 0                /*MIGOR provjeriti jos*/  
                              // if ($scope.parameters.selectedItem!=undefined) { /*MIGOR provjeriti jos*/ 
                               //     outcomeId = $scope.parameters.selectedItem.id;  
                              // }
                              if ($scope.task.TaskOutcomeHeadId !=undefined) outcomeId = $scope.task.TaskOutcomeHeadId;
                              
                               
                               $scope.loadingActions=true; 
                              if (!$scope.outcomesDownloaded)
                               {   
                                    TaskDataService.GetTaskOutcomes( $scope.task.ResourceDefId,outcomeId,lang).then(function(data) {            
                                               
                                              $scope.outcomes = data.data;
                                              //$scope.task.TaskOutcomeHeadId = $scope.parameters.selectedItem.id;
                                              //$scope.selectedOutcomeId=$scope.parameters.selectedItem.id;
                                              $scope.outcomesDownloaded = true;
                                              $scope.loadingActions=false; 
                                             // if ($scope.outcomes.length>0)  $scope.showoutcomedetails($scope.outcomes[0],0,$scope.showLoadFromTemplate); //show first available outcome (if any)
                                              
                                    },function(error){
                                             $scope.loadingActions=false; 
                                             MessagingService.addMessage(error.msg,'error');
                                    });
                               }
                               else
                               {
                                $scope.loadingActions=false;      
                               }
                 
                     }//GetOutcomes
         
                        //**********************************************************
                        //           SAVE TASK OUTCOMES
                        //**********************************************************    
                        $scope.saveTaskOutcomes = function(){
               
                                    //check for errors
                                    var saveTaskOutcomesErrors=[];
                                    if (!$scope.task.InfiniteTask)
                                    {
                                       for(var i=0;i<$scope.outcomes.length;i++){
                                       if ($scope.outcomes[i].outcomeName==null) saveTaskOutcomesErrors.push('Outcome name must be defined!');
                        
                                       }
                                       if ($scope.outcomes.length==0) {	saveTaskOutcomesErrors.push("Outcome must be defined!");};
                                    }
                                    if (saveTaskOutcomesErrors.length>0) 
                                                MessagingService.addMessage(saveTaskOutcomesErrors,'error');
                                    else 
                                    {
                         
                                                var lang=$rootScope.globals.currentUser.lang;
                                 
                                                //ako ne postoji outcomeHead a ima podataka onda kreiramo novi outcomeHead 
                                                if (($scope.task.TaskOutcomeHeadId == null || $scope.task.TaskOutcomeHeadId==undefined || $scope.task.TaskOutcomeHeadId==0))
                                                {
                                                            if ($scope.outcomes.length>0) {
                                    
                                                                        $scope.OutcomeHead = {Active:true,id:null};
                                                                        $scope.OutcomeHead.Lang = lang;
                                                                        $scope.OutcomeHead.OutcomeName="OutcomeTask"+$scope.task.ResourceDefId;
                                                                        $scope.OutcomeHead.Name="OutcomeTask"+$scope.task.ResourceDefId;
                    
                                                                        TaskDataService.SaveOutcomeDefinition($scope.OutcomeHead).then(function(data) {
                                                           
                                                                                    $scope.task.TaskOutcomeHeadId=data.data.data.id;
                                                                                    MessagingService.addMessage(data.data.msg,'success');     
                                                                                    $scope.saveTaskOutcomesFinalize();
                                                        
                                                                        },function(error){                   
                                                                                    MessagingService.addMessage(error.msg,'error');
                                                                        }); 
                                                            }
         
                                                }  //ako već postoji outcomehead onda samo snimamo outcome 
                                                else  $scope.saveTaskOutcomesFinalize();
                                    }
                        };
                   
                   
                        $scope.saveTaskOutcomesFinalize = function(){
                            
                                 var outcomes = {outcomeId:$scope.task.TaskOutcomeHeadId,defaultOutcomeId:$scope.task.DefaultOutcomeId,outcomes:$scope.outcomes};
         
                                 TaskDataService.SaveTaskOutcomes($scope.task.ResourceDefId,!$scope.task.InfiniteTask,outcomes,lang).then(function(data) {
                                                                 
                                           $scope.outcomes.outcomeCodesDetails = data.data;
                                           $scope.outcomes.selectedOutcomeIndex=-1;
                                           MessagingService.addMessage(data.msg,'success');
                                
                                         
                                     },function(error){
                                         
                                           MessagingService.addMessage(error.msg,'error');
                                       });
                                                                   
                        }
                    
                            
                        $scope.GetAllOutcomes = function(){
                           
                               var lang=$rootScope.globals.currentUser.lang;                
                               TaskDataService.GetTaskOutcomes(0,0,lang).then(function(data) {            
                                                                                         
                                   for(var i=0;i<data.data.length;i++) { 
                                    data.data[i].id=data.data[i].id1;
                                    data.data[i].name=data.data[i].name1;
                                   }
                                   $scope.allOutcomes = data.data;
                                   
                               },function(error){
                                           MessagingService.addMessage(error.msg,'error');
                               });
                 
                        };//GetAllOutcomes
                           
                        // $scope.GetAllOutcomes();        
                        
            },
            link: function (scope, elem, attrs) {
              
               
            }
    }
};
'use strict';

export function ktProcessingAnimation () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktProcessingAnimation.html',
            scope:{
                   message : "@",
                   showMsg: "=",
                   showAsCard: "=",
      			},
                controller: function(){},
             link: function (scope, elem, attrs) {
                    
              }
        }             
};
'use strict';

export function ktProcessingAnimationTimeline () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktProcessingAnimationTimeline.html',
            scope:{
                   message : "@",
                   showMsg: "=",
                   animationType: "=",
      			},
             link: function (scope, elem, attrs) {
                
                scope.formItems = [1,2,3,4];
                if (scope.animationType=="table") scope.formItems = [1,2,3,4,5,6,7,8];
              }
        }             
};
'use strict';

export function ktRegexValidator (){ 
   return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, elem, attr, ngModel) {           
          ngModel.$validators.ktRegexValidator = function(modelValue, viewValue) {
            
            if (modelValue===undefined && viewValue===undefined) return true;
            
              let regex = attr.ktRegexValidator;
              let value = modelValue || viewValue;
              let valid = value.match(regex);
              if (valid!==null) return true;
              else
              {
                ngModel.$setValidity(scope.fd.ErrorMsg,false);
                return false;
              }
          };    
      }
   };
};
'use strict';

export function ktResource () {
        return {
            restrict: 'A', 
			controller: function ($scope, $rootScope,$element,$compile,$templateCache,ResourcesDataService,ProcessingService,$timeout,MessagingService,CODES_CONST,GridsterService,WidgetDataExchangeService,KatalyoStateManager) {
	
        
        $scope.gsrvc = GridsterService;
        
        if ($scope.localVars==undefined) $scope.localVars={};        
        if ($scope.formData == undefined) $scope.formData=[{}];
        if ($scope.formData.length == 0) $scope.formData.push({});
        let newValueSingle,newValueMultiple;
        
        if ($scope.formParamsParent==undefined) $scope.formParamsParent={};
        $scope.ctrl = this;
        
        /*
        if ($scope.fd.PresentationType==1)
        {
                
                $scope.setDropdownValue=function(theSelectItemFn)
                {
                        $scope.setItemValueDropdown = theSelectItemFn;
                
                }
                 $scope.setLoadDropdown = function(directiveFn) {
                        $scope.loadDropdown = directiveFn;
            
                };
                $scope.setClearDropdown = function(directiveFn) {
                        $scope.clearDropdown = directiveFn;
                }
        }
        */
        
       
        var widgetDefinition = {DEI: [{'name':'resourceLinkDataset','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'datasetListWidget',widgetId: $scope.fd.PresentationId,taskId:  $scope.lTaskId,
                                resourceDefId : $scope.fd.Related, //resourceDefId : $scope.selectedResource
                                resourceRecordId:$scope.localVars.resourceRecordId,task_initiate_id:$scope.taskDefinition.task_initiate_id,task_execute_id:$scope.taskDefinition.task_execute_id, output:null };
        $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        
        $scope.ksm = KatalyoStateManager;
        
        $scope.populateValue = function(newValue)
        {
                if ($scope.fd.MaxLength!=1)
                {
                 newValueMultiple = newValue;
                 newValueSingle="";
                }
                else
                {
                 newValueMultiple = [];
                 newValueSingle=newValue;
                }
               
                $scope.itemValue.val = newValue;
                //if ($scope.fd.PresentationType==1 && $scope.setItemValueDropdown!=undefined) $scope.setItemValueDropdown(null,$scope.itemValue.val);
                $scope.formData[0]['Field'+$scope.fd.ItemId] = $scope.itemValue.val;
                $scope.fd.Search.value = $scope.formData[0]['Field'+$scope.fd.ItemId];
                $scope.ksm.executeAction(valueStateName,"valueChanged", newValue);
                //if (newValue && $scope.setItemValueDropdown!=undefined) $scope.setItemValueDropdown(null,newValue);
                //else if ($scope.clearDropdown!=undefined) $scope.clearDropdown();
                WidgetDataExchangeService.setData({
                    DEI: [{name:'resourceLinkDataset',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:newValueSingle}
                        ,{name:'resourceRecordIds',value:newValueMultiple},{name:'resourceRecordsAll',value:$scope.fd.datasetItems}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});   
                
        }
      
      /*  
         $scope.setDropdownValue = function(fnSetValue) {
            $scope.setDropdown = fnSetValue;
        };
        */
         /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
       
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
        $scope.itemValue = {val:null};
        
        let valueState= $scope.ksm.addSubject($scope.fd.ElementType+'ValueStateName'+$scope.fd.ItemId+$scope.taskDefinition.transaction_id,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        
        let apply_value = function(data)
        {
            let local_data;        
            if ($scope.itemValue.val!=data)
            {
                local_data = data;
                if ($scope.fd.Parameters.DependentFieldFilter!=undefined)
                {
                        if ($scope.fd.Parameters.DependentFieldFilter!="" || $scope.fd.Parameters.DependentFieldElement!="")
                        {
                                if (Array.isArray(data))
                                {
                                        if (data.length>0) local_data = data[0];
                                        else local_data = null;
                                        
                                }
                                else
                                {
                                     local_data = data;
                                }
                                let dItems ;
                                if ($scope.fd.ShowField && !$scope.fd.ReadOnly) dItems = $scope.fd.datasetItems;
                                else dItems = $scope.fd.datasetItemsHidden;
                                if (dItems==undefined)
                                {
                                        $scope.fd.refreshDatasetDataList("",true,local_data);
                                        local_data=null;
                                }
                                else
                                {
                                        let element1,element2;
                                        if ($scope.fd.Parameters.DependentFieldFilter!="")
                                        {
                                                element1 = $scope.fd.Parameters.DependentFieldFilter;
                                                element2 = "id";
                                        }
                                        else
                                        {
                                                element1 = "id";
                                                element2 = $scope.fd.Parameters.DependentFieldElement;
                                        }
                                        let pos = dItems.map(function(e) { return e[element1]; }).indexOf(local_data[element2]);

                                        if (pos>=0) local_data = dItems[pos];
                                        else local_data = null;
                                }
                        }
                }
                $scope.populateValue(local_data);
            }
        }; 
       
        if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
        
        {
            if ($scope.fd.Parameters.DependentFieldId!="")
            {
                let dependent_field = "Field"+$scope.fd.ItemId;
                let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId+$scope.taskDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value,true);
                let val = $scope.ksm.getState(subscribedSubject);
                $scope.populateValue(val.state);
            }
        }
        
          /************ Get selected records for dropdown **************/
        $scope.fd.getDatasetList = function()
        {
                if ($scope.formData[0]['Field'+$scope.fd.ItemId+'l']!=undefined && $scope.formData[0]['Field'+$scope.fd.ItemId+'l'].length>0 && $scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined)
                {
                  ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,{'id__in': $scope.formData[0]['Field'+$scope.fd.ItemId+'l']}).then(function(data) {
                             
                             if ($scope.formData===undefined) $scope.formData = [{}];
                             if ($scope.fd.MaxLength==1) $scope.formData[0]['Field'+$scope.fd.ItemId] = data.data[0];
                             else $scope.formData[0]['Field'+$scope.fd.ItemId] = data.data;
                             $scope.populateValue($scope.formData[0]['Field'+$scope.fd.ItemId]);
                             WidgetDataExchangeService.setSearch($scope.fd.PresentationId,$scope.taskExecuteId);
                             //$scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0]['Field'+$scope.fd.ItemId]);
                             //$scope.itemValue.val = $scope.formData[0]['Field'+$scope.fd.ItemId];
                      },function(error){    
                      MessagingService.addMessage(error.msg,'error');
                  });
                }
        }
        
      
      
        $scope.$watch('itemValue.val',function(newValue,oldValue){
                if (newValue!=oldValue)
                {
                        $scope.populateValue(newValue);    
                
                }
        });
        
        
        $scope.search=[
                            {id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
                            {id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                      ];
				
        if ($scope.fd!=undefined) {
                  if ($scope.fd.Search==undefined)
                  {
                    $scope.fd.Search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                  }
        } 

			  $scope.applySearchFilters = function(index) {
                   
				  $scope.fd.Search=$scope.search[index];
                            $scope.fd.Search.value = [ $scope.formData[0]['Field'+$scope.fd.ItemId] ];
                            $scope.fd.isOpen=false;		
			  };
       
       
        $scope.src_type_text=CODES_CONST._POPULATE_TYPE_  
      
        $scope.fd.inputParamsDatasets = {placeholder:'Select dataset...',label:'Dataset',name:'datasets',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label-xs text-muted',sizeXs:true};
       
       
        $scope.fd.inputParamsSearchForm = {placeholder:'Select task...',label:'Search form task',name:'tasks',columnSizeLabel:'col-24',
                hideLabel:false,paddingLeft:true,dropdownSize:'col-24',labelTextSize:'label-xs text-muted',sizeXs:true};
                
       
        var lang = $rootScope.globals.currentUser.lang;
        
        $scope.localVars.isResourceSelected = false;
 
				$scope.localVars.selectedDataRecord=false;
 
				$scope.taskId=0;
       
        $scope.localVars.showForm = false;
        
        $scope.localVars.gridOptions = {
							enableGridMenu: true,
							showGridFooter: true,
							showColumnFooter: false,
							enableRowSelection: true,
						   multiSelect: true,
						   enableHorizontalScrollbar : 0, 
						   enableVerticalScrollbar : 2,
						   enableFiltering: true,
						   enableRowHeaderSelection: true,
						   enableColumnResizing: true,
						   autoResize:true,
						   minRowsToShow: 4,
						   minimumColumnSize: 40,
						
					   }
					   
					   
					   
	$scope.fd.gridOptions2 = {
                data:[],
                showGridFooter: false,
                showColumnFooter: false,
                enableRowSelection: !$scope.fd.ReadOnly,
                multiSelect: false,
                enableHorizontalScrollbar : true, 
                enableVerticalScrollbar : true,
                enableRowHeaderSelection: false, //false
                showHeader:true,
                enableColumnResizing: true,
                autoResize:true,
                minRowsToShow: 4,
                displayselectionCheckbox:false,
                enableGridMenu: true,
        }
					   
        $scope.fd.RelationshipType = $scope.fd.MaxLength;
     
						
         
           $scope.colLength=[];
           for (var i=0;i<24;i++) $scope.colLength.push('col-'+(i+1));
          
        // $scope.fd.showSearchForm = false;
        
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        if ($scope.taskDefinition!=undefined)
        {
          $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
          $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
          $scope.formType=$scope.taskDefinition.form_type;
          $scope.source_type=$scope.taskDefinition.source_type;
          $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
          $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
          $scope.formDefinition = $scope.taskDefinition.form_definition;
          
         
        
        }
        
         $scope.fd.gridsterType = "resource";
          
          $scope.localVars.resourceDashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: [],
          data:{}
				} ;
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.fd.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        if ($scope.fd.PresentationType==null)
        {
              $scope.fd.PresentationType = 1;
        }
            
          $scope.fd.tItemValue = $scope.fd.FormDef;
          if (typeof $scope.fd.tItemValue=="string") $scope.fd.tItemValue=[]; 
          $scope.fd.resourcesList=[];
          $scope.fd.resourceListLength=0;
          $scope.fd.selectedDataset = 0;
          //if ($scope.fd.Related!=null) $scope.fd.selectedDataset = $scope.fd.Related;
					
          
          //*********************************************************************************************
          //************************************ GET DATASET LIST ***************************************
					//*********************************************************************************************
       $scope.fd.getResources = function(search)  {
						var lang=$rootScope.globals.currentUser.lang;
              ResourcesDataService.getResourceDefListByTypeFilter(lang,'dataset',search,$scope.fd.selectedDataset).then(
			function(data) {
										
       			$scope.fd.resourcesList = data.data;
                            
                            if (!Array.isArray($scope.fd.resourcesList))   $scope.fd.resourcesList=[];            
                        
                            if ($scope.fd.Related!=null)
                            {
                                   $scope.fd.resourceId = $scope.fd.Related;
                                   $scope.fd.resourceListLength = $scope.fd.resourcesList.length;
                                   //select dataset from dropdown
                                    var pos = $scope.fd.resourcesList.map(function(e) { return e.id; }).indexOf($scope.fd.resourceId);

                                   if (pos>=0){
                                       $scope.fd.selectedResource=$scope.fd.resourcesList[pos];
                                      
                                       $scope.fd.isResourceSelected=true;
                                       $scope.localVars.pickButtonLabel="Choose "+$scope.fd.selectedResource.name+" record...";

                                   }
                         
                            }
                            $scope.fd.RelatedLoaded=true;
											 
                     },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
       };	  
          
          
          
				  $scope.fd.getResources();
				  $scope.fd.resourceDataRecordSelected=false;
				  
         //*********************************************************************************************
          //************************************ GET TASK LIST ***************************************
					//*********************************************************************************************
					$scope.fd.getTasks = function(search)  {
						var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
										
											  $scope.fd.taskList = data.data;
                        
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
          }
					
          $scope.fd.getTasks('');
          
				    // when confirm selection clicked
            /*
              $scope.fd.confirmSelection = function ()
						{
							
							$scope.fd.SearchFormDownloaded=false;
							$scope.fd.resourceDashboard.widgets.length=0;
					 }
            	$scope.fd.cancel = function ()
						{
              $scope.fd.SearchFormDownloaded=false;
              $scope.fd.resourceDashboard.widgets.length=0;

            }
            */
	// *******************             FOR GRID 1 
						
	$scope.localVars.gridOptions.onRegisterApi = function (gridApi) {
                
                $scope.localVars.gridApi = gridApi;
									
                $scope.localVars.gridApi.grid.registerRowsProcessor($scope.localVars.singleFilter, 200);
									 
                $scope.localVars.gridApi.treeBase.on.rowExpanded(null, function(row) {
										updatePagination(row.treeNode.children.length);
									  });
									 
                $scope.localVars.gridApi.treeBase.on.rowCollapsed(null, function(row) {
										updatePagination(-row.treeNode.children.length);
									  });
							
							
                gridApi.selection.on.rowSelectionChanged($scope,function(row){
								
                        // Copy selected to formData
                        $scope.formData[0]['Field'+$scope.fd.ItemId]=$scope.localVars.gridApi.selection.getSelectedRows().map( function (a) { return a.id; });
                                                               
                       // Copy selected to GRID2
                       $scope.fd.gridOptions2.data=$scope.localVars.gridApi.selection.getSelectedRows();
                       // count selected
                       $scope.fd.resourceDataRecordSelected=$scope.formData[0]['Field'+$scope.fd.ItemId].length; 
		});     
	};
        
         $scope.fd.rowSelectionChanged = function(row){
                             
                                $scope.formData[0]['Field'+$scope.fd.ItemId]=row;
                                
                                $scope.localVars.selectedDatasetRecordId = row.id;                                 
                                // count selected
                                $scope.fd.resourceDataRecordSelected=$scope.formData[0]['Field'+$scope.fd.ItemId].length; 
                                
                                WidgetDataExchangeService.setData({
                                DEI: [{name:'resourceLinkDataset',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId},
                                {name:'resourceRecordIds',value:row},{name:'resourceRecordsAll',value:$scope.fd.gridOptions2.data}]}],
                                widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});

        };
        
                $scope.fd.rowSelectionChanged = function(item)
                {
                        $scope.formData[0]['Field'+$scope.fd.ItemId]=item;
                                
                        $scope.localVars.selectedDatasetRecordId = item.id;                                 
                        // count selected
                        $scope.fd.resourceDataRecordSelected=item.isSelected; 
                        
                        WidgetDataExchangeService.setData({
                        DEI: [{name:'resourceLinkDataset',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId},
                        {name:'resourceRecordIds',value:item},{name:'resourceRecordsAll',value:$scope.fd.gridOptions2.data}]}],
                        widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
                };
                /*
                $scope.fd.gridOptions2.onRegisterApi = function (gridApi) {
                        
                        $scope.localVars.gridApi2 = gridApi;
                     
                        if ($scope.fd.resGridState) $scope.localVars.gridApi2.saveState.restore($scope,$scope.fd.GridState);
                        gridApi.selection.on.rowSelectionChanged($scope,function(row){
                                                                        
                                // Copy selected to formData
                            
                                $scope.formData[0]['Field'+$scope.fd.ItemId]=$scope.localVars.gridApi2.selection.getSelectedRows().map( function (a) { return a.id; });
                                
                                $scope.localVars.selectedDatasetRecordId = row.entity.id;                                 
                                // count selected
                                $scope.fd.resourceDataRecordSelected=$scope.formData[0]['Field'+$scope.fd.ItemId].length; 
                                
                                WidgetDataExchangeService.setData({
                                DEI: [{name:'resourceLinkResource',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId},
                                {name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:$scope.fd.gridOptions2.data}]}],
                                widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
                    
                      
                      
                        });
                };
        
                function updatePagination(rowsDifference) {
                 //updating pagination will trigger singleFilter where the height is being reset
                 $scope.localVars.gridOptions.paginationPageSizes = [$scope.localVars.gridOptions.paginationPageSize + rowsDifference, 25, 50, 100, 500];
                 $scope.localVars.gridOptions.paginationPageSize = $scope.localVars.gridOptions.paginationPageSize + rowsDifference;
                }
                //you can name the function anything, I was doing global external filtering inside this, so just named this.
                $scope.localVars.singleFilter = function(renderableRows) {
                       $timeout(function() {
                         var newHeight = ($scope.localVars.gridApi.grid.getVisibleRowCount() * 30) + 145;
                         angular.element(document.getElementsByClassName('myGrid')[0]).css('height', newHeight + 'px');
                       }, 10);
                       return renderableRows;
                }
  
                */
           //$scope.datasetRecordId=445;
           $scope.fd.getResourceDataRefresh = function (retValue) 
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
              ResourcesDataService.getResourceDataWithRelated($scope.parentDatasetDefId,$scope.resourceId,$scope.datasetRecordId,$scope.taskId,$scope.fd.ItemId,lang).then(function(data) {
                            $scope.formData[0]['Field'+$scope.fd.ItemId] = data.m2m; 
                            $scope.setupGrid(data);                
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
									});
                      
            }
            
            $scope.linkedWidgetId = 0;
            
            if ($scope.fd.Search!=undefined) $scope.linkedWidgetId = $scope.fd.Search.WidgetId;
            
            var refresh_list_from_callback=function(data)
            {
                $scope.fd.refreshDatasetDataList("",true,$scope.lData);
                
            }
              
       
            
            $scope.fd.refreshDatasetDataList = function(search,apply,val)
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv
              $scope.lData = val;
               if ($scope.fd.PresentationId!=null && $scope.fd.PresentationId!=undefined)
                {
                        var ctrl = this;
                        this.l_apply = apply;
                        this.l_val = val;
                        let fromCache=true;
                   //ResourcesDataService.getResourceDataList($scope.fd.Related,$scope.fd.PresentationId,lang,search).then(function(data) {
                   ResourcesDataService.getResourceDataListAll($scope.fd.Related,$scope.fd.PresentationId,lang,fromCache,refresh_list_from_callback).then(function(data) {
                           
                           if ($scope.itemValue.val==undefined || $scope.itemValue.val==null)
                           {
                                if (Array.isArray($scope.formData))
                                {
                                   if (Array.isArray($scope.formData[0]['Field'+$scope.fd.ItemId+'l']))
                                        for (let i=0;i<$scope.formData[0]['Field'+$scope.fd.ItemId+'l'].length;i++)
                                        {
                                                if ($scope.fd.MaxLength==1) $scope.itemValue.val={'id':$scope.formData[0]['Field'+$scope.fd.ItemId+'l'][i]};
                                                else  $scope.itemValue.val.push ({'id':$scope.formData[0]['Field'+$scope.fd.ItemId+'l'][i]});
                                        }
                                }
                                
                           }
                           
                           if ($scope.fd.ShowField && !$scope.fd.ReadOnly)
                           {
                                $scope.fd.datasetItems = data.data;
                                if ($scope.fd.datasetItems.length>0)
                                {
                                    if (!$scope.fd.Required && $scope.fd.datasetItems[0].id!=null) $scope.fd.datasetItems.unshift({id:null});   
                                }
                                
                           }
                           else
                           {
                                $scope.fd.datasetItemsHidden = data.data;
                                if ($scope.fd.datasetItemsHidden.length>0)
                                {
                                    if (!$scope.fd.Required && $scope.fd.datasetItemsHidden[0].id!=null) $scope.fd.datasetItemsHidden.unshift({id:null});   
                                }
                           }
                           $timeout(function(){
                                //if (!$scope.fd.ReadOnly) $scope.loadDropdown($scope.fd.datasetItems);
                                if (ctrl.l_apply) apply_value(ctrl.l_val);
                           });
                    },function(error){    
                    MessagingService.addMessage(error.msg,'error');
									});
              
                }
            };
           
          
          if ($scope.fd.PresentationType==1 && $scope.fd.ShowField && !$scope.fd.ReadOnly) $scope.fd.refreshDatasetDataList(""); //This should be connected to search form
          /************ Call task when magnifier is clicked or autoSearch=true **************/
          
          $scope.fd.SelectDatasetRecords = function(taskId,autoSearch){
            
           // $scope.PreInitiateTask(taskId,0);
            $scope.fd.autoSearchLocal=autoSearch;
            $scope.localVars.showForm = true;
           if (!$scope.fd.searchFormDownloaded)
            
            {   if  (taskId==undefined || taskId==null || taskId==0) MessagingService.addMessage("Error in definition!! Search form is not assigned to dataset.","error");
               else 
               {
               $scope.localVars.StartTask(taskId,0,0);
               //$rootScope.$broadcast("ProcessTask"+$scope.fd.presentationId,{'taskId':taskId,'task_execute_id':$scope.taskExecuteId});
               //if (autoSearch) $scope.fd.ConfirmSelection();
          
                $scope.fd.searchFormDownloaded=true;
                
               }
            }
          };
     
    
          
          
          /*
           var localWidgetId="";  
            $scope.$on("Event"+localWidgetId+"resourceLinkDataset",function(event,data){
             
            for (var i=0;i<data[1].value.length;i++)
            {
             $scope.fd.gridOptions2.data.push(data[1].value[i]);
            }
          });
          */
          
          
          /************ Confirm selection - populate with selected items from search form **************/
          
          
          $scope.fd.autoSearchLocal = true;
          var counter=0;
          
          $scope.fd.ConfirmSelection = function(){
            
            var items=[];
            if ($scope.fd.gridOptions2.data!=undefined)
            {
              for (var i=0;i<$scope.fd.gridOptions2.data.length;i++)
              {
              
             
               items.push($scope.fd.gridOptions2.data[i].id);
              
              }
            }
            //Get also selected from search form
            var linkedItem = 'resourceLinkDataset';
            if ($scope.linkedWidgetId!=undefined) //linkedWidgetId = 2325;
            {
             var data = WidgetDataExchangeService.getDataByWidgetIdOnly($scope.linkedWidgetId,linkedItem);
             //var data = WidgetDataExchangeService.getDataByLocalTaskWidgetId(localTaskId,WidgetId,linkedItem);
             var fromWidget=[];
             for (var k=0;k<data.length;k++) {
                if ($scope.fd.AutoSearch && $scope.fd.autoSearchLocal)
                {
                   if (data[k].name=='resourceRecordsAll') fromWidget = data[k].value; 
                }
                else{
                     if (data[k].name=='resourceRecordIds') fromWidget = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                  }
              }
              
            
             if (fromWidget!=null)                         
             {
               for (var j=0;j<fromWidget.length;j++)
               {
               
                   var pos = items.map(function(e) { return e; }).indexOf(fromWidget[j].id);
               
                   if (pos<0) items.push(fromWidget[j].id);
                }
              
              }
            }
            if ($scope.formData!=undefined)
            {
              if ($scope.formData.length>0) $scope.formData[0]['Field'+$scope.fd.ItemId+'l']=items;
            }
            
            if ($scope.fd.PresentationType==0)
            {
              if ($scope.fd.gridOptions2.data!=undefined)
              {
                 if (items.length>0 && $scope.fd.gridOptions2.data.length<items.length)
                 {
                   $scope.fd.getDatasetDirect($scope.fd.Related,items);
                 
                 }
              }
            }
            
            if ($scope.fd.PresentationType==1 && items.length>0) $scope.fd.getDatasetList();
            
            //$scope.fd.searchFormDownloaded=false;
            
            
            $scope.localVars.showForm = false;
          };
              /************ Cancel selection - cancel selection from search form **************/
          
          $scope.fd.CancelSelection = function(){
             $scope.localVars.showForm = false;
            
          }
          
          $scope.fd.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.fd.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.formType,$scope.fd.PresentationId,"f",lang).then(function(data) {
                               
                                  $scope.fd.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.fd.resourceDashboard.widgets =  data.data.widgets;
                                   $scope.fd.selectedResourceItem = {'name':$scope.fd.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related,'presentationId':$scope.fd.PresentationId,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                               
                              
                                $scope.fd.fItemValue=data.data.widgets;
                               
                                
                                 // $scope.pickResourceData();
                                 
                                   $timeout(function() {
                                      $scope.fd.formLoaded=true;
                                      $scope.fd.formLoading=false;
                                       $scope.fd.searchFormDownloaded = true;
                                      /*  if  ($scope.fd.autoSearch)
                                        {
                                          $scope.getResourceDataFiltered();
                                          
                                        }*/
                                  });
                                   
                                  
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.formLoading=false;
                                 
                                
                             });
                              
          };
            
      
         //**********************************************************
         //           GET FORM FIELDS
         //**********************************************************      
            
          $scope.fd.getFormFields = function(){
              
              
              var lang=$rootScope.globals.currentUser.lang;
           
                         
              ResourcesDataService.getFormFields($scope.fd.Related,lang).then(function(data) {
                               
                                  $scope.fd.presentationElements= data.data;
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
                              
          };
      
      
       //**********************************************************
         //          Clear saerch task dropdown
         //**********************************************************      
            
           $scope.localVars.clearSearchTask = function(event,select){
            $scope.fd.Search.taskId = null;
           };
         //**********************************************************
         //          Remove selected records from grid
         //**********************************************************      
            
           $scope.localVars.removeSelectedRecords = function(){
              
                       
               for (var i=0;i<$scope.formData[0]['Field'+$scope.fd.ItemId].length;i++)
                {
                   var delRec = $scope.fd.gridOptions2.data.map(function(e) { return e.id; }).indexOf($scope.formData[0]['Field'+$scope.fd.ItemId][i]);

                  if (delRec>=0){
                  $scope.fd.gridOptions2.data.splice(delRec,1);
                  }
                }
              $scope.formData[0]['Field'+$scope.fd.ItemId] = $scope.fd.gridOptions2.data;
              $scope.fd.resourceDataRecordSelected=0;
            };
            
            $scope.fd.setupGrid= function(data)
            {
              $scope.localVars.gridOptions.data = data.data;
              $scope.localVars.gridOptions.columnDefs = data.columnsDef;
              $scope.fd.gridOptions2.columnDefs = data.columnsDef;
              if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=undefined){
                for (var i=0;i<$scope.formData[0]['Field'+$scope.fd.ItemId].length;i++)
                {
                   var pos = $scope.localVars.gridOptions.data.map(function(e) { return e.id; }).indexOf($scope.formData[0]['Field'+$scope.fd.ItemId][i]);

                  if (pos>=0){
                      //prebaci u grid 2
                      $scope.fd.gridOptions2.data.push(angular.copy($scope.localVars.gridOptions.data[pos]));
                      //selektiraj odabrane
                      $scope.fd.gridApi.grid.modifyRows($scope.localVars.gridOptions.data);
                      $scope.fd.gridApi.selection.selectRow($scope.localVars.gridOptions.data[pos]);
                  }            
                    
                }
              }
              
              $timeout(function(){
                $scope.fd.restoreGridState();
               
               });
              
              
            }
            
              $scope.localVars.setupGridNew= function(data)
              {
                $scope.fd.gridOptions2.data = data.data;
                $scope.fd.gridOptions2.columnDefs = data.columnsDef;
                $scope.showGrid=true;
              
              }
              
              $timeout(function(){
                $scope.fd.restoreGridState();
               
               });
              
              
            
            //  Popuni listu gridOptions.data sa listom svih resursa odabranog tipa
						
            
		 $scope.fd.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.fd.selectedResource==null) {
            $scope.fd.selectedResourceId = $scope.fd.Related;
          }else
          {
             $scope.fd.selectedResourceId = $scope.fd.selectedResource.id;
            
          }
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.Related,lang,$scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered($scope.fd.selectedResourceId,$scope.taskId,lang,$scope.fd.resourceDashboard.widgets).then(function(data) {//MIGOR
                            
                            $scope.fd.setupGrid(data);
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        }
		
						
             
        $scope.fd.getResourceData = function () 
	{
                // $scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+$scope.resourceId);
                 var lang = $rootScope.globals.currentUser.lang;
                 ResourcesDataService.getResourceData($scope.resourceId,$scope.taskId,lang).then(function(data) {
                                                 
                                                                $scope.localVars.setupGridNew(data);
        
                },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                });
	};
                
     //**********************************************************
     //           GET DATASET DIRECT FILTER
     //**********************************************************      
      $scope.fd.getDatasetDirect = function (relatedDatasetId,items) {

        ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,0,"i",lang,{id__in: items}).then(function(data) {
                                
                                    $scope.localVars.setupGridNew(data);
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
                
             	 $scope.fd.saveGridState= function() {
                    var state = $scope.localVars.gridApi2.saveState.save();
                   $scope.fd.GridState = state;
                  MessagingService.addMessage("To make changes stick please save form",'info');
      
                  }
  
              $scope.fd.restoreGridState= function() {
                   if ($scope.fd.GridState!=null && $scope.fd.GridState!=undefined)
                   {
                      if ($scope.localVars.gridApi2!=undefined)
                      {
                     
                       $scope.localVars.gridApi2.saveState.restore($scope,$scope.fd.GridState);
                       
                      }else
                      {
                      
                           $scope.fd.resGridState = true;
                      }
                   }
                 }
            
            // Resource is selected
              $scope.fd.onSelectCallback = function (item, model){
                var eventResultId=item.id;
                $scope.fd.eventResultName=item.name;
                $scope.fd.pickButtonLabel="Choose "+$scope.fd.eventResultName+" record...";
						 
                //console.log("onSelectCallback :" +  $scope.eventResultName+ ' ' + eventResultId);

                 $scope.fd.resourceId=eventResultId;
                 $scope.fd.isResourceSelected=true;
					
               	$scope.fd.Related=$scope.fd.resourceId;
                if ($scope.fd.Related!=undefined && $scope.fd.Related!=null) $scope.fd.getFormFields();
              }
              
              
              $scope.fd.onSelectSearchForm= function (item, model){
               
               if ($scope.fd.Search==undefined) $scope.fd['search']={taskId:item};
               else $scope.fd.Search.taskId = item;
                //$scope.fd.Search.widgetId=0; //ovo treba na serveru dohvatiti widgetId
                
                
              } 
            //ako ima odabranih dohvati ih i setupiraj
            if (($scope.formData!=undefined && $scope.formData.length>0))
            {
                if ($scope.formData[0]['Field'+$scope.fd.ItemId+'l']!=undefined){
                   if ($scope.fd.PresentationType==0)
                  {
                    $scope.fd.getDatasetDirect($scope.fd.Related,$scope.formData[0]['Field'+$scope.fd.ItemId+'l']);
                  }
                  else
                  {
                   if  ($scope.fd.OverrideType!="f") $scope.fd.getDatasetList();
                  }
                } else if ($scope.fd.PresentationType==0 && $scope.formParams.formViewType==1 && $scope.formParamsParent.formViewType!=2) $scope.fd.getDatasetDirect($scope.fd.Related,{});
            }else if ($scope.fd.PresentationType==0 && $scope.formParams.formViewType==1 && $scope.formParamsParent.formViewType!=2)
            {
                $scope.fd.getDatasetDirect($scope.fd.Related,{});
            }
          if ($scope.fd.Related!=undefined && $scope.fd.Related!=null) $scope.fd.getFormFields();
          
          /*
           if  ($scope.fd.AutoSearch && $scope.fd.Search!=undefined && $scope.fd.Search!=null && $scope.linkedWidgetId!=undefined)
              {
                  $scope.localVars.autoSearch = $scope.fd.AutoSearch;
           
                  if ( $scope.fd.Search.taskId!=undefined)
                  {
                    $scope.localVars.menuId = $scope.fd.Search.taskId.id;
                  }else
                  {
                    $scope.localVars.menuId =0;
                  }
                  
                  $scope.localVars.outcomeId = 0;
                  $scope.localVars.previousTask = 0;
                  $scope.localVarsSearch = {'isInlineTask':null,'OpenTaskType':'current','taskIndex':0,'loadTaskDirect' : true,'taskId':$scope.localVars.menuId,'outcomeId':$scope.localVars.outcomeId,'previousTask':$scope.localVars.previousTask};
                   

                    $scope.$on("StartTask"+$scope.linkedWidgetId+"Completed",function(event,data){
                 
                        if (counter==0 && $scope.fd.AutoSearch) $scope.fd.ConfirmSelection();//$scope.fd.SelectDatasetRecords($scope.fd.Search.taskId.id,true);
                        counter++;
                               
                    });
                  
                  
              }else
              
              {
                  WidgetDataExchangeService.setSearch($scope.fd.PresentationId,$scope.taskExecuteId);
                                   
              }
              */
          let template;
          if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktResource.html');
          else template = $templateCache.get('ktdirectivetemplates/ktResourceExe.html');
          
          $element.append($compile(template)($scope));  
          
	},//...controller
				
           
            link: function (scope, elem, attrs) {
             		  
          
            }
    
    }
};
'use strict';

export function ktResourceDefinition () {
      
        return {
        restrict: 'A',
        scope:{
                    resource:'=',
                  
            },
	templateUrl: 'ktdirectivetemplates/ktResourceDefinition.html',
        controller: function ($scope,GridsterService,KatalyoStateManager)
        {
                $scope.gsrvc = GridsterService;
                
                $scope.ksm = KatalyoStateManager;
               
                $scope.EditResourceFn=function(val)
                {
                        
                     $scope.editResource=val;
                }
               
                
                },
        link: function (scope, elem, attrs) {
				
        
        
        }      
            
        }
};
'use strict';

export function ktResourceid () {
      
        return {
        restrict: 'A',
	templateUrl: 'ktdirectivetemplates/ktResourceid.html',
        controller: function ($scope,GridsterService,KatalyoStateManager)
        {
                $scope.gsrvc = GridsterService;
                
                $scope.ksm = KatalyoStateManager;
                if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
                let resourceIdValue = null;
                if ($scope.formData!=undefined)
                {
                        if ($scope.formData.length==0) $scope.formData=[{}];
                        resourceIdValue=$scope.formData[0]['id']
                        
                }else $scope.formData=[{}];
                
                let valueState= $scope.ksm.addSubject('resourceidValueStateName'+$scope.fd.ItemId+$scope.taskDefinition.transaction_id,resourceIdValue);
                let valueStateName = valueState.subject.name;
                
                let value_changed = function(data)
                {
                    valueState.subject.setStateChanges = data;
                    valueState.subject.notifyObservers("valueChanged");
                };
                
                let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
               
                $scope.on_blur_action=function()
                {
                        
                        $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0]["id"]);
                        
                };
               
                
                
                let apply_value = function(data)
                {
                    if (Array.isArray(data)) $scope.formData[0]["id"] = data[0].id;
                    else if (Object.prototype.toString.call(data) === '[object Object]') $scope.formData[0]["id"] = data.id;

                    $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.formData[0]["id"]);
                }; 
               // let observer_undo = $scope.ksm.subscribe(formChangesSubject,"Field"+$scope.fd.ItemId,"valueChanged",apply_value);
                if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
                
                {
                    if ($scope.fd.Parameters.DependentFieldId!="")
                    {
                        let dependent_field = "Field"+$scope.fd.ItemId;
                        let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId+$scope.taskDefinition.transaction_id;
                        let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
                        let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
                        let val = $scope.ksm.getState(subscribedSubject);
                        if (val.state!=null) apply_value(val.state);
                    }
                }
                
                
                },
        link: function (scope, elem, attrs) {
				
        
        
                scope.search=[
                {id:1,filter:'gt',name:"Greater than",icon:"fa fa-chevron-right"},
                {id:2,filter:'between',name:"Between",icon:"fa fa-expand"},
                {id:3,filter:'lt',name:"Lower than",icon:"fa fa-chevron-left"},
                {id:4,filter:'eq',name:"Equals",icon:"fa fa-bars"} ];
				
                scope.refreshSearchValue = function() {
                        if (scope.fd.Search) scope.fd.Search.value=scope.formData[0]['id'];      
                } 
                
                if (scope.fd.ShowSearchForm)  {
                    scope.fd.Search=scope.search[3];//initialize to equals
                    if (scope.fd.Search && scope.formData!=undefined && scope.formData.length>0) scope.fd.Search.value=scope.formData[0]['id']; 
                }
              
                scope.showProperties = function(event)
                {
                        scope.gsrvc.setFieldProperties(scope.fd,event);
       
                };
                
                scope.applyFilters = function(index) {
                        scope.fd.Search=scope.search[index];
                              
                        if (scope.formData[0]['id']) scope.fd.Search.value=scope.formData[0]['id'];      
                         
                };
            
                scope.colLength=[];
                for (var i=0;i<24;i++) scope.colLength.push('col-'+(i+1));
        
            }
        };
};
'use strict';

export function ktResourceLinks () {
        return {
        restrict: 'A', 
        controller: function ($scope, $rootScope,ResourcesDataService,ProcessingService,$timeout,MessagingService,GridsterService) {
	
        $scope.gsrvc = GridsterService;
        
        if ($scope.localVars==undefined) $scope.localVars={};        
        if ($scope.formData == undefined) $scope.formData=[{}];
        if ($scope.formData.length == 0) $scope.formData[0]={};
 
        $scope.localVars.isResourceSelected = false;
      
        $scope.localVars.pickButtonClicked=false;
				$scope.localVars.pickButtonLabel='Choose dataset..';
			  $scope.selectedResource=null;	
				$scope.selectedDataRecord=false;
				$scope.taskId=0;	
        $scope.localVars.gridOptions = {
              columnDefs: [],
              data: [],
							enableGridMenu: true,
							showGridFooter: true,
							showColumnFooter: false,
							enableRowSelection: true,
						   multiSelect: true,
						   enableHorizontalScrollbar : 2, 
						   enableVerticalScrollbar : 2,
						   enableFiltering: true,
						   enableRowHeaderSelection: true,
						   enableColumnResizing: true,
						   autoResize:true,
						   minRowsToShow: 4,
						   minimumColumnSize: 40,
				
					   }
					   
					   
					   
					   $scope.localVars.gridOptions2 = {
							//enableGridMenu: true,
							showGridFooter: false,
							showColumnFooter: true,
							enableRowSelection: false,
						   multiSelect: false,
						  enableHorizontalScrollbar : true, 
						  enableVerticalScrollbar : true,
						  // enableFiltering: true,
						  enableRowHeaderSelection: true, //false
              showHeader:true,
						  enableColumnResizing: true,
						   autoResize:true,
						   minRowsToShow: 4,
               displayselectionCheckbox:false,
               enableGridMenu: true,
						 
					   }
					   
						$scope.relationshipType = $scope.fd.maxLength;
            //if ($scope.relationshipType>2) $scope.relationshipType=2;
						
          $scope.colLength = ['col-lg-2','col-lg-4','col-lg-6','col-lg-8','col-lg-10','col-lg-12','col-lg-14','col-lg-16','col-lg-18','col-lg-20','col-lg-22','col-lg-24'];
       
          $scope.fd.tItemValue = $scope.fd.formDef;
          if (typeof $scope.fd.tItemValue=="string") $scope.fd.tItemValue=[]; 
					$scope.fd.resourcesList=[];
          $scope.resourceListLength=0;
          $scope.fd.selectedDataset = 0;
          if ($scope.fd.related!=null) $scope.fd.selectedDataset = $scope.fd.related;
					// POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
					$scope.fd.getResources = function(search)  {
						var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByTypeFilter(lang,'dataset',search,$scope.fd.selectedDataset).then(
						function(data) {
										
											  $scope.fd.resourcesList = data.data;
                        
                        if ($scope.fd.related!=null)
                        {
                          $scope.resourceId = $scope.fd.related;
                          $scope.resourceListLength = $scope.fd.resourcesList.length;
                          //select dataset from dropdown
                           var pos = $scope.fd.resourcesList.map(function(e) { return e.id; }).indexOf($scope.resourceId);

                          if (pos>=0){
                                $scope.selectedResource=$scope.fd.resourcesList[pos];
                                $scope.localVars.isResourceSelected=true;
                                $scope.localVars.pickButtonLabel="Choose "+$scope.selectedResource.name+" record...";
                                
                          }
                          
                          if ($scope.resourceId != undefined) {	
                              $scope.fd.getResourceData();
                          }   
                        }      
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
				  
				  //$scope.getResources();
				  $scope.localVars.pickButtonClicked=false;
				  $scope.resourceDataRecordSelected=false;
				  
				     
              
						// *******************             ZA GRID 1 
						
						$scope.localVars.gridOptions.onRegisterApi = function (gridApi) {
									$scope.gridApi = gridApi;
									$scope.gridApi.grid.registerRowsProcessor($scope.fd.singleFilter, 200);
									 $scope.gridApi.treeBase.on.rowExpanded(null, function(row) {
										updatePagination(row.treeNode.children.length);
									  });
									 $scope.gridApi.treeBase.on.rowCollapsed(null, function(row) {
										updatePagination(-row.treeNode.children.length);
									  });
							
							
							gridApi.selection.on.rowSelectionChanged($scope,function(row){
								
                  // Ubaci odabrane u FD
                   $scope.fd.Value=$scope.gridApi.selection.getSelectedRows().map( function (a) { return a.id; });
							 
                 // Ubaci odabrane u GRID2
                 $scope.localVars.gridOptions2.data=$scope.gridApi.selection.getSelectedRows();
                 // koliko ih je odabranih
                 $scope.resourceDataRecordSelected=$scope.fd.Value.length; 
							});     
						 }
 
						// *******************             ZA GRID 2
						
						$scope.localVars.gridOptions2.onRegisterApi = function (gridApi) {
									$scope.gridApi2 = gridApi;
            }
            
             function updatePagination(rowsDifference) {
						  //updating pagination will trigger singleFilter where the height is being reset
						  $scope.gridOptions.paginationPageSizes = [$scope.gridOptions.paginationPageSize + rowsDifference, 25, 50, 100, 500];
						  $scope.gridOptions.paginationPageSize = $scope.gridOptions.paginationPageSize + rowsDifference;
						}
						//you can name the function anything, I was doing global external filtering inside this, so just named this.
						$scope.fd.singleFilter = function(renderableRows) {
							$timeout(function() {
							  var newHeight = ($scope.gridApi.grid.getVisibleRowCount() * 30) + 145;
							  angular.element(document.getElementsByClassName('myGrid')[0]).css('height', newHeight + 'px');
							}, 10);
							return renderableRows;
						  }
  

						
						// when PICK BUTTON pressed
						$scope.localVars.pickResourceData = function ()
						{
							//console.log($scope.resourceDataRecordSelected);
							$scope.localVars.pickButtonClicked=!$scope.localVars.pickButtonClicked;
							
							if (!$scope.localVars.pickButtonClicked) { // RESOURCE_SELECTED stanje
								$scope.localVars.pickButtonLabel="Choose "+$scope.selectedResource.name+" record...";

							}
							
							if ($scope.localVars.pickButtonClicked) { //CHOOSE_RESOURCE  stanje
								
								$scope.localVars.pickButtonLabel='Click to finish';

							}

					 }
         
           $scope.fd.getResourceDataRefresh = function (retValue) 
            {
              var lang = $rootScope.globals.currentUser.lang;
              //ToDo ovo prebaciti sve u jedan API poziv??
              ResourcesDataService.getResourceDataWithRelated($scope.parentDatasetDefId,$scope.resourceId,$scope.datasetRecordId,$scope.taskId,$scope.fd.itemId,lang).then(function(data) {
                            $scope.formData[0]['Field'+$scope.fd.itemId] = data.m2m; 
                            $scope.setupGrid(data);                
                },function(error){    
                    MessagingService.addMessage(error.msg,'error');
									});
                      
            }
            $scope.localVars.setupGrid= function(data)
            {
              $scope.localVars.gridOptions.data = data.data;
             
              $scope.localVars.gridOptions.columnDefs = data.columnsDef;
              $scope.localVars.gridOptions2.columnDefs = data.columnsDef;
  
              if ($scope.formData[0]['Field'+$scope.fd.itemId]!=undefined){
              for (var i=0;i<$scope.formData[0]['Field'+$scope.fd.itemId].length;i++)
                {
                   var pos = $scope.localVars.gridOptions.data.map(function(e) { return e.id; }).indexOf($scope.formData[0]['Field'+$scope.fd.itemId][i]);

                  if (pos>=0){
                      //prebaci u grid 2
                      $scope.localVars.gridOptions2.data.push(angular.copy($scope.gridOptions.data[pos]));
  
                      //selektiraj odabrane
                      $scope.fd.gridApi.grid.modifyRows($scope.localVars.gridOptions.data);
                      $scope.fd.gridApi.selection.selectRow($scope.localVars.gridOptions.data[pos]);
                  }            
                    
                }
              }

                            
                $timeout(function(){
                $scope.restoreGridState();
               
               });
            }
             
              $scope.fd.getResourceData = function () 
								{
								// $scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+$scope.resourceId);
								 var lang = $rootScope.globals.currentUser.lang;
								 ResourcesDataService.getResourceData($scope.resourceId,$scope.taskId,lang).then(function(data) {
												 
														$scope.localVars.setupGrid(data);
                            
											  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
									});
								};
            
            
            		 $scope.fd.saveGridState= function() {
                    var state = $scope.gridApi2.saveState.save();
                   $scope.fd.gridState = state;
                  MessagingService.addMessage("To make changes stick please save form",'info');
      
                  }
  
                  $scope.restoreGridState= function() {
                   if ($scope.fd.gridState!=null)
                   {
                      if ($scope.gridApi2!=undefined)
                      {
                     
                       $scope.gridApi2.saveState.restore($scope,$scope.fd.gridState);
                       
                      }else
                      {
                       $timeout(function(){
                           $scope.restoreGridState();
                       });
                      }
                   }
                 }
            
                        		
					// Resource is selected
              $scope.fd.onSelectCallback = function (item, model){
                var eventResultId=item.id;
                $scope.fd.selectedDatasetName=item.name;
               
               
                $scope.fd.selectedResource={name :item.name};
                //console.log("onSelectCallback :" +  $scope.eventResultName+ ' ' + eventResultId);
                $scope.localVars.pickButtonLabel="Choose "+$scope.eventResultName+" record...";
						 
                 $scope.resourceId=eventResultId;
                 $scope.localVars.isResourceSelected=true;
						 
							
						  
								
                 if ($scope.resourceId != undefined) {	
                		$scope.fd.getResourceData();
                	}
                	$scope.fd.related=$scope.resourceId;						
              } 
          
            
				},//...controller
				
            templateUrl: 'ktdirectivetemplates/ktResourceLink.html',
            link: function (scope, elem, attrs) {
				  
            }
    
    }
};
'use strict';

export function ktRichtextbox () {
       
        return {
            restrict: 'A',
                controller: function ($scope,$rootScope,$templateCache,$element,$compile,GridsterService,CodesService,$sce) {
                        $scope.gsrvc = GridsterService;
                        if ($scope.localVars==undefined) $scope.localVars={};
                        
                        $scope.colLength=[];
                        if ($scope.formData==undefined)
                        {
                                $scope.formData = [{}];     
                        }else if ($scope.formData.length==0) $scope.formData = [{}];
                        
                        var lang=$rootScope.globals.currentUser.lang;
                         CodesService.getCodesByName('usertags',lang).then(function (data) {
                                $scope.fd.tagList = data.data;
                                
                                 var pos = $scope.fd.tagList.map(function(e) { return e.id; }).indexOf($scope.fd.UniqueId);

                                   if (pos>=0){
                                       $scope.fd.UniqueIdObj=$scope.fd.tagList[pos];
                                      
                                   }
                             });
                         
                        if ($scope.formData[0]!=undefined &&  $scope.fd.ReadOnly) $scope.fd.readOnlyVal=$sce.trustAsHtml($scope.formData[0]['Field'+$scope.fd.ItemId]);
                        
                         $scope.$watch("fd.ReadOnly",function(newValue,oldValue){
                                  
                                  if (newValue)
                                  {
                                     //if ($scope.showSearchFilters)
                                       if ($scope.formData[0]!=undefined &&  $scope.fd.ReadOnly) $scope.fd.readOnlyVal=$sce.trustAsHtml($scope.formData[0]['Field'+$scope.fd.ItemId]);
                                  } 
                         });
                         
                        for (var i=0;i<24;i++) $scope.colLength.push('col-lg-'+(i+1));
                        
                        $scope.isOpen=true;
                        $scope.isOpen=false;
                                                
                                                $scope.search=[
                                                {id:1,filter:'begins',name:"Begins with",icon:"fa fa-chevron-right"},
                                                {id:2,filter:'contains',name:"Contains",icon:"fa fa-expand"},
                                                {id:3,filter:'ends',name:"Ends with",icon:"fa fa-chevron-left"},
                                                {id:4,filter:'eq',name:"Equals",icon:"fa fa-bars"} ];
                                                
                       $scope.fd.SetDefault = function(){
                                $scope.fd.DefaultValue = $scope.formData[0]["Field"+$scope.fd.ItemId];
                        }
                        
                                          $scope.applyTextFilters = function(index) {
                                                   $scope.fd.Search=$scope.search[index];
                                    if ($scope.fd.Search) $scope.fd.Search.value=$scope.fd.sItemValue; 
                                    $scope.isOpen=false;		
                                                };
                                
                                $scope.refreshSearchValue = function() {
                                 if ($scope.fd.Search) $scope.fd.Search.value=$scope.fd.sItemValue;      
                             };
                         
                         $scope.fd.onSelectUnique = function(item,model)
                        {
                                
                                $scope.fd.UniqueId=item.id;
                        }
                             
                              $scope.showProperties = function(event)
                                {
                                  $scope.gsrvc.setFieldProperties($scope.fd,event);
                       
                                };
                             
                               if ($scope.fd.showSearchForm)  {
                                   if ($scope.fd.Search==undefined) $scope.fd.Search=$scope.search[3];//initialize to equals
                              }
                        
                        let template;
                        if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktRichtextbox.html');
                        else template = $templateCache.get('ktdirectivetemplates/ktRichtextboxExe.html');
          
                        $element.append($compile(template)($scope));  
                        
                        },
             
             link: function (scope, elem, attrs) {
				
       
               
              
            }
        };
};
'use strict';

export function ktSelectGeneric () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectGeneric.html',
             scope: {
                inputParameters: '=',
                selectedItem: '=',
                inputArray: '=',
                onSelectFn: '&',
                refreshFn: '&',
            },
            controller: function(UserService,ResourcesDataService,$rootScope,ProcessingService){},
             link: function (scope, elem, attrs) {
                
                 scope.onSelectItem = function(item,model) {
                   scope.onSelectFn(item,model);
                }
                
                 scope.refreshResults = function(filter) {
                   scope.refreshFn(filter);
                }
                     
              }
        }
  
};
'use strict';

export function ktSelectGroups () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectGroups.html',
            /*  scope:{
                selectedItems:'=',
             },*/
            controller: function($scope,UserService){
                
                
                
                $scope.groupList=[];
                
                $scope.getGroups = function () {
                      UserService.getUsersGroups('groups').then(function(data){
                      $scope.groupList = data.data;
                            });
            
                 }
                
                $scope.getGroups();
                            
            },
            link: function (scope, elem, attrs) {
            
            
           
                    
                   
                
            
            }

    }
};
'use strict';

export function ktSelectGroupsWithScope () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectGroupsWithScope.html',
              scope:{
                selectedItems:'=',
                size:'=?',
                selectId:'=',
             },
             controller: function($scope,UserService){
                 $scope.selected={groups:$scope.selectedItems};
         
         
           $scope.$watch('selected.groups',function(newValue,oldValue){
              
              if (newValue!=oldValue && newValue!==undefined)
              {
               $scope.selectedItems=newValue;
              }
            });
          
           
             $scope.groupList=[];
        //if ($scope.selectedItems==undefined) $scope.selectedItems=[]

        $scope.getGroups = function () {
          UserService.getUsersGroups('groups').then(function(data){
          $scope.groupList = data.data;
				});

        }
				$scope.getGroups();
                },
             link: function (scope, elem, attrs) {
            
          
       
        
        
      
    

            }

    }
};
'use strict';

export function ktSelectUsers (UserService) {

    return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectUsers.html',
          /*   scope:{
              selectedItems:'=',
             },*/
           controller: function(UserService){},
             link: function (scope, elem, attrs) {


              
        scope.userList=[];
        //if (scope.selectedItems==undefined) scope.selectedItems=[]


        scope.getUsers = function () {
          UserService.getUsersGroups('users').then(function(data){
          scope.userList = data.data;
				});

        }
				scope.getUsers();

            
            
        scope.userSelected =  function(item,model) {
        
     
        /*
         var pos = scope.selectedItems.map(function(e) { return e.id; }).indexOf(item.id);
              
              if (pos<0){
                 scope.selectedItems.push(angular.copy(item));
                
              }
        */    

        };
      
      }
    }
};
'use strict';

export function ktSelectUsersWithScope (UserService) {

    return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktSelectUsersWithScope.html',
             scope:{
              selectedItems:'=',
              size:'=?',
              selectId:'=',
             },
              controller: function(UserService){},
             link: function (scope, elem, attrs) {


              
        scope.userList=[];
        //if (scope.selectedItems==undefined) scope.selectedItems=[]
        scope.selected={users:scope.selectedItems};
        
        
           
             scope.$watch('selected.users',function(newValue,oldValue){
              
              if (newValue!==oldValue && newValue!==undefined)
              {
               scope.selectedItems=newValue;
              }
            });
         

        scope.getUsers = function () {
          UserService.getUsersGroups('users').then(function(data){
          scope.userList = data.data;
				});

        }
				scope.getUsers();

            
            
        scope.userSelected =  function(item,model) {
        
     
        /*
            var pos = scope.selectedItems.map(function(e) { return e.id; }).indexOf(item.id);
              
            if (pos<0){
                 scope.selectedItems.push(angular.copy(item));
                
              }
          */  

        };
      
      }
    }
};
'use strict';

export function ktSeparator () {
        return {
            restrict: 'A',
			 controller: function ($scope,GridsterService) {
                
                $scope.gsrvc = GridsterService;
                $scope.showProperties = function(event)
                {
                        $scope.gsrvc.setFieldProperties($scope.fd,event);
       
                };
                $scope.colLength=[];
                for (let i=0;i<24;i++) $scope.colLength.push('col-'+(i+1));
                },
             templateUrl: 'ktdirectivetemplates/ktSeparator.html',
             link: function (scope, elem, attrs) {
              
            
         
            }
        };
};
'use strict';

export function ktSimpleUser (UserService) {

	return {
        restrict: 'A',
         templateUrl: 'ktdirectivetemplates/ktSimpleUser.html',
         scope:{
                selectedUser : '=',
                userList: '=',
                selectedUserModel: '='
                },      
		 controller: function(UserService){},
         link: function (scope, elem, attrs) {
          
            console.log('scope user list')
            console.log(scope.userList);
           /* scope.getUsers = function () {
              UserService.getUsersGroups('users').then(function(data){
                  scope.userList = data.data;
                  scope.selectedUserModel = UserService.getUserObjectById(scope.selectedUser); 
                  scope.selectedUser = scope.selectedUserModel.id;                  
                 });
            }*/
          
            scope.populateUser = function (item,model) { 
                  scope.selectedUserModel = item;
                  scope.selectedUser = item.id;   
    		};
                    

         }
    }
};
'use strict';

export function ktSmartTable () {
        return {
            restrict: 'EA',
             controller: function ($scope,$filter) {
                
                $scope.displayTableData = [];
                if ($scope.clientSide==undefined) $scope.clientSide=false;
                 if ($scope.usePagination==undefined) $scope.usePagination=false;
                
                if ($scope.tableData!=undefined) $scope.displayTableData = $scope.tableData;
                
                $scope.getItem=function(column,item)
                {
                              
                    let val = get(item,column.name,null) ;
                    if (column.cellFilter)
                    {
                        //let temp = column.cellFilter.substring(0,4).trim();
                        if (column.cellFilter.substring(0,4).trim()=="date") val = $filter(column.cellFilter.substring(0,4))(val,column.cellFilter.substring(6,column.cellFilter.length).trim());
                    }
                    return val;
                
                };
                
                $scope.rowSelected=function(row)
                {
                              
                     $scope.rowSelectedCount = row.isSelected;
                     $scope.rowSelectedChange({item:row}); 
                    
                
                };
                
                 $scope.refreshDataExt=function(pageNumber,pageSize)
                { 
                  $scope.tableState.pagination.number = pageSize;
                  $scope.tableState.pagination.start = (pageNumber-1)*pageSize;
                  $scope.refreshData($scope.tableState);
                }
                
                $scope.refreshData=function(tableState)
                {
                    
                   if (tableState.pagination.number==undefined || tableState.pagination.number==NaN) tableState.pagination.number=10;
                    //scope.getData();
                    $scope.getData({pageNumber:(tableState.pagination.start/tableState.pagination.number)+1,pageSize:tableState.pagination.number}).then(function (result) {
                        
                       
                        $scope.displayTableData = result.data.results;
                        $scope.tableColumns = result.data.columns;
                        $scope.totalMatched = result.data.count;
                        //scope.paginationStart = start;
                        //scope.totalCalls++;
                        if (tableState!=undefined)
                        {
                            tableState.pagination.numberOfPages = result.data.numberOfPages;
                             tableState.pagination.totalItemCount = result.data.count;
                            //tableState.pagination.number = result.data.pageSize;
                        }
                        $scope.tableState = tableState;
                    });
                    
                };
                
               // scope.refreshData();
                
                let stringToPath = function (path) {
                
                    // If the path isn't a string, return it
                    if (typeof path !== 'string') return path;
            
                    // Create new array
                    var output = [];
            
                    // Split to an array with dot notation
                    path.split('.').forEach(function (item, index) {
            
                        // Split to an array with bracket notation
                        item.split(/\[([^}]+)\]/g).forEach(function (key) {
            
                            // Push to the new array
                            if (key.length > 0) {
                                output.push(key);
                            }
            
                        });
            
                    });
            
                    return output;
                
                };
                    
                let get = function (obj, path, def) {

                /**
                 * If the path is a string, convert it to an array
                 * @param  {String|Array} path The path
                 * @return {Array}             The path array
                 */

                    // Get the path as an array
                    path = stringToPath(path);
                
                    // Cache the current object
                    var current = obj;
                
                    // For each item in the path, dig into the object
                    for (var i = 0; i < path.length; i++) {
                
                        // If the item isn't found, return the default (or null)
                        if (!current[path[i]]) return def;
                
                        // Otherwise, update the current  value
                        current = current[path[i]];
                
                    }
            
                    return current;
            
                };
                
                
                },
               scope:{
                    tableData:'=?',
                    tableColumns:'=?',
                //  rowSelectedCount:'?=',
                    usePagination:'=?',
                //  totalItems:'=',
                    clientSide:'=?',
                    itemsOnPage:'=',
                    allowSort:'=',
                    rowSelectedChange:'&',
                    getData:'&ktRefreshData',
                    setFnRefreshData: '&',
                  
            
            },
             templateUrl: 'ktdirectivetemplates/ktSmartTable.html',
			 link: function (scope, elem, attrs) {
                 
                //scope.displayTableData = angular.copy(scope.tableData);
                scope.setFnRefreshData({theDirFn: scope.refreshDataExt});
                
                
             },
             
      }
};
'use strict';

export function ktStartTaskWidget () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktStartTaskWidget.html',
            controller: function(UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$stateParams,$cookies,WidgetDataExchangeService,$state,TaskDataService,MessagingService,GridsterService){},
             link: function (scope, elem, attrs) {
                 
                var lang=$rootScope.globals.currentUser.lang;
                scope.taskListParameters = {placeholder:'Select or search task...',label:scope.fd.Label,name:'task',
                  selectedItem:null,hideLabel:false,columnSizeLabel:'col-lg-4',dropdownSize:'col-lg-8',onSelectFunction:''};
               
                scope.initiateFormLoaded=false;
                scope.isSaving=false;
                
                scope.previousTask=$stateParams.prev_task_execute_id;
                scope.previousTaskOutcomeId=$stateParams.outcome_id;
                scope.previousTaskPackage=$stateParams.prev_task_package; 
                scope.gridsterType="task";
                scope.gridsterOpts = GridsterService.getGridsterOptions();
                scope.showSearchFilters=false;      
                scope.dashboard = {widgets : []};
                scope.taskDefId=scope.fd.Related;          
                
                scope.fromStateName=$stateParams.fromStateName;
                scope.fromStateParams=$stateParams.fromStateParams;
                scope.cookieFromStateName=$cookies.getObject('initiateTaskFromStateName');
                scope.cookieFromStateParams=$cookies.getObject('initiateTaskFromStateParams');
                scope.noBackbutton = false;
                scope.backBtnFromCookie=false;
      
      
  
                scope.removeField = function (index){
						
                  if (index > -1) {
						 
                 scope.inputArray.layout.splice(index, 1);
						 
                  }

                }   

 
 
    
          scope.InititateAllList = function(){
      
            
              ResourcesDataService.getResourceDefByType(lang,'task').then(function(data) {
                                
                                  scope.gridOptions.data = data.data;
                                   
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
          }
        
    
    //napuni grid s definicijama resursa
   // $scope.InititateAllList();
                 
     scope.InititateMyList = function(){
      
         
              ResourcesDataService.getResourceDefListByLangByTypeUser(lang,'task').then(function(data) {
                                
                                 scope.gridOptions.data = data.data;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
    
          
    };   
    
      scope.TaskSelectionChanged = function(item,model){
      
       scope.taskListParameters.selectedItem=item;
       scope.fd.Related = scope.taskListParameters.selectedItem.id;
       scope.SelectAnyTask();
  
     };
     
     scope.SelectAnyTask = function(){
      
      if (scope.fd.Search.startAnyTask)
          {
            
            scope.taskDefId=scope.taskListParameters.selectedItem.id;   
          //  scope.InititateMyList(); 
          }
          else
          {
            scope.taskDefId = scope.fd.Related;
          }
          
     };
      
     
      if (scope.fromStateName==undefined || scope.fromStateName=="")
      {
          if (scope.cookieFromStateName==undefined || scope.cookieFromStateName=="")
          {
            scope.noBackButton = true;
          }else
          {
            scope.fromStateName =  scope.cookieFromStateName;
            scope.backBtnFromCookie = true;
          }
          
        
      }else{
        $cookies.putObject('initiateTaskFromStateName',scope.fromStateName);
        
      }
      
      if (scope.fromStateParams==undefined)
      {
          if (scope.cookieFromStateParams!=undefined)
          {
              if (scope.backBtnFromCookie)
              {
                scope.fromStateParams =  scope.cookieFromStateParams;
              }
          }
          
      }else if (scope.cookieFromStateParams==undefined)
      {
        $cookies.putObject('initiateTaskFromStateParams',scope.fromStateParams);
        
      }else
      {
          if (scope.backBtnFromCookie)
          {
        
            scope.fromStateParams =  scope.cookieFromStateParams;
        
          }else
          {
              $cookies.putObject('initiateTaskFromStateParams',scope.fromStateParams);    
          }
      }
      
      
       if (scope.previousTask==undefined || scope.previousTask=="")
          {
           // $state.go();
            
            scope.previousTask = 0;
            
          }
      scope.potentialOwners = {};
      

      
    //WidgetDataExchangeService.deRegisterAllWidgets();	//Migor - cistim taskwidgetRegistry 

      scope.localTaskId=WidgetDataExchangeService.registerTask(scope.taskDefId);
      
      scope.taskDefinition ={};
      scope.potentialOwners.potentialOwnersUsers = [];
      scope.potentialOwners.potentialOwnersGroups = [];
      
         scope.FormLockUnlock = function()
      {
        scope.resourceDefinition.formParams.formLocked=!scope.resourceDefinition.formParams.formLocked;

     
      };
      
      scope.PreInitiateTask = function(){
           var lang=$rootScope.globals.currentUser.lang;
          scope.taskInitiateId=0;
          scope.taskExecuteId=0;
          
         
        TaskDataService.preInitiateTask(scope.taskDefId,scope.previousTask,lang).then(function(data) {
                                
                                   
                                   scope.taskDefinition = data.data.taskdef[0];
                                   scope.taskDefinition.prev_task_id = scope.previousTask;
                                   scope.taskDefinition.form_type="i";
                                   scope.taskDefinition.source_type = $stateParams.src_type;
                                   scope.taskDefinition.taskFormLoaded = false;
                                   if (scope.taskDefinition.AutoInitiate) {
                                  
                                       scope.AutoInitiateTask();
                                                                    
                                  }else
                                      {
                                       scope.resourceDefinition=data.data.resourceDefinition;
                                       scope.dashboard.widgets.layout = data.data.widgets;
                                       scope.resourceDefinition.formParams = {formLocked:true,formViewType:2};
                                      
                                      $timeout(function(){scope.initiateFormLoaded = true;});
                      
                                      }
                                     
     
                              },function(error){
                                
                            
                                  MessagingService.addMessage(error.msg,'error');
                            });
      };
      
      scope.CancelClicked = function(){
        
        $state.go( scope.fromStateName, scope.fromStateParams);
      
      };
      
       scope.AutoInitiateTask = function(){
        var lang=$rootScope.globals.currentUser.lang;
        //  if (isValid) {
        var parentDataset=scope.getPreviousTaskWidget();
        if (scope.previousTaskOutcomeId==undefined) scope.previousTaskOutcomeId=0;
          
          TaskDataService.initiateTask(scope.taskDefId,scope.previousTask,scope.previousTaskOutcomeId,[],scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
                                    
                                    scope.task_initiate_id = data.data.task_initiate_id;
                                    scope.task_execute_id = data.data.task_execute_id;
                                    //$state.go('app.menu.tasks.execute',{id: scope.taskDefId,task_initiate_id:scope.task_initiate_id,task_execute_id:scope.task_execute_id,fromStateName:scope.fromStateName,fromStateParams:scope.fromStateParams,prev_task_package:scope.previousTaskPackage,prev:scope.taskExecuteId});
                                   
                                  
                              },function(error){
                                    
                                  MessagingService.addMessage(error.msg,'error');
                            });
         // }
      }
      
       scope.InitiateTask = function(form){
        var f = scope.forma;
        if (form.$submitted) scope.setSubmitted(form);
        if (form.$valid) {
            
            //var initiateData={};
            $rootScope.$broadcast('ProcessTaskWidgets',{}); //svi widgeti slusaju ovaj event
            scope.isSaving = true;
            var lang=$rootScope.globals.currentUser.lang;
            if (scope.previousTaskOutcomeId==undefined) scope.previousTaskOutcomeId=0;
            //ako je prethodni task imao listu povuci WidgetData
            var parentDataset=scope.getPreviousTaskWidget();
                    
                TaskDataService.initiateTask(scope.taskDefId,scope.previousTask,scope.previousTaskOutcomeId,scope.dashboard.widgets.layout,scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
					
                                  MessagingService.addMessage(data.data.msg,'success');
                                  $rootScope.$broadcast('InitiateTaskPostProcess',data.data.ret_value);
                                  //ovo treba staviti u event InitiateTaskPostProcessFinished                        
                                  scope.fd.GridState.cancelBtnIcon = "fa fa-arrow-circle-left";
                                  scope.fd.GridState.cancelBtnTxt = "Go back";
                                  scope.taskInitiated=true;
                                 
     
                              },function(error){
                                 // $scope.isSaving = false;    
                                  MessagingService.addMessage(error.msg,'error');
                            });
                          
                          scope.isSaving = false;  
						
			
							
          } // if (isValid)
          else
          {
            MessagingService.addMessage("Please enter required data",'warning');
            
          }
      };

    scope.getPreviousTaskWidget  = function()
    {
      var pTaskData = WidgetDataExchangeService.getPrevTaskData(scope.taskDefinition.prev_task_id);
            var datasetId=0,datasetRecordId=0;
            if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
            {
            for (var i=0;i<pTaskData.DEI.length;i++)
            {
              if (pTaskData.DEI[i].name=="resourceLink")
              {
                if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                {
                  for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                  {
                   if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                   if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                   
                    
                  }
                     
                    
                }
                  
              }
                
              }
              if (datasetId==undefined || datasetId=="") datasetId=0;
              if (datasetRecordId==undefined || datasetRecordId=="") datasetRecordId=0;
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };
        scope.setSubmitted = function (form) {
          form.$setSubmitted();
          angular.forEach(form, function(item) {
            if(item && item.$$parentForm === form && item.$setSubmitted) {
              scope.setSubmitted(item);
            }
          });
        } 
      //get form   
    
     
                 
                ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                    
                                  scope.taskList = data.data;
                                    var pos = scope.taskList.map(function(e) { return e.id; }).indexOf(scope.fd.Related);
              
                                   if (pos>=0){
                                        scope.taskListParameters.selectedItem =  scope.taskList[pos];
                                          }                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
      
      if (scope.fd.Search===undefined || scope.fd.Search===null)         scope.fd.Search = {startAnyTask:false};  
      if (scope.taskDefId!=undefined && scope.taskDefId>0 && !scope.fd.Search.startAnyTask) scope.PreInitiateTask();
      else if (scope.fd.Search.startAnyTask)  $rootScope.$broadcast('PageLoaded',{});             
              }
        }             
};
'use strict';

export function ktStyleAttribute () {

        return {
            restrict: 'A',
            
            scope:{
              fd: '=',
              styleType:'=',
            },
         
            link: function (scope, elem, attrs) {
                
                if (scope.fd.Parameters==undefined) scope.fd.Parameters={};
                
                scope.$watch(function () { return elem[0].style.width},  widthChangedCallBack, true);

                function widthChangedCallBack(newValue, oldValue) {
                    if (newValue !== oldValue) {
                    // do something interesting here
                    if (scope.styleType=="label")
                    {
                        if (scope.fd.Parameters.LabelStyle==undefined) scope.fd.Parameters.LabelStyle = {};
                        scope.fd.Parameters.LabelStyle.Width = newValue;
                    }
                    if (scope.styleType=="element")
                    {
                        if (scope.fd.Parameters.ElementStyle==undefined) scope.fd.Parameters.ElementStyle = {};
                        scope.fd.Parameters.ElementStyle.Width = newValue;
                    }
                  }
                }
              
                 
            }
        }
  
};
'use strict';

export function ktTabs () {
       
        return {
              restrict: 'A',
		controller: function ($scope) {},
             templateUrl: 'ktdirectivetemplates/ktTabs.html',
             link: function (scope, elem, attrs) {

            }
        };
};
'use strict';

export function ktTaskAddMultipleResources () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService) {
      
    $scope.searchFormDownloaded = false;
    $scope.src_type_text=CODES_CONST._POPULATE_TYPE_   
     
    $scope.widgetType = 1;
    $scope.animationsEnabled = true;
     
          $scope.gridsterType="resource";
           $scope.gridsterOpts = GridsterService.getGridsterOptions();
          
  
  $scope.gsrvc = GridsterService;
  
  $scope.prevTaskPackage = $stateParams.prev_task_package;
  
  $scope.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: GridsterService.getEmptyDatasetForm()
				} ;
      $scope.localVars.datasetMapperType = 0;
     //register widget
     var out_fields = ['resourceRecordId']
       var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'updateResourceWidget',widgetId: $scope.fd.presentationId,taskId:  $scope.lTaskId,
       resourceDefId : $scope.fd.related, //resourceDefId : $scope.selectedResource
       resourceRecordId:$scope.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId, output:out_fields };
      $scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
       $scope.fd.localId=$scope.localWidgetId;  
 
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        
        $scope.parentDatasetDefId=$scope.fd.related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.formType=$scope.taskDefinition.form_type;
        $scope.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        $scope.formDefinition = $scope.taskDefinition.form_definition;
                
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        
        
        if ($scope.source_type=="fromOutcome")
        {
           $scope.resourceRecordId = WidgetDataExchangeService.getDataByWidgetId($scope.prevTaskExeId,$scope.taskDefinition.task_initiate_id,$scope.taskDefinition.prev_task_id,$scope.fd.parentElementId,'resourceRecordId');
        }
         
        if ($scope.resourceRecordId==undefined)
         {
          $scope.resourceRecordId = 0; 
         }
          
         $scope.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.related,"i",lang).then(function(data) {
                            
                                $scope.resourceWidgetDefinition= data.data.resourceDefinition;
                               
                                if ( $scope.taskInitiateId==0 && $scope.taskExecuteId==0)
                                {
                                 $scope.dashboard.widgets.layout=[data.data.widgets];
                                }
                                 $scope.selectedResourceItem = {'name':$scope.resourceWidgetDefinition.name,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                            
                            
                               
                                $scope.fd.wItemValue= $scope.dashboard.widgets.layout;
                                
                                //MIGOR BITNO ZA BROADCAST - ktTaskUpdateResource 
                                //WidgetDataExchangeService.setData($scope.widgetId,'resourceRecordId',{'resourceRecordId':$scope.fd.wItemValue.resourceRecordId});
                                 //ovo je da trenutno radi
                                WidgetDataExchangeService.setData({DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.resourceRecordId}]}],widgetId: $scope.fd.presentationId});
								
                                
                                
                                   $timeout(function() {
                                    $scope.formLoaded=true;
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
         
        $scope.getFormResource = function(type){
              var lang=$rootScope.globals.currentUser.lang;
             
              if ($scope.fd.presentationId==null) {
                $scope.fd.presentationId=0;
              }
              ResourcesDataService.getResourceFormExtendedMultiple($scope.fd.related,$scope.taskId,$scope.formType,$scope.fd.presentationId,["w"],lang).then(function(data) {
                               
                          $scope.resourceWidgetDefinition= data.data.resourceDefinition;
                          //$scope.dashboard.widgetsTemplate = angular.copy(data.data.widgets[0]);
                         // $scope.dashboard.widgetsFilter= data.data.widgets.widgetsf;
                           
                          $scope.selectedResourceItem = {'name':$scope.resourceWidgetDefinition.name,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                          if (type==0)
                          {
                            $scope.dashboard.widgets.layout.push(angular.copy(data.data.widgets.widgetsw));
                            $scope.fd.wItemValue= $scope.dashboard.widgets.layout;
                             
                          }else
                          {
                             if ( $scope.taskInitiateId==0 && $scope.taskExecuteId==0)
                                  {
                                  $scope.dashboard.widgets.layout = [angular.copy(data.data.widgets.widgetsw)];
                                  $scope.fd.wItemValue=$scope.dashboard.widgets.layout;
                              }else
                              {
                                 $scope.dashboard.widgets.layout=angular.copy(data.data.widgets.widgetsw);
                                 $scope.fd.wItemValue=$scope.dashboard.widgets.layout;
                              }
                          }
                          //$scope.fd.fItemValue= $scope.dashboard.widgetsFilter;
                        
                          
                           $timeout(function() {
                                     $scope.formDownloaded = true;
                                 //   $scope.setRequired($scope.fd.fItemValue,false);
                                                                     
                                    });
                           
                      
                  },function(error){
                  MessagingService.addMessage(error.msg,'error');
                                 
                                 
                                
              });
                             
      };
        
        $scope.addNewItem = function(){
         $scope.getFormResource(0); 
        }
       
        $scope.selectedDatasetRecords=[];
        $scope.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.updateFormLoaded=false;
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              
              if ($scope.fd.parentElementId==null)
              {
                $scope.fd.parentElementId = 0;
                
              }
              //$scope.selectedDatasetRecords = $scope.getSelectedRecordsFromSource();
              $scope.selectedDatasetRecords = [];
               
                $scope.filter = $scope.prevTaskPackage;
                
              
              ResourcesDataService.getResourceFormAddMultiple($scope.fd.related,$scope.taskInitiateId,$scope.taskExecuteId, $scope.fd.parentElementId,$scope.fd.presentationId,$scope.prevTaskExeId,$scope.formType,$scope.widgetType, "w",$scope.filter,lang).then(function(data) {
                                //$scope.formLocked = false;
                                  $scope.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.dashboard.widgets.layout=data.data.widgets;
                                  //$scope.dashboard.widgetsTemplate = angular.copy(data.data.widgets[0]);
                                  //$scope.dashboard.widgetsFilter=data.data.widgetsf;
                                  $scope.resourceRecordIds = data.data.resourceRecordId;
                                  if ($scope.resourceRecordIds.length>0)
                                  {
                                    $scope.datasetRecordId=$scope.resourceRecordId[0];
                                  }
                                  $scope.selectedResourceItem = {'name':$scope.resourceWidgetDefinition.name,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                                /*
                                if ($scope.formLocked) {
                                  //code
                                  $scope.dashboard.widgets= GridsterService.ProcessWidgets($scope.dashboard.widgetsOriginal);
                                }else
                                {
                                  
                                  $scope.dashboard.widgets =  $scope.dashboard.widgetsOriginal;
                                }
                               */
                                $scope.fd.wItemValue=$scope.dashboard.widgets.layout;
                               // $scope.fd.fItemValue=data.data.widgetsf;
                                
                                
                                   $timeout(function() {
                                     $scope.formDownloaded = true;
                                  
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
               } 
                              
               
     
       $scope.saveDatasetRecordsMultiple = function(){
              //var lang=$rootScope.globals.currentUser.lang;
              //$scope.updateFormLoaded=false;
               
              ResourcesDataService.saveDatasetRecordsMultiple($scope.fd.related,$scope.fd.wItemValue).then(function(data) {
                             
                                
                                   MessagingService.addMessage(data.msg,'success');
                                   //$scope.dashboard.widgets.length=0;
                                  // $scope.getResourceDataFiltered();                               
                                   $timeout(function() {
                                    //$scope.formLoaded=true;
                                    //$scope.updateFormLoaded=true;
                                     
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
              
                              
               
      };
      
      
     $scope.gridOptionsResourceData = {
        columnDefs: [],
        data:[],
        enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: true,
        enableHorizontalScrollbar : 1,
        enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: true,
        enableColumnResizing: true,
        enableColumnReordering: true,
      //exporterCsvFilename: 'myFile.csv',
     /*
        paginationPageSizes: [5, 10, 20, 50, 100],
         paginationPageSize: 5,
       enableSelectAll: false,
       enableCellEdit: false*/

   }
      
      
      $scope.gridOptionsResourceData.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.gridApi = gridApi;
           
          //gridApi.selection.on.rowSelectionChanged($scope,function(row){

         
                  
              
         // });
     }
     
   
      
       $scope.getResourceDataFiltered = function () {

            $scope.filter = {};
            //$scope.gridOptionsResourceData.columnDefs.length=0;
            //$scope.gridOptionsResourceData.data.length=0;
            var lang = $rootScope.globals.currentUser.lang;
            $scope.dataDownloading=true;
          if ($scope.selectedResource==null) {
            $scope.selectedResource = $scope.fd.related;
          }
          
         ResourcesDataService.getResourceDataFiltered($scope.selectedResource,$scope.taskId,lang,$scope.dashboard.widgetsFilter.layout).then(function(data) { 
                            
                                  $scope.gridOptionsResourceData.data = data.data;
                                  $scope.gridOptionsResourceData.columnDefs = data.columnsDef;
                                  
                                    $timeout(function(){
                                      $scope.resourceDataDownloaded = true;
                                      $scope.restoreGridState();
                                    });
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
              $scope.dataDownloading=false;
        }
    
    
    $scope.saveDatasetRecordsMultiple = function(){
              //var lang=$rootScope.globals.currentUser.lang;
              //$scope.updateFormLoaded=false;
               
              ResourcesDataService.saveDatasetRecordsMultiple($scope.fd.related,$scope.fd.wItemValue).then(function(data) {
                             
                                
                                   MessagingService.addMessage(data.msg,'success');
                                   $scope.dashboard.widgets.layout.length=0;
                                   $scope.getResourceDataFiltered();                               
                                   $timeout(function() {
                                    //$scope.formLoaded=true;
                                    //$scope.updateFormLoaded=true;
                                     
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
              
                              
               
      };
    
    
    $scope.saveGridState= function() {
       var state = $scope.gridApi.saveState.save();
       $scope.fd.gridState = state;
       MessagingService.addMessage("To make changes stick please save form",'info');
                 
    }
  
   $scope.restoreGridState= function() {
      if ($scope.fd.gridState!=null)
      {
         if ($scope.gridApi!=undefined)
         {
      
          $scope.gridApi.saveState.restore($scope,$scope.fd.gridState);
        
         }else
         {
        $timeout(function(){
            $scope.restoreGridState();
          });
         }
      }
    }
       $scope.setReadOnly = function(form,readOnly)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('readOnly' in form[i])
                    {
                      form[i].readOnly = readOnly;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.setReadOnly(form[i].layout,readOnly);
                      }
              }
          }
        };
        
    $scope.setRequired = function(form,required)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('required' in form[i])
                    {
                      form[i].required = required;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.setRequired(form[i].layout,required);
                      }
              }
          }
        }
  
 // $scope.getFormResource();
   
  if ($scope.fd.related!=null &&  !$scope.formDefinition && !$scope.formDownloaded)
  {
     $scope.getFormResourceWithData();
    
  }else if ($scope.fd.related!=null)
  {
     $scope.getFormResource();
  }
  
      }];

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskAddMultipleResources.html',
            controller: controller,
            link: function (scope, elem, attrs) {

            scope.resourceData = {};
  
            scope.prepareResourceData = function(resourceRecordId){
           
     
                scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData(scope.dashboard.widgets.layout,resourceRecordId);
  
          }
          
          
           scope.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name==linkedItem) && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             console.log("view "+scope.fd.presentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                console.log("view "+ scope.fd.presentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    scope.fd.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    scope.resourceRecordId = scope.fd.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') scope.fd.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              //scope.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if (scope.fd.presentationId==undefined || scope.fd.presentationId==null) scope.fd.presentationId=0;
          
          scope.formType=scope.taskDefinition.form_type;
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.presentationId,scope.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;
                               // scope.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
          
          
          scope.$on('InitiateTaskPostProcess',function(event, data){
              
              //find data
            //  var item = data;
              //send data to widget exchange service
              //WidgetDataExchangeService.setData(item);
              scope.setReadOnly(scope.dashboard.widgets.layout,true);
          });
  
          }
    } 
        
};
'use strict';

export function ktTaskAddResource () {
   
   var controller = ['$scope', '$uibModal', '$state','$stateParams','dragularService','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','CODES_CONST','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$state,$stateParams,dragularService,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,CODES_CONST,$templateCache,$compile,$element) {
      
      $scope.localVars = {};
      $scope.localVars.searchFormDownloaded = false;
      $scope.localVars.formLoaded=true;
      $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.localVars.animationsEnabled = true;
      $scope.localVars.widgetType = 1;
      $scope.localVars.hidePopulateMethod = true;
      $scope.localVars.datasetMapperType=0;      
      $scope.localVars.formParams={formViewType:1,showGridNavigation:true};
      //if ($scope.formParams!==undefined) $scope.localVars.formParams = angular.copy($scope.formParams);
      
      $scope.formParamsParent=$scope.formParams;
      
      if ($scope.fd!=undefined)
      {
           $scope.fd.PopulateMethod = "M";
      }else
      {
           $scope.fd={PopulateMethod : "M"};
      }
      if (typeof($scope.fd.DatasetMapping)=='string') $scope.fd.DatasetMapping=[];
      $scope.gsrvc = GridsterService;
      
      
      /*
      if ($scope.fd.hasParentDataset) {
        
        $scope.fd.ParentDatasetId = $stateParams.presentation_id;
      
      }
      
      $scope.localVars.presentationIdLocal = $scope.fd.PresentationId;
      
      if ($scope.localVars.parentDatasetIdLocal == undefined || $scope.localVars.parentDatasetIdLocal=="")
      {
        $scope.localVars.parentDatasetIdLocal = 0;
        
      }else
      {
        
         $scope.fd.ParentDatasetId = $scope.localVars.parentDatasetIdLocal;
      }
      */
      $scope.localVars.openModal = function (size,template,ctrl,selectedType) {

            var modalInstance = $uibModal.open({
            animation: $scope.animationsEnabled,
            templateUrl: template,
            controller: ctrl,
            size: size,
            resolve: {
              selectedResourceItem: function () {
                return $scope.localVars.selectedResourceItem;
                },
              type: function () {
                return $scope.localVars.selectDatasetType;
                }
            }
        });
         modalInstance.result.then(function (selectedItem,windex,index) {
      
          if ($scope.localVars.selectDatasetType==1){
            $scope.localVars.selectedResourceItem = selectedItem;
            $scope.fd.Related =  $scope.localVars.selectedResourceItem.relatedId;
            $scope.fd.PopulateType=selectedItem.src_type_id;
            $scope.fd.ParentElementId = $scope.localVars.selectedResourceItem.parentElementId;
            $scope.fd.PresentationId = $scope.localVars.selectedResourceItem.presentationId;
            $scope.localVars.getFormResourceOriginal();
          
          }else if ($scope.localVars.selectDatasetType==2)
          {
            $scope.localVars.selectedRelatedResourceItem = selectedItem;
            $scope.fd.HasParentDataset =  $scope.localVars.selectedResourceItem.relatedId;
            $scope.fd.PopulateTypeParent=selectedItem.src_type_id;
            //$scope.fd.ParentElementId = $scope.selectedResourceItem.parentElementId;
            //$scope.fd.PresentationId = $scope.selectedResourceItem.presentationId;
          }
         
        }, function () {
        //$log.info('Modal dismissed at: ' + new Date());
        });
         
        };
     
      $scope.localVars.openModalSelectResource = function(){
        $scope.localVars.selectDatasetType  = 1;
        $scope.localVars.openModal('lg','selectResourceModal.html','SelectResourceModalCtrl',$scope.localVars.selectDatasetType);
        
      };
     
      $scope.localVars.openModalSelectRelatedResource = function(){
        $scope.localVars.selectDatasetType  = 2;
        $scope.localVars.openModal('lg','selectDatasetModal.html','SelectDatasetModalCtrl',$scope.localVars.selectDatasetType);
      };
      
     
          $scope.localVars.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
  $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
				} ;
       
     
  
        //$scope.taskId=$stateParams.id;
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        $scope.localVars.taskId=$scope.taskId;
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.localVars.formType=$scope.taskDefinition.form_type;
        $scope.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        $scope.formDefinition = $scope.taskDefinition.form_definition;
        
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.localVars.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId']
      var widgetDefinition = {DEI: [{'name':'resourceLink','displayName':'Dataset record id','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],displayName: 'Add dataset record',name: 'addResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVars.selectedResource, output:out_fields, };
      $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.localVars.localId=$scope.localVars.localWidgetId;
      $scope.fd.LocalId=$scope.localVars.localWidgetId;  		  
      
      let update_presentation_id = function(data)
      {
         if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
      }
      if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
      {
         
         let dependent_field = $scope.fd.LocalId;
         let subscribedSubject = "formDefinitionState"+$scope.taskId+$scope.localVars.formType;
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
  
      }          
           $scope.localVars.showProperties=function(datasetMapperType)
           {
            
            if ($scope.localVars.datasetMapperType==undefined)
            {
               $scope.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
               else $scope.localVars.datasetMapperType=0;
            }
            
           };
        
        $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              if ($scope.fd.Related!=null && $scope.fd.Related!=undefined)
              {
                  $scope.localVars.formLoaded=false;
               
                  ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                  $scope.localVars.searchFormDownloaded = true;
                                  $scope.localVars.formLoaded=true;
                                     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
              } else $scope.localVars.formLoaded=true;
                              
      };
        
        $scope.localVars.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               if ($scope.fd.Related!=null && $scope.fd.Related!=undefined)
              {
               $scope.localVars.formLoaded=false;
               $scope.localVars.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.localVars.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                  
                                 if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                if ($scope.localVars.dashboard.widgets.layout.length==0) $scope.localVars.getFormResourceOriginal();
                                else
                                {
                                    $scope.fd.wItemValue=data.data.widgets;
                                    $scope.localVars.searchFormDownloaded = true;
                                      
                                    $scope.localVars.formLoaded=true;
                                    $scope.localVars.formLoading=false;
                                 }  
                                  
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVars.formLoading=false;
                                 
                                
                             });
              }else $scope.localVars.formLoaded=true;
      };
      
              
        $scope.localVars.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }

              if ($scope.fd.Related!=null && $scope.fd.Related!=undefined)
              {
                  $scope.localVars.formLoaded=false;
               
                  ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                  $scope.localVars.resourceRecordId = data.data.resourceRecordId;
                                  $scope.localVars.datasetRecordId=$scope.localVars.resourceRecordId;
                                  if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                //$scope.fd.wItemValue=data.data.widgets;
                               
                                   $timeout(function() {
                                     $scope.localVars.formLoaded=true;
                                     $scope.localVars.formLoading=false;
                                     $scope.localVars.searchFormDownloaded = true;
                                      
                                    });   
                                                                          
                                   WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
	                                 
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                  
              }else $scope.localVars.formLoaded=true;
                              
      };
      
      
      
        $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
           $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.resourceList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.resourceList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.resourceList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.localVars.getResources = function()  {
						
            if ($scope.localVars.resourceList==undefined) $scope.localVars.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
						function(data) {
										
											  $scope.localVars.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVars.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
          
  if ($scope.fd.Related!=null && $scope.fd.Related!=undefined &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded)
  {
     $scope.localVars.getFormResourceWithData();
    // $scope.localVars.getResources();
    // $scope.localVars.setSelectedDataset($scope.fd.Related);
    
  }else if ($scope.fd.Related!=null && $scope.fd.Related!=undefined)
  {
     $scope.localVars.getFormResource();
     $scope.localVars.getResources();
     //$scope.localVars.setSelectedDataset($scope.fd.Related);
    
  }
  
  
              $scope.localVars.prepareResourceData = function(resourceRecordId){

             $scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData($scope.localVars.dashboard.widgets.layout,resourceRecordId);
            }
          
           $scope.localVars.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                               // console.log("view "+ $scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.resourceRecordId = $scope.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              //$scope.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:$scope.fd.linkedResourceDefId,resource_id:$scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  $scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
          $scope.localVars.formType=$scope.taskDefinition.form_type;
          TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.localVars.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                                $scope.localVars.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
          
            $scope.$on('InitiateTaskPostProcess'+$scope.taskDefinition.transaction_id,function(event, data){
              
            if (data!=undefined){
              for(var i=0;i<data.length;i++) {
                if ($scope.fd.PresentationId==data[i].widgetId)
                {
                  WidgetDataExchangeService.setData(data[i]);
                  $scope.localVars.setField($scope.localVars.dashboard.widgets.layout,'ReadOnly',true);
                }
              }
              
              //set all elements read-only
            }
              
          });
  
                  let template;
                if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskAddResource.html');
                else template = $templateCache.get('ktdirectivetemplates/ktTaskAddResourceExe.html');
          
                $element.append($compile(template)($scope)); 
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

           
            
           // $scope.resourceData = {};
  

      }     
    }
        
};
'use strict';

export function ktTaskContainer () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskContainer.html',
             /*scope: {
                inputParameters: '=',
                //selectedItem: '=',
                inputArray: '=',
            },*/
             controller: function($scope,$rootScope,$timeout,UserService,ResourcesDataService,TaskDataService,MessagingService,GridsterService) {
                
                 $scope.gsrvc= GridsterService;
                 if (!Array.isArray($scope.fd.selectedTasks)) $scope.fd.selectedTasks=[];
                if ($scope.taskDefinition!=undefined)
                {
                  $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
                }
                if ($scope.localVars == undefined) $scope.localVars={};
                $scope.localObj={loadedTasks : []};
                $scope.localVars.taskItem = null;
                $scope.localVars.selectedTask = {};
                
                               
                $scope.$on('InlineTaskClosed',function(event,data){
                    //var index=data;
                    //$scope.localObj.loadedTasks.splice(index,1);
                    var taskId=data;
                    var pos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (pos>=0)
                    {
                      $scope.localObj.loadedTasks.splice(pos,1);  
                    }
                });
               
                if ($scope.fd.selectedTasks==undefined) $scope.fd.selectedTasks = [];
                
                if ($scope.fd.wItemValue!=null) {
                 $scope.fd.selectedTasks = $scope.fd.wItemValue;
                }else
                {
                $scope.fd.wItemValue = [];
                
                } 
                
                let initiate_task = function(data)
                {
                    let loadTask=false;
                    $scope.localVars.taskLoaded = false;
                    if ($scope.localObj.loadedTasks.length>0)
                    
                    {
                        if ($scope.localObj.loadedTasks[0].taskId != data.taskId)
                        {
                            $scope.localObj.loadedTasks.length=0;
                            loadTask=true;
                        }
                    }else loadTask=true;
                    
                    
                  //  if (loadTask)
                    //{
                        $scope.localObj.loadedTasks.splice(0,1);
                         
                        for (let j = 0;j<$scope.fd.selectedTasks.length;j++)
                        {
                        
                            if ($scope.fd.selectedTasks[j].taskId==data.taskId)
                            {
                            
                                $timeout(function(){
                                $scope.localObj.loadedTasks.push(data);
                                $scope.localVars.taskLoaded = true;
                                });
                            }
                        }
                    //}
                }
                
                for (let i = 0;i<$scope.fd.selectedTasks.length;i++)
                {
                    let subscribedSubject = 'initiateTaskStateName'+$scope.fd.selectedTasks[i].widgetId;
                    let dependent_field = 'taskContainer'+$scope.fd.PresentationId+$scope.taskDefinition.transaction_id;
                    $scope.ksm.subscribe(subscribedSubject,dependent_field,"taskInitiated",initiate_task);  
                
                }
                
                /*
                  $scope.localVars.LoadTask=function(taskId,outcomeId,previousTask,openTaskType)
                  {
                    
                   
                        $scope.localObj.loadedTasks.splice(0,0,{'taskId':taskId,'outcomeId':outcomeId,'previousTask':previousTask,'localVars':localVars});
                        
                    
                    
                  }
                  
                 */
                  
                   $scope.localVars.taskIsOpen = function(taskId)
                  {
                    var isOpenPos = $scope.localObj.loadedTasks.map(function(e) { return e.taskId; }).indexOf(taskId);
   
                    if (isOpenPos>=0) return true;
                    else return false;
                  }
                 
                  
                  
                $scope.fd.AddTaskToList = function (){
  
                    $scope.fd.selectedTasks.push({widgetId:null,taskId:null});
     
                }
                  
                   $scope.fd.ConfirmTaskList = function (){
                     $scope.fd.wItemValue = $scope.fd.selectedTasks;
                     $scope.fd.showConfirmed=true;
                     $timeout(function(){$scope.fd.showConfirmed=false},5000);
                   }
                   $scope.fd.RemoveTaskFromList = function (index){
                 
                  
                   if (index>=0){
             
                             $scope.fd.selectedTasks.splice(index,1);
                                  
                   }
                            
                    
                 }
          
          
                 $scope.localVars.saveTaskToResource = function(tdid,tei,datasetDefId,datasetRecordId){
                          TaskDataService.saveTaskToResource(tei,datasetDefId,datasetRecordId,$scope.fd.presentationId).then(function(data) {
                                                    
                              $state.go('app.menu.tasks.initiate',{id: tdid,fromStateName:$state.current.name,fromStateParams:$state.params,outcome_id:0,prev_task_execute_id:tei});
                                                             
                                
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
             }
             
                
                },
             link: function (scope, elem, attrs) {
                
               
        }       
              
    }
  
};
'use strict';

export function ktTaskDatasetList () {
   
    var controller = ['$scope', '$uibModal','$stateParams','$timeout','CodesService','ResourcesDataService','$rootScope','ProcessingService','WidgetDataExchangeService','GridsterService','MessagingService','CODES_CONST','TaskDataService','KatalyoStateManager',
                      function ($scope,$uibModal,$stateParams,$timeout,CodesService,ResourcesDataService,$rootScope,ProcessingService,WidgetDataExchangeService,GridsterService,MessagingService,CODES_CONST,TaskDataService,KatalyoStateManager) {
      
      
    
    $scope.localVars={};
    $scope.gsrvc=GridsterService;
    $scope.localVars.datasetMapperType=0;
    $scope.fd.initialLoad=true;
    $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_; 
    $scope.localVars.searchFormDownloaded = false;
    $scope.localVars.showSearchFilters=true;
    $scope.localVars.resourceDataDownloaded = false;
    $scope.localVars.selectedItems=[];
    $scope.taskId=$scope.taskDefinition.ResourceDefId;
    if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
    if ($scope.taskId==undefined) $scope.taskId=0
    $scope.localVars.taskId=$scope.taskId;
    $scope.localVars.widgetType = 4;
    $scope.localVars.formParams={formViewType:1,showGridNavigation:true};
    $scope.localVars.cardLayoutParams={formViewType:1,showGridNavigation:true};
    //$scope.gsrvc.setFormViewType($scope.localVars.formParams={formViewType));
    $scope.localVars.parentDatasetDefId=$scope.fd.Related;
    $scope.localVars.animationsEnabled = true;
    if ($scope.fd.Parameters==undefined) $scope.fd.Parameters = {PresentationType:'table'};
    if ($scope.fd.Parameters.PresentationType==undefined || $scope.fd.Parameters.PresentationType==null) $scope.fd.Parameters.PresentationType='table';
    $scope.localVars.gridsterType="resource";
    $scope.itemValue = {val:null};
    $scope.localVars.isCollapsed = $scope.fd.Parameters.SearchFormCollapsed;
    if ($scope.localVars.isCollapsed==undefined) $scope.localVars.isCollapsed =true;
    if ($scope.fd.AutoSearch) $scope.localVars.resourceDataDownloading = true;

     $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
				} ;
        
         $scope.localVars.dashboardCard = {
  				id: '1',
  				name: 'Home',
  				widgets: {}
				} ;
       $scope.localVars.gridOptionsResourceData = {
           //  columnDefs: colDefs,
        //enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: $scope.fd.Multiline,
      //  enableHorizontalScrollbar : 1,
       // enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: false,
        enableColumnResizing: true,
        enableColumnReordering: true,
        //useExternalPagination: false,
        paginationPageSizes: [10, 25, 50,100,200,500,1000,5000,10000],
       // enablePaginationControls: true,
      };

  var paginationOptions = {
    pageNumber: 1,
    pageSize: 10,
    sort: null
    };
    
    
       $scope.localVars.gridOptionsRelated = {
      //  columnDefs: colDefs,
       enableGridMenu: true,
       showGridFooter: true,
       showColumnFooter: true,
       enableRowSelection: false,
       multiSelect: false,
       enableHorizontalScrollbar : 2, 
       nableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
       minRowsToShow: 2,
      
   }
    
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        
        //$scope.fd.PopulateType=1;
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.localVars.formType=$scope.taskDefinition.form_type;
        $scope.localVars.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        $scope.formDefinition = $scope.taskDefinition.form_definition;
        if  ($scope.formDefinition==undefined)
        {
          
          $scope.formDefinition = false;
        }
        
        
        
        
          if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        $scope.localVars.resourceRecordId = 0;
        $scope.fd.ParentElementId = 0;
      
      var out_fields = ['resourceRecordId'];
      //resourceLink
      var widgetDefinition = {DEI: [{'name':'resourceLinkDatasetList','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'datasetListWidget',widgetId: $scope.fd.PresentationId,taskId:  $scope.lTaskId,
      resourceDefId : $scope.fd.Related, //resourceDefId : $scope.selectedResource
      resourceRecordId:$scope.localVars.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId, output:out_fields };
      $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.localVars.LocalId=$scope.localVars.localWidgetId;
      $scope.fd.LocalId=$scope.localVars.localWidgetId;
      
      /*
        $scope.setClearDropdown = function(directiveFn) {
            $scope.clearDropdown = directiveFn;
        };
        
        $scope.setLoadDropdown = function(directiveFn) {
            $scope.loadDropdown = directiveFn;
            
        };
        */
        
       
         /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
        
        let update_presentation_id = function(data)
        {
           if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
        }
        if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
        {
         
            let dependent_field_pid = $scope.fd.LocalId;
            let subscribedSubjectPid = "formDefinitionState"+$scope.taskId+$scope.taskDefinition.form_type;
            let observerPid = $scope.ksm.subscribe(subscribedSubjectPid,dependent_field_pid,"formSaved",update_presentation_id);
  
        }
        
        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
       
        
        let valueState= $scope.ksm.addSubject($scope.fd.ElementType+"ValueStateName"+$scope.fd.PresentationId+$scope.taskDefinition.transaction_id,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        
        let apply_value = function(data)
        {
            $scope.itemValue.val = data;
        }; 
       
        if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
        
        {
            if ($scope.fd.Parameters.DependentFieldId!="")
            {
                let dependent_field = "Field"+$scope.fd.Parameters.DependentFieldId;
                let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            }
        }
        
      
           $scope.localVars.showProperties=function(datasetMapperType)
           {
            
            if ($scope.localVars.datasetMapperType==undefined)
            {
               $scope.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
               else $scope.localVars.datasetMapperType=0;
            }
            
           };
           
      $scope.localVars.gridOptionsResourceData.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.localVars.gridApi = gridApi;
         if ($scope.restoreGridState) $scope.localVars.gridApi.saveState.restore($scope,$scope.fd.GridState);
          gridApi.selection.on.rowSelectionChanged($scope,function(row){

            $scope.localVars.datasetRecordSelected=row.isSelected;
            if ($scope.localVars.datasetRecordSelected)
              {
                if (row.entity.id!=$scope.localVars.selectedDatasetRecordId)
                {
                  $scope.localVars.selectedDatasetRecordId = row.entity.id;
                }
              }else
              {
                $scope.localVars.selectedDatasetRecordId = 0;
                
              }
              $scope.localVars.gridOptionsRelated.columnDefs=[];
              $scope.localVars.gridOptionsRelated.data=[];
              $scope.localVars.showGrid=false;
              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.Related,records:gridApi.selection.getSelectedRows()}
              
              
              $scope.localVars.selectedItems = gridApi.selection.getSelectedRows();
                
              //$rootScope.$broadcast('EventresourceLink'+$scope.fd.PresentationId,$scope.selectedDatasetRecordId);
            WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
              
              
            });
          
            //external pagination
        /*
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,newPage,pageSize);
          });
      */
           gridApi.selection.on.rowSelectionChangedBatch($scope,function(row){

              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.Related,records:gridApi.selection.getSelectedRows()}
              
          });
     }
     
        
    let process_form_change = function(data)
    {
        
        $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
        if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(true);
        else if ($scope.fd.Parameters.PresentationType=='dropdown') $scope.localVars.getDatasetDataList($scope.fd.Parameters.ClientSideFilter,true);
        else $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                      
    };
    
    
    //subscribe to events - initially only refresh data
   
    let dependent_field2 = "Field"+$scope.fd.PresentationId;
    let subscribedSubject2 = "task"+$scope.taskDefinition.transaction_id;
    let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,process_form_change);

        
     $scope.localVars.ProcessSearchForm=function (form){
            
           if (form!=undefined){
            for(var i=0;i<form.length;i++) {
                
                    if ('ElementType' in form[i])
                    {
                      if (form[i].AutoSearch)
                      {
                        if (form[i].ElementType == 'resource')
                        {
                        var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(form[i].PresentationId);
                        if (pos<0) $scope.localVars.childWidgets.push({widgetId:form[i].PresentationId,processed:false})
                        }
                        //subscribe to change
                        if (form[i].Parameters!=undefined)
                        {
                            if (form[i].Parameters.DependentFieldId!=undefined && form[i].Parameters.DependentFieldId!=null)
        
                            {
                                if (form[i].Parameters.DependentFieldId!="")
                                {
                                    let dependent_field = "Field"+$scope.fd.PresentationId;
                                    let subscribedSubject = form[i].ElementType+"ValueStateName"+form[i].ItemId+$scope.taskDefinition.transaction_id;
                                    let subject = $scope.ksm.addSubject(subscribedSubject,null);
                                    let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",process_form_change);
                                }
                            }
                        }
                        
                      }
                      
                     }
                      if ('layout' in form[i])
                      {
                           
                       $scope.localVars.ProcessSearchForm(form[i].layout);
                      }
              }
          } 
           
      };
      
      $scope.localVars.SearchFormProcessed=false;

      /*
      $scope.localVars.setDatasetMapperType= function(type){
            $scope.localVars.datasetMapperType = type;
          };      
      */
       $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.datasetList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.datasetList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.datasetList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.datasetList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					};
          
       // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
           $scope.localVars.getDatasets = function()  {
						
                       if ($scope.localVars.datasetList==undefined) $scope.localVars.datasetList=[];
          
                       var lang=$rootScope.globals.currentUser.lang;
                       ResourcesDataService.getResourceDefListByType(lang,'dataset').then(function(data) {
										
                                 $scope.localVars.datasetList = data.data;
                                  if ($scope.fd.Related!=null)
                                  {
                                   $scope.localVars.setSelectedDataset($scope.fd.Related);
                           
                                   }     
											 
                      },function(error){    
                       MessagingService.addMessage(error.msg,'error');
                      });
	};
            
      $scope.localVars.GetDatasetData=function(data)

      {

            fromWidget = data.widgetId;
            var allProcessed=true;
            var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(fromWidget);
            //if (pos<0) $scope.fd.childWidgets.push({widgetId:fromWidget,processed:true});
            for (var i=0;i<$scope.localVars.childWidgets.length;i++)
              {
                
                if ($scope.localVars.childWidgets[i].widgetId == fromWidget) $scope.localVars.childWidgets[i].processed = true;
                if (!$scope.localVars.childWidgets[i].processed) allProcessed = $scope.localVars.childWidgets[i].processed;
              }
              // if (!$scope.SearchFormProcessed) $timeout(function() {$scope.GetDatasetData(fromWidget);},1000);
              if($scope.fd.AutoSearch && allProcessed && $scope.localVars.SearchFormProcessed) {
                    $scope.localVars.selectedResource=$scope.fd.Related;
                    if ($scope.fd.Parameters!=null && $scope.fd.Parameters!=undefined)
                    {
                      if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(true);
                      else if ($scope.fd.Parameters.PresentationType=='dropdown') $scope.localVars.getDatasetDataList($scope.fd.Parameters.ClientSideFilter,false);
                      else $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                      
                        
                      
                    }                   
                }
      };
    
      if ($scope.localVars!=undefined) $scope.localVars.childWidgets = [];
      else $scope.localVars = {childWidgets : []};
     // $scope.uncaughtWidgets = [];
      var fromWidget=0;
   
      
      
       let search_form_ready = function(data)
        {
            //valueState.subject.setStateChanges = data;
            //valueState.subject.notifyObservers("childWidgets");
            $scope.localVars.GetDatasetData(data); 
        };
        
        let action_search_form_ready = $scope.ksm.addAction(valueStateName,"SearchFormReady"+$scope.taskExecuteId+$scope.taskDefinition.transaction_id,search_form_ready);
       
       
      
      /*   
      $scope.$on('SearchFormReady'+$scope.taskExecuteId+$scope.taskDefinition.transaction_id,function(event, data){
      
          
            
      });     
     */
   
   //**********************************************************
	//           GET DATASET RELATED RECORDS
	//**********************************************************      
        $scope.localVars.getDatasetRelatedRecords = function (relatedDatasetId,recordId,modelId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataRelated($scope.fd.Related,recordId,relatedDatasetId,0,modelId,lang).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                                     $scope.localVars.showGrid=true;
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
        
        
 //**********************************************************
	//           GET DATASET SINGLE RECORD
	//**********************************************************      
      $scope.localVars.getDatasetSingleRecord = function (relatedDatasetId,recordId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,0,lang,{id: recordId}).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
    
        $scope.$on('SearchFormReady'+$scope.taskExecuteId+$scope.fd.PresentationId,function(event, data1){
      
                                        $scope.localVars.GetDatasetData(data1); 
            
        });
        
    $scope.localVars.getFormResource = function(){   
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null) {
                $scope.fd.PresentationId = 0;
              }
               
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"f",lang).then(function(data) {
                 
                                    $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                
                             
                                    $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.Related,'relatedId':$scope.fd.Related,'presentationId':$scope.fd.PresentationId,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                              
                               
                                    $scope.fd.fItemValue=data.data.widgets;

                                    $scope.localVars.searchFormDownloaded = true;
                                    $scope.localVars.setField($scope.fd.fItemValue,'Required',false);
                                    $scope.localVars.formLoaded=true;
                                   //prepare search form
                                    $scope.localVars.ProcessSearchForm($scope.fd.fItemValue);
                                    $scope.localVars.SearchFormProcessed = true;
                                    if ($scope.localVars.childWidgets.length>0)
                                    {
                                      WidgetDataExchangeService.registerSearch({widgetId:$scope.fd.PresentationId,taskExecuteId:$scope.taskExecuteId,prevTaskExeId:$scope.prevTaskExeId,childWidgets:$scope.localVars.childWidgets});
                                    }
                                    else
                                    {
                                       $scope.ksm.executeAction(valueStateName,"SearchFormReady"+$scope.taskExecuteId+$scope.taskDefinition.transaction_id, {widgetId:$scope.fd.PresentationId});
                                       //$rootScope.$broadcast('SearchFormReady'+$scope.taskExecuteId+$scope.taskDefinition.transaction_id,{widgetId:$scope.fd.PresentationId});
                                    }
                                    $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                    if ($scope.formData == undefined) $scope.formData={};
                                    $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                    $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
                                    if ($scope.fd.Search==undefined) $scope.fd.Search={};
               
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getFormResource_END
      
    $scope.localVars.executeDatasetList = function(){   
        var lang=$rootScope.globals.currentUser.lang;
        if ($scope.fd.PresentationId==null) {
            $scope.fd.PresentationId = 0;
        }
        if ($scope.localVars.selectedResource==undefined) $scope.localVars.selectedResource = $scope.fd.Related;
        if ($scope.localVars.pageSize==undefined) $scope.localVars.pageSize = paginationOptions.pageSize;
               
        TaskDataService.ktTaskDatasetList($scope.fd.Related,$scope.fd.PresentationId,$scope.localVars.taskId,$scope.localVars.formType,lang).then(function(data) {
                 
                                    $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                
                             
                                    //$scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.Related,'relatedId':$scope.fd.Related,'presentationId':$scope.fd.PresentationId,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                              
                                    $scope.localVars.gridOptionsResourceData.columnDefs = data.data.columns;
                                    $scope.fd.fItemValue=data.data.widgets;
                                    if (data.data.widgetsCard!=null)
                                    {
                                        $scope.fd.wItemValue=data.data.widgets;
                                        $scope.localVars.dashboardCard.widgets.layout =  data.data.widgetsCard;
                                    }
                                    $scope.localVars.searchFormDownloaded = true;
                                    $scope.localVars.setField($scope.fd.fItemValue,'Required',false);
                                    $scope.localVars.formLoaded=true;
                                   
                                    $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                    if ($scope.formData == undefined) $scope.formData={};
                                    $scope.formData[$scope.fd.PresentationId] =  data.data.formData;
                                    $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
                                    if ($scope.fd.Search==undefined) $scope.fd.Search={};
                                    
                                    //setup data grid or card
                                    $scope.localVars.gridOptionsResourceData.data = data.data.data;
                                    if ($scope.fd.Parameters.PresentationType=='card')
                                    $scope.localVars.gridOptionsResourceData.data = $scope.TransformDataForCard(data.data.data);
                                    $scope.localVars.restoreGridState();
                                    $scope.fd.initialLoad = false;
                                    $scope.localVars.resourceDataDownloaded = true;
                                    $scope.localVars.resourceDataDownloading = false;
                                    $scope.localVars.nextPage = data.data.data.next;
                                    $scope.localVars.previousPage = data.data.data.previous;
                                    $scope.localVars.totalCount=data.data.data.count;
                                    $scope.localVars.currentPage=1;
                                    if ($scope.localVars.totalCount>0 && $scope.localVars.currentPage==0) $scope.localVars.currentPage=1;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/$scope.localVars.pageSize);
                                    
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
               
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getFormResource_END

      
    
  $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                 $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.Related,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                            
                             
                                $scope.fd.fItemValue=data.data.widgets;
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                 $scope.localVars.searchFormDownloaded = true;
                                 $timeout(function() {
                                            $scope.localVars.formLoaded=true;
                                     
                                 });
           
                                 if ($scope.formData == undefined) $scope.formData={};
                                 $scope.formData[$scope.fd.PresentationId] = [{}];
                                 $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
                                    
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
   
     $scope.localVars.getDatasetCardLayoutOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceDefinitionCard= data.data.resourceDefinition;
                                $scope.localVars.dashboardCard.widgets.layout=data.data.widgets;
                                
                                $scope.fd.wItemValue=data.data.widgets;
                                
                                
                                 
                                 $timeout(function() {
                                           $scope.localVars.cardLayoutLoaded = true;
                                     
                                 });
           
                                 if ($scope.formDataCard == undefined) $scope.formDataCard={};
                                    
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
     $scope.localVars.getCardLayout = function(){   
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null) {
                $scope.fd.PresentationId = 0;
              }
               
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"w",lang).then(function(data) {
                 
                                    $scope.localVars.resourceDefinitionCard= data.data.resourceDefinition;
                               
                                    $scope.fd.wItemValue=data.data.widgets;
                                    $scope.localVars.dashboardCard.widgets.layout =  data.data.widgets;
                                    
                                    $scope.formDataCard =  data.data.form_data;
                                    if ($scope.formDataCard == undefined) $scope.formDataCard={};
                                   
                                    $timeout(function() {
                                           $scope.localVars.cardLayoutLoaded = true;
                                     
                                    });
                                   
                                    
               
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getCardlayout_END

     $scope.localVars.selectCardItem = function(index){
        let value;
        if ($scope.localVars.selectedCardIndex!=index)
        {
            $scope.localVars.selectedCardIndex=index;
            value=$scope.localVars.gridOptionsResourceData.data[$scope.localVars.selectedCardIndex][0];
        }
        else
        {
            $scope.localVars.selectedCardIndex=null;
            value = null;
        }
        //send data to package
         WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:value},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
     };
      
   $scope.localVars.datasetRecordSelected = false;
   $scope.localVars.selectedDatasetRecordId = 0;
 
    $scope.localVars.restoreGridState= function() {
        if ($scope.fd.GridState!=null)
        {
           if ($scope.localVars.gridApi!=undefined)
           {
          
            $scope.localVars.gridApi.saveState.restore($scope,$scope.fd.GridState);
            
           }
           else
           {
           // $scope.localVars.gridOptionsResourceData.columnDefs = $scope.fd.GridState.columns;
            $scope.restoreGridState=true;
          //  $timeout(function(){
          //      $scope.localVars.restoreGridState();
          //  });
           }
        }
    };
      $scope.localVars.getResourceData = function () {

        // scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+scope.selectedResource);
        var lang = $rootScope.globals.currentUser.lang;
        $scope.localVars.resourceDataDownloading = true;
        if ($scope.localVars.pageSize==undefined) $scope.localVars.pageSize = paginationOptions.pageSize;
        ResourcesDataService.getResourceData($scope.localVars.selectedResource,$scope.taskId,$scope.localVars.formType,lang).then(function(data) {
                               
                                     $scope.localVars.gridOptionsResourceData.data = data.data;
                                     $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                     $scope.localVars.restoreGridState();
                                     $scope.fd.initialLoad = false;
                                     $scope.localVars.resourceDataDownloaded = true;
                                     $scope.localVars.resourceDataDownloading = false;
                                    
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   $scope.localVars.resourceDataDownloading = false;
                             });
        };

    //**********************************************************
    //           GET FORM FIELDS
    //**********************************************************      
            
          $scope.localVars.getFormFields = function(){
              
              
              var lang=$rootScope.globals.currentUser.lang;
           
                         
              ResourcesDataService.getFormFields($scope.fd.Related,lang).then(function(data) {
                               
                                  $scope.localVars.PresentationElements= data.data;
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
                              
          };
          
          
          $scope.$watch('itemValue.val',function(newValue,oldValue){
                  if (newValue!=oldValue)
                  {
                   //send data to package
                   let newValueSingle,newValueMultiple;
                   if ($scope.fd.Multiline)
                   {
                    newValueMultiple = newValue;
                    newValueSingle="";
                   }
                   else
                   {
                    newValueMultiple = {};
                    newValueSingle=newValue;
                   }
                   
                   $scope.ksm.executeAction(valueStateName,"valueChanged", newValue);
                   
                    WidgetDataExchangeService.setData({
                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:newValueSingle}
                        ,{name:'resourceRecordIds',value:newValueMultiple},{name:'resourceRecordsAll',value:$scope.localVars.datasetItems}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
           
                  }
      });
        
       
       //**********************************************************
      //           GET DATASET DATA FOR DROPDOWN
      //**********************************************************
      var refresh_list_from_callback=function(data)
            {
                $scope.localVars.getDatasetDataList(true);
                
            }
        $scope.filterOnClient = function(items)
        {
            let temp=[];
            let search;
            if (Array.isArray($scope.fd.Search) && $scope.fd.Search.length>0) search = $scope.fd.Search[0];
            else search = $scope.fd.Search;
            for (let i=0;i<items.length;i++)
            {
  
                for (let key in search) {
                    
                    
                    if (search[key]!=undefined)
                    {
                        if (key in items[i])
                        {
                            if (items[i][key]==search[key].id || search[key]==null || search[key]==undefined || items[i][key]==undefined)  temp.push(items[i]);
                        }else if (key in items[i])
                        {
                            if (items[i][key]==search[key] || search[key]==null || search[key]==undefined || items[i][key]==undefined)  temp.push(items[i]);
                        }else temp.push(items[i]);
                    }else temp.push(items[i]);
                }
                
                
            }
            return temp;
            
        }
        $scope.localVars.getDatasetDataList = function(fromCache,clientSideFilter)
        {
                    if (fromCache==undefined) fromCache=true;
                    if (clientSideFilter==undefined) clientSideFilter=false;
                    var lang = $rootScope.globals.currentUser.lang;
                    $scope.localVars.datasetItems = null;
                    ResourcesDataService.getResourceDataListAll($scope.fd.Related,$scope.fd.PresentationId,lang,fromCache,refresh_list_from_callback).then(function(data) {
                   
                        if (clientSideFilter) $scope.localVars.datasetItems = $scope.filterOnClient(data.data);
                        else $scope.localVars.datasetItems = data.data;
                        $timeout(function(){
                            
                            //$scope.loadDropdown($scope.localVars.datasetItems);
                        
                       
                            if ($scope.itemValue.val!=undefined)
                            {
                            let pos = $scope.localVars.datasetItems.map(function(e) { return e.id; }).indexOf($scope.itemValue.val.id);
                  
                                if (pos<0){
                                    //$scope.clearDropdown();
                                    $scope.itemValue.val = null;
                                }
                            }else
                            
                            {
                                //$scope.clearDropdown();
                                $scope.itemValue.val = null;
                            }
                        });
                        
                    },function(error){    
                        MessagingService.addMessage(error.msg,'error');
                    });
              
            
        };
        
        $scope.localVars.GetDatasetDataClick = function()
        {
            if ($scope.fd.Parameters.PresentationType=='dropdown')
            {
               $scope.localVars.getDatasetDataList(); 
            }else
            {
                $scope.localVars.selectedResource=$scope.fd.Related;
                $scope.localVars.getResourceColumns(true);
            }
        };    
           
	$scope.TransformDataForCard = function(data)
    {
        let newData = [];
        let newElement = [];
        for (let i=0;i<data.length;i++)
        {
        
        newElement.push(data[i]);
        newData.push(newElement);
        
        newElement = [];
        }
        return newData; 
    };
      //**********************************************************
      //           GET RESOURCE DATA PAGINATED
      //**********************************************************      
    $scope.localVars.getResourceDataPaginated = function (urlNext,urlPrev,newPage,pageSize) {
        
        
        $scope.localVars.resourceDataDownloaded = false;        
        if (Math.ceil($scope.localVars.totalCount/pageSize)<newPage)
        {
          newPage = Math.ceil($scope.localVars.totalCount/pageSize);
        }
         
         var lang = $rootScope.globals.currentUser.lang;
          
         if (pageSize==undefined)
         
         {
          $scope.localVars.pageSize = paginationOptions.pageSize;
          pageSize= $scope.localVars.pageSize;
         }
         $scope.localVars.selectedItems.length=0;
         if ($scope.fd.PopulateMethod=='M')
         {
           $scope.localVars.resourceDataDownloading = true;
          
          ResourcesDataService.getResourceDataPaginatedFilter($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.Search, $scope.localVars.dashboard.widgets.layout).then(function(data) {
                                    
                                    
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data;
                                    if ($scope.fd.Parameters.PresentationType=='card')
                                    $scope.localVars.gridOptionsResourceData.data = $scope.TransformDataForCard(data.data);
                                    $scope.localVars.restoreGridState();
                                    $scope.fd.initialLoad = false;
                                    $scope.localVars.resourceDataDownloaded = true;
                                    $scope.localVars.resourceDataDownloading = false;
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    if ($scope.localVars.totalCount>0 && $scope.localVars.currentPage==0) $scope.localVars.currentPage=1;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.PresentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.localVars.resourceDataDownloading = false;
                             });
         }
         else if ($scope.fd.PopulateMethod=='A')
         {
          var task_instance=0;  
          if ($scope.localVars.formType=='i') task_instance = $scope.taskInitiateId;
          else task_instance = $scope.taskExecuteId;
           $scope.localVars.resourceDataDownloading = true;
          ResourcesDataService.getResourceDataPaginatedAuto($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.PresentationId,task_instance,$scope.localVars.formType).then(function(data) {
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data;
                                    $scope.localVars.restoreGridState();
                                    $scope.fd.initialLoad = false;
                                    $scope.localVars.resourceDataDownloaded = true;
                                    $scope.localVars.resourceDataDownloading = false;
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLink',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.PresentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.localVars.resourceDataDownloading = false;
                             });
          
         }
        };


 $scope.localVars.pageChanged = function(){
        
        $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,$scope.localVars.currentPage,$scope.localVars.pageSize);
         };
   //**********************************************************
	//           GET RESOURCE COLUMNS
	//**********************************************************      
  $scope.localVars.getResourceColumns = function (getData) {
     var lang = $rootScope.globals.currentUser.lang;
     if ($scope.localVars.selectedResource==undefined) $scope.localVars.selectedResource = $scope.fd.Related;
     
     if ($scope.localVars.selectedResource!=undefined && $scope.localVars.selectedResource!=null)
     {
           taskId = $scope.taskId;
           if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null || $scope.fd.PresentationId==0)
           {
              var taskId = 0;        
           }
      $scope.localVars.resourceDataDownloading = true;

     ResourcesDataService.getResourceColumns($scope.localVars.selectedResource,taskId,$scope.localVars.formType,lang).then(function(data) {
                                
                $scope.localVars.gridOptionsResourceData.columnDefs = data.data;
                if ($scope.localVars.currentPage==undefined) $scope.localVars.currentPage=1;
                if (getData && !$scope.formDefinition) $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                else
                
                {
                      $scope.localVars.restoreGridState();
                      $scope.fd.initialLoad = false;
                      $scope.localVars.resourceDataDownloaded = true;
                      $scope.localVars.resourceDataDownloading = false;
                }
         //                            MessagingService.addMessage(data.msg,'success');
         
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');
                                    $scope.localVars.resourceDataDownloading = false;
                             });
               
     }
  };
     
     $scope.localVars.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.localVars.selectedResource==null) {
            $scope.localVars.selectedResource = $scope.fd.Related;
          }
          $scope.localVars.resourceDataDownloading = true;
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.Related,lang,$scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered($scope.localVars.selectedResource,$scope.taskId,$scope.localVars.formType,lang,$scope.localVars.dashboard.data).then(function(data) {//MIGOR
                            
                                  $scope.localVars.gridOptionsResourceData.data = data.data;
                                  $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                  
                                    $timeout(function(){
                                      $scope.fd.initialLoad = false;
                                      $scope.localVars.resourceDataDownloaded = true;
                                      $scope.localVars.resourceDataDownloading = false;
                                      $scope.localVars.restoreGridState();
                                    });
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                                $scope.localVars.resourceDataDownloading = false;
                             });
        };
		
       $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
          $scope.localVars.showHideSearchForm = function()
        {
     				if ($scope.fd.ShowSearchForm) $scope.localVars.getFormResource();
        };
       
       
       
    $scope.localVars.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
            var datasetId=0,datasetRecordId=0;
            let action;
            for (let k=0;k<pTaskData.length;k++)
            {
                if (pTaskData[k].DEI!=undefined && pTaskData[k].DEI!=null)
                {
                for (var i=0;i<pTaskData[k].DEI.length;i++)
                {
                  if (pTaskData[k].DEI[i].name==linkType)
                  {
                    if (pTaskData[k].DEI[i].value!=undefined && pTaskData[k].DEI[i].value!=null)
                    {
                      //populate selected item
                     
                      for (var j=0;j<pTaskData[k].DEI[i].value.length;j++)
                      {
                       if (pTaskData[k].DEI[i].value[j].name=="resourceId" && pTaskData[k].DEI[i].value[j].value!=undefined) datasetId=pTaskData[k].DEI[i].value[j].value;
                       if (pTaskData[k].DEI[i].value[j].name=="resourceRecordId" && pTaskData[k].DEI[i].value[j].value!=undefined)
                       {
                            datasetRecordId=pTaskData[k].DEI[i].value[j].value;
                            if ($scope.fd.Parameters.PresentationType == 'dropdown' && datasetId==$scope.fd.Related && !$scope.fd.Multiline)
                            {
                        
                                $scope.itemValue.val = pTaskData[k].DEI[i].value[j].value;
                                action = $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.itemValue.val);
                            }
                       }
                       if (pTaskData[k].DEI[i].value[j].name=="resourceRecordIds" && pTaskData[k].DEI[i].value[j].value!=undefined)
                       {
                            datasetRecordId=pTaskData[k].DEI[i].value[j].value;
                            if ($scope.fd.Parameters.PresentationType == 'dropdown' && datasetId==$scope.fd.Related && $scope.fd.Multiline)
                            {
                        
                                $scope.itemValue.val = pTaskData[k].DEI[i].value[j].value;
                                action = $scope.ksm.executeAction(valueStateName,"valueChanged", $scope.itemValue.val);
                            }
                       }
                        
                      }
                         
                        
                    }
                      
                  }
                    
                  }
                }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
   
  $scope.localVars.previousTaskData=$scope.localVars.getPreviousTaskWidget("resourceLinkDatasetList");
 
        
   
		 $scope.localVars.saveGridState= function() {
       var state = $scope.localVars.gridApi.saveState.save();
       $scope.fd.GridState = state;
       MessagingService.addMessage("To make changes stick please save form",'info');
             
    };
  
                if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded && !$scope.fd.Parameters.DownloadAllRecords)
                {
                  
                  //$scope.localVars.getFormResource();
                  $scope.localVars.executeDatasetList();
                  //if ($scope.fd.Parameters.PresentationType=='card') $scope.localVars.getCardLayout();
                  
                }else if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded && $scope.fd.Parameters.DownloadAllRecords)
                {
                  //$scope.localVars.getFormResource();
                  if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(true);
                  if ($scope.fd.Parameters.PresentationType=='dropdown')
                  {
                    $scope.localVars.getDatasetDataList(true,$scope.fd.Parameters.ClientSideFilter);
                    $scope.localVars.getFormResource();
                  }
                  if ($scope.fd.Parameters.PresentationType=='card') $scope.localVars.getCardLayout();
                
                }
                else if ($scope.fd.Related!=null && ($scope.localVars.datasetMapperType==2 || $scope.fd.AutoSearch))
                {
                   $scope.localVars.getFormResource();
                   $scope.localVars.getDatasets();
                   if ($scope.fd.Parameters.PresentationType=='table') $scope.localVars.getResourceColumns(false);
                   else if ($scope.fd.Parameters.PresentationType=='card') $scope.localVars.getCardLayout();
                  
                }else if($scope.localVars.datasetMapperType!=5)
                {
                   $scope.localVars.showHideSearchForm();
                   $scope.localVars.getResourceColumns(false);
                   $scope.localVars.getDatasets();
                  
                }
                  
                  if ($scope.fd.Parameters!=null && $scope.fd.Parameters!=undefined)
                   {
                     if ($scope.fd.Parameters.PresentationType=="dropdown") $scope.localVars.getFormFields(); 
                   }
  
   $rootScope.$broadcast("Widget"+$scope.fd.PresentationId+"Ready",null);
        
}]; //controler_END

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskDatasetList.html',
            controller: controller,
            link: function (scope, elem, attrs) {
                
                /*  
                if (scope.fd.Related!=null &&  !scope.formDefinition && !scope.localVars.searchFormDownloaded && !scope.fd.Parameters.DownloadAllRecords)
                {
                  
                  //scope.localVars.getFormResource();
                  scope.localVars.executeDatasetList();
                  //if (scope.fd.Parameters.PresentationType=='card') scope.localVars.getCardLayout();
                  
                }else if (scope.fd.Related!=null &&  !scope.formDefinition && !scope.localVars.searchFormDownloaded && scope.fd.Parameters.DownloadAllRecords)
                {
                  //scope.localVars.getFormResource();
                  if (scope.fd.Parameters.PresentationType=='table') scope.localVars.getResourceColumns(true);
                  if (scope.fd.Parameters.PresentationType=='dropdown') scope.localVars.getDatasetDataList(true,scope.fd.Parameters.ClientSideFilter);
                  if (scope.fd.Parameters.PresentationType=='card') scope.localVars.getCardLayout();
                
                }
                else if (scope.fd.Related!=null && (scope.localVars.datasetMapperType==5 || scope.fd.AutoSearch))
                {
                   scope.localVars.getFormResource();
                   scope.localVars.getDatasets();
                   if (scope.fd.Parameters.PresentationType=='table') scope.localVars.getResourceColumns(false);
                   else if (scope.fd.Parameters.PresentationType=='card') scope.localVars.getCardLayout();
                  
                }else if(scope.localVars.datasetMapperType!=5)
                {
                   scope.localVars.showHideSearchForm();
                   scope.localVars.getResourceColumns(false);
                   scope.localVars.getDatasets();
                  
                }
                  
                if (scope.fd.Parameters!=null && scope.fd.Parameters!=undefined)
                {
                     if (scope.fd.Parameters.PresentationType=="dropdown") scope.localVars.getFormFields(); 
                }
                */
            
             }
             
             
  } 
        
};
'use strict';

export function ktTaskDefDetails () {

        return {
            restrict: 'A',
            scope:{
              taskDefinition:'=',
              isCollapsed:'='
              },
             templateUrl: 'ktdirectivetemplates/ktTaskDefDetails.html',
             link: function (scope, elem, attrs) {

         
       
            }

    }
};
'use strict';

export function ktTaskDetails () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskDetails.html',
               scope:{
              tName: "=",
              tInit:'=',
              tExe:'=',
             },
             controller: function(CodesService,$rootScope){},
             link: function (scope, elem, attrs) {

            
            
            scope.ti = scope.tInit;
            /*
            scope.getInitiateId = function(){
              
              if (scope.taskInitiateInstance != undefined)
              {
                return scope.taskInitiateInstance.id;
              }else
              
              {
                return scope.taskExecuteInstance.id;
                
              }
              
            }
            
            scope.getStatus = function(){
              if (scope.taskInitiateInstance != undefined)
              {
                return scope.taskInitiateInstance.Status.Name;
              }else
              
              {
                return scope.taskExecuteInstance.Status.Name;
                
              } 
              
            }
            */
       
            }

    }
};
'use strict';

export function ktTaskExecuteOutcomes () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskExecuteOutcomes.html',
              scope:{
                outcomes: '=',
                taskDefinition: '=',
                taskExe: '=',
                exeForm: '=',
                form: '=',
                formParams: '=',
                taskInitiateInstance: '=',
                localVars:'=',
                },
                controller: function($scope,CodesService,MessagingService,TaskDataService,$rootScope,$state)
                {
                   
                },
             link: function (scope, elem, attrs) {
              
              if (scope.localVars==undefined) scope.localVars={};
              
              scope.localVars.showInlineTask=false;
              scope.localVars.isInlineTask = false;
              
             if (scope.taskExe!=undefined) scope.taskExe.showInlineTask=false;
             else scope.taskExe = {showInlineTask:false};   
              
              scope.localVars.ProcessOutcome = function (outcome){
                
                for (var i=0;i<outcome.actions.length;i++) {
                  if (outcome.actions[i].type==1 || outcome.actions[i].type==2)
                  {
                     scope.localVars.InitiateTaskFromOutcome(outcome.actions[i].taskId,outcome.id1,outcome.actions[i].type,outcome.actions[i].actionParams);
                         
                  }
                 
                }
                if (outcome.actions.length==0)
                {
                    $rootScope.$broadcast('ExecuteTask'+scope.taskExe.id,{form:scope.form,outcomeId:outcome.id1});
                  
                }
                     
                 };
                 
                 
                 
              scope.localVars.InitiateTaskFromOutcome = function (taskDefId,outcomeId,type,actionParams){
                      //save task instance form for later processing
                      if (scope.taskExe!=undefined)
                      {
                      if (scope.taskExe.id!=undefined)
                      {
                      TaskDataService.saveTaskFormData(scope.taskExe.id,scope.exeForm).then(function(data) {
                               if (type==1)
                               {
                                
                                 scope.localVars.showInlineTask=true;
                                  scope.taskExe.showInlineTask=true;
                
                                  scope.localVars.isInlineTask=true;
                                  scope.localVars.fromOutcome=true;
                                  //scope.localVars.taskDefId=taskDefId;
                                  //scope.localVars.outcomeId=outcomeId;
                                  //scope.localVars.prevTaskId=scope.taskExe.id;
                                  if (taskDefId!=undefined &&  taskDefId>0) scope.localVars.StartTask(taskDefId,outcomeId,scope.taskExe.id);             
                              
                              
                                }
                                if (type==2)
                                {
                                      $state.go('app.menu.tasks.proc',{id: taskDefId,fromStateName:$state.current.name,
                                      fromStateParams:$state.params,prev_task_execute_id:scope.taskExe.id,outcome_id:outcomeId,presentation_id:0});
                            
                                 }
                        },function(error){
                                   MessagingService.addMessage(error.msg,'error');

                        });

                      }
                        else{
                        
                        MessagingService.addMessage("Invalid task data --> Task execution id is undefined",'error');
                        }
                      }else
                      {
                         MessagingService.addMessage("Invalid task data --> Task execution object is undefined",'error');
                      }
                 }
                 
                
                
        }
    }
};
'use strict';

export function ktTaskFiles () {
       
     return {
        restrict: 'A', 
        templateUrl: 'ktdirectivetemplates/ktTaskFiles.html',
         controller: function ($scope, $rootScope,$uibModal,CodesService,ResourcesDataService,ProcessingService,MessagingService,CODES_CONST,WidgetDataExchangeService,GridsterService,TaskDataService,$timeout) {
				 
              $scope.fd.ReadOnly=false;
              $scope.animationsEnabled = true;
              
              $scope.gsrvc = GridsterService;
              
              if ($scope.localVars==undefined)  $scope.localVars = {datasetMapperType:0};
              
              if ($scope.fd.Parameters == null ||  $scope.fd.Parameters==undefined)  $scope.fd.Parameters = {};
              
              
              $scope.showMetadata = function (fileId) {
            
                    
                  var modalInstance = $uibModal.open({
                  animation: $scope.animationsEnabled,
                  templateUrl: 'metadata_modal.html',
                  controller: 'FileMetadataModalInstanceCtrl',
                  size: 'lg',
                  resolve: {
                    retValue: function () {
                      return {file_id:fileId};
                    }
                  }
              });
           
                  modalInstance.result.then(function (retValue,windex,index) {
                    
            
                 }, function () {
             
                 });
          
       
            };
            
           $scope.localVars.showProperties=function(datasetMapperType)
           {
            
               if ($scope.localVars.datasetMapperType==undefined)
               {
                  $scope.localVars.datasetMapperType = datasetMapperType;
               }else
               {
                  if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                  else $scope.localVars.datasetMapperType=0;
               }
            
           };
           
            $scope.localVars.okFileConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.fd.listOfConnectors;
                $scope.localVars.showProperties(0);
                
                });
            };
            
             $scope.localVars.cancelFileConnector = function () {
                $timeout(function() {
                //Can't copy! Making copies of Window or Scope instances is not supported
                $scope.fd.listOfConnectors=angular.copy($scope.fd.tItemValue);
                //$scope.fd.listOfConnectors=$scope.fd.tItemValue;
                $scope.localVars.showProperties(0);
                
                });
            };
            
          //   kt taskfiles - FILECONNECTOR  -  ista funkcija kao i za uploader!
		  $scope.localVars.openFileConnector = function(){
             $scope.localVars.showProperties(1);
             
             if ($scope.localVars.datasetMapperType==1) {
				//POPUNI LISTU DATASETOVA 
                  var lang = $rootScope.globals.currentUser.lang;                          
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                               function(data) {
                                           $scope.fd.datasetList = data.data;
                                           //dodaj ime dataseta u konektore
                                           if ($scope.fd.listOfConnectors!=undefined) 
                                                      for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                            var p = $scope.fd.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                            if (p>=0) $scope.fd.listOfConnectors[i].parentDatasetName = $scope.fd.datasetList[p].name;  
                                                      }
                                           },function(error){  MessagingService.addMessage(error.msg,'error');
                  });
						
							
                  if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = [];  
						 
                  //ovo je kt-taskFiles
                  $scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
                          
                            //Brisi sve koji se vec nalaze u tItemValue
						if ($scope.fd.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.fd.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.fd.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.fd.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.fd.listOfConnectors.push($scope.fd.tItemValue[i]);	
                                                  
							  
							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
							   
								if ($scope.fd.listOfConnectors!=undefined){
									for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                     if ($scope.fd.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.fd.listOfConnectors[i].DEI.length;j++) {
                                                             if ($scope.fd.listOfConnectors[i].DEI[j].name=='resourceLink' || $scope.fd.listOfConnectors[i].DEI[j].name=='resourceLinkDatasetList') {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.fd.listOfConnectors[i].DEI[j].value!=false) && ($scope.fd.listOfConnectors[i].DEI[j].value!=true) ) $scope.fd.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                 newlist.push($scope.fd.listOfConnectors[i]);
                                                             };						 						  						   					      
                                                    }
                                               }
									}//if
							  $scope.fd.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora (NE ukljucuje one u tItemValue koja se salje posebno)
 
						
             }//if
			}; // open FIleConnector - ktTaskFiles 
    
                $scope.fd.fileListDownloaded = false;
        $scope.fd.isCollapsedFilesList = true;
        
        
         $scope.taskId=$scope.taskDefinition.ResourceDefId;
         if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
         if ($scope.taskId==undefined)  $scope.taskId=0;
        
      
        $scope.fd.getResourceDef = function(){
           var lang=$rootScope.globals.currentUser.lang;
           var file_resource_type = "file";
           ResourcesDataService.getResourceDefByType(lang,file_resource_type).then(function(data) {
                               
                                  //$timeout();
                                  $scope.fd.gridOptions.data = data.data;
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
		};
         
    
       //ktTaskFiles = VIEWFILES 
    	var out_fields = ['resourceId'];
		  var widgetDefinition = { DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktTaskFiles',widgetId: $scope.fd.PresentationId,taskId:  $scope.lTaskId,resourceDefId : $scope.selectedResource, output:out_fields, };
		  
      $scope.fd.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition); //zamijeniti gdje se sve pojavljujue i staviti LOCAL TODO
		  $scope.fd.LocalId=$scope.fd.localWidgetId;  
    
    
	   $scope.fd.downloadFile = function(fileId,fileName){
                ResourcesDataService.downloadFile(fileId).then(function(data) {
                               
                                    MessagingService.addMessage('File downloaded','info');
                                    var url = URL.createObjectURL(new Blob([data.data]));
                                    var a = document.createElement('a');
                                    a.href = url;
                                    a.download = fileName;
                                    a.target = '_blank';
                                    a.click();
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// dowload file END
      
      
       $scope.fd.previewFile = function(fileId,fileName,fileType){
           
            ResourcesDataService.previewFile(fileId).then(function(data) {
                               
                                    var url = URL.createObjectURL(new Blob([data.data],{type:fileType}));
                                    window.open(url,"_blank");
                                  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
      };// preview file END
   
      //kt TASK FILES
     /*
     $scope.localVars.gridOptionsResourceData = {
        columnDefs: [ { name: 'FileId.id', displayName: 'ID', type: 'number', width:'5%',enableHiding: false, visible: true },
         { name: 'FileId.Name', displayName: 'Name'},
         { name: 'FileId.Size', displayName: 'Size in bytes' },
         { name: 'FileId.FileType', displayName: 'File type' },
          { name: 'FileId.Sha512', displayName: 'File hash' },
        // { name: 'Actions', displayName: 'Actions' ,cellTemplate:"<div class='text-center'><a ng-click='grid.appScope.fd.previewFile(row.entity.FileId.id,row.entity.FileId.Name,row.entity.FileId.FileType)' href><i title='Preview file' class='fa fa-search fa-lg text-center' ></i></a>&nbsp&nbsp<a ng-click='grid.appScope.fd.downloadFile(row.entity.FileId.id,row.entity.FileId.Name)' href><i title='File download' class='fa fa-download fa-lg text-center' ></i></a>&nbsp&nbsp<a  ng-click='grid.appScope.fd.showMetadata(row.entity.id)' href><i title='Show metadata' class='fa fa-list-alt fa-lg' ></i></a></div>"}
        // { name: 'Metadata', displayName: 'Metadata',cellTemplate:"<div class='text-center'></div>"}
        ],
        enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: false,
        enableHorizontalScrollbar : 0, 
        enableVerticalScrollbar : 2,
       // enableFiltering: true,
        enableRowHeaderSelection: true,
        enableColumnResizing: true,   
   }
   */
    $scope.localVars.filesColumns = 
        [ { name: 'FileId.id', displayName: 'ID', type: 'number', width:'5%',enableHiding: false, visible: true },
         { name: 'FileId.Name', displayName: 'Name'},
         { name: 'FileId.Size', displayName: 'Size in bytes' },
         { name: 'FileId.FileType', displayName: 'File type' },
          { name: 'FileId.Sha512', displayName: 'File hash' },
        // { name: 'Actions', displayName: 'Actions' ,cellTemplate:"<div class='text-center'><a ng-click='grid.appScope.fd.previewFile(row.entity.FileId.id,row.entity.FileId.Name,row.entity.FileId.FileType)' href><i title='Preview file' class='fa fa-search fa-lg text-center' ></i></a>&nbsp&nbsp<a ng-click='grid.appScope.fd.downloadFile(row.entity.FileId.id,row.entity.FileId.Name)' href><i title='File download' class='fa fa-download fa-lg text-center' ></i></a>&nbsp&nbsp<a  ng-click='grid.appScope.fd.showMetadata(row.entity.id)' href><i title='Show metadata' class='fa fa-list-alt fa-lg' ></i></a></div>"}
        // { name: 'Metadata', displayName: 'Metadata',cellTemplate:"<div class='text-center'></div>"}
        ];
        
   
    $scope.localVars.filesData = [];
    
    /*
         $scope.localVars.gridOptionsResourceData.onRegisterApi = function (gridApi) {
            $scope.fd.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged($scope,function(row){
              $scope.fd.fileSelected=row.isSelected;
              $scope.fd.SelectedFile = row.entity;
          });
		};
    */
    
    $scope.localVars.fileSelectionChanged = function (item) {
       $scope.fd.fileSelected=item.isSelected;
       $scope.fd.SelectedFile = item;
     
    }
	$scope.fd.getFilesData = function (resource_def_id,resource_id) {
				
				$scope.filter = {};
				var lang = $rootScope.globals.currentUser.lang;
				//$scope.fd.linkedResourceId = resource_id; //MIGOR - mozda je visak (je)
				//$scope.fd.linkedResourceDefId = resource_def_id; //MIGOR - mozda je visak (je)
           if (resource_def_id!=undefined && resource_id!=undefined)
           {
               if (($scope.lastResourceDefId != resource_def_id) || ($scope.lastResourceId != resource_id))
               {
                    $scope.localVars.filesData.length=0;
                    $scope.fd.fileSelected = false;
                    ResourcesDataService.getFilesData(resource_def_id,resource_id,lang).then(function(data) {
                                   
                         if ($scope.lastResourceDefId != resource_def_id)
                         {   
                              if ($scope.localVars.filesData==undefined)
                              {
                                   $scope.localVars.filesData = [];
                                   $scope.localVars.filesData = data.data;
                              }
                              else if ($scope.localVars.filesData.length>0)
                              {
                                   Array.prototype.push.apply($scope.localVars.filesData,data.data);
                                   //$scope.localVars.filesData.length=0;
                              
                              }else  $scope.localVars.filesData = data.data;
       
                         }else if ($scope.lastResourceId != resource_id)
                         {
                              $scope.localVars.filesData = data.data;
                         }
                         $scope.lastResourceDefId = resource_def_id;
                         $scope.lastResourceId = resource_id;
                         $scope.fd.fileListDownloaded = true;
                    
                    }			
                    ,function(error){    
                         MessagingService.addMessage(error.msg,'error');	
                    });
               }
          }else 
          {
               if ($scope.localVars.filesData==undefined) $scope.localVars.filesData = [];
               else $scope.localVars.filesData.length=0;
               
          }
	};//getFilsData END
      
      //TODO - vidjeti da li ovaj treba i zbog èega
       $scope.$on('InitiateTaskFilesUploaded',function(event, data){
             $scope.fd.getFilesData($scope.fd.linkedResourceDefId ,$scope.fd.linkedResourceId ); 
          });
		  
      //ktTaskFiles  - ProcessEvent
      $scope.fd.ProcessEvent=function(data)
      {
        for (var i=0;i<data.length;i++)
        {
         if (data[i].name=='resourceRecordId')
         {
               if (data[i].value!=undefined && typeof data[i].value =='object')
               {
                     $scope.fd.linkedResourceId = data[i].value.id;
               }else $scope.fd.linkedResourceId = data[i].value;

         }
         if (data[i].name=='resourceId')
          {
               
                if (data[i].value!=undefined && typeof data[i].value =='object')
               {
                     $scope.fd.linkedResourceDefId = data[i].value.id;
               }else $scope.fd.linkedResourceDefId = data[i].value;
          }
        }

      }; //ktTaskFiles  - ProcessEvent
      
        //ktTaskFiles  - pr0cessWidgetDependencies
        $scope.fd.ProcessWidgetDependencies = function() {
                                    
            if ($scope.fd.tItemValue!=undefined)
	    		for (var i=0;i< $scope.fd.tItemValue.length;i++) { // prolazim po DEI od vezanih widgeta
					var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;
                    if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                     //linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                        for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                            if (($scope.fd.tItemValue[i].DEI[j].name==='resourceLink' || $scope.fd.tItemValue[i].DEI[j].name==='resourceLinkDatasetList') && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                           
                               //console.log("kt-taskfiles " + $scope.fd.PresentationId+" vezani widgetid=" + linkedWidgetId);       
                               var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;
                               
                               $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on
                                                 
                                 //    console.log("kt-taskfiles "+$scope.fd.PresentationId+", dobio event " + event.name);				 
                                     //ktTASKfiles
                                                    
                                 $scope.fd.ProcessEvent(data);  
                                                 
                                }) //$on_END
                                 var data = WidgetDataExchangeService.getDataByWidgetId($scope.taskDefinition.task_execute_id,$scope.taskDefinition.task_initiate_id,$scope.taskDefinition.prev_task_id,linkedWidgetId,linkedItem);
                                 $scope.fd.ProcessEvent(data);
                            }//if
                    }//for j
                   }//if   
                } //for i
        }// fn pr0cessWidgetDependencies
              
        if ($scope.fd.linkedResourceDefId!=undefined && $scope.fd.linkedResourceDefId!="" && $scope.fd.linkedResourceId!=undefined && $scope.fd.linkedResourceId!="")  $scope.fd.getFilesData($scope.fd.linkedResourceDefId,$scope.fd.linkedResourceId);
                                 
      //ILJU treba dohvatit sa servera tItemValue ktTaskFiles
          $scope.formType=$scope.taskDefinition.form_type;
          if ($scope.fd.PresentationId!=undefined && $scope.fd.PresentationId!=null)
          {
          TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                //console.log(' prije '+$scope.fd.tItemValue[0].widgetId+':'+$scope.fd.tItemValue[0].DEI[0].name+' '+$scope.fd.tItemValue[0].DEI[0].value);
                //console.log('prije '+$scope.fd.tItemValue[1].widgetId+':'+$scope.fd.tItemValue[1].DEI[0].name+' '+$scope.fd.tItemValue[1].DEI[0].value);
                                  //ovo je da trenutno radi
                               // WidgetDataExchangeService.setData($scope.fd.tItemValue);
                                $scope.fd.ProcessWidgetDependencies();
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
       
          }
             
         },//ktTaskFile $CONTROLER
        link: function (scope, elem, attrs) {
          
      
		}//LINK ktTaskFiles
    }
}; //ktTaskFiles END
'use strict';

export function ktTaskForm () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktTaskForm.html',
             controller: function($scope,TaskDefinitionService,TaskDataService,MessagingService,GridsterService,WidgetRegisterService,ProcessingService,
              ResourcesDataService,KatalyoStateManager,WidgetDataExchangeService,dragulaService,$stateParams,$rootScope){
                $scope.tds=TaskDefinitionService;
                
                $scope.resourceObject = $stateParams.resource;
                $scope.formLoaded=false;
                $scope.formVersion={};
                $scope.resourceId=$stateParams.id;
                $scope.gsrvc = GridsterService;
                $scope.showFieldProperties = false;
                $scope.formType=$scope.tds.showTaskFormFn();
                $scope.taskDefinition = {ResourceDefId_id:$scope.resourceId};
                $scope.taskDefinition.form_type=$scope.formType;
                $scope.taskDefinition.form_definition=true;
                $scope.gridsterType="task";
                $scope.refreshForm=false;
                $scope.dashboard = {'i':{},'e':{}};
                if ($scope.localVars==undefined) $scope.localVars={};
                
                $scope.localVars.cbAutoExecuteChanged = false;
                $scope.localVars.cbAutoInitiateChanged = false;
                // $scope.gsrvc.destroyDragula('bag-columns');
                // $scope.gsrvc.destroyDragula('bag-rows-'+$scope.gridsterType);
                 
                 //$rootScope.$emit('RegisterTaskWidgets',null);
                 
                 WidgetRegisterService.ListenToEvents();
                 WidgetRegisterService.EmitRegisterTaskWidgetEvent();
                 
                 WidgetDataExchangeService.deRegisterAllWidgets();	
                 
                 $scope.hideTabIndex = true;
                 $scope.outcomes = {outcomeCodesDetails:[]};
                 $scope.outcomes.selectedOutcomeIndex=-1;
                 $scope.dashboardLocal ={widgets:{layout: GridsterService.getEmptyTaskForm(),data:{}}};
                 var lang=$rootScope.globals.currentUser.lang;
                
                $scope.ksm = KatalyoStateManager;
                
                var form_saved = function(data)
                    {
                        formDefinitionState.subject.setStateChanges = data;
                        formDefinitionState.subject.notifyObservers("formSaved");
                    };
                
                var formDefinitionState,formDefinitionStateName;   
                $scope.setupKatalyoStateManager = function()
                {
                    formDefinitionState= $scope.ksm.addSubject('formDefinitionState'+$scope.resourceId+$scope.taskDefinition.form_type,null);
                    formDefinitionStateName = formDefinitionState.subject.name;
                    
                    let action_value_changed = $scope.ksm.addAction(formDefinitionStateName,"formSaved",form_saved);
                }
                 $scope.setupKatalyoStateManager();
                $scope.ShowFormView = function(viewId,locked)
                {
                    $scope.resourceDefinition.formParams.formViewType=viewId;
                    $scope.resourceDefinition.formParams.formLocked = locked;
                    $scope.gsrvc.setFormViewType($scope.resourceDefinition.formParams.formViewType);
                    
                };
            
           
              $scope.showHideTaskForm = function(form_type)
                      {
                        
                        $scope.tds.showHideTaskForm(form_type);
                        $scope.taskDefinition.form_type=form_type;
                        if (form_type=="")  $scope.ShowFormView(2,false);
                        $scope.setupKatalyoStateManager();
             
                      };
                      
              $scope.showHideProperties = function(value)
                      {
                        $scope.gsrvc.setFieldPropertiesOpened(value);
                        $scope.showFieldProperties=$scope.gsrvc.getFieldPropertiesOpened();
             
                      };
            
            $scope.$watch('gsrvc.getFieldPropertiesOpened()',function(newValue,oldValue){
                    
                    if (newValue!=oldValue)
                    {
                     $scope.selectedField=$scope.gsrvc.getFieldProperties();
                     $scope.showFieldProperties = $scope.gsrvc.getFieldPropertiesOpened();
                    }
            });
            
            
             $scope.$watch('gsrvc.getFieldProperties()',function(newValue,oldValue){
                    
                    if (newValue!=oldValue)
                    {
                     $scope.selectedField=$scope.gsrvc.getFieldProperties();
                     $scope.showFieldProperties = $scope.gsrvc.getFieldPropertiesOpened();
                    }
            });
   
   
          
      //save task parameters
      $scope.saveTaskParameters = function(){
        
      
        
        TaskDataService.SaveTaskParameters($scope.taskDefinition.id,$scope.taskDefinition).then(function(data) {
 
                                  MessagingService.addMessage(data.msg,'success');
                                  $scope.taskDefinition = data.data;
                                  $scope.taskDefinition.form_type=$scope.formType;
                                  $scope.taskOriginal=angular.copy($scope.taskDefinition);
                                  $scope.localVars.cbAutoInitiateChanged = false;
                                  $scope.localVars.cbAutoExecuteChanged = false;
                            },function(error){     
                                  MessagingService.addMessage(error.msg,'error');   
                             });  
      };
         
      
               
   $scope.setAutoExecute= function(){
    
    
        if  ($scope.taskDefinition.AutoExecute)
        {
         $scope.taskDefinition.SelfAssigned=true;
         $scope.taskDefinition.InfiniteTask=false;
        }
        $scope.localVars.cbAutoExecuteChanged = !$scope.localVars.cbAutoExecuteChanged;
    };
  
             $scope.getTaskParameters = function(){
                TaskDataService.GetTaskParameters($scope.resourceId).then(function(data) {
                                         //  $scope.ac.alerts = data.data;
                                      
                                      if (data.data.length>0) {
                                                                               
                                          $scope.taskDefinition = data.data[0];
                                          $scope.taskDefinition.form_type=$scope.formType;
                                          $scope.taskDefinition.form_definition=true;
                                          if (!$scope.taskDefinition.InfiniteTask)
                                          {
                                                 //get Task Outcomes 
                                              if ($scope.taskDefinition.TaskOutcomeHeadId == null || $scope.taskDefinition.TaskOutcomeHeadId==undefined)
                                                  {
                                                   $scope.taskDefinition.TaskOutcomeHeadId=0; //vidjeti da li ovo treba MIGOR
                                                  }
                                         
                                         
                                              //TaskDataService.GetTaskCodesActionsById($scope.resourceId,lang,$scope.taskDefinition.TaskOutcomeHeadId).then(function(data) {
                                              if ($scope.form_type==="e")
                                              {
                                                TaskDataService.GetTaskOutcomes($scope.resourceId,$scope.taskDefinition.TaskOutcomeHeadId,lang).then(function(data) {            
                                                                        $scope.outcomes.outcomeCodesDetails = data.data;
                                                                        $scope.taskDefinition = {outcomes:{outcomeCodesDetails:data.data}};
                                                                        //prikazi defaultno detalje od prvog
                                                                       // if ($scope.outcomes.outcomeCodesDetails.length>0)   $scope.clickedOutcome = $scope.outcomes.outcomeCodesDetails[0];
                                                                        
                                                                  },function(error){
                                                                        MessagingService.addMessage(error.msg,'error');
                                                                    });
                                              }
                                          }
                                          
                                            
                                      }  
                                   },function(error){
                                    
                                    MessagingService.addMessage(error.msg,'error');
                                    });
                                     
                                  
             };
            
            $scope.formFromServerLoaded = {};
            $scope.getResourceForm = function (afterSave,afterSaveMsg) {
                  if (!$scope.formFromServerLoaded[$scope.formType])
                  {
                    ResourcesDataService.getResourceForm($scope.resourceId,$scope.formType,lang).then(function(data) {
                                      
                                          if (data.data.widgets.length>0)
                                         {
                                          $scope.dashboard[$scope.formType]={widgets:{layout:data.data.widgets}};
                                         }else
                                         {
                                          $scope.dashboard[$scope.formType] = angular.copy($scope.dashboardLocal);  
                                         }
                                         $scope.resourceDefinition= data.data.resourceDefinition;
                                         $scope.formVersion [$scope.formType] = $scope.resourceDefinition.formVersion;
                                         $scope.resourceDefinition.formParams={formViewType:2,showGridNavigation:false};
                                         $scope.ShowFormView($scope.resourceDefinition.formParams.formViewType,false);
                                       
                                         $scope.formLoaded=true;
                                         $scope.formFromServerLoaded[$scope.formType] = true;
                                         //send to state manager
                                         
                                         if (afterSave)
                                         {
                                           MessagingService.addMessage(afterSaveMsg,'success');
                                          
                                         }
                                      },function(error){
                                   
                                        
                                       MessagingService.addMessage(error.msg,'error');
                                      
                                      
                                   });
                  }
            };
        
           
        //**********************************************************
          //           SAVE TASK FORM DEFINITION
          //**********************************************************
      
        $scope.saveTaskForm = function () {
          //if (isValid) {
            //code
               
               $scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving task form for '+$scope.resourceId);
               //$scope.formLoaded=false;       
               ResourcesDataService.saveResourceForm($scope.dashboard[$scope.formType].widgets.layout,$scope.resourceId,$scope.formType).then(function(data) {
                                       
      
                                       // $scope.formLoaded=true;
                                       // if (data.updateForm) $scope.dashboard[$scope.formType].widgets.layout=data.data.widgets;
                                        MessagingService.addMessage(data.msg,data.msgType);
                                        $scope.formVersion [$scope.formType] = data.version;
                                        $scope.ksm.executeAction(formDefinitionStateName,"formSaved",data.new_items);
                                      // $scope.dashboard.widgets = data.data;
                                     //  $scope.getResourceForm(true,data.msg);
                                      
                                      
                                   },function(error){
                                     
                                       MessagingService.addMessage(error.msg,'error');
                                      
                                    });
                                      
                                  
            //   }
              };
              
         //**********************************************************
          //           SAVE TASK BUTTONS
          //**********************************************************      
        $scope.saveTaskBtns = function () {
       
          
               //$scope.activity.activityMessage = ProcessingService.setActivityMsg('Saving task btns for '+$scope.resourceId);
               
               TaskDataService.SaveTaskBtns($scope.resourceDefinition.initTaskBtnDef,$scope.resourceId,lang).then(function(data) {
                                       
                                        
                                       MessagingService.addMessage(data.msg,'success');
                                  
                                   },function(error){
                                        
                                       MessagingService.addMessage(error.msg,'error');
                                      
                                    });
                                      
                                  
       
              };
              

             
                             
            $scope.$on('CtrlPBPressed',function(event,data){
                  
                var key=data;
                if (key=='b' || key=='B')
                {
                    if ($scope.resourceDefinition.formParams.formViewType!=1) $scope.ShowFormView(1);
            
                }
                if (key=='p' || key=='P')
                {
                    if ($scope.resourceDefinition.formParams.formViewType!=2) $scope.ShowFormView(2);
                }
                  
            });  
          
           //**********************************************************
          //           CALL FUNCTIONS FOR FETCHING TASK FORM, PARAMETERS, OUTCOMES
          //**********************************************************
          
           $scope.$watch('tds.showTaskFormFn()',function(newValue,oldValue){
                    
                     $scope.formType = newValue;
                     if ($scope.resourceId != undefined)
                        {
                            
                            $scope.getResourceForm();
                        }
            
                        $scope.getTaskParameters();
                    
                  });
           
            
                
                },
             link: function (scope, elem, attrs) {
              
            
            
             
                  
                  
            }
        }
};
'use strict';

export function ktTaskformlayout () {
        return {
            restrict: 'A',
            
			controller: function ($scope,dragulaService,$rootScope,WidgetDataExchangeService,GridsterService,$compile,$element,$templateCache) {
                    
                
				$scope.removeField = function (index){
						// console.log("REMOVE FIELD "+index);
						if (index > -1) {
                        
                            WidgetDataExchangeService.deRegisterWidget($scope.inputArray.layout[index].LocalId);
                            if ($scope.inputArray.layout[index].Saved==true && $scope.inputArray.layout[index].PresentationId!=null && $scope.inputArray.layout[index].PresentationId!=undefined) {
								
                                 $scope.inputArray.layout[index].Status="Deleted";
							 }else
                             {
                                $scope.inputArray.layout.splice(index,1);
                                
                             }
                             
						}

				};
                                 let template;
                                if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktTaskFormLayout.html');
                                else template = $templateCache.get('ktdirectivetemplates/ktTaskFormLayoutExe.html');
          
                                $element.append($compile(template)($scope));

			},
			 link: function (scope, elem, attrs) {

                if (scope.inputArray.layout==undefined || scope.inputArray.layout==null) scope.inputArray.layout = [];
          
            }
        };
};
'use strict';

export function ktTaskListWidget () {
             var controller = ['$scope', '$stateParams','$state','UserService','ResourcesDataService','$rootScope','ProcessingService','$timeout','$cookies','CodesService','WidgetDataExchangeService','TaskDataService','MessagingService','GridsterService','KatalyoStateManager','$q','$templateCache','$compile','$element',
                               function ($scope,$stateParams,$state,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$cookies,CodesService,WidgetDataExchangeService,TaskDataService,MessagingService,GridsterService,KatalyoStateManager,$q,$templateCache,$compile,$element) {
          
               
             
             var lang=$rootScope.globals.currentUser.lang;
                
                    if ($scope.localVars==undefined) $scope.localVars = {};                      
                    $scope.stateName=$state.current.name;
                    $scope.stateParams = $state.current.params;
                    $scope.task_initiate_id=$stateParams.task_initiate_id;
                    $scope.task_execute_id=$stateParams.task_execute_id;
                                    
                     $scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;
                   
                    $scope.gridOptions = {
                      data:[],
                    enableGridMenu: true,
                    //showGridFooter: true,
                    //showColumnFooter: true,
                    enableRowSelection: true,
                    multiSelect: false,
                    enableHorizontalScrollbar : 0, 
                    enableVerticalScrollbar : 2,
                    //enableFiltering: true,
                    enableRowHeaderSelection: false,
                    enableColumnResizing: true,
                    useExternalPagination: true,
                    paginationPageSizes: [10, 25, 50,100,200,500,1000],
                    enablePaginationControls: false,
                    //paginationPageSize: 10,
                    //useExternalSorting : true,
                    //useExternalFiltering: true,
                   // minRowsToShow : 3
                   };
                    
                  var paginationOptions = {
                    pageNumber: 1,
                    pageSize: 10,
                    sort: null
                    };
                  
                  $timeout(function(){  
                           $scope.localVars.pageSize =  paginationOptions.pageSize;
                  });
                  $scope.localVars.firstTime = true;
                var columnDefsInitiate = [  
                  { name: 'TaskInitiationId.id', displayName: 'Task Start ID', type: 'number', width:'5%',enableHiding: false, visible: true },
                  { name: 'TaskInitiationId.InitiatorId.name', displayName: 'Started by'},
                  { name: 'TaskInitiationId.Status.CodesDetailLang[0].Value', displayName: 'Task status' },
                  { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Name', displayName: 'Task name' },
                  { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Description', displayName: 'Task description' },
                  { name: 'TaskInitiationId.Resourcedef.id', displayName: 'Task def id',enableHiding: false,visible: false },
                  { name: 'TaskInitiationId.CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                  { name: 'TaskInitiationId.CreatedBy.name', displayName: 'Created by'},
                  { name: 'ForGroup.name', displayName: 'For group'},
                  ];
                    
                   var columnDefsExecute = [
                         { name: 'id', displayName: 'Task Execute ID', type: 'number', width:'10%',enableHiding: false, visible: true },
                         { name: 'resourcedef[0].Name', displayName: 'Task name' },
                         { name: 'resourcedef[0].Description', displayName: 'Task description' },
                         { name: 'actualOwner.name', displayName: 'Task Owner'},
                         { name: 'status[0].Value', displayName: 'Task status' },
                        // { name: 'outcome[0].Name', displayName: 'Task outcome' },
                         { name: 'resourcedef[0].id', displayName: 'Task def id',enableHiding: false,visible: false },
                         { name: 'CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                         { name: 'createdBy.name', displayName: 'Created by'},
                         ];   
                   
                    if ($scope.task_execute_id==undefined) $scope.task_execute_id = 0;
                    if ($scope.task_initiate_id==undefined) $scope.task_initiate_id = 0;
                    $scope.localVars.detailsClicked=false;
                    if ($scope.fd===undefined) $scope.fd={};
                    if ($scope.fd.Search===undefined || $scope.fd.Search===null) $scope.fd.Search = {};
             
             
                let widgetDefinition = {name: 'taskExecuteWidget',widgetId: $scope.fd.LocalId,task_initiate_id:$scope.task_initiate_id,task_execute_id:$scope.task_execute_id,taskId:  $scope.taskDefinition.ResourceDefId };
                $scope.fd.LocalId=WidgetDataExchangeService.registerWidget(widgetDefinition);
                
                $scope.ksm = KatalyoStateManager;
      
                let update_presentation_id = function(data)
                {
                   if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
                    //unsubscribe here later after implementing unsubscribe - ToDo   
                }
                if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
                {
                   
                   let dependent_field = $scope.fd.LocalId;
                   let subscribedSubject = "formDefinitionState"+$scope.taskDefinition.ResourceDefId+$scope.taskDefinition.form_type;
                   let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
            
                } 
                    $scope.filter=$scope.fd.Search;
                   //ovo treba prilagoditi
                   if ($scope.fd.Search.taskListType==undefined) $scope.fd.Search.taskListType="claim";
                      
                      
                    
                     $scope.gridOptions.onRegisterApi = function (gridApi) {
                        $scope.gridApi = gridApi;
                        gridApi.selection.on.rowSelectionChanged($scope,function(row){
                         $scope.localVars.taskSelected=row.isSelected
                       
                         if(row.isSelected){
                           
                             
                               if ($scope.fd.Search.taskListType=="execute")
                               {
                                $scope.selectedTask=row.entity.id
                                $scope.task_execute_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=row.entity.resourcedef.id
                                $scope.selectedTaskObject = row.entity;  
                               }
                               else
                               {
                                $scope.selectedTask=row.entity.TaskInitiationId.id
                                $scope.task_initiate_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=row.entity.TaskInitiationId.Resourcedef.id
                                $scope.selectedTaskObject = row.entity.TaskInitiationId;  
                               }
                               
                            }
                        });
                        
                        //external pagination
                      gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                          paginationOptions.pageNumber = newPage;
                          paginationOptions.pageSize = pageSize;
                          $scope.fd.ExecuteAllListPaginatedFilter($scope.fd.Search.taskListType,1,false,"",$scope.localVars.nextPage,$scope.localVars.previousPage,newPage,pageSize,$scope.filter);
                      });
                      
                       gridApi.core.on.filterChanged($scope, function() {
                           // Set some $scope variable that both lists use for filtering
                          // $$scope.someFilterValueBothListsLookAt = ......
                       });
                
                      
                     }
                   
                   
                  $scope.localVars.showProperties=function(datasetMapperType)
                  {
                   
                   if ($scope.localVars.datasetMapperType==undefined)
                   {
                      $scope.localVars.datasetMapperType = datasetMapperType;
                   }else
                   {
                      if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                      else $scope.localVars.datasetMapperType=0;
                   }
                   
                  };
                      
              /*
                    $scope.removeField = function (index){
						
                        if (index > -1) {
						 
                           $scope.inputArray.layout.splice(index, 1);
						 
                        }

                  }
                */
                    $scope.ClaimSelected = function(){
                              
                              
                            var lang=$rootScope.globals.currentUser.lang;
                             TaskDataService.ExecuteTaskAction($scope.selectedTask,0,'claim',lang).then(function(data) {
                       
                                                   
                                                    
                                                    //refresh liste task-ova za claim
                                                    $scope.ExecuteAllList($scope.fd.Search.taskListType,1,true,data.data.msg);
                                                   
                                              },function(error){
                                                
                                            
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                      } 
                    
                    $scope.ExecuteAllList = function(type,filter,afterClaim,msgAfter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      TaskDataService.getInitiatedTasks(type,filter).then(function(data) {
                                                
                                                  $scope.gridOptions.data = data.data.results;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    
                  
                  $scope.ExecuteAllListPaginated = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize){
                      
                      $scope.localVars.dataLoaded = false;
                      var lang=$rootScope.globals.currentUser.lang;
                       if ($scope.localVars.totalCount>0)
                      {
                           if (Math.ceil($scope.totalCount/pageSize)<newPage)
                           {
                             newPage = Math.ceil($scope.totalCount/pageSize);
                           }
                      }
                      TaskDataService.getInitiatedTasksPaginated(type,filter,urlNext,urlPrev,newPage,pageSize).then(function(data) {
                                                
                                                  $scope.gridOptions.data = data.data.results;
                                                  $scope.nextPage = data.data.next;
                                                  $scope.previousPage = data.data.previous;
                                                  $scope.totalCount=data.data.count;
                                                  $scope.currentPage=newPage;
                                                  $scope.numPages = Math.ceil($scope.totalCount/pageSize);
                                                  $scope.pageSize = pageSize;
                                                  $scope.gridOptions.totalItems=$scope.totalCount;
                                                  $scope.localVars.dataLoaded = true;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    $scope.fd.rowSelectionChanged=function(item)
                    {
                        $scope.localVars.taskSelected=item.isSelected;

                        if(item.isSelected){
                           
                             
                               if ($scope.fd.Search.taskListType=="execute")
                               {
                                $scope.selectedTask=item.id
                                $scope.task_execute_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=item.resourcedef[0].id
                                $scope.selectedTaskObject = item;  
                               }
                               else
                               {
                                $scope.selectedTask=item.TaskInitiationId.id
                                $scope.task_initiate_id = $scope.selectedTask;
                                $scope.selectedTaskDefId=item.TaskInitiationId.Resourcedef.id
                                $scope.selectedTaskObject = item.TaskInitiationId;  
                               }
                               
                            }   
                    }
                    
                    $scope.fd.ExecuteAllListPaginatedFilter = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize,f_filter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      var deferred = $q.defer()
                      $scope.localVars.dataLoaded = false;
                      
                      if ($scope.fd.Search.taskListType=="claim")
                      {
                        $scope.results = {columns : columnDefsInitiate};
                      }
                    
                         if ($scope.fd.Search.taskListType=="execute")
                      {
                        $scope.results = {columns : columnDefsExecute};
                      }
                    
                      
                      if ($scope.localVars.totalCount>0)
                      {
                           if (Math.ceil($scope.localVars.totalCount/pageSize)<newPage)
                           {
                             newPage = Math.ceil($scope.localVars.totalCount/pageSize);
                           }
                      }
                     // $scope.gridOptions.data.length=0;
                      
                      TaskDataService.getInitiatedTasksPaginatedFiltered(type,filter,urlNext,urlPrev,newPage,pageSize,f_filter).then(function(data) {
                                                
                                                  $scope.results.results = data.data.results;
                                                  $scope.localVars.nextPage = data.data.next;
                                                  $scope.localVars.previousPage = data.data.previous;
                                                  $scope.localVars.totalCount=data.data.count;
                                                  $scope.localVars.currentPage=newPage;
                                                  $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                                  $scope.localVars.pageSize = pageSize;
                                                  $scope.results.totalItems=$scope.localVars.totalCount;
                                                  $scope.localVars.firstTime = false;
                                                  $scope.localVars.dataLoaded = true;
                                                  
                                                  
                               
                                                    $scope.results.pageSize = pageSize;
                                                    $scope.results.numberOfPages = $scope.localVars.numPages;
                                                    $scope.results.count = data.data.count;
                                                    
                                                    if (deferred!=undefined) deferred.resolve({data: $scope.results});
                                                  
                                                  
                                                  
                                               /*   if ($scope.localVars.totalCount==1)
                                                  {
                                                        if (!$scope.localVars.detailsClicked)
                                                        {
                                                                if ($scope.fd.Search.taskListType=="execute")
                                                                {
                                                                $scope.task_execute_id = $scope.gridOptions.data[0].id;
                                                                 
                                                                }
                                                                else
                                                                {
                                                                $scope.task_initiate_id = $scope.gridOptions.data[0].TaskInitiationId.id;
                                                               
                                                                }
                                                        }*/
                                                  
                                                  $timeout(function(){
                                                      $rootScope.$broadcast('PageLoaded');
                                                  });
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                  deferred.reject({data: $scope.results});
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                          return deferred.promise;
                    }
             $scope.fd.pageChanged = function(){
                        
                        $scope.directiveFnSmartTableRefresh(1,$scope.localVars.pageSize);
                        //$scope.fd.getTaskList(1,$scope.localVars.pageSize);
                       
             }
             
             $scope.setDirectiveFnRefreshData = function(directiveFn) {
                          $scope.directiveFnSmartTableRefresh = directiveFn;
             };
    
             $scope.fd.getTaskList = function(pageNumber,pageSize){
                          var dfrd = $q.defer();
                          $scope.localVars.dataLoaded = false;
                          $scope.fd.ExecuteAllListPaginatedFilter($scope.fd.Search.taskListType,1,false,"",
                                                                  $scope.localVars.nextPage,$scope.localVars.previousPage,
                                                                  pageNumber,pageSize,$scope.filter).then(function(data)
                                                                                                                            
                                                                 {
                                                                              dfrd.resolve(data);
                                                                 });
                          return dfrd.promise;
             };
                         
                         
                    //napuni grid s definicijama resursa
                     //$scope.currentPage =  paginationOptions.pageNumber;
                     //$scope.pageSize = paginationOptions.pageSize;
                      
                     //$scope.fd.ExecuteAllListPaginatedFilter($scope.fd.Search.taskListType,1,false,"","","",paginationOptions.pageNumber,paginationOptions.pageSize,$scope.filter);
                     //$scope.fd.getTaskList(paginationOptions.pageNumber,paginationOptions.pageSize);
                     
                     $scope.ExecuteListPrePaginated = function(listFilter){
                            $scope.ExecuteAllListPaginated($scope.fd.Search.taskListType,listFilter,false,"","","",paginationOptions.pageNumber,paginationOptions.pageSize);
                         }
                         
                          ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                
                                                  $scope.localVars.taskDefList = data.data;
                                                  
                                                
                                                 
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                      //
                      $scope.fd.Search.headerLabel = "Select users or groups";
                      $scope.fd.Search.usersLabel ="Users";
                      $scope.fd.Search.groupsLabel = "Groups";
                      
                  $scope.$watch('fd.Search.taskDefIds',function(newValue,oldValue){
                    
                    if (newValue!=oldValue && newValue!=undefined)
                    {
                     $scope.filter.taskDefIds=$scope.fd.Search.taskDefIds;
                     
                    }
                  });
                   $scope.$watch('fd.Search.taskStatus',function(newValue,oldValue){
                    
                    if (newValue!=oldValue && newValue!=undefined)
                    {
                     $scope.filter.taskStatus=$scope.fd.Search.taskStatus;
                     
                    }
                  });
                      
                      //get task statuses
                      
                       CodesService.getCodesByName('taskstatuses',lang).then(function (data) {
                                $scope.localVars.taskStatuses = data.data;
                             });
             let template;
             if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktTaskListWidget.html');
             else template = $templateCache.get('ktdirectivetemplates/ktTaskListWidgetExe.html');
          
             $element.append($compile(template)($scope));      
          
          }];
          
          
        return {
            restrict: 'A',
            controller:controller,
             link: function (scope, elem, attrs) {
                 
            
              }
        }             
};
'use strict';

export function ktTaskMessage () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskMessage.html',
             controller: function($scope,GridsterService,$sce){
                
                $scope.gsrvc= GridsterService;
                
                if ($scope.localVars == undefined) $scope.localVars={};
                $scope.localVars.ResponseMsg = $sce.trustAsHtml($scope.fd.ResponseMsg);

                },
             
            link: function (scope, elem, attrs) {
                
              
        }       
              
    }
  
};
'use strict';

export function ktTaskProcDirective () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcDirective.html',
            scope: {
                fd: '=',
                localVars: '=',
                taskDefinition:'=',
            },
            controller: function($scope,MessagingService,TaskDataService,PublicTaskDataService,MenuService,$timeout,$rootScope,GridsterService,$stateParams,WidgetDataExchangeService,dragulaService,KatalyoStateManager){
                
                $scope.gsrvc = GridsterService;
                  if ($scope.localVars==undefined) $scope.localVars={};
        if ($scope.fd==undefined) $scope.fd={};
        $scope.localVars.gridsterType = "task";
        $scope.gsrvc.showFooter=true;
        if ($scope.taskDefinition!=undefined && $scope.localVars.previousTask==undefined) $scope.localVars.previousTask= $scope.taskDefinition.task_execute_id;
        else if ($scope.localVars.previousTask==undefined)  $scope.localVars.previousTask=0;
        //if ($scope.taskDefinition==undefined) $scope.taskDefinition =  {};
        $scope.localVars.potentialOwners = {};
        $scope.localVars.potentialOwners.potentialOwnersUsers = [];
        $scope.localVars.potentialOwners.potentialOwnersGroups = [];
           
        $scope.localVars.backCloseIcon = "fa fa-close";
        $scope.localVars.cancelBackBtnTxt = "Cancel";
        $scope.localVars.inlineTaskDefinition={};
        $scope.localVars.inlineTask={};
                   
        $scope.localVars.inlineTask = {
                id: '1',
                name: 'Home',
                widgets: $scope.gsrvc.getEmptyColumn(),
                widgetsOriginal: $scope.gsrvc.getEmptyColumn(),
                data:{}
            };
            
       
      if ($scope.localVars.selectedTasks==undefined) $scope.localVars.selectedTasks = [];
       
      $scope.localVars.selectedTaskIndex=-1;
      if ($scope.fd.type!=undefined)
      {
          if ($scope.fd.type=='itask')
          {
            if ($scope.fd.wItemValue!=null) {
               $scope.localVars.selectedTasks = $scope.fd.wItemValue;
            }else
            {
              $scope.fd.wItemValue = [];
              
            }
          }
          else
          {
              if ($scope.fd.tItemValue!=null) {
               $scope.localVars.selectedTasks = $scope.fd.tItemValue;
              }else
              {
              $scope.fd.tItemValue = [];
              
              } 
              
          }
      }
       
       $scope.ProcessDataFromStartTask = function(data)
       {
        
                if (data.taskdef!=undefined)  $scope.localVars.inlineTaskDefinition = data.taskdef[0];
                if ($scope.taskDefinition!=undefined)
                {
                    $scope.localVars.inlineTaskDefinition.prev_task_id = $scope.taskDefinition.task_execute_id;
                    $scope.localVars.inlineTaskDefinition.prev_task_transaction_id = $scope.taskDefinition.transaction_id;
                    $scope.localVars.inlineTaskDefinition.prev_task_object = $scope.taskDefinition;
                }
                $scope.localVars.inlineTaskDefinition.proc_type = data.procType;
                $scope.localVars.inlineTaskDefinition.form_type = data.formType;
                $scope.localVars.inlineTaskDefinition.transaction_id = data.transactionId;
                $scope.localVars.inlineTaskDefinition.taskExecuteInstance = data.taskExecuteInstance;
                $scope.localVars.inlineTaskDefinition.taskInitiateInstance = data.taskInitiateInstance;
                $scope.localVars.inlineTaskDefinition.inline_task=$scope.localVars.isInlineTask;
                $scope.localVars.inlineTaskDefinition.source_type = $stateParams.src_type;
                $scope.localVars.inlineTaskDefinition.taskFormLoaded = false;
                $scope.localVars.inlineTaskDefinition.inlineInitiateFormLoaded = true;  
                
                if ($scope.localVars.inlineTaskDefinition.taskExecuteInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskExecuteInstance.length>0) $scope.localVars.inlineTaskDefinition.task_execute_id = $scope.localVars.inlineTaskDefinition.taskExecuteInstance[0].id;
                if ($scope.localVars.inlineTaskDefinition.taskInitiateInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskInitiateInstance.length>0) $scope.localVars.inlineTaskDefinition.task_initiate_id = $scope.localVars.inlineTaskDefinition.taskInitiateInstance[0].id;
                
                $scope.localVars.inlineTask.resourceDefinition=data.resourceDefinition;
                $scope.localVars.inlineTask.data = data.form_data;
               
               
                if ($scope.localVars.inlineTask.data==undefined) $scope.localVars.inlineTask.data = {};
                $scope.localVars.inlineTask.widgets.layout= data.widgets;
                if ($scope.localVars.inlineTask.resourceDefinition==undefined) $scope.localVars.inlineTask.resourceDefinition = {};
                $scope.localVars.inlineTask.resourceDefinition.formParams = {formViewType:2,formLocked : true};
                $scope.gsrvc.setFormViewType($scope.localVars.inlineTask.resourceDefinition.formParams.formViewType);
                
                
                $scope.ksm = KatalyoStateManager;
                //define task_closed action from parent task if parent exists
                if ($scope.taskDefinition!=undefined)
                {
                    let taskParentState= $scope.ksm.getSubject("task"+$scope.taskDefinition.transaction_id);
                    let task_closed = function(data)
                    {
                        //textValueState.subject.setStateChanges = data;
                        taskParentState.notifyObservers("task_closed");
                    };
                    
                    let action_task_closed;
                    if (taskParentState!=undefined) action_task_closed = $scope.ksm.addAction(taskParentState.name,"task_closed",task_closed);
                }
                
                
                //Register task with state manager
                let taskState= $scope.ksm.addSubject('task'+$scope.localVars.inlineTaskDefinition.transaction_id,$scope.localVars.inlineTaskDefinition);
                let taskStateName = taskState.subject.name;
                        
                let task_started = function(data)
                {
                    //textValueState.subject.setStateChanges = data;
                    taskState.subject.notifyObservers("task_started");
                };
                        
                let action_task_started = $scope.ksm.addAction(taskStateName,"task_started",task_started);
                
                $scope.ksm.executeAction(taskStateName,"task_started");
                
                let task_initiated = function(data)
                {
                    //textValueState.subject.setStateChanges = data;
                    taskState.subject.notifyObservers("task_initiated");
                };
                        
                let action_task_initiated = $scope.ksm.addAction(taskStateName,"task_initiated",task_initiated);
                
                $scope.$on('RefreshTask'+$scope.localVars.inlineTaskDefinition.transaction_id,function(event,data){

                      $scope.localVars.StartNewTask();
                });
                
                $timeout(function(){
                    $scope.localVars.initiateFormLoaded=true;
                    $scope.localVars.taskInitiated=false;
                    $scope.localVars.isCollapsed3=true;
                },1);      
        
        
        
       }
        $scope.localVars.ProcessMenuClick= function(menuId){
            var lang=$rootScope.globals.currentUser.lang;
          
          
           if (menuId!=0)
           {
              $scope.localVars.initiateFormLoaded=false;
              MenuService.ProcessMenuClick(menuId).then(function(data) {
                                
                                $scope.ProcessDataFromStartTask(data);                            
                                 
     
                              },function(error){
                                
                                  if (error.msg!=undefined) MessagingService.addMessage(error.msg,'error');
                                  else MessagingService.addMessage(error,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
           }
        };
       
       $scope.localVars.GetExecuteTaskByExeId= function(task_execute_id,task_initiate_id){
            var lang=$rootScope.globals.currentUser.lang;
          
          
           if (task_execute_id>0)
           {
              
              TaskDataService.preExecuteTask(task_initiate_id,task_execute_id,lang).then(function(data) {
                                
                                $scope.ProcessDataFromStartTask(data.data);                            
                                 
     
                              },function(error){
                                
                                  if (error.msg!=undefined) MessagingService.addMessage(error.msg,'error');
                                  else MessagingService.addMessage(error,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
           }
        };
         
       if ($scope.localVars.processMenuClicked) $scope.localVars.ProcessMenuClick($scope.localVars.menuId);
       
       
         $scope.localVars.StartTask = function(taskId,outcomeId,previousTaskId){
                var lang=$rootScope.globals.currentUser.lang;
                if (outcomeId==undefined || outcomeId=="") outcomeId=0;
                if (previousTaskId==undefined || previousTaskId=="") previousTaskId=0;
               
                if (taskId!=0)
                {
                    $scope.localVars.initiateFormLoaded=false;
                    
                    TaskDataService.StartTask(taskId,outcomeId,previousTaskId).then(function(data) {
                                
                                  
                                  if (Object.keys(data.data).length==0 || data.data==null || data.data==undefined)
                                  {
                                    MessagingService.addMessage('Task processing error. Task data is empty! --> Check task definition --> Task id = '+taskId,'error');
                                  }
                                  else
                                  {
                                    
                                    $scope.ProcessDataFromStartTask(data.data);
                                                                     }
                              },function(error){
                                
                            
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
                }
          };
        
         $scope.localVars.StartPublicTask = function(organisationId,taskName,taskId,outcomeId,previousTaskId){
                if (organisationId==undefined || organisationId=="") organisationId=0;
                if (outcomeId==undefined || outcomeId=="") outcomeId=0;
                if (previousTaskId==undefined || previousTaskId=="") previousTaskId=0;
                if (taskId==undefined || taskId=="") taskId=0;
                if (taskName==undefined) taskName="";
                if ((taskId!=0 || taskName!="") && organisationId>0)
                {
                  PublicTaskDataService.StartTask(organisationId,taskName,taskId,outcomeId,previousTaskId).then(function(data) {
                                
                                   
                                  $scope.localVars.inlineTaskDefinition = data.data.taskdef[0];
                                  if ($scope.taskDefinition!=undefined) $scope.localVars.inlineTaskDefinition.prev_task_id = $scope.taskDefinition.task_execute_id;
                                  $scope.localVars.inlineTaskDefinition.proc_type = data.data.procType;
                                  $scope.localVars.inlineTaskDefinition.form_type = data.data.formType;
                                  $scope.localVars.inlineTaskDefinition.transaction_id = data.data.transactionId;
                                  $scope.localVars.inlineTaskDefinition.inline_task=$scope.localVars.isInlineTask;
                                  $scope.localVars.inlineTaskDefinition.source_type = $stateParams.src_type;
                                  $scope.localVars.inlineTaskDefinition.taskFormLoaded = false;
                                  $scope.localVars.inlineTaskDefinition.taskExecuteInstance = data.data.taskExecuteInstance;
                                  $scope.localVars.inlineTaskDefinition.taskInitiateInstance = data.data.taskInitiateInstance;
                                  $scope.localVars.inlineTaskDefinition.inlineInitiateFormLoaded = true;  
                                  
                                  if ($scope.localVars.inlineTaskDefinition.taskExecuteInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskExecuteInstance.length>0) $scope.localVars.inlineTaskDefinition.task_execute_id = $scope.localVars.inlineTaskDefinition.taskExecuteInstance[0].id;
                                  if ($scope.localVars.inlineTaskDefinition.taskInitiateInstance!=undefined && $scope.localVars.inlineTaskDefinition.taskInitiateInstance.length>0) $scope.localVars.inlineTaskDefinition.task_initiate_id = $scope.localVars.inlineTaskDefinition.taskInitiateInstance[0].id;
                                  
                                  $scope.localVars.inlineTask.resourceDefinition=data.data.resourceDefinition;
                                  $scope.localVars.inlineTask.data = data.data.form_data;
                                  if ($scope.localVars.inlineTask.data==undefined) $scope.localVars.inlineTask.data = {};
                                  $scope.localVars.inlineTask.widgets.layout= data.data.widgets;
                                  $scope.localVars.inlineTask.resourceDefinition.formParams = {formViewType:2,formLocked : true};
                                  $scope.localVars.taskInitiated = false;                 
                                  
                                    $timeout(function(){
                                      $scope.localVars.initiateFormLoaded=true;
                                      $scope.localVars.isCollapsed3=true;
                                    },1);   
     
                              },function(error){
                                
                            
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.localVars.inlineTask.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
                }
          };
        
          
        if ($scope.localVars.loadTaskDirect) $scope.localVars.StartTask($scope.localVars.taskId,$scope.localVars.outcomeId,$scope.localVars.previousTask);
          
        if ($scope.localVars.processStartTask || $scope.localVars.autoSearch) $scope.localVars.StartTask($scope.localVars.menuId,$scope.localVars.outcomeId,$scope.localVars.previousTask);
        
        if ($scope.localVars.publicTask) $scope.localVars.StartPublicTask($scope.localVars.organisationId,$scope.localVars.publicTaskName,$scope.localVars.publicTaskId,$scope.localVars.outcomeId,$scope.localVars.previousTask);
              
                },
            
             link: function (scope, elem, attrs) {
       
       
       
      
        }
      }
};
'use strict';

export function ktTaskProcExecute () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcExecute.html',
            scope:{
                   taskDefinition : "=",
                   dashboard: "=",
                   resourceDefinition:"=",
                   taskExecuteInstance: "=",
                   taskInitiateInstance: "=",
                   localVars: "=",
                   
      			},
                controller: function($scope,$stateParams,$cookies,$rootScope,TaskDataService,GridsterService,MessagingService){
                    
                     
                if ($scope.fd==undefined) $scope.fd={};
                if ($scope.lVars==undefined) $scope.lVars={};
                $scope.gsrvc = GridsterService;
                 var lang=$rootScope.globals.currentUser.lang;
                 if ($scope.localVars==undefined) $scope.localVars={};
                 $scope.lVars.isCollapsed3=true;
                 $scope.taskOutcomes = $scope.localVars.taskOutcomes;   
                 $scope.executeTaskDataLoaded=false;
                 
                $scope.fromStateName=$stateParams.fromStateName;
                $scope.fromStateParams=$stateParams.fromStateParams;
                $scope.cookieFromStateName=$cookies.getObject('executeTaskFromStateName');
                $scope.cookieFromStateParams=$cookies.getObject('executeTaskFromStateParams');
                $scope.noBackbutton = false;
                $scope.backBtnFromCookie=false;
                
            
               if ($scope.taskInitiateInstance.length>0)
               {
                $scope.task_initiate_id = $scope.taskInitiateInstance[0].id;
                $scope.taskDefinition.taskInitiateInstance = $scope.taskInitiateInstance[0];
               }
               else $scope.task_initiate_id = 0;
               
               if ($scope.taskExecuteInstance.length>0)
               {
                $scope.task_execute_id = $scope.taskExecuteInstance[0].id;
                $scope.taskDefinition.taskExecuteInstance = $scope.taskExecuteInstance[0];
               }
               else $scope.task_execute_id=0;
                if ($scope.fromStateName==undefined || $scope.fromStateName=="")
                {
                    if ($scope.cookieFromStateName==undefined || $scope.cookieFromStateName=="")
                    {
                      $scope.noBackButton = true;
                    }else
                    {
                      $scope.fromStateName =  $scope.cookieFromStateName;
                      $scope.backBtnFromCookie = true;
                    }
                    
                  
                }else{
                  $cookies.putObject('executeTaskFromStateName',$scope.fromStateName);
                  
                }
                
                if ($scope.fromStateParams==undefined)
                {
                    if ($scope.cookieFromStateParams!=undefined)
                    {
                        if ($scope.backBtnFromCookie)
                        {
                          $scope.fromStateParams =  $scope.cookieFromStateParams;
                        }
                    }
                    
                }else if ($scope.cookieFromStateParams==undefined)
                {
                  $cookies.putObject('executeTaskFromStateParams',$scope.fromStateParams);
                  
                }else
                {
                    if ($scope.backBtnFromCookie)
                    {
                  
                      $scope.fromStateParams =  $scope.cookieFromStateParams;
                  
                    }else
                    {
                        $cookies.putObject('executeTaskFromStateParams',$scope.fromStateParams);    
                    }
                }
                
                $scope.gridsterType="task";
                //$scope.gridsterExeFormOpts = GridsterService.getGridsterOptions();
                $scope.formType="e";
               
                $scope.isCollapsedTaskDetails=true;
                
                $scope.lVars.changeIsCollapsed3 = function()
                    {
                     if ($scope.lVars.isCollapsed3) $scope.lVars.isCollapsed3 = false;
                     else $scope.lVars.isCollapsed3 = true;
               
                    }
                
                
                $scope.setForm = function(form)
                    {
                        $scope.forma = form;
               
                    }
                
                $scope.FormLockUnlock = function()
                {
                  $scope.resourceDefinition.formParams.formLocked=!$scope.resourceDefinition.formParams.formLocked;
               
                }
                
                $scope.goBack = function(){
                                    $state.go($scope.fromStateName,$scope.fromStateParams);
                             
                };
                
                $scope.returnToPreviousTask = function(){
                
                    $scope.gsrvc.setOpenTaskInNewPage(false);
                             
                };
                
                
                $scope.fd.CancelClicked = function()
                {
                       $scope.taskDefinition.proc_type = 0;
                       $scope.taskDefinition.inlineInitiateFormLoaded=false;
                       $scope.taskDefinition.showInlineTask = false;
                       $scope.localVars.showInlineTask = false;
                       $scope.taskDefinition.inlineTaskInitiated = false;
                       $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
                };
            
                
                
                $scope.ExecuteTaskAction = function(action){
                     
                     
                        var lang=$rootScope.globals.currentUser.lang;
                      
                       TaskDataService.ExecuteTaskAction($scope.localVars.task_initiate_id,$scope.localVars.task_execute_id,action,lang).then(function(data) {
                 
                                             
                                              $scope.taskInitiateInstance =data.data.data.taskInitiateInstance[0];
                                              $scope.taskExecuteInstance =data.data.data.taskExecuteInstance[0];
                                              if ($scope.taskExecuteInstance!=undefined)
                                                {
                                                $scope.taskDefinition.task_execute_id = $scope.taskExecuteInstance.id;
                                             
                                                }
                                                
                                              if (action=="claim")
                                              
                                              {
                                                //$scope.pageChanged();
                                                $rootScope.$broadcast('RefreshData0',data.data.ret_value);
                                              }
                                              
                                              MessagingService.addMessage(data.data.msg,'success');
                                             
               
                                        },function(error){
                                          
                                      
                                            MessagingService.addMessage(error.msg,'error');
                                      });
                }
                
                
                 $scope.$on('ExecuteTask'+$scope.task_execute_id,function(event,data){
                        $scope.localVars.ExecuteTask(data.outcomeId);
                    });
                
                
                
                
                $scope.localVars.ExecuteTask = function(outcomeId){
                        
                        
                    var lang=$rootScope.globals.currentUser.lang;
                    let form = $scope.forma;  
                    //$rootScope.$broadcast('ProcessTaskWidgets',{});
                    if (form.$submitted) $scope.localVars.setSubmitted(form);
                    if (form.$valid) {
                      
                      
                        TaskDataService.executeTask($scope.task_execute_id,$scope.dashboard.data,outcomeId,lang).then(function(data) {
                                      
                                  MessagingService.addMessage(data.data.msg,'success');
                                  $rootScope.$broadcast('ExecuteTaskPostProcess',data.data.ret_value);
                                },function(error){
                                  
                                  MessagingService.addMessage(error.msg,'error');           
                                            
                        });
                          
                    } // if (isValid)
                    else
                    {
                      MessagingService.addMessage("Please enter required data",'warning');
                      
                    }
                };
                   // 
               
               $scope.localVars.setSubmitted = function (form) {
                  form.$setSubmitted();
                  angular.forEach(form, function(item) {
                  if(item && item.$$parentForm === form && item.$setSubmitted) {
                      $scope.localVars.setSubmitted(item);
                  }
                  });
                } 
                    
                    },
             link: function (scope, elem, attrs) {
                
                
              }
        }             
};
'use strict';

export function ktTaskProcInitiate () {
             var controller = ['$scope', '$stateParams','$state','UserService','ResourcesDataService','$rootScope','ProcessingService','$timeout','$cookies','CodesService','KatalyoStateManager',
              'WidgetDataExchangeService','TaskDataService','TaskProcService','MessagingService','GridsterService', '$window',
                               function ($scope,$stateParams,$state,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$cookies,CodesService,KatalyoStateManager,
              WidgetDataExchangeService,TaskDataService,TaskProcService,MessagingService,GridsterService, $window) {
          
                 if ($scope.localVars==undefined) $scope.localVars={};
          
          $scope.localVars.isCollapsed3=true;  
          //$scope.localVars = {dashboard:{}};
          $scope.localVars.autoInitiate=false;
          $scope.localVars.showTask = true;
          if ($scope.localVars.previousTask==undefined) $scope.localVars.previousTask = 0;
          var aParams = {};
          var pTaskPackage={};
          $scope.gsrvc = GridsterService;
          if ($scope.fd!=undefined)
          {
              $scope.$on('ProcessTask'+ $scope.fd.presentationId,function(event,data){
                  if ($scope.localVars.inlineTaskDefinition==undefined) $scope.localVars.inlineTaskDefinition={task_execute_id : data.task_execute_id};
                  else if ($scope.localVars.inlineTaskDefinition.task_execute_id==undefined) $scope.localVars.inlineTaskDefinition.task_execute_id = data.task_execute_id;
                  
                  $scope.localVars.StartTask(data.taskId,data.outcomeId);
              });
          }
          
          /*
           $scope.localVars.StartTask = function(taskId,outcomeId,previousTaskId){
                var lang=$rootScope.globals.currentUser.lang;
                if (outcomeId==undefined || outcomeId=="") outcomeId=0;
                if (previousTaskId==undefined || previousTaskId=="") previousTaskId=0;
                TaskDataService.StartTask(taskId,outcomeId,previousTaskId).then(function(data) {
                                
                                   
                                  $scope.taskDefinition = data.data.taskdef[0];
                                  $scope.taskDefinition.prev_task_id = $scope.localVars.previousTask;
                                  $scope.taskDefinition.proc_type = data.data.procType;
                                  $scope.taskDefinition.form_type = data.data.formType;
                                  $scope.taskDefinition.transaction_id = data.data.transactionId;
                                  $scope.taskDefinition.inline_task=$scope.localVars.isInlineTask;
                                  $scope.taskDefinition.source_type = $stateParams.src_type;
                                  $scope.taskDefinition.taskFormLoaded = false;
                                  $scope.taskDefinition.taskExecuteInstance = data.data.taskExecuteInstance;
                                  $scope.taskDefinition.taskInitiateInstance = data.data.taskInitiateInstance;
                                  $scope.taskDefinition.inlineInitiateFormLoaded = true;  
                                  
                                  if ($scope.taskDefinition.taskExecuteInstance!=undefined && $scope.taskDefinition.taskExecuteInstance.length>0) $scope.taskDefinition.task_execute_id = $scope.localVars.inlineTaskDefinition.taskExecuteInstance[0].id;
                                  if ($scope.taskDefinition.taskInitiateInstance!=undefined && $scope.taskDefinition.taskInitiateInstance.length>0) $scope.taskDefinition.task_initiate_id = $scope.localVars.inlineTaskDefinition.taskInitiateInstance[0].id;
                                  
                                  $scope.resourceDefinition=data.data.resourceDefinition;
                                  $scope.dashboard.data = data.data.form_data;
                                  if ($scope.dashboard.data==undefined) $scope.dashboard.data = {};
                                  $scope.dashboard.widgets= data.data.widgets;
                                  $scope.resourceDefinition.formLocked = {formViewType:2,formLocked : true};
                                  $scope.localVars.taskInitiated=false;
                                     
     
                              },function(error){
                                
                            
                                  MessagingService.addMessage(error.msg,'error');
                                  $scope.dashboard.taskProcResponse = {status : error.status,msg:error.msg};
                                  
                            });
          };
         */
             // $scope.localVars.StartTask ($scope.localVars.taskDefId,$scope.localVars.outcomeId,$scope.localVars.prevTaskId);
              
                var lang=$rootScope.globals.currentUser.lang;
               
                $scope.localVars.initiateFormLoaded=false;
                $scope.isSaving=false;
                $scope.previousTask=$scope.taskDefinition.prev_task_id;
                $scope.previousTaskOutcomeId=$stateParams.outcome_id;
                $scope.previousTaskPackage=$stateParams.prev_task_package; 
                $scope.gridsterType="task";
                $scope.showSearchFilters=false;      
                //$scope.dashboard = {widgets : []};
                if ($scope.previousTaskOutcomeId=="") $scope.previousTaskOutcomeId = 0;
                
                $scope.fromStateName=$stateParams.fromStateName;
                $scope.fromStateParams=$stateParams.fromStateParams;
                $scope.cookieFromStateName=$cookies.getObject('initiateTaskFromStateName');
                $scope.cookieFromStateParams=$cookies.getObject('initiateTaskFromStateParams');
                $scope.noBackbutton = false;
                $scope.backBtnFromCookie=false;
      
      
  
                $scope.removeField = function (index){
						
                  if (index > -1) {
						 
                 $scope.inputArray.layout.splice(index, 1);
						 
                  }

                }   

 
 
    
          $scope.InititateAllList = function(){
      
            
              ResourcesDataService.getResourceDefByType(lang,'task').then(function(data) {
                                
                                  $scope.gridOptions.data = data.data;
                                   
                                 
                               },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
          }
        
    
   
      $scope.InititateMyList = function(){
      
         
              ResourcesDataService.getResourceDefListByLangByTypeUser(lang,'task').then(function(data) {
                                
                                 $scope.gridOptions.data = data.data;
                                 
                              },function(error){
                                
                                  MessagingService.addMessage(error.msg,'error');
                            });
    
          
    };   
    
   
     
      
     
      if ($scope.fromStateName==undefined || $scope.fromStateName=="")
      {
          if ($scope.cookieFromStateName==undefined || $scope.cookieFromStateName=="")
          {
            $scope.noBackButton = true;
          }else
          {
            $scope.fromStateName =  $scope.cookieFromStateName;
            $scope.backBtnFromCookie = true;
          }
          
        
      }else{
        $cookies.putObject('initiateTaskFromStateName',$scope.fromStateName);
        
      }
      
      if ($scope.fromStateParams==undefined)
      {
          if ($scope.cookieFromStateParams!=undefined)
          {
              if ($scope.backBtnFromCookie)
              {
                $scope.fromStateParams =  $scope.cookieFromStateParams;
              }
          }
          
      }else if ($scope.cookieFromStateParams==undefined)
      {
        $cookies.putObject('initiateTaskFromStateParams',$scope.fromStateParams);
        
      }else
      {
          if ($scope.backBtnFromCookie)
          {
        
            $scope.fromStateParams =  $scope.cookieFromStateParams;
        
          }else
          {
              $cookies.putObject('initiateTaskFromStateParams',$scope.fromStateParams);    
          }
      }
      
      
       if ($scope.previousTask==undefined || $scope.previousTask=="")
          {
           // $state.go();
            
            $scope.previousTask = 0;
            
          }
      $scope.potentialOwners = {};
      

      
    //WidgetDataExchangeService.deRegisterAllWidgets();	//Migor - cistim taskwidgetRegistry 

      $scope.localTaskId=WidgetDataExchangeService.registerTask($scope.taskDefId);
      
     // $scope.taskDefinition ={};
      $scope.potentialOwners.potentialOwnersUsers = [];
      $scope.potentialOwners.potentialOwnersGroups = [];
      
         $scope.FormLockUnlock = function()
      {
        $scope.resourceDefinition.formParams.formLocked=!$scope.resourceDefinition.formParams.formLocked;

     
      };
     
      $scope.menuId = $stateParams.id;
      var lang=$rootScope.globals.currentUser.lang;
      
        $scope.localVars.NewTask = function(taskId)
        {
             $scope.localVars.inlineTask.widgets.layout=angular.copy($scope.localVars.inlineTask.widgetsOriginal);
             $scope.taskDefinition.inlineTaskInitiated=false;
        };
          
        $scope.localVars.StartNewTask = function()
        {
             $scope.localVars.StartTask($scope.taskDefinition.ResourceDefId_id,0,0);
             
        };
        
        $scope.returnToPreviousTask = function(){
             
             
             $scope.ksm=KatalyoStateManager;
             let taskStateName = "task"+$scope.taskDefinition.prev_task_transaction_id;
                         
             $scope.ksm.executeAction(taskStateName,"task_closed");
             
             $scope.gsrvc.setOpenTaskInNewPage(false);
                             
        };       
          $scope.localVars.CancelClicked = function()
          {
             if ($scope.localVars.fromOutcome  && !$scope.taskDefinition.inline_task)
             {
              $scope.localVars.executeTaskDataLoaded=false;
              if ($scope.localVars.pageChanged!=undefined) $scope.localVars.pageChanged();
             }
             $scope.taskDefinition.proc_type=0;
             $scope.taskDefinition.inlineInitiateFormLoaded=false;
             $scope.taskDefinition.showInlineTask = false;
             $scope.taskDefinition.inlineTaskInitiated = false;
            /*
             $scope.localVars.proc_type=0;
             $scope.localVars.inlineInitiateFormLoaded=false;
             $scope.localVars.showInlineTask = false;
             $scope.localVars.inlineTaskInitiated = false;
             */
             $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
             if (!$scope.taskDefinition.inline_task) $window.history.back();
          };
      
      
       $scope.localVars.AutoInitiateTask = function(){
        var lang=$rootScope.globals.currentUser.lang;
        //  if (isValid) {
        var parentDataset=$scope.localVars.getPreviousTaskWidget();
        if ($scope.previousTaskOutcomeId==undefined) $scope.previousTaskOutcomeId=0;
          
          TaskDataService.initiateTask($scope.taskDefinition.ResourceDefId_id,$scope.previousTask,$scope.previousTaskOutcomeId,[],$scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
                                    
                                    $scope.task_initiate_id = data.data.task_initiate_id;
                                    $scope.task_execute_id = data.data.task_execute_id;
                                    //$state.go('app.menu.tasks.execute',{id: $scope.taskDefId,task_initiate_id:$scope.task_initiate_id,task_execute_id:$scope.task_execute_id,fromStateName:$scope.fromStateName,fromStateParams:$scope.fromStateParams,prev_task_package:$scope.previousTaskPackage,prev:$scope.taskExecuteId});
                                   
                                  
                              },function(error){
                                    
                                  MessagingService.addMessage(error.msg,'error');
                            });
         // }
      };
      
      $scope.$on('CloseTaskForm'+$scope.taskDefinition.transaction_id,function(event,data){
                  
                  $scope.localVars.showTask = false;
                  $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
       });
      
       $scope.localVars.InitiateTask = function(form){
        var f = $scope.forma;
        
        if (form.$submitted) $scope.localVars.setSubmitted(form);
        if (form.$valid) {
            
            //var initiateData={};
            $rootScope.$broadcast('ProcessTaskWidgets',{}); //svi widgeti slusaju ovaj event
            $scope.isSaving = true;
            var lang=$rootScope.globals.currentUser.lang;
            if ($scope.previousTaskOutcomeId==undefined) $scope.previousTaskOutcomeId=0;
            //ako je prethodni task imao listu povuci WidgetData
            var parentDataset=$scope.localVars.getPreviousTaskWidget("resourceLinkDatasetList");
      
            if (parentDataset['datasetId']==undefined || parentDataset['datasetId']=="") parentDataset['datasetId'] = 0;
            if (parentDataset['datasetRecordId']==undefined || parentDataset['datasetRecordId']=="") parentDataset['datasetRecordId'] = 0;
            let resource_def_id = $scope.taskDefinition.ResourceDefId;
            if (resource_def_id==undefined) resource_def_id = $scope.taskDefinition.ResourceDefId_id;
                TaskDataService.InitiateTask(resource_def_id,$scope.taskDefinition.transaction_id,$scope.dashboard.data,$scope.potentialOwners,parentDataset['datasetId'],parentDataset['datasetRecordId'],lang).then(function(data) {
                                
					
                                  MessagingService.addMessage(data.data.msg,'success');
                                  $rootScope.$broadcast('InitiateTaskPostProcess'+$scope.taskDefinition.transaction_id,data.data);
                                  //ovo treba staviti u event InitiateTaskPostProcessFinished
                                   if (data.data.taskInitiateInstance!=undefined)
                                    {
                                    if (data.data.taskInitiateInstance.length>0)
                                        $scope.taskDefinition.taskInitiateInstance = data.data.taskInitiateInstance[0];
                                    }
                                    if (data.data.ret_value!=undefined)
                                    {
                                       if(data.data.ret_value.length>0)
                                       {
                                                    if (data.data.ret_value[0].eosResponse!=null && data.data.ret_value[0].eosResponse!=undefined) $scope.eosResponse = JSON.stringify(data.data.ret_value[0].eosResponse,null,2);
                                                    if (data.data.ret_value[0].eosResponse2!=null && data.data.ret_value[0].eosResponse2!=undefined) $scope.eosResponse2 = JSON.stringify(data.data.ret_value[0].eosResponse2,null,2);
                                       }
                                    }
                                  //execute action task_initiated
                                  $scope.ksm = KatalyoStateManager;
                                  let taskStateName = "task"+$scope.taskDefinition.transaction_id;
                                  $scope.ksm.executeAction(taskStateName,"task_initiated");
                                  
                                  if (data.data.restart_task!=null && data.data.restart_task!=undefined)
                                  
                                  {
                                       $scope.taskDefinition.transaction_id = data.data.restart_task.data.transactionId;
                                       
                                       $scope.$on('CloseTaskForm'+$scope.taskDefinition.transaction_id,function(event,data){
                  
                                                    $scope.localVars.showTask = false;
                                                    $scope.$emit('InlineTaskClosed',$scope.localVars.taskId);
                                       });
                                  }
                                                                  
                                  
                                  $scope.$emit('RefreshData'+ $scope.taskDefinition.prev_task_id,$scope.taskDefinition.ResourceDefId_id); 
                                  $scope.localVars.taskInitiated=true;
                                  if (data.data.task_execute_id>0)
                                  {
                                       if (data.data.taskdef[0].Parameters!=null && data.data.taskdef[0].Parameters!=undefined)
                                       {     
                                            if (data.data.taskdef[0].Parameters.AutoLoadExeForm)
                                            {
                                                         $scope.localVars.GetExecuteTaskByExeId(data.data.task_execute_id,data.data.task_initiate_id);  
                                            }
                                       }
                                  }
     
                              },function(error){
                                 // $scope.isSaving = false;    
                                  MessagingService.addMessage(error.msg,'error');
                            });
                          
                          $scope.isSaving = false;  
						
			
							
          } // if (isValid)
          else
          {
            MessagingService.addMessage("Please correct invalid entries",'warning');
            
          }
      };

    $scope.localVars.getPreviousTaskWidget  = function(deiType)
    {
      var pTaskPkg = WidgetDataExchangeService.getPrevTaskData($scope.taskDefinition.prev_task_id);
             var datasetId=0,datasetRecordId=0,pTaskData,pTaskDataArray;
             if (!Array.isArray(pTaskPkg))
             {
                          pTaskDataArray = [pTaskPkg];
             }else
             {
                          pTaskDataArray = pTaskPkg;        
             }
             for (let l=0;l<pTaskDataArray.length;l++)
             {
                          pTaskData = pTaskDataArray[l];
                          if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
                          {
                          for (var i=0;i<pTaskData.DEI.length;i++)
                          {
                            if (pTaskData.DEI[i].name==deiType)
                            {
                              if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                              {
                                for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                                {
                                 if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                                 if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                                 
                                  
                                }
                                   
                                  
                              }
                                
                            }
                              
                            }
                          }
             }
            
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };
        $scope.localVars.setSubmitted = function (form) {
          form.$setSubmitted();
          angular.forEach(form, function(item) {
            if(item && item.$$parentForm === form && item.$setSubmitted) {
              $scope.localVars.setSubmitted(item);
            }
          });
        }     
          
          }];
          
          
        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcInitiate.html',
            scope:{
                   taskDefinition : "=",
                   dashboard: "=",
                   resourceDefinition:"=",
                   localVars: "=",
      			},
            controller:controller,
          
             link: function (scope, elem, attrs) {
                 
               
                    
       
             
    }
  }             
};
'use strict';

export function ktTaskProcList () {
             var controller = ['$scope', '$stateParams','$state','UserService','ResourcesDataService','$rootScope','ProcessingService','$timeout','$cookies','CodesService','WidgetDataExchangeService','TaskDataService','MessagingService','GridsterService',
                               function ($scope,$stateParams,$state,UserService,ResourcesDataService,$rootScope,ProcessingService,$timeout,$cookies,CodesService,WidgetDataExchangeService,TaskDataService,MessagingService,GridsterService) {
          
                  
          
          }];
          
          
        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskProcList.html',
            controller:controller,
             link: function (scope, elem, attrs) {
                 
             var lang=$rootScope.globals.currentUser.lang;
                
                    scope.localVars = {};                      
                    scope.stateName=$state.current.name;
                    scope.stateParams = $state.current.params;
                    scope.task_initiate_id=$stateParams.task_initiate_id;
                    scope.task_execute_id=$stateParams.task_execute_id;
                                    
                     scope.is_superuser =  $rootScope.globals.currentUser.is_superuser;
                   
                    scope.gridOptions = {
                      data:[],
                    enableGridMenu: true,
                    //showGridFooter: true,
                    //showColumnFooter: true,
                    enableRowSelection: true,
                    multiSelect: false,
                    enableHorizontalScrollbar : 0, 
                    enableVerticalScrollbar : 2,
                    //enableFiltering: true,
                    enableRowHeaderSelection: true,
                    enableColumnResizing: true,
                    useExternalPagination: true,
                    paginationPageSizes: [10, 25, 50,100,200,500,1000],
                    enablePaginationControls: false,
                    //paginationPageSize: 10,
                    //useExternalSorting : true,
                    //useExternalFiltering: true,
                   // minRowsToShow : 3
                   };
                    
                  var paginationOptions = {
                    pageNumber: 1,
                    pageSize: 10,
                    sort: null
                    };
                    
                    var columnDefsInitiate = [
                        { name: 'TaskInitiationId.id', displayName: 'ID', type: 'number', width:'5%',enableHiding: false, visible: true },
                        { name: 'TaskInitiationId.InitiatorId.name', displayName: 'Started by'},
                        { name: 'TaskInitiationId.Status.CodesDetailLang[0].Value', displayName: 'Task status' },
                        { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Name', displayName: 'Task name' },
                        { name: 'TaskInitiationId.Resourcedef.resourcedeflang_set[0].Description', displayName: 'Task description' },
                        { name: 'TaskInitiationId.Resourcedef.id', displayName: 'Task def id',enableHiding: false,visible: false },
                        { name: 'TaskInitiationId.CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                        { name: 'TaskInitiationId.CreatedBy.name', displayName: 'Created by'},
                        { name: 'ForGroup.name', displayName: 'For group'},
                        ];
                    
                   var columnDefsExecute = [
                         { name: 'id', displayName: 'Task Execute ID', type: 'number', width:'10%',enableHiding: false, visible: true },
                         { name: 'resourcedef.resourcedeflang_set[0].Name', displayName: 'Task name' },
                         { name: 'resourcedef.resourcedeflang_set[0].Description', displayName: 'Task description' },
                         { name: 'actualOwner.name', displayName: 'Task Owner'},
                         { name: 'status.CodesDetailLang[0].Value', displayName: 'Task status' },
                         { name: 'outcome.TaskOutcomesDetailLang_taskoutcomedetailid[0].DisplayName', displayName: 'Task outcome' },
                         { name: 'resourcedef.id', displayName: 'Task def id',enableHiding: false,visible: false },
                         { name: 'CreatedDateTime', displayName: 'Date created',enableHiding: false,type: 'date', cellFilter: 'date:\'dd.MM.yyyy HH:mm:ss:sss\'' },
                         { name: 'createdBy.name', displayName: 'Created by'},
                         ];   
                   
                    scope.task_execute_id = 0;
                   scope.task_initiate_id = 0;
                    
                    if (scope.fd===undefined) scope.fd={};
                    if (scope.fd.search===undefined || scope.fd.search===null) scope.fd.search = {};
                   //ovo treba prilagoditi
                   if (scope.fd.search.taskListType==undefined) scope.fd.search.taskListType="claim";
                      
                      
                    
                     scope.gridOptions.onRegisterApi = function (gridApi) {
                        scope.gridApi = gridApi;
                        gridApi.selection.on.rowSelectionChanged(scope,function(row){
                         scope.taskSelected=row.isSelected
                       
                         if(row.isSelected){
                           
                               if (scope.fd.search.taskListType=="execute")
                               {
                                scope.selectedTask=row.entity.id
                                scope.task_execute_id = scope.selectedTask;
                                scope.selectedTaskDefId=row.entity.resourcedef.id
                                scope.selectedTaskObject = row.entity;  
                               }
                               else
                               {
                                scope.selectedTask=row.entity.TaskInitiationId.id
                                scope.task_initiate_id = scope.selectedTask;
                                scope.selectedTaskDefId=row.entity.TaskInitiationId.Resourcedef.id
                                scope.selectedTaskObject = row.entity.TaskInitiationId;  
                               }
                               
                            }
                        });
                        
                        //external pagination
                      gridApi.pagination.on.paginationChanged(scope, function (newPage, pageSize) {
                          paginationOptions.pageNumber = newPage;
                          paginationOptions.pageSize = pageSize;
                          scope.ExecuteAllListPaginatedFilter(scope.fd.search.taskListType,1,false,"",scope.localVars.nextPage,scope.localVars.previousPage,newPage,pageSize,$scope.fd.search);
                      });
                      
                       gridApi.core.on.filterChanged(scope, function() {
                           // Set some scope variable that both lists use for filtering
                          // scope.someFilterValueBothListsLookAt = ......
                       });
                
                      
                     }
                      
                    scope.removeField = function (index){
						
                        if (index > -1) {
						 
                           scope.inputArray.layout.splice(index, 1);
						 
                        }

                  }
                
                    scope.ClaimSelected = function(){
                              
                              
                            var lang=$rootScope.globals.currentUser.lang;
                             TaskDataService.ExecuteTaskAction(scope.selectedTask,0,'claim',lang).then(function(data) {
                       
                                                   
                                                    
                                                    //refresh liste task-ova za claim
                                                    scope.ExecuteAllList(scope.fd.search.taskListType,1,true,data.data.msg);
                                                   
                                              },function(error){
                                                
                                            
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                      } 
                    
                    scope.ExecuteAllList = function(type,filter,afterClaim,msgAfter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      TaskDataService.getInitiatedTasks(type,filter).then(function(data) {
                                                
                                                  scope.gridOptions.data = data.data.results;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    
                  
                  scope.ExecuteAllListPaginated = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      if (Math.ceil(scope.totalCount/pageSize)<newPage)
                      {
                        newPage = Math.ceil(scope.totalCount/pageSize);
                      }
                      TaskDataService.getInitiatedTasksPaginated(type,filter,urlNext,urlPrev,newPage,pageSize).then(function(data) {
                                                
                                                  scope.gridOptions.data = data.data.results;
                                                  scope.nextPage = data.data.next;
                                                  scope.previousPage = data.data.previous;
                                                  scope.totalCount=data.data.count;
                                                  scope.currentPage=newPage;
                                                  scope.numPages = Math.ceil(scope.totalCount/pageSize);
                                                  scope.pageSize = pageSize;
                                                  scope.gridOptions.totalItems=scope.totalCount;
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                    
                    
                    scope.ExecuteAllListPaginatedFilter = function(type,filter,afterClaim,msgAfter,urlNext,urlPrev,newPage,pageSize,f_filter){
                      
                      var lang=$rootScope.globals.currentUser.lang;
                      
                      
                      if (scope.fd.search.taskListType=="claim")
                      {
                        scope.gridOptions.columnDefs = columnDefsInitiate;
                      }
                    
                         if (scope.fd.search.taskListType=="execute")
                      {
                        scope.gridOptions.columnDefs = columnDefsExecute;
                      }
                    
                      
                      
                      if (Math.ceil(scope.localVars.totalCount/pageSize)<newPage)
                      {
                        newPage = Math.ceil(scope.localVars.totalCount/pageSize);
                      }
                      scope.gridOptions.data.length=0;
                      TaskDataService.getInitiatedTasksPaginatedFiltered(type,filter,urlNext,urlPrev,newPage,pageSize,f_filter).then(function(data) {
                                                
                                                  scope.gridOptions.data = data.data.results;
                                                  scope.localVars.nextPage = data.data.next;
                                                  scope.localVars.previousPage = data.data.previous;
                                                  scope.localVars.totalCount=data.data.count;
                                                  scope.localVars.currentPage=newPage;
                                                  scope.localVars.numPages = Math.ceil(scope.localVars.totalCount/pageSize);
                                                  scope.localVars.pageSize = pageSize;
                                                  scope.gridOptions.totalItems=scope.localVars.totalCount;
                                                  if (scope.localVars.totalCount==1)
                                                  {
                                                    if (scope.fd.search.taskListType=="execute")
                                                      {
                                                       scope.task_execute_id = scope.gridOptions.data[0].id;
                                                         
                                                      }
                                                      else
                                                      {
                                                       scope.task_initiate_id = scope.gridOptions.data[0].TaskInitiationId.id;
                                                       
                                                      }
                                                      scope.localVars.getTaskExecuteData(scope.task_initiate_id,scope.task_execute_id);
                                                  }
                                                  $timeout(function(){
                                                      $rootScope.$broadcast('PageLoaded');
                                                  });
                                                 if (afterClaim)
                                                 {
                                                   MessagingService.addMessage(msgAfter,'success');
                                                  
                                                 }
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                    }
                     scope.localVars.pageChanged = function(){
                        scope.ExecuteAllListPaginatedFilter(scope.fd.search.taskListType,1,false,"",scope.localVars.nextPage,scope.localVars.previousPage,scope.localVars.currentPage,scope.localVars.pageSize,scope.fd.search);
                         }
                         
                         
                    //napuni grid s definicijama resursa
                     //scope.currentPage =  paginationOptions.pageNumber;
                     //scope.pageSize = paginationOptions.pageSize;
                      
                     scope.ExecuteAllListPaginatedFilter(scope.fd.search.taskListType,1,false,"","","",paginationOptions.pageNumber,paginationOptions.pageSize,scope.fd.search);
                     
                     scope.ExecuteListPrePaginated = function(listFilter){
                            scope.ExecuteAllListPaginated(scope.fd.search.taskListType,listFilter,false,"","","",paginationOptions.pageNumber,paginationOptions.pageSize);
                         }
                         
                          ResourcesDataService.getResourceDefListByType(lang,'task').then(function(data) {
                                                
                                                  scope.taskDefList = data.data;
                                                  
                                                
                                                 
                                               },function(error){
                                                
                                                  MessagingService.addMessage(error.msg,'error');
                                            });
                      //
                      scope.fd.search.headerLabel = "Select users or groups";
                      scope.fd.search.usersLabel ="Users";
                      scope.fd.search.groupsLabel = "Groups";
                      
                      //get task statuses
                      
                       CodesService.getCodesByName('taskstatuses',lang).then(function (data) {
                                scope.taskStatuses = data.data;
                             });
              
              }
        }             
};
'use strict';

export function ktTaskToolbox () {

        return {
                restrict: 'A',
                templateUrl: 'ktdirectivetemplates/ktTaskToolbox.html',
                controller: ['$scope','$rootScope','GridsterService', function($scope,$rootScope,GridsterService){
              
                        $scope.gsrvc = GridsterService;
                        $scope.toolboxItems = [];
                        
                        //$scope.gsrvc.SetTaskToolboxLoaded(false);
        
                        var widgetHandle = 'task-element-drag-handle';
        
                        var setupDragulaResult;
                        
                        
                        $scope.taskToolboxLoaded=function(value){
        
                                if (!value)
                                {
                                    $scope.gsrvc.destroyDragula('bag-task');
                                    $scope.gsrvc.SetTaskToolboxLoaded(value);
                                }
                                else
                                {
                                    setupDragulaResult = $scope.gsrvc.setupDragula('bag-task','task-toolbox',widgetHandle);
                                    $scope.toolboxItems= angular.copy($scope.gsrvc.getTaskToolboxItems());
                                   
                                    //$timeout(function(){$scope.gsrvc.SetTaskToolboxLoaded(value);},500);
                                }
               
                        };
                        
                        $scope.toolboxStatus=function(value){
        
                         $scope.gsrvc.SetTaskToolboxLoaded(value);
                        };
             
             }],
             link: function (scope, elem, attrs) {
              
                       
              }
      }
};
'use strict';

export function ktTaskUpdateMultipleResources () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService) {
      
    $scope.searchFormDownloaded = false;
    $scope.src_type_text=CODES_CONST._POPULATE_TYPE_;   
     
    $scope.widgetType = 2;
    $scope.animationsEnabled = true;
     var lang=$rootScope.globals.currentUser.lang;
          $scope.gridsterType="resource";
           $scope.gridsterOpts = GridsterService.getGridsterOptions();
          
  
  
            var lang = $rootScope.globals.currentUser.lang;
  
  
  $scope.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: GridsterService.getEmptyDatasetForm()
				} ;
      
      
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        
        $scope.parentDatasetDefId=$scope.fd.related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.localVars.formType=$scope.taskDefinition.form_type;
        $scope.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        
        //register widget
       var out_fields = ['resourceRecordId']
       var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:''}]},{'name':'parentDatasetLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'updateMultipleResourceWidget',widgetId: $scope.fd.presentationId,taskId:  $scope.lTaskId,
      
       resourceDefId : $scope.fd.related, //resourceDefId : $scope.selectedResource
       resourceRecordId:$scope.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,prev_task_id:$scope.prevTaskExeId,  output:out_fields };
       
       $scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
       
       $scope.fd.localId=$scope.localWidgetId;  
 
      
        
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        
        
        if ($scope.source_type=="fromOutcome")
        {
           $scope.resourceRecordId = WidgetDataExchangeService.getDataByWidgetId($scope.prevTaskExeId,$scope.taskDefinition.task_initiate_id,$scope.fd.parentElementId,'resourceRecordId');
        }
         
        if ($scope.resourceRecordId==undefined)
         {
          $scope.resourceRecordId = 0; 
         }
          
         $scope.getFormResourceOriginal = function(){
              
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.related,"i",lang).then(function(data) {
                            
                                $scope.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.dashboard.widgetsFilter.layout=angular.copy(data.data.widgets);
                                if ( $scope.taskInitiateId==0 && $scope.taskExecuteId==0)
                                {
                                 $scope.dashboard.widgets.layout=[data.data.widgets];
                                }
                                 $scope.selectedResourceItem = {'name':$scope.resourceWidgetDefinition.name,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                            
                            
                                $scope.fd.fItemValue= $scope.dashboard.widgetsFilter.layout;
                                $scope.fd.wItemValue= $scope.dashboard.widgets.layout;
                                
                                //MIGOR BITNO ZA BROADCAST - ktTaskUpdateResource 
                                //WidgetDataExchangeService.setData($scope.widgetId,'resourceRecordId',{'resourceRecordId':$scope.fd.wItemValue.resourceRecordId});
                                 //ovo je da trenutno radi
                                WidgetDataExchangeService.setData({DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.related},{name:'resourceRecordId',value:$scope.resourceRecordId}]}],widgetId: $scope.fd.presentationId});
								
                                
                                  $scope.searchFormDownloaded = true;
                                   $timeout(function() {
                                    $scope.formLoaded=true;
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
  
      $scope.SearchFormProcessed=false;
      
      $scope.ProcessSearchForm=function (form){
            
            if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('type' in form[i])
                    {
                      if (form[i].type == 'resource' && form[i].autoSearch)
                      {
                        var pos = $scope.childWidgets.map(function(e) { return e.widgetId; }).indexOf(form[i].presentationId);
                        if (pos<0) $scope.childWidgets.push({widgetId:form[i].presentationId,processed:false})
                        
                      }
                     }
                      if ('layout' in form[i])
                      {
                           
                       $scope.ProcessSearchForm(form[i].layout);
                      }
              }
          } 
           
      };
            
            
      $scope.GetDatasetData=function(data)
      {

            fromWidget = data;
            var allProcessed=true;
            var pos = $scope.childWidgets.map(function(e) { return e.widgetId; }).indexOf(fromWidget);
            if (pos<0) $scope.childWidgets.push({widgetId:fromWidget,processed:true});
            for (var i=0;i<$scope.childWidgets.length;i++)
              {
                
                if ($scope.childWidgets[i].widgetId == fromWidget) $scope.childWidgets[i].processed = true;
                if (!$scope.childWidgets[i].processed) allProcessed = $scope.childWidgets[i].processed;
              }
             // if (!$scope.SearchFormProcessed) $timeout(function() {$scope.GetDatasetData(fromWidget);},1000);
              if($scope.fd.autoSearch && allProcessed && $scope.SearchFormProcessed) {
                  $scope.selectedResource=$scope.fd.related;
                  $scope.getResourceDataFiltered();
                                      
                }
           
      	
      };
       
       
      $scope.childWidgets = [];
     // $scope.uncaughtWidgets = [];
      var fromWidget=0;
   
       $scope.$on('SearchFormReady'+$scope.taskExecuteId,function(event, data){
      
           $scope.GetDatasetData(data); 
            
      });     
            
            
        $scope.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
             
              if ($scope.fd.presentationId==null) {
                $scope.fd.presentationId=0;
              }
              ResourcesDataService.getResourceFormExtendedMultiple($scope.fd.related,$scope.taskId,$scope.formType,$scope.fd.presentationId,["w","f"],lang).then(function(data) {
                               
                          $scope.resourceWidgetDefinition= data.data.resourceDefinition;
                          //$scope.dashboard.widgetsTemplate = angular.copy(data.data.widgets[0]);
                          $scope.dashboard.widgetsFilter.layout= data.data.widgets.widgetsf;
                           if ( $scope.taskInitiateId==0 && $scope.taskExecuteId==0)
                                {
                                $scope.dashboard.widgets.layout = [data.data.widgets.widgetsw];
                                }
                          $scope.selectedResourceItem = {'name':$scope.resourceWidgetDefinition.name,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
               
                          $scope.fd.wItemValue=$scope.dashboard.widgets.layout;
                          $scope.fd.fItemValue= $scope.dashboard.widgetsFilter.layout;
                          $scope.searchFormDownloaded = true;
                          
                           $timeout(function() {
                                     $scope.searchFormDownloaded = true;
                                    $scope.setRequired($scope.fd.fItemValue,false);
                                    $scope.formLoaded=true;
                                   //prepare search form
                                    $scope.ProcessSearchForm($scope.fd.fItemValue);
                                    $scope.SearchFormProcessed = true;
                                    //$scope.GetDatasetData(0);                                 
                                   });
                           
                      
                  },function(error){
                  MessagingService.addMessage(error.msg,'error');
                                 
                                 
                                
              });
                             
      };
        
       
        $scope.selectedDatasetRecords=[];
        $scope.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.updateFormLoaded=false;
              if ($scope.fd.presentationId==null)
              {
                $scope.fd.presentationId = 0;
                
              }
              
              if ($scope.fd.parentElementId==null)
              {
                $scope.fd.parentElementId = 0;
                
              }
               if ($scope.fd.linkedResourceModelDefinitionId==null || $scope.fd.linkedResourceModelDefinitionId==undefined)
              {
                $scope.fd.linkedResourceModelDefinitionId = 0;
                
              }
              
              if ($scope.gridApi!=undefined) $scope.selectedDatasetRecords = $scope.gridApi.selection.getSelectedRows();
              
               if ($scope.selectedDatasetRecords.length>0 || $scope.fd.linkedResourceModelDefinitionId>0)
               {
                $scope.filter = $scope.selectedDatasetRecords;
               var record_id = $scope.selectedDatasetRecords.length;
               
               if ($scope.fd.linkedResourceModelDefinitionId>0) record_id = $scope.fd.linkedResourceId;
               
               if ($scope.fd.linkedResourceDefId==undefined) $scope.fd.linkedResourceDefId=0;
               if (record_id == null || record_id==undefined || record_id=="") record_id=0;
                
              
              ResourcesDataService.getResourceFormExtendedWithDataMultiple($scope.fd.related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.populateType,$scope.fd.parentElementId,$scope.fd.presentationId,$scope.prevTaskExeId,$scope.formType,$scope.widgetType,record_id,"w",$scope.filter,$scope.fd.linkedResourceDefId,$scope.fd.linkedResourceModelDefinitionId,lang).then(function(data) {
                                
                                  $scope.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.dashboard.widgets.layout=data.data.widgets;
                                  
                                 
                                  $scope.resourceRecordIds = data.data.resourceRecordId;
                                  if ($scope.resourceRecordIds.length>0)
                                  {
                                    $scope.datasetRecordId=$scope.resourceRecordId[0];
                                  }
                                  $scope.selectedResourceItem = {'name':$scope.resourceWidgetDefinition.name,'relatedId':$scope.fd.related,'presentationId':$scope.fd.presentationId,'src_type_id':$scope.fd.populateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.populateType],'parentElementId':$scope.fd.parentElementId};
                                
                                  $scope.fd.wItemValue=$scope.dashboard.widgets.layout;//data.data.widgets;
                                //  $scope.fd.fItemValue=data.data.widgetsf;
                                
                                  $scope.searchFormDownloaded = true;
                                //  $timeout(function() {
                                    $scope.formLoaded=true;
                                    $scope.updateFormLoaded=true;
                                     
                                 // });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
               }else
               {
                MessagingService.addMessage("Please select record(s) to update","info");
               }
                              
               
      };
      
     $scope.gridOptionsResourceData = {
        columnDefs: [],
        data:[],
        enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: true,
        enableHorizontalScrollbar : 1,
        enableVerticalScrollbar : 2,
        enableFiltering: true,
        enableRowHeaderSelection: true,
        enableColumnResizing: true,
        enableColumnReordering: true,
      //exporterCsvFilename: 'myFile.csv',
     /*
        paginationPageSizes: [5, 10, 20, 50, 100],
         paginationPageSize: 5,
       enableSelectAll: false,
       enableCellEdit: false*/

   }
      
      
      $scope.gridOptionsResourceData.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.gridApi = gridApi;
           
          //gridApi.selection.on.rowSelectionChanged($scope,function(row){

         
                  
              
         // });
     }
     
      
 

    
          
       $scope.getResourceDataFiltered = function () {

            $scope.filter = {};
            //$scope.gridOptionsResourceData.columnDefs.length=0;
            //$scope.gridOptionsResourceData.data.length=0;
            $scope.dataDownloading=true;
          if ($scope.selectedResource==null) {
            $scope.selectedResource = $scope.fd.related;
          }
          
         ResourcesDataService.getResourceDataFiltered($scope.selectedResource,$scope.taskId,lang,$scope.dashboard.widgetsFilter.layout).then(function(data) { 
                            
                                  $scope.gridOptionsResourceData.data = data.data;
                                  $scope.gridOptionsResourceData.columnDefs = data.columnsDef;
                                  
                                    $timeout(function(){
                                      $scope.resourceDataDownloaded = true;
                                      $scope.restoreGridState();
                                    });
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
              $scope.dataDownloading=false;
        }
    
    
    $scope.saveDatasetRecordsMultiple = function(){
              //var lang=$rootScope.globals.currentUser.lang;
              //$scope.updateFormLoaded=false;
               
              ResourcesDataService.saveDatasetRecordsMultiple($scope.fd.related,$scope.fd.wItemValue).then(function(data) {
                             
                                
                                   MessagingService.addMessage(data.msg,'success');
                                   $scope.dashboard.widgets.layout.length=0;
                                   $scope.getResourceDataFiltered();                               
                                   $timeout(function() {
                                    //$scope.formLoaded=true;
                                    //$scope.updateFormLoaded=true;
                                     
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
              
                              
               
      };
    
    
    $scope.saveGridState= function() {
       var state = $scope.gridApi.saveState.save();
       $scope.fd.gridState = state;
       MessagingService.addMessage("To make changes stick please save form",'info');
                 
    }
  
   $scope.restoreGridState= function() {
      if ($scope.fd.gridState!=null)
      {
         if ($scope.gridApi!=undefined)
         {
      
          $scope.gridApi.saveState.restore($scope,$scope.fd.gridState);
        
         }else
         {
        $timeout(function(){
            $scope.restoreGridState();
          });
         }
      }
    };
    
        //mupdate
          $scope.openWidgetConnector  = function(){
             $scope.fd.showWidgetConnector= !$scope.fd.showWidgetConnector;
             if ($scope.fd.showWidgetConnector) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                                function(data) {
                                                  $scope.datasetList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.fd.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                                   //var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.fd.listOfConnectors[i].parentDatasetName = $scope.datasetList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.fd.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.fd.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.fd.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.fd.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.fd.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.fd.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                     if ($scope.fd.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.fd.listOfConnectors[i].DEI.length;j++) {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.fd.listOfConnectors[i].DEI[j].value!=false) && ($scope.fd.listOfConnectors[i].DEI[j].value!=true) ) $scope.fd.listOfConnectors[i].DEI[j].value=false;
                                                                
                                                                  if ($scope.fd.listOfConnectors[i].DEI[j].params!=undefined && $scope.fd.listOfConnectors[i].DEI[j].params!=null)
                                                                  
                                                                  {
                                                                    if ($scope.fd.listOfConnectors[i].DEI[j].params.type=="parent")
                                                                    
                                                                    {
                                                                      var related_id = 0;
                                                                      
                                                                      if ($scope.fd.listOfConnectors[i].DEI[j].params.value!=undefined || $scope.fd.listOfConnectors[i].DEI[j].params.value!=null)
                                                                        related_id = $scope.fd.listOfConnectors[i].DEI[j].params.value;
                                                                      
                                                                      $scope.getFormFields($scope.fd.related,related_id,'resource',i,j);
                                                                     
                                                                      
                                                                    }
                                                                    
                                                                  }
                                                                 
                                                                 //dodaj konektor u novu listu 
                                                                 
                                                             };
                                                             newlist.push($scope.fd.listOfConnectors[i]);
                                               }
                                }//if
							  $scope.fd.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
			
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - VIEW
    

            $scope.okWidgetConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.fd.listOfConnectors;
                $scope.fd.showWidgetConnector=false;  
                
                });
            };
    
    $scope.cancelWidgetConnector = function () {
                $timeout(function() {
                
                $scope.fd.showWidgetConnector=false;  
                
                });
            };
    
    
    
      $scope.setField = function(form,name,value)
        {
     				TaskDataService.setField(form,name,value);
        }  
    
       $scope.setReadOnly = function(form,readOnly)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('readOnly' in form[i])
                    {
                      form[i].readOnly = readOnly;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.setReadOnly(form[i].layout,readOnly);
                      }
              }
          }
        };
        
    $scope.setRequired = function(form,required)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('required' in form[i])
                    {
                      form[i].required = required;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.setRequired(form[i].layout,required);
                      }
              }
          }
        }
  
  //$scope.getFormResource();
   
  if ($scope.fd.related!=null &&  !$scope.searchFormDownloaded && $scope.taskInitiateId==0 && $scope.taskExecuteId==0 && $scope.prevTaskExeId==0)
  {
     $scope.getFormResource();
    
  }
  
   if ($scope.fd.related!=null &&  !$scope.searchFormDownloaded && ($scope.taskInitiateId!=0 || $scope.taskExecuteId!=0 || $scope.prevTaskExeId!=0))
  {
     $scope.getFormResource();
    
  }
  
  
      }];

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTaskUpdateMultipleResources.html',
            controller: controller,
            link: function (scope, elem, attrs) {

            scope.resourceData = {};
  
            scope.prepareResourceData = function(resourceRecordId){
           
     
                scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData(scope.dashboard.widgets.layout,resourceRecordId);
  
          }
          
          scope.ProcessEvent = function(data)
          {
             for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    scope.fd.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    scope.resourceRecordId = scope.fd.linkedResourceId;
                                   
                                  }
                                  if (data[k].name=='resourceId') scope.fd.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                  
                                  //scope.fd.linkedResourceModelDefinitionId = scope.fd.tItemValue[i].DEI[j].params.selectedItem.id;
                             
                                
                                }
                          
                              //get selectedRecord
                              scope.getFormResourceWithData();
            
          }
           scope.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if (scope.fd.tItemValue[i].DEI[j].value==true) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+scope.fd.presentationId+" se veze na serverski " + linkedWidgetId); 
                             scope.fd.linkedResourceModelDefinitionId = scope.fd.tItemValue[i].DEI[j].params.selectedItem.id;
                                          
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                console.log("view "+ scope.fd.presentationId+" dobio event " + event.name);
                                scope.ProcessEvent(data);
                                    
                              }) //on_END
                               var data = WidgetDataExchangeService.getDataByWidgetId(scope.taskDefinition.task_execute_id,scope.taskDefinition.task_initiate_id,scope.taskDefinition.prev_task_id,linkedWidgetId,linkedItem);
                               if (data!=undefined && data!=null && data!=0)  scope.ProcessEvent(data);
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget
      
          if (scope.fd.presentationId==undefined || scope.fd.presentationId==null) scope.fd.presentationId=0;
          
          scope.formType=scope.taskDefinition.form_type;
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.presentationId,scope.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;
                                scope.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
          
          
          
           //**********************************************************
         //           GET FORM FIELDS
         //**********************************************************      
            
          scope.getFormFields = function(resource_id,related_id,element_type,i,j){
              
              
              var lang=$rootScope.globals.currentUser.lang;
           
                         
              ResourcesDataService.getFormFieldsByType(resource_id,related_id,element_type,lang).then(function(data) {
                               
                                  scope.fd.listOfConnectors[i].DEI[j].params.list= data.data;
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 
                                
                             });
                              
          };
          
         
          scope.$on('InitiateTaskPostProcess',function(event, data){
              
              //find data
            //  var item = data;
              //send data to widget exchange service
              //WidgetDataExchangeService.setData(item);
              scope.setReadOnly(scope.dashboard.widgets.layout,true);
          });
  
          }
    } 
        
};
'use strict';

export function ktTaskUpdateResource (ResourcesDataService,TaskDataService) {
    var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,$templateCache,$compile,$element) {
   
      $scope.localVars={};
      $scope.localVars.searchFormDownloaded = false;
      $scope.localVars.formLoaded=false;
      $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_;  
      $scope.localVars.animationsEnabled = true;
      $scope.localVars.widgetType = 2;
      $scope.gsrvc = GridsterService;
      $scope.localVars.formParams={formViewType:1,showGridNavigation:true};
      $scope.localVars.gridsterType="resource";
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
        
    $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: {layout: []}
				} ;
      
  
        //$scope.taskId=$stateParams.id;
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        $scope.localVars.taskId=$scope.taskId;
        
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.localVars.formType=$scope.taskDefinition.form_type;
        $scope.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        $scope.formDefinition = $scope.taskDefinition.form_definition;
        
        if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
        $scope.localVars.resourceRecordId=0;
        if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        
      //register widget 
      var out_fields = ['resourceId'];
      var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',
        widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.fd.Related, output:out_fields, };
        $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
        $scope.localVars.LocalId=$scope.localVars.localWidgetId;
        
        $scope.fd.LocalId=$scope.localVars.localWidgetId;
        
        $scope.ksm = KatalyoStateManager;
        let update_presentation_id = function(data)
        {
           if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
        }
        if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
        {
         
            let dependent_field = $scope.fd.LocalId;
            let subscribedSubject = "formDefinitionState"+$scope.taskId+$scope.localVars.formType;
            let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
  
        }
      
       $scope.localVars.showProperties=function(datasetMapperType)
           {
            
            if ($scope.localVars.datasetMapperType==undefined)
            {
               $scope.localVars.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
               else $scope.localVars.datasetMapperType=0;
            }
            
           };        
        
        
        $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                  $scope.localVars.searchFormDownloaded = true;
                                  $scope.localVars.formLoaded=true;
                                     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
        
        $scope.localVars.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.localVars.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.localVars.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                 if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                  $scope.localVars.searchFormDownloaded = true;
                                   $timeout(function() {
                                    $scope.localVars.formLoaded=true;
                                     $scope.localVars.formLoading=false;
                                      
                                    });
                                   
                                  
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVars.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVars.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }
              if ($scope.localVars.previousTaskData!=undefined)
              {
                if ($scope.localVars.previousTaskData.datasetRecordId!=undefined) $scope.localVars.resourceRecordId = $scope.localVars.previousTaskData.datasetRecordId;
                
              }

              
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                  $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                  $scope.localVars.resourceRecordId = $scope.formData[$scope.fd.PresentationId][0]['id'];
                                  $scope.localVars.datasetRecordId=$scope.localVars.resourceRecordId;
                                  if ($scope.localVars.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVars.selectedResourceItem.name=$scope.localVars.resourceWidgetDefinition.name;
                                  $scope.localVars.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVars.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVars.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVars.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVars.selectedResourceItem={'name':$scope.localVars.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                //$scope.fd.wItemValue=data.data.widgets;
                               
                                 //  $timeout(function() {
                                     $scope.localVars.formLoaded=true;
                                     $scope.localVars.formLoading=false;
                                     $scope.localVars.searchFormDownloaded = true;
                                      
                                 //   });   
                                  
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - UPDATE_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.localVars.presentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
			                             
                                  
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
      
            
       $scope.localVars.setReadOnly = function(form,readOnly)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('readOnly' in form[i])
                    {
                      form[i].readOnly = readOnly;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.localVars.setReadOnly(form[i].layout,readOnly);
                      }
              }
          }
        }
       $scope.localVars.setRequired = function(form,required)
        {
          if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('required' in form[i])
                    {
                      form[i].required = required;
                     }
                      if ('layout' in form[i])
                      {
                           
                         $scope.localVars.setRequired(form[i].layout,required);
                      }
              }
          }
        }
        
           $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.resourceList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.resourceList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.resourceList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.localVars.getResources = function()  {
						
            if ($scope.localVars.resourceList==undefined) $scope.localVars.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
						function(data) {
										
											  $scope.localVars.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVars.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
   
   
       $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };  
   
  
  $scope.localVars.getPreviousTaskWidget  = function(widgetType,linkType)
    {
      var pTaskData;
      var pTaskDataRet = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
      if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0)
      {
            pTaskData = pTaskDataRet[0];
            for (let k=0;k<pTaskDataRet.length;k++)
            {
                if (pTaskDataRet[k].name==widgetType && pTaskDataRet[k].resourceDefId==$scope.fd.Related)
                {
                    for (let l=0;l<pTaskDataRet[k].DEI.length;l++)
                    {
                        if (pTaskDataRet[k].DEI[l].name == linkType) pTaskData = pTaskDataRet[k];
                    }
                }
            }
        }
      
            var datasetId=0,datasetRecordId=0;
            if (pTaskData!=undefined)
            {
                if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
                {
                for (var i=0;i<pTaskData.DEI.length;i++)
                {
                  if (pTaskData.DEI[i].name==linkType)
                  {
                    if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                    {
                      for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                      {
                       if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                       if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                       
                        
                      }
                         
                        
                    }
                      
                  }
                    
                  }
                }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
   
  $scope.localVars.previousTaskData=$scope.localVars.getPreviousTaskWidget("resourceListWidget", "resourceLinkDatasetList");
  
          
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded)
  {
     $scope.localVars.getFormResourceWithData();
    // $scope.localVars.getResources();
    // $scope.localVars.setSelectedDataset($scope.fd.Related);
    
  }else if ($scope.fd.Related!=null)
  {
     $scope.localVars.getFormResource();
     $scope.localVars.getResources();
     //$scope.localVars.setSelectedDataset($scope.fd.Related);
    
  }
  
    let template;
    if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskUpdateResource.html');
    else template = $templateCache.get('ktdirectivetemplates/ktTaskUpdateResourceExe.html');
          
    $element.append($compile(template)($scope)); 
  
  
}];
  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            scope.localVars.resourceData = {};
  
            scope.localVars.prepareResourceData = function(resourceRecordId){
           
     
                scope.fd.itemValue =  ResourcesDataService.prepareResourceWidgetData(scope.localVars.dashboard.widgets.layout,resourceRecordId);
  
          }
          
          
           scope.localVars.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name==linkedItem) && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             console.log("view "+scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                console.log("view "+ scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    scope.localVars.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    scope.localVars.resourceRecordId = scope.localVars.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') scope.localVars.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              //scope.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if (scope.fd.PresentationId==undefined || scope.fd.PresentationId==null) scope.fd.PresentationId=0;
          
          scope.localVars.formType=scope.taskDefinition.form_type;
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.PresentationId,scope.localVars.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;
                                scope.localVars.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
          
          
        
          
          scope.$on('InitiateTaskPostProcess',function(event, data){
              
              //find data
            //  var item = data;
              //send data to widget exchange service
              //WidgetDataExchangeService.setData(item);
              scope.localVars.setReadOnly(scope.localVars.dashboard.widgets.layout,true);
          });
  
          }
    } 
        
};
'use strict';

export function ktTaskViewResource () {
   
   var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService','KatalyoStateManager','UtilityService','$templateCache','$compile','$element',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService,KatalyoStateManager,UtilityService,$templateCache,$compile,$element) {
     
      $scope.localVarsWidget = {};
      //$scope.fd = {};
      $scope.localVarsWidget.searchFormDownloaded = false;
      $scope.localVarsWidget.formLoaded=false;
      $scope.localVarsWidget.src_type_text=CODES_CONST._POPULATE_TYPE_;
      $scope.localVarsWidget.animationsEnabled = true;
      $scope.localVarsWidget.widgetType = 3;
      $scope.gsrvc = GridsterService;
      var lang=$rootScope.globals.currentUser.lang;

      $scope.localVarsWidget.formParams={formViewType:1,showGridNavigation:true};
      if ($scope.formData==undefined) $scope.formData={};
      if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
      
      $scope.localVarsWidget.datasetMapperType=0;
      
      if ($scope.fd.PopulateType==undefined) $scope.fd.PopulateType="";
      
      $scope.localVarsWidget.openModal = function (size,template,ctrl,selectedType) {
     
         var modalInstance = $uibModal.open({
            animation: $scope.animationsEnabled,
            templateUrl: template,
            controller: ctrl,
            size: size,
            resolve: {
              selectedResourceItem: function () {
                return $scope.localVarsWidget.selectedResourceItem;
                },
              type: function () {
                return $scope.localVarsWidget.selectDatasetType;
                }
            }
         });
         modalInstance.result.then(function (selectedItem,windex,index) {
      
          if ($scope.localVarsWidget.selectDatasetType==1){
            $scope.localVarsWidget.selectedResourceItem = selectedItem;
            $scope.fd.Related =  $scope.selectedResourceItem.relatedId;
            $scope.fd.PopulateType=selectedItem.src_type_id;
            $scope.fd.ParentElementId = $scope.selectedResourceItem.parentElementId;
            $scope.fd.PresentationId = $scope.selectedResourceItem.presentationId;
            $scope.localVarsWidget.getFormResourceOriginal();
          
          }else if ($scope.localVarsWidget.selectDatasetType==2)
          {
            $scope.localVarsWidget.selectedRelatedResourceItem = selectedItem;
            $scope.fd.HasParentDataset =  $scope.selectedResourceItem.relatedId;
            $scope.fd.PopulateTypeParent=selectedItem.src_type_id;
            //$scope.fd.ParentElementId = $scope.selectedResourceItem.parentElementId;
            //$scope.fd.PresentationId = $scope.selectedResourceItem.presentationId;
          }
         
         }, function () {
        //$log.info('Modal dismissed at: ' + new Date());
         });
         
      };
     
      $scope.localVarsWidget.openModalSelectResource = function(){
        $scope.localVarsWidget.selectDatasetType  = 1;
        $scope.localVarsWidget.openModal('lg','selectResourceModal.html','SelectResourceModalCtrl',$scope.localVarsWidget.selectDatasetType);
        
      };
     
      $scope.localVarsWidget.openModalSelectRelatedResource = function(){
        $scope.localVarsWidget.selectDatasetType  = 2;
        $scope.localVarsWidget.openModal('lg','selectDatasetModal.html','SelectDatasetModalCtrl',$scope.localVarsWidget.selectDatasetType);
      };
      
     
      $scope.localVarsWidget.gridsterType="resource";
          // $scope.gridsterOpts = GridsterService.getGridsterOptions();
    
    
        
      $scope.localVarsWidget.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: []
      } ;
        
    
  
      //$scope.taskId=$stateParams.id;
      $scope.taskId=$scope.taskDefinition.ResourceDefId;
      if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
      if ($scope.taskId==undefined) $scope.taskId=0;
      $scope.localVarsWidget.taskId=$scope.taskId;
      $scope.fd.ParentDatasetDefId=$scope.fd.Related;
      $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
      $scope.localVarsWidget.formType=$scope.taskDefinition.form_type;
      $scope.source_type=$scope.taskDefinition.source_type;
      $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
      $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
      $scope.formDefinition = $scope.taskDefinition.form_definition;
        
      if  ($scope.formDefinition==undefined) $scope.formDefinition=false;
        
      $scope.localVarsWidget.resourceRecordId=0;
      if ($scope.taskInitiateId==undefined)
      {
        $scope.taskInitiateId =0;
      
      }
      if ($scope.taskExecuteId==undefined)
      {
         $scope.taskExecuteId =0;  
      }
        if ($scope.prevTaskExeId==undefined)
        {
            $scope.prevTaskExeId =0;
        }
        
      //register widget 
      var out_fields = ['resourceId'];
      //if ($scope.fd.LocalId==undefined || $scope.fd.LocalId==null || $scope.fd.LocalId==0)
      //{
         var widgetDefinition = {DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'viewResourceWidget',widgetId: $scope.fd.PresentationId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId,taskId:  $scope.lTaskId,resourceDefId : $scope.localVarsWidget.selectedResource, output:out_fields, };
         $scope.localVarsWidget.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
         $scope.localVarsWidget.LocalId=$scope.localVarsWidget.localWidgetId;
         $scope.fd.LocalId=$scope.localVarsWidget.localWidgetId;
         //$scope.fd.LocalId=UtilityService.uuidNow();
         
      //}
      $scope.ksm = KatalyoStateManager;
      
      let update_presentation_id = function(data)
      {
         if (data[$scope.fd.LocalId]>0 && ($scope.fd.PresentationId==null || $scope.fd.PresentationId==0)) $scope.fd.PresentationId = data[$scope.fd.LocalId];
          //unsubscribe here later after implementing unsubscribe - ToDo
          
      }
      if ($scope.fd.PresentationId==0 || $scope.fd.PresentationId==null)
      {
         
         let dependent_field = $scope.fd.LocalId;
         let subscribedSubject = "formDefinitionState"+$scope.taskId+$scope.taskDefinition.form_type;
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"formSaved",update_presentation_id);
  
      }        
      
       let apply_value = function(data)
        {
            let do_refresh=false;
            if (data!=undefined)
            {
               if (data != $scope.localVarsWidget.resourceRecordId)
               {
                  if (typeof data ==='number') $scope.localVarsWidget.resourceRecordId= data;
                  else if (Array.isArray(data))
                  {
                     if (data.length>0)
                     {
                      $scope.localVarsWidget.resourceRecordId= data[0].id  
                     }
                  }else
                  {
                     $scope.localVarsWidget.resourceRecordId = data.id;
                  }
                  do_refresh = true;
               }
            }
            //get selectedRecord
            if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
            if ($scope.localVarsWidget.resourceRecordId>0 && do_refresh) $scope.localVarsWidget.getFormResourceWithData();
            
            
        };
        
      
      if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
      
      if ($scope.fd.Parameters.RefreshOnIdChange)
      {
         
         //find 
         //subscribe observer
           
         let dependent_field = "Field"+$scope.fd.PresentationId;
         let subscribedSubject = "resourceidValueStateName"+$scope.fd.Parameters.ResourceIdItemId+$scope.taskDefinition.transaction_id;
         let subject = $scope.ksm.addSubject(subscribedSubject,null);                          
         let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
         let val = $scope.ksm.getState(subscribedSubject);
         $scope.localVarsWidget.resourceRecordId= val.id;
            
            //get selectedRecord
         if ($scope.localVarsWidget.resourceRecordId == null) $scope.localVarsWidget.resourceRecordId=0;
            
         if ($scope.localVarsWidget.resourceRecordId>0) $scope.localVarsWidget.getFormResourceWithData();
      }
      
      //subscribe observer
      if ($scope.fd.PopulateType.toString().substr(0,1)=="4")
      {
           /**********************************************************************
         ****************** Sync data with State manager **********************
         ***********************************************************************/
        /*
        $scope.itemValue = {val:null};
        
        let valueState= $scope.ksm.addSubject('datasetValueStateName'+$scope.fd.ItemId,$scope.itemValue.val);
        let valueStateName = valueState.subject.name;
        
        let value_changed = function(data)
        {
            valueState.subject.setStateChanges = data;
            valueState.subject.notifyObservers("valueChanged");
        };
        
        let action_value_changed = $scope.ksm.addAction(valueStateName,"valueChanged",value_changed);
       
        */
       
       
        if ($scope.fd.SrcWidgetId!=undefined && $scope.fd.SrcWidgetId!=null)
        
        {
           
                let dependent_field = "Field"+$scope.fd.SrcWidgetId;
               // let subscribedSubject = $scope.fd.Parameters.SrcWidgetType+"ValueStateName"+$scope.fd.SrcWidgetId;
                let subscribedSubject = "rlistValueStateName"+$scope.fd.SrcWidgetId+$scope.taskDefinition.transaction_id;
                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
            
        }  
         
      }
      
      let refresh_widget_data = function()
      
      {
         $scope.localVarsWidget.getFormResourceWithData();    
         
      }
      if ($scope.fd.Parameters.EventName!=undefined)
      {
         if ($scope.fd.Parameters.EventName!="")
         {
            let dependent_field2 = "Field"+$scope.fd.PresentationId;
            let subscribedSubject2 = "task"+$scope.taskDefinition.transaction_id;
            let observer2 = $scope.ksm.subscribe(subscribedSubject2,dependent_field2,$scope.fd.Parameters.EventName,refresh_widget_data);
         }
      }
      
      $scope.localVarsWidget.showProperties=function(datasetMapperType)
      {
            
            if ($scope.localVarsWidget.datasetMapperType==undefined)
            {
               $scope.localVarsWidget.datasetMapperType = datasetMapperType;
            }else
            {
               if ($scope.localVarsWidget.datasetMapperType==0 || $scope.localVarsWidget.datasetMapperType!=datasetMapperType) $scope.localVarsWidget.datasetMapperType = datasetMapperType;
               else $scope.localVarsWidget.datasetMapperType=0;
            }
            
      };
           
      $scope.localVarsWidget.setField = function(form,name,value,msg)
      {
         TaskDataService.setField(form,name,value);
         if (msg) MessagingService.addMessage(msg,'info');
      };  

      $scope.localVarsWidget.getFormResourceOriginal = function(){
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(function(data) {
                            
                                $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                
                                if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVars.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVars.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                $scope.fd.wItemValue=data.data.widgets;
                                
                           /*
                                var container = $element.children().eq(0);
                                GridsterService.setupDragular($scope.fd.wItemValue,container,'rows-'+$scope.fd.PresentationId,'row-'+$scope.localVarsWidget.gridsterType+'-hadle',true);
                             */   
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.fd.ResourceRecordId}]}]});
						
                                  $scope.localVarsWidget.searchFormDownloaded = true;
                                  $scope.localVarsWidget.formLoaded=true;
                                
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);     
                                   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
        
        $scope.localVarsWidget.getFormResource = function(){
              var lang=$rootScope.globals.currentUser.lang;
               $scope.localVarsWidget.formLoaded=false;
               if ($scope.fd.PresentationId==null)
               {
                    $scope.fd.PresentationId=0;
            
               }
               $scope.localVarsWidget.formLoading=true;
                         
              ResourcesDataService.getResourceFormExtended($scope.fd.Related,$scope.taskId,$scope.localVarsWidget.formType,$scope.fd.PresentationId,"w",lang).then(function(data) {
                               
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                  
                                 if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                              
                                $scope.fd.wItemValue=data.data.widgets;
                               
                                
                                  
                                $scope.localVarsWidget.searchFormDownloaded = true;
                                
                                $timeout(function(){    
                                   $scope.localVarsWidget.formLoaded=true;
                                   $scope.localVarsWidget.formLoading=false;
                                });
                                  
                               
                              //  $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);
                                
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                 $scope.localVarsWidget.formLoading=false;
                                 
                                
                             });
                              
      };
      
              
        $scope.localVarsWidget.getFormResourceWithData = function(){
              var lang=$rootScope.globals.currentUser.lang;
              $scope.localVarsWidget.formLoaded=false;
              if ($scope.fd.PresentationId==null || $scope.fd.PresentationId==undefined)
              {
                $scope.fd.PresentationId = 0;
                
              }
              
              if ($scope.fd.ParentElementId==null || $scope.fd.ParentElementId==undefined)
              {
                $scope.fd.ParentElementId = 0;
                
              }
              
              
              
              
               if ($scope.localVarsWidget.resourceRecordId==undefined || $scope.localVarsWidget.resourceRecordId==0)
               {
                
                  if ($scope.localVarsWidget.previousTaskData['datasetRecordId']!=undefined && $scope.localVarsWidget.previousTaskData['datasetRecordId']!="" && $scope.localVarsWidget.previousTaskData['datasetId']==$scope.fd.Related) $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.previousTaskData['datasetRecordId'];
                
               }
               if (typeof $scope.localVarsWidget.resourceRecordId !=='number' && typeof $scope.localVarsWidget.resourceRecordId !=='string')
               {
                  
                  if (Array.isArray($scope.localVarsWidget.resourceRecordId))
                  {
                     if ($scope.localVarsWidget.resourceRecordId.length>0)
                     {
                        $scope.localVarsWidget.resourceRecordId= $scope.localVarsWidget.resourceRecordId[0].id  
                     
                     }
                  }
                  else $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.resourceRecordId.id;                 
               }
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVarsWidget.formType,$scope.localVarsWidget.widgetType,$scope.localVarsWidget.resourceRecordId,"w",lang).then(function(data) {

                                  $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                  if ($scope.formData[$scope.fd.PresentationId]==undefined) $scope.formData[$scope.fd.PresentationId]=[];
                                  $scope.localVarsWidget.resourceWidgetDefinition= data.data.resourceDefinition;
                                  if (Array.isArray(data.data.widgets)) $scope.localVarsWidget.dashboard.widgets.layout =  data.data.widgets;
                                 
                                  if ($scope.formData[$scope.fd.PresentationId].length>0)
                                  {
                                    $scope.localVarsWidget.resourceRecordId = $scope.formData[$scope.fd.PresentationId][0]['id'];
                                  }
                                  $scope.localVarsWidget.datasetRecordId=$scope.localVarsWidget.resourceRecordId;
                                  if ($scope.localVarsWidget.selectedResourceItem!=undefined)
                                 { 
                                  $scope.localVarsWidget.selectedResourceItem.name=$scope.localVarsWidget.resourceWidgetDefinition.name;
                                  $scope.localVarsWidget.selectedResourceItem.relatedId=$scope.fd.Related;
                                  $scope.localVarsWidget.selectedResourceItem.presentationId=$scope.fd.PresentationId;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_id=$scope.fd.PopulateType;
                                  $scope.localVarsWidget.selectedResourceItem.src_type_text=$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType];
                                  $scope.localVarsWidget.selectedResourceItem.parentElementId=$scope.fd.ParentElementId;
                                 }
                                else{
                                  $scope.localVarsWidget.selectedResourceItem={'name':$scope.localVarsWidget.resourceWidgetDefinition.name,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVarsWidget.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
 
                                }
                                    //$scope.fd.wItemValue=data.data.widgets;
                               
                                  // $timeout(function() {
                                     $scope.localVarsWidget.formLoaded=true;
                                    // $scope.localVarsWidget.initiateFormLoaded=true;
                                     $scope.localVarsWidget.formLoading=false;
                                     $scope.localVarsWidget.searchFormDownloaded = true;
                                      
                                  //  });   
                                  
                                   
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - VIEW_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVarsWidget.resourceRecordId}]}]});
                                
                               // $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'ReadOnly',true);       
                                $scope.localVarsWidget.setField($scope.localVarsWidget.dashboard.widgets.layout,'Required',false);   
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
      
      
           $scope.localVarsWidget.setSelectedDataset = function(id)  {
              
              if ($scope.localVarsWidget.selectedResourceItem==undefined) $scope.localVarsWidget.selectedResourceItem={};
              var pos = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVarsWidget.selectedResourceItem.id = $scope.localVarsWidget.resourceList[pos].id;
                $scope.localVarsWidget.selectedResourceItem.name = $scope.localVarsWidget.resourceList[pos].name;
                $scope.localVarsWidget.selectedDataset = $scope.localVarsWidget.resourceList[pos];
                $scope.localVarsWidget.selectedResourceItem.name_confirmed = $scope.localVarsWidget.selectedResourceItem.name +' ('+$scope.localVarsWidget.selectedResourceItem.id +')'
                $scope.localVarsWidget.selectedResourceItem_c=$scope.localVarsWidget.selectedResourceItem;
                }
					}
          
                  
          // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
	$scope.localVarsWidget.getResources = function()  {
						
            if ($scope.localVarsWidget.resourceList==undefined) $scope.localVarsWidget.resourceList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
						function(data) {
										
											  $scope.localVarsWidget.resourceList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
   
   

$scope.localVarsWidget.getPreviousTaskWidget  = function(linkType)
    {
      var pTaskData;
      var pTaskDataRet = WidgetDataExchangeService.getPrevTaskData($scope.prevTaskExeId);
      if (Array.isArray(pTaskDataRet) && pTaskDataRet.length>0) pTaskData = pTaskDataRet[0];
            var datasetId=0,datasetRecordId=0;
            if (pTaskData!=undefined)
            {
               if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
               {
               for (var i=0;i<pTaskData.DEI.length;i++)
               {
                 if (pTaskData.DEI[i].name==linkType)
                 {
                   if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                   {
                     for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                     {
                      if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                      if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                      
                       
                     }
                        
                       
                   }
                     
                 }
                   
                 }
               }
            }
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };


   
   
  $scope.localVarsWidget.previousTaskData=$scope.localVarsWidget.getPreviousTaskWidget("resourceLinkDatasetList");
 
          
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVarsWidget.searchFormDownloaded)
  {
    
     $scope.localVarsWidget.getFormResourceWithData();
    // $scope.localVarsWidget.getResources();
    // $scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  }else if ($scope.fd.Related!=null)
  {
     $scope.localVarsWidget.getFormResource();
     $scope.localVarsWidget.getResources();
     //$scope.localVarsWidget.setSelectedDataset($scope.fd.Related);
    
  } 

  
      //novi FILE CONNECTOR - view resource widget
      $scope.openWidgetConnector  = function(){
             $scope.localVarsWidget.showWidgetConnector= !$scope.localVarsWidget.showWidgetConnector;
             if ($scope.localVarsWidget.showWidgetConnector) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                                function(data) {
                                                  $scope.resourceList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.localVarsWidget.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.localVarsWidget.listOfConnectors.length;i++) {
                                                                   //var p = $scope.resourceList.map(function(e) { return e.id; }).indexOf($scope.localVarsWidget.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.localVarsWidget.resourceList.map(function(e) { return e.id; }).indexOf($scope.localVarsWidget.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.localVarsWidget.listOfConnectors[i].parentDatasetName = $scope.resourceList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.localVarsWidget.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.localVarsWidget.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.localVarsWidget.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.localVarsWidget.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.localVarsWidget.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.localVarsWidget.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.localVarsWidget.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.localVarsWidget.listOfConnectors.length;i++) {
                                                     if ($scope.localVarsWidget.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.localVarsWidget.listOfConnectors[i].DEI.length;j++) {
                                                                 //ako DEI nije true/false - resetiraj na false
                                                                 if ( ($scope.localVarsWidget.listOfConnectors[i].DEI[j].value!=false) && ($scope.localVarsWidget.listOfConnectors[i].DEI[j].value!=true) ) $scope.localVarsWidget.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                
                                                             };
                                                        newlist.push($scope.localVarsWidget.listOfConnectors[i]);
                                               }
                                }//if
							  $scope.localVarsWidget.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
			
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - VIEW
    

            $scope.localVarsWidget.okWidgetConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.localVarsWidget.listOfConnectors;
                $scope.localVarsWidget.showWidgetConnector=false;  
                
                });
            };

          $scope.localVarsWidget.cancelWidgetConnector = function () {
                $timeout(function() {
                
                $scope.localVarsWidget.showWidgetConnector=false;  
                
                });
            };

       
        $scope.localVarsWidget.processWidgetDependencies = function() { //-----                
           if ($scope.fd.tItemValue!=undefined) 
            for (var i=0;i< $scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=$scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = $scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<$scope.fd.tItemValue[i].DEI.length;j++) {
                        if (($scope.fd.tItemValue[i].DEI[j].name==linkedItem) && ($scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = $scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("view "+$scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             $scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj $scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                              //  console.log("view "+ $scope.fd.PresentationId+" dobio event " + event.name);
                                for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId')
                                  {
                                    $scope.localVarsWidget.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                    $scope.localVarsWidget.resourceRecordId = $scope.localVarsWidget.linkedResourceId;
                                  }
                                  if (data[k].name=='resourceId') $scope.localVarsWidget.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                }
                          
                              //get selectedRecord
                              $scope.localVarsWidget.getFormResourceWithData();
                                
                                    //	data: {resource_def_id:$scope.fd.linkedResourceDefId,resource_id:$scope.fd.linkedResourceId}
                                    
                              }) //on_END
                        }//if
                    }//for j
                }//if

             // else {  $scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktViewSingleResourceWidget

          if ($scope.fd.PresentationId==undefined || $scope.fd.PresentationId==null) $scope.fd.PresentationId=0;
          
          $scope.localVarsWidget.formType=$scope.taskDefinition.form_type;
          TaskDataService.getWidgetDependencies($scope.taskId,$scope.fd.PresentationId,$scope.localVarsWidget.formType).then(function(data) {
                               
                                $scope.fd.tItemValue=data.data;
                                $scope.localVarsWidget.processWidgetDependencies();
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                              
            
            $scope.fd.verify_blockchain_data = function () {
               
                
               ResourcesDataService.getBlockchainDatasetRecords($scope.fd.Related,'dataset','kataly1.code',1,$scope.formData[$scope.fd.PresentationId][0].BChainRecId,lang).then(function(data) {
                               
                                $scope.formData[$scope.fd.PresentationId][0].formDataBlockchain= JSON.parse(data.data.data.rows[0].datasetData);
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                
            };
            $scope.fd.get_transaction = function () {
               
                
               ResourcesDataService.getBlockchainTransaction($scope.formData[$scope.fd.PresentationId][0].TrxId,$scope.formData[$scope.fd.PresentationId][0].BlockId).then(function(data) {
                               
                               // let ret_val = {'block_num':data.data.block_num,'block_time':data.data.block_num,
                               // 'id':data.data.id,'traces':data.data.traces,'trx':data.data.trx};
                                let ret_val = data.data;
                                $scope.fd.BlockChainTransaction = JSON.stringify(ret_val,null,2);
                                $scope.fd.showTransaction = true;
                            
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                
            };

    
            let template;
            if ($scope.formDefinition) template = $templateCache.get('ktdirectivetemplates/ktTaskViewResource.html');
            else template = $templateCache.get('ktdirectivetemplates/ktTaskViewResourceExe.html');
          
            $element.append($compile(template)($scope)); 

  
      }];

  return {
            restrict: 'A',
           
            controller: controller,
            link: function (scope, elem, attrs) {

            }     
  }
  
};
'use strict';

export function ktTextbox () {
        return {
                restrict: 'A',
		controller: function ($scope,$rootScope,GridsterService,KatalyoStateManager,CodesService,$templateCache,$compile,$element) {
                        
                        if ($scope.localVars==undefined) $scope.localVars={};
                               
                        $scope.gsrvc = GridsterService;
                        $scope.ksm = KatalyoStateManager;
                        var lang=$rootScope.globals.currentUser.lang;
                        CodesService.getCodesByName('usertags',lang).then(function (data) {
                                $scope.fd.tagList = data.data;
                                
                                 var pos = $scope.fd.tagList.map(function(e) { return e.id; }).indexOf($scope.fd.UniqueId);

                                   if (pos>=0){
                                       $scope.fd.UniqueIdObj=$scope.fd.tagList[pos];
                                      
                                   }
                             });
                         
                        if ($scope.fd.Parameters==undefined) $scope.fd.Parameters={};
                        let textValue = null;
                        if ($scope.formData!=undefined)
                        {
                                if ($scope.formData.length==0) $scope.formData=[{}];
                                textValue=$scope.formData[0]['Field'+$scope.fd.ItemId]
                                
                        }else $scope.formData=[{}];
                        
                        let textValueState= $scope.ksm.addSubject('textValueStateName'+$scope.fd.ItemId,textValue);
                        let textValueStateName = textValueState.subject.name;
                        
                        let value_changed = function(data)
                        {
                            textValueState.subject.setStateChanges = data;
                            textValueState.subject.notifyObservers("valueChanged");
                            $scope.localVars.refreshSearchValue();
                        };
                        
                        let action_value_changed = $scope.ksm.addAction(textValueStateName,"valueChanged",value_changed);
                       
                        $scope.on_blur_action=function()
                        {
                                
                                $scope.ksm.executeAction(textValueStateName,"valueChanged", $scope.formData[0]["Field"+$scope.fd.ItemId]);
                                //$scope.fd.DefaultValue = $scope.formData[0]["Field"+$scope.fd.ItemId];
                        };
                       
                        
                        
                        let apply_value = function(data)
                        {
                            $scope.formData[0]["Field"+$scope.fd.ItemId] = data;
                        }; 
                        if ($scope.fd.Parameters.DependentFieldId!=undefined && $scope.fd.Parameters.DependentFieldId!=null)
                        
                        {
                            if ($scope.fd.Parameters.DependentFieldId!="")
                            {
                                let dependent_field = "Field"+$scope.fd.Parameters.DependentFieldId;
                                let subscribedSubject = $scope.fd.Parameters.DependentFieldType+"ValueStateName"+$scope.fd.Parameters.DependentFieldId;
                                let observer = $scope.ksm.subscribe(subscribedSubject,dependent_field,"valueChanged",apply_value);
                            }
                        }
                        
                        $scope.fd.SetDefault = function(){
                                $scope.fd.DefaultValue = {Value:$scope.formData[0]["Field"+$scope.fd.ItemId]};
                        }
                    
                        $scope.fd.onSelectUnique = function(item,model)
                        {
                                
                                $scope.fd.UniqueId=item.id;
                        }
                       
                       let template;
                        if ($scope.taskDefinition.form_definition) template = $templateCache.get('ktdirectivetemplates/ktTextbox.html');
                        else template = $templateCache.get('ktdirectivetemplates/ktTextboxExe.html');
                      
                        $element.append($compile(template)($scope));  
    
                        },
       
        link: function (scope, elem, attrs) {
				
                     
                scope.colLength=[];
                for (var i=0;i<24;i++) scope.colLength.push('col-'+(i+1));
            
		
                scope.search=[
                {id:1,filter:'begins',name:"Begins with",icon:"fa fa-chevron-right"},
                {id:2,filter:'contains',name:"Contains",icon:"fa fa-expand"},
                {id:3,filter:'ends',name:"Ends with",icon:"fa fa-chevron-left"},
                {id:4,filter:'eq',name:"Equals",icon:"fa fa-bars"} ];
                

                scope.applyTextFilters = function(index) {
                        scope.fd.Search=scope.search[index];
                        
                        if (scope.fd.Search && scope.formData!=undefined)
                        {
                        if (scope.formData.length>0) scope.fd.Search.Value=scope.formData[0]['Field'+scope.fd.ItemId]; 
                        }
                        if (scope.fd.Search.Value==undefined) scope.fd.Search.Value = "";
                };

                scope.localVars.refreshSearchValue = function() {
                        if (scope.fd.Search) scope.fd.Search.Value=scope.formData[0]['Field'+scope.fd.ItemId];      
                };
             
                scope.showProperties = function(event)
                {
                  scope.gsrvc.setFieldProperties(scope.fd,event);
       
                };
             
               if (scope.fd.ShowSearchForm)  {
                   if (scope.fd.Search==undefined) scope.fd.Search=scope.search[1];//initialize to contains
              }
              
              
            }
        };
};
'use strict';

export function ktTime () {
        return {
                restrict: 'A',
                controller: function ($scope,GridsterService,KatalyoStateManager) {
                        
                        $scope.gsrvc = GridsterService;
                         $scope.showProperties = function()
                          {
                             $scope.gsrvc.setFieldProperties($scope.fd);
                          };
                      
                        },
        templateUrl: 'ktdirectivetemplates/ktTime.html',
        link: function (scope, elem, attrs) {
				
           if (scope.formData===undefined) scope.formData = [{'Field':0}];
          if (scope.formParams===undefined) scope.formParams = {formViewType:1};
          if (scope.formParamsParent===undefined) scope.formParamsParent = {formViewType:1};
          
          if (scope.fd.ParametersLang===undefined) scope.fd.ParametersLang={format1:'HH:mm'};
          
          scope.colLength = [];
          for (var i=0;i<24;i++) scope.colLength.push('col-lg-'+(i+1));
             
          scope.fd.timeFormatList = [{id:1,name:'HH:mm',mask:'99:99'},{id:2,name:'HH:mm:ss',mask:'99:99:99'},{id:3,name:'HH:mm'},{id:4,name:'HH:mm:ss:sss'}];
          
          if (scope.fd.ParametersLang!=undefined && scope.fd.ParametersLang!=null)
          {
             
              var posFormatTime = scope.fd.timeFormatList.map(function(e) { return e.name.toString(); }).indexOf(scope.fd.ParametersLang.format1);
                  
              if (posFormatTime>=0){
                 
                scope.fd.ParametersLang.format1=scope.fd.timeFormatList[posFormatTime];
                                      
              }
                 
              scope.localVars.format = scope.fd.ParametersLang.format1;           
          }  
        }
    };

}

'use strict';

export function ktToolbox () {

        return {
            restrict: 'A',
             templateUrl: 'ktdirectivetemplates/ktToolbox.html',
             /* scope:{
                	 form : '=',
            },*/
             controller: ['$scope','dragulaService','$rootScope','GridsterService',
          
            function($scope,dragulaService,$rootScope,GridsterService){
               
                $scope.gsrvc = GridsterService;      
                var widgetHandle = 'element-drag-handle';
                var setupDragula = $scope.gsrvc.setupDragula('bag-resource','dataset-toolbox',widgetHandle);
            
            }],
            
             link: function (scope, elem, attrs) {

              scope.toolboxItems= scope.gsrvc.getToolboxItems();
              
        }
    }
};
'use strict';

export function ktTreeView () {
   
    var controller = ['$scope', '$uibModal', '$stateParams','$state','$timeout','CodesService','ResourcesDataService','$rootScope','CODES_CONST','ProcessingService','MessagingService','GridsterService','TaskDataService','WidgetDataExchangeService',
                     function ($scope,$uibModal,$stateParams,$state,$timeout,CodesService,ResourcesDataService,$rootScope,CODES_CONST,ProcessingService,MessagingService,GridsterService,TaskDataService,WidgetDataExchangeService) {
     
    
    $scope.localVars={};
    $scope.localVars.datasetMapperType=0;
    $scope.localVars.src_type_text=CODES_CONST._POPULATE_TYPE_; 
    $scope.localVars.searchFormDownloaded = false;
    $scope.localVars.showSearchFilters=true;
    $scope.localVars.resourceDataDownloaded = true;
    $scope.taskId=$scope.taskDefinition.ResourceDefId;
    if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
    if ($scope.taskId==undefined) $scope.taskId=0
    $scope.localVars.taskId=$scope.taskId;
    $scope.localVars.widgetType = 4;
    
    $scope.localVars.parentDatasetDefId=$scope.fd.Related;
    $scope.localVars.animationsEnabled = true;
	  
 
     $scope.localVars.gridsterType="resource";
          

     $scope.localVars.dashboard = {
  				id: '1',
  				name: 'Home',
  				widgets: GridsterService.getEmptyDatasetForm()
				} ;
        
        
       $scope.localVars.gridOptionsResourceData = {
        enableGridMenu: true,
        showGridFooter: true,
        showColumnFooter: true,
        enableRowSelection: true,
        multiSelect: $scope.fd.Multiline,
        enableFiltering: true,
        enableRowHeaderSelection: true,
        enableColumnResizing: true,
        enableColumnReordering: true,
        useExternalPagination: true,
        paginationPageSizes: [10, 25, 50,100,200,500,1000],
        enablePaginationControls: false,
      };

  var paginationOptions = {
    pageNumber: 1,
    pageSize: 10,
    sort: null
    };
    
    
       $scope.localVars.gridOptionsRelated = {
      //  columnDefs: colDefs,
       enableGridMenu: true,
       showGridFooter: true,
       showColumnFooter: true,
       enableRowSelection: false,
       multiSelect: false,
       enableHorizontalScrollbar : 2, 
       nableVerticalScrollbar : 2,
       enableFiltering: true,
       enableRowHeaderSelection: true,
       enableColumnResizing: true,
       minRowsToShow: 2,
      
   }
    
        $scope.taskId=$scope.taskDefinition.ResourceDefId;
        if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
        if ($scope.taskId==undefined) $scope.taskId=0;
        
        //$scope.fd.PopulateType=1;
        $scope.fd.ParentDatasetDefId=$scope.fd.Related;
        $scope.prevTaskExeId =  $scope.taskDefinition.prev_task_id;
        $scope.localVars.formType=$scope.taskDefinition.form_type;
        $scope.localVars.source_type=$scope.taskDefinition.source_type;
        $scope.taskInitiateId = $scope.taskDefinition.task_initiate_id;
        $scope.taskExecuteId = $scope.taskDefinition.task_execute_id;
        $scope.formDefinition = $scope.taskDefinition.form_definition;
        if  ($scope.formDefinition==undefined)
        {
          
          $scope.formDefinition = false;
        }
        
        
        
        
          if ($scope.taskInitiateId==undefined)
       {
        $scope.taskInitiateId =0;
        
       }
       if ($scope.taskExecuteId==undefined)
       {
        $scope.taskExecuteId =0;
        
       }
        if ($scope.prevTaskExeId==undefined)
        {
          $scope.prevTaskExeId =0;
        }
        
        $scope.localVars.resourceRecordId = 0;
        $scope.fd.ParentElementId = 0;
        
        
        
      var out_fields = ['resourceRecordId']
      //resourceLink
      var widgetDefinition = {DEI: [{'name':'resourceLinkDatasetList','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'datasetListWidget',widgetId: $scope.fd.PresentationId,taskId:  $scope.lTaskId,
      resourceDefId : $scope.fd.Related, //resourceDefId : $scope.selectedResource
      resourceRecordId:$scope.localVars.resourceRecordId,task_initiate_id:$scope.taskInitiateId,task_execute_id:$scope.taskExecuteId, output:out_fields };
      $scope.localVars.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition);
      $scope.localVars.localId=$scope.localWidgetId;
      
      
      $scope.localVars.gridOptionsResourceData.onRegisterApi = function (gridApi) {
        //set gridApi on scope
        $scope.localVars.gridApi = gridApi;
           
          gridApi.selection.on.rowSelectionChanged($scope,function(row){

            $scope.localVars.datasetRecordSelected=row.isSelected;
            if ($scope.localVars.datasetRecordSelected)
              {
                if (row.entity.id!=$scope.localVars.selectedDatasetRecordId)
                {
                  $scope.localVars.selectedDatasetRecordId = row.entity.id;
                }
              }else
              {
                $scope.localVars.selectedDatasetRecordId = 0;
                
              }
              $scope.localVars.gridOptionsRelated.columnDefs=[];
              $scope.localVars.gridOptionsRelated.data=[];
              $scope.localVars.showGrid=false;
              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.Related,records:gridApi.selection.getSelectedRows()}
              
               if (gridApi.selection.getSelectedRows().length>0)
              {
                //$rootScope.$broadcast('EventresourceLink'+$scope.fd.PresentationId,$scope.selectedDatasetRecordId);
                WidgetDataExchangeService.setData({
                  DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                        ,{name:'resourceRecordIds',value:gridApi.selection.getSelectedRows()},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
              }
              
          });
          
            //external pagination
          gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
            paginationOptions.pageNumber = newPage;
            paginationOptions.pageSize = pageSize;
            $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,newPage,pageSize);
          });
      
           gridApi.selection.on.rowSelectionChangedBatch($scope,function(row){

              $scope.localVars.prevTaskPackage ={resourceDefId:$scope.fd.Related,records:gridApi.selection.getSelectedRows()}
              
          });
     }
     
     
     $scope.localVars.ProcessSearchForm=function (form){
            
            if (form!=undefined){
     					for(var i=0;i<form.length;i++) {
                
                    if ('type' in form[i])
                    {
                      if (form[i].type == 'resource' && form[i].autoSearch)
                      {
                        var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(form[i].presentationId);
                        if (pos<0) $scope.localVars.childWidgets.push({widgetId:form[i].presentationId,processed:false})
                        
                      }
                     }
                      if ('layout' in form[i])
                      {
                           
                       $scope.localVars.ProcessSearchForm(form[i].layout);
                      }
              }
          } 
           
      };
      
      $scope.localVars.SearchFormProcessed=false;

      /*
      $scope.localVars.setDatasetMapperType= function(type){
            $scope.localVars.datasetMapperType = type;
          };      
      */
       $scope.localVars.setSelectedDataset = function(id)  {
              
              if ($scope.localVars.selectedResourceItem==undefined) $scope.localVars.selectedResourceItem={};
              var pos = $scope.localVars.datasetList.map(function(e) { return e.id; }).indexOf(id);
              
              if (pos>=0){
                $scope.localVars.selectedResourceItem.id = $scope.localVars.datasetList[pos].id;
                $scope.localVars.selectedResourceItem.name = $scope.localVars.datasetList[pos].name;
                $scope.localVars.selectedDataset = $scope.localVars.datasetList[pos];
                $scope.localVars.selectedResourceItem.name_confirmed = $scope.localVars.selectedResourceItem.name +' ('+$scope.localVars.selectedResourceItem.id +')'
                $scope.localVars.selectedResourceItem_c=$scope.localVars.selectedResourceItem;
                }
					};
          
       // POPUNI LISTU DEFINICIJA OD RESURSA (RESOURCES LIST)
					$scope.localVars.getDatasets = function()  {
						
            if ($scope.localVars.datasetList==undefined) $scope.localVars.datasetList=[];
          
            var lang=$rootScope.globals.currentUser.lang;
            ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
						function(data) {
										
											  $scope.localVars.datasetList = data.data;
                       if ($scope.fd.Related!=null)
                       {
                        $scope.localVars.setSelectedDataset($scope.fd.Related);
                
                        }     
											 
										  },function(error){    
                                MessagingService.addMessage(error.msg,'error');
										 });
					}
            
      $scope.localVars.GetDatasetData=function(data)

      {

            fromWidget = data.widgetId;
            var allProcessed=true;
            var pos = $scope.localVars.childWidgets.map(function(e) { return e.widgetId; }).indexOf(fromWidget);
            //if (pos<0) $scope.fd.childWidgets.push({widgetId:fromWidget,processed:true});
            for (var i=0;i<$scope.localVars.childWidgets.length;i++)
              {
                
                if ($scope.localVars.childWidgets[i].widgetId == fromWidget) $scope.localVars.childWidgets[i].processed = true;
                if (!$scope.localVars.childWidgets[i].processed) allProcessed = $scope.localVars.childWidgets[i].processed;
              }
             // if (!$scope.SearchFormProcessed) $timeout(function() {$scope.GetDatasetData(fromWidget);},1000);
              if($scope.fd.AutoSearch && allProcessed && $scope.localVars.SearchFormProcessed) {
                  $scope.localVars.selectedResource=$scope.fd.Related;
                  $scope.localVars.getResourceColumns(true);
                                      
                }
      };
       
      if ($scope.localVars!=undefined) $scope.localVars.childWidgets = [];
      else $scope.localVars = {childWidgets : []};
     // $scope.uncaughtWidgets = [];
      var fromWidget=0;
   
 
      $scope.$on('SearchFormReady'+$scope.taskExecuteId,function(event, data){
      
           $scope.localVars.GetDatasetData(data); 
            
      });     
     
   
   //**********************************************************
	//           GET DATASET RELATED RECORDS
	//**********************************************************      
        $scope.localVars.getDatasetRelatedRecords = function (relatedDatasetId,recordId,modelId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataRelated($scope.fd.Related,recordId,relatedDatasetId,0,modelId,lang).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                                     $scope.localVars.showGrid=true;
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
        
        
 //**********************************************************
	//           GET DATASET SINGLE RECORD
	//**********************************************************      
      $scope.localVars.getDatasetSingleRecord = function (relatedDatasetId,recordId) {
  
  
         var lang = $rootScope.globals.currentUser.lang;
        
         ResourcesDataService.getResourceDataDirectFilter(relatedDatasetId,0,lang,{id: recordId}).then(function(data) {
                                
                                     $scope.localVars.gridOptionsRelated.data = data.data;
                                     $scope.localVars.gridOptionsRelated.columnDefs = data.columnsDef;
                               
         //                            MessagingService.addMessage(data.msg,'success');
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
        };
    
        $scope.$on('SearchFormReady'+$scope.taskExecuteId+$scope.fd.PresentationId,function(event, data1){
      
                                        $scope.localVars.GetDatasetData(data1); 
            
        });
        
    $scope.localVars.getFormResource = function(){   
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null) {
                $scope.fd.PresentationId = 0;
              }
              
               
              ResourcesDataService.getResourceFormExtendedWithData($scope.fd.Related,$scope.taskInitiateId,$scope.taskExecuteId,$scope.fd.PopulateType,$scope.fd.ParentElementId,$scope.fd.PresentationId,$scope.prevTaskExeId,$scope.localVars.formType,$scope.localVars.widgetType,$scope.localVars.resourceRecordId,"f",lang).then(function(data) {
                 
                                    $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                
                             
                                    $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.Related,'relatedId':$scope.fd.Related,'presentationId':$scope.fd.PresentationId,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                              
                               
                                    $scope.fd.fItemValue=data.data.widgets;

                                    $scope.localVars.searchFormDownloaded = true;
                                    $scope.localVars.setField($scope.fd.fItemValue,'required',false);
                                    $scope.localVars.formLoaded=true;
                                   //prepare search form
                                    $scope.localVars.ProcessSearchForm($scope.fd.fItemValue);
                                    $scope.localVars.SearchFormProcessed = true;
                                    if ($scope.localVars.childWidgets.length>0)
                                    {
                                      WidgetDataExchangeService.registerSearch({widgetId:$scope.fd.PresentationId,taskExecuteId:$scope.taskExecuteId,prevTaskExeId:$scope.prevTaskExeId,childWidgets:$scope.localVars.childWidgets});
                                    }
                                    else
                                    {
                                       $rootScope.$broadcast('SearchFormReady'+$scope.taskExecuteId,{widgetId:$scope.fd.PresentationId});
                                    }
                                    $scope.localVars.dashboard.widgets.layout =  data.data.widgets;
                                    if ($scope.formData == undefined) $scope.formData={};
                                    $scope.formData[$scope.fd.PresentationId] =  data.data.form_data;
                                    $scope.fd.Search = $scope.formData[$scope.fd.PresentationId];
               
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error'); 
                             });
                              
      };//getFormResource_END
    
  $scope.localVars.getFormResourceOriginal = function(){
              var lang=$rootScope.globals.currentUser.lang;
              if ($scope.fd.PresentationId==null)
              {
                $scope.fd.PresentationId = 0;
                
              }
              ResourcesDataService.getResourceForm($scope.fd.Related,"i",lang).then(function(data) {
                            
                                $scope.localVars.resourceWidgetDefinition= data.data.resourceDefinition;
                                $scope.localVars.dashboard.widgets.layout=data.data.widgets;
                                 $scope.localVars.selectedResourceItem_c = {'name':$scope.localVars.resourceWidgetDefinition.name,'id':$scope.fd.Related,'relatedId':$scope.fd.Related, 'presentationId':$scope.fd.PresentationId  ,'src_type_id':$scope.fd.PopulateType,'src_type_text':$scope.localVars.src_type_text[$scope.fd.PopulateType],'parentElementId':$scope.fd.ParentElementId};
                            
                             
                                $scope.fd.fItemValue=data.data.widgets;
                                
                                //MIGOR - bitno - DOBIO RESOURCERECORD-ID ZA BROADCAST  - ADD_RESOURCE WIDGET
                                WidgetDataExchangeService.setData({widgetId:$scope.fd.PresentationId, DEI: [{'name':'resourceLink','value':[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.resourceRecordId}]}]});
						
                                  $scope.localVars.searchFormDownloaded = true;
                                   $timeout(function() {
                                    $scope.localVars.formLoaded=true;
                                     
                                    });
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                             });
                              
      };
   
   $scope.localVars.datasetRecordSelected = false;
   $scope.localVars.selectedDatasetRecordId = 0;
 
     
      $scope.localVars.getResourceData = function () {

        // scope.activity.activityMessage = ProcessingService.setActivityMsg('Downloading resource data for '+scope.selectedResource);
        var lang = $rootScope.globals.currentUser.lang;
        $scope.localVars.resourceDataDownloading = true;
        if ($scope.localVars.pageSize==undefined) $scope.localVars.pageSize = paginationOptions.pageSize;
        ResourcesDataService.getResourceData($scope.localVars.selectedResource,$scope.taskId,lang).then(function(data) {
                               
                                     $scope.localVars.gridOptionsResourceData.data = data.data;
                                     $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                     $scope.localVars.restoreGridState();
                                     $scope.localVars.resourceDataDownloaded = true;
                                    
                                 },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                   
                             });
        };

		 
      //**********************************************************
      //           GET RESOURCE DATA PAGINATED
      //**********************************************************      
    $scope.localVars.getResourceDataPaginated = function (urlNext,urlPrev,newPage,pageSize) {
        
        
        $scope.localVars.resourceDataDownloaded = false;        
        if (Math.ceil($scope.localVars.totalCount/pageSize)<newPage)
        {
          newPage = Math.ceil($scope.localVars.totalCount/pageSize);
        }
         
         var lang = $rootScope.globals.currentUser.lang;
          
         if (pageSize==undefined)
         
         {
          $scope.localVars.pageSize = paginationOptions.pageSize;
          pageSize= $scope.localVars.pageSize;
         }
         
         if ($scope.fd.PopulateMethod=='M')
         {
          ResourcesDataService.getResourceDataPaginatedFilter($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.Search, $scope.localVars.dashboard.widgets.layout).then(function(data) {
                                    
                                    
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data.results;
                                    $scope.localVars.restoreGridState();
                                    $scope.localVars.resourceDataDownloaded = true;
                                    
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLinkDatasetList',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.PresentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
         }
         else if ($scope.fd.PopulateMethod=='A')
         {
          var task_instance=0;  
          if ($scope.localVars.formType=='i') task_instance = $scope.taskInitiateId;
          else task_instance = $scope.taskExecuteId;
    
          ResourcesDataService.getResourceDataPaginatedAuto($scope.localVars.selectedResource,urlNext,urlPrev,newPage,pageSize,lang,$scope.fd.PresentationId,task_instance,$scope.localVars.formType).then(function(data) {
                                    
                                    
                                      
                                    $scope.localVars.gridOptionsResourceData.data = data.data.results;
                                    $scope.localVars.restoreGridState();
                                    $scope.localVars.resourceDataDownloaded = true;
                                    
                                    $scope.localVars.nextPage = data.data.next;
                                    $scope.localVars.previousPage = data.data.previous;
                                    $scope.localVars.totalCount=data.data.count;
                                    $scope.localVars.currentPage=newPage;
                                    $scope.localVars.numPages = Math.ceil($scope.localVars.totalCount/pageSize);
                                    $scope.localVars.pageSize = pageSize;
                                    $scope.localVars.gridOptionsResourceData.totalItems=$scope.localVars.totalCount;
                                    
                                    WidgetDataExchangeService.setData({
                                    DEI: [{name:'resourceLink',value:[{name:'resourceId',value:$scope.fd.Related},{name:'resourceRecordId',value:$scope.localVars.selectedDatasetRecordId}
                                    ,{name:'resourceRecordIds',value: null},{name:'resourceRecordsAll',value:$scope.localVars.gridOptionsResourceData.data}]}],widgetId: $scope.fd.PresentationId,task_execute_id:$scope.taskExecuteId});
            
                                    $rootScope.$broadcast("StartTask"+$scope.fd.PresentationId+"Completed",$scope.localVars.gridOptionsResourceData.data);
                                   
                                   
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
          
         }
        };


 $scope.localVars.pageChanged = function(){
        $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,$scope.localVars.currentPage,$scope.localVars.pageSize);
         };
   //**********************************************************
	//           GET RESOURCE COLUMNS
	//**********************************************************      
  $scope.localVars.getResourceColumns = function (getData) {
     var lang = $rootScope.globals.currentUser.lang;
     if ($scope.localVars.selectedResource==undefined) $scope.localVars.selectedResource = $scope.fd.Related;
     
     if ($scope.localVars.selectedResource!=undefined && $scope.localVars.selectedResource!=null)
     {
     ResourcesDataService.getResourceColumns($scope.localVars.selectedResource,$scope.taskId,lang).then(function(data) {
                                
                $scope.localVars.gridOptionsResourceData.columnDefs = data.data;
                
                if (getData) $scope.localVars.getResourceDataPaginated($scope.localVars.nextPage,$scope.localVars.previousPage,1,$scope.localVars.pageSize);               
                
         //                            MessagingService.addMessage(data.msg,'success');
         
                                  },function(error){
                                    MessagingService.addMessage(error.msg,'error');               
                             });
               
     }
  };
     
     $scope.localVars.getResourceDataFiltered = function () {

            $scope.filter = {};
            var lang = $rootScope.globals.currentUser.lang;

           //scope.activity.activityMessage = ProcessingService.setActivityMsg('Retriving data '+scope.selectedResource);
          //$scope.filter = ResourcesDataService.prepareResourceWidgetData($scope.dashboard.widgets,-1);
         
          if ($scope.localVars.selectedResource==null) {
            $scope.localVars.selectedResource = $scope.fd.Related;
          }
	//		ResourcesDataService.getResourceDataFiltered($scope.fd.Related,lang,$scope.filter).then(function(data) {//MIGOR
         ResourcesDataService.getResourceDataFiltered($scope.localVars.selectedResource,$scope.taskId,lang,$scope.localVars.dashboard.data).then(function(data) {//MIGOR
                            
                                  $scope.localVars.gridOptionsResourceData.data = data.data;
                                  $scope.localVars.gridOptionsResourceData.columnDefs = data.columnsDef;
                                  
                                    $timeout(function(){
                                      $scope.localVars.resourceDataDownloaded = true;
                                      $scope.localVars.restoreGridState();
                                    });
                                 
                                     
                                  },function(error){
                                MessagingService.addMessage(error.msg,'error');
                             });
        };
		
       $scope.localVars.setField = function(form,name,value,msg)
        {
     				TaskDataService.setField(form,name,value);
            if (msg) MessagingService.addMessage(msg,'info');
        };
        
          $scope.localVars.showHideSearchForm = function()
        {
     				if ($scope.fd.ShowSearchForm) $scope.localVars.getFormResource();
        };
       
        
    
  if ($scope.fd.Related!=null &&  !$scope.formDefinition && !$scope.localVars.searchFormDownloaded)
  {
    $scope.localVars.getFormResource();
    
  }else if ($scope.fd.Related!=null && ($scope.localVars.showForm || $scope.fd.AutoSearch))
  {
     $scope.localVars.getFormResource();
     $scope.localVars.getDatasets();
      $scope.localVars.getResourceColumns(false);
    
  }else if(!$scope.localVars.showForm)
  {
     $scope.localVars.showHideSearchForm();
     $scope.localVars.getResourceColumns(false);
     $scope.localVars.getDatasets();
    
  }
  
    
    
		 $scope.localVars.saveGridState= function() {
       var state = $scope.localVars.gridApi.saveState.save();
       $scope.fd.GridState = state;
       MessagingService.addMessage("To make changes stick please save form",'info');
             
    };
  
   $scope.localVars.restoreGridState= function() {
    if ($scope.fd.GridState!=null)
    {
       if ($scope.localVars.gridApi!=undefined)
       {
      
        $scope.localVars.gridApi.saveState.restore($scope,$scope.fd.GridState);
        
       }else
       {
        $timeout(function(){
            $scope.localVars.restoreGridState();
        });
       }
    }
  };
        
               $rootScope.$broadcast("Widget"+$scope.fd.PresentationId+"Ready",null);
                          
}]; //controler_END

  return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktTreeView.html',
            controller: controller,
            link: function (scope, elem, attrs) {

            
            
            
             }
             
             
  } 
        
};
'use strict';

export function ktUploader ($timeout,uiUploader,WidgetDataExchangeService,ResourcesDataService,TaskDataService,$cookies,$rootScope) {
        return {
        restrict: 'A', 
             templateUrl: 'ktdirectivetemplates/ktUploader.html',
             controller: function ($scope, $element,$rootScope,$uibModal,MessagingService,ProcessingService,$log,GridsterService,$timeout,$stateParams) {

                //console.log("U kontroleru");
                $scope.gsrvc = GridsterService;
                $scope.fd.ReadOnly=false;
                $scope.animationsEnabled = true;
                $scope.showFileMetaData=false;
                $scope.taskId=$scope.taskDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;  
                if ($scope.localVars==undefined)  $scope.localVars = {datasetMapperType:0};
                $scope.files = [];              
                $scope.localVars.showProperties=function(datasetMapperType)
                {
                 
                 if ($scope.localVars.datasetMapperType==undefined)
                 {
                    $scope.localVars.datasetMapperType = datasetMapperType;
                 }else
                 {
                    if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                    else $scope.localVars.datasetMapperType=0;
                 }
                 
                };
            
            
             $scope.localVars.okFileConnector = function () {
                $timeout(function() {
                $scope.fd.tItemValue=$scope.fd.listOfConnectors;
                $scope.localVars.showProperties(0);
                
                });
            };
            
             $scope.localVars.cancelFileConnector = function () {
                $timeout(function() {
                $scope.fd.listOfConnectors=angular.copy($scope.fd.tItemValue);
                $scope.localVars.showProperties(0);
                
                });
            };

            
		  $scope.okModal = function (windex,index) {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };

		  $scope.cancelModal = function () {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };
		  
       
        
		 $scope.showMetadata = function(fileIndex,fileId){ 
		 
				   var lang=$rootScope.globals.currentUser.lang;
				   var file_resource_type = "file";
				    $scope.taskId=$stateParams.id;
				   
				    //ResourcesDataService.getResourceFormextended(id resursa ,task-id, i, $scope.fd.presentationId,lang)
					
				   ResourcesDataService.getResourceForm(fileId,"i",lang).then(function(data) {
                               
                                 var sc=$scope;
                                  //$scope.gridOptions.data = data.data;
								  //$scope.files[fileIndex].dashboard=[];
								  $scope.files[fileIndex].dashboard=data.data;
								  //files[$index].dashboard.widgets
								  
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
						});
                            
		

			  };
     
           
			// OPEN MODAL filehelper
			 $scope.openModal = function (size,fileIndex) {
                  var modalInstance = $uibModal.open({
                  animation: $scope.animationsEnabled,
                  templateUrl: 'filehelper.html',
                  controller: 'FileModalInstanceCtrl',
                  size: size,
                  resolve: {
                    retValue: function () {
                      return {resourceId:$scope.resourceId,fileIndex:fileIndex,files:$scope.files,headline:'Enter file metadata'};
                    }
                  }
            });
			
			
            modalInstance.result.then(function (retValue,windex,index) {
             // $scope.getResourceForm ();
             
         
          }, function () {
          //$log.info('Modal dismissed at: ' + new Date());
          });
       
		};
        
      
      //novi FILE CONNECTOR - UPLOADER
      $scope.localVars.openFileConnector  = function(){
             //$scope.fd.showFileConnector= !$scope.fd.showFileConnector;
            $scope.localVars.showProperties(1);
             if ($scope.localVars.datasetMapperType==1) {
                           
                 //POPUNI LISTU DATASETOVA            
                  ResourcesDataService.getResourceDefListByType(lang,'dataset').then(
                                function(data) {
                                                  $scope.datasetList = data.data;
                                                  //dodaj ime dataseta u konektore
                                                  if ($scope.fd.listOfConnectors!=undefined) 
                                                             for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                                   //var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   var p = $scope.datasetList.map(function(e) { return e.id; }).indexOf($scope.fd.listOfConnectors[i].parentDatasetDefId);
                                                                   if (p>=0) $scope.fd.listOfConnectors[i].parentDatasetName = $scope.datasetList[p].name;  
                                                             }
                                                  
                                                  },function(error){    
                                        MessagingService.addMessage(error.msg,'error');
                                                 });
                                                 
                                                 
 							if ($scope.fd.tItemValue==undefined || $scope.fd.tItemValue[0]==null) $scope.fd.tItemValue = []; 
							// ovo je  Kt-UPLOADER
							  $scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredWidgets();//MIGOR  - uzmi sve registrirane widgete
							  
							  //Brisi sve koji se vec nalaze u tItemValue
							   if ($scope.fd.listOfConnectors!=undefined) 
								  for (var i=0;i< $scope.fd.tItemValue.length ;i++) {
										 for (var j=0;j< $scope.fd.listOfConnectors.length;j++) {
                                              if ($scope.fd.tItemValue[i]!=null) {
                                                 if ($scope.fd.listOfConnectors[j].widgetId==$scope.fd.tItemValue[i].widgetId)  {
                                                     $scope.fd.listOfConnectors.splice(j,1);//brisi lokalni				   					    		
                                                 }
                                              }
                                         }
							    }
                                //dodaj sa servera
                                for (var i=0;i< $scope.fd.tItemValue.length ;i++) 
                                              if ($scope.fd.tItemValue[i]!=null) 
                                                  $scope.fd.listOfConnectors.push($scope.fd.tItemValue[i]);		
                                

							  //Ostavi u listi konektora samo WIDGETE koji imaju "ResourceID" jer su to data widgeti
							  var newlist=[];
                              
							    if ($scope.fd.listOfConnectors!=undefined){
                 
                                 for (var i=0;i< $scope.fd.listOfConnectors.length;i++) {
                                                     if ($scope.fd.listOfConnectors[i].DEI!=undefined)  
                                                         for (var j=0;j< $scope.fd.listOfConnectors[i].DEI.length;j++) {
                                                             if ($scope.fd.listOfConnectors[i].DEI[j].name=='resourceLink') {
                                                                 //ako DEI.value nije true/false - resetiraj na false (znaci NIJE POVEZAN još)
                                                                 if ( ($scope.fd.listOfConnectors[i].DEI[j].value!=false) && ($scope.fd.listOfConnectors[i].DEI[j].value!=true) ) $scope.fd.listOfConnectors[i].DEI[j].value=false;
                                                                 //dodaj konektor u novu listu 
                                                                 newlist.push($scope.fd.listOfConnectors[i]);
                                                             };						 						  						   					      
                                                    }
                                               }
                                }//if
							  $scope.fd.listOfConnectors=newlist; //konacna lista NOVIH dataset konektora 
 
							  //return {selectedItemFromServer:$scope.fd.tItemValue,listOfConnectors: $scope.fd.listOfConnectors,headline:'Choose required interfaces',selectedFileConnector:$scope.selectedFileConnector};
						
				  
				/* interfaceModal.result.then(function (selectedItem) { 
							//$scope.fd.tItemValue=selectedItem; // //MIGOR TODO vidjet da li treba angular.copy(selectedItem);
                            $scope.fd.tItemValue=angular.copy(selectedItem); // MIGOR TODO - TEST SA ANGULAR COPY
                            
                            
							// MIGOR  TODO -
							//selektirani widget ima "resourceID" interface" -  registriramo se na njegov "event"
							
							$scope.$on('resourceId:'+selectedItem,
								function(event, data){
									console.log('resourceID uhvacen u ktUploader! data:' +  data);
							})
							
							//$scope.fd.listOfConnectors= WidgetDataExchangeService.getRegisteredInterfaces(selectedItem); 
							
							
				}*/
	
            } //if showfileconnetor  
		}; // open FILECONNECTOR - UPLOADER
                    
      
					
				 	// FUNCTION ONSELECT CALLBACK II
					$scope.onSelectCallback2 = function (item, model,fileIndex){
						var eventResultId=item.id;
						$scope.eventResultName=item.Name;
						
						 //console.log("onSelectCallback II:" +  $scope.eventResultName+ ' ' + eventResultId);

						  $scope.resourceId=eventResultId;
						  $scope.isResourceSelected=true;
						 	
								$scope.fd.filetype=$scope.resourceId; 						
					}//onSelectCallback II
				 
				 
				 
				 
					// FUNCTION - ON_SELECT_FILETYPE 
					// NAKON TO SE ZA POJEDINAÈNI FILE ODABERE FILE-TYPE  --> $scope.resourceId
					
					$scope.onSelectFileType = function (item,fileIndex){
						var selectedFileTypeId=item.id;
						$scope.resourceId=selectedFileTypeId;
						 $scope.isResourceSelected=true;
			             if ($scope.files[fileIndex].fileResourceID!=selectedFileTypeId) {
			              $scope.files[fileIndex].fileResourceID = selectedFileTypeId;
			              $scope.files[fileIndex].formLoaded = false;
			             }
					
					
						 
						console.log("onSelectFileType :" + selectedFileTypeId);
		
						$scope.fileIndex=fileIndex;
						
								//if ($scope.files[fileIndex].fileResourceID== undefined) {
								//	$scope.getResourceForm ();
								//	}
									
								//if ($scope.resourceId != undefined) {	
									//$scope.getResourceForm ();
								//}
						 		
						//$scope.fd.related=$scope.resourceId; // ovo viska??? MIGOR
						
						$scope.showMetadata(fileIndex,$scope.files[fileIndex].fileResourceID );
						
						var err=$scope.testRules();
				
					}//onSelectFileType
				 
				 
				    
				var lang = $rootScope.globals.currentUser.lang;
				var type="file"; // PROMJENITI - ZASAD JE HARD-CODED !!!!! MIGOR
					 
					 
					// poziva se iz ktUploader.html
					$scope.remove = function (index) {
						
						$scope.fd.MetaData.splice(index,1);
						$scope.isOpen=true;
						var err=$scope.testRules();	
					}
					 
					 
			// POPUNI LISTU  lIST OF FILE TYPES
            ResourcesDataService.getResourceDefByType(lang,type).then(
						function(data) {
											  $scope.listOfFileTypes = data.data;
											 
							},function(error){
											 MessagingService.addMessage(error.msg,'error');
							
						});
                	            
            
	
      
     
			 },// controler_ktUploader_END
			

			//  ***************************************************  KT- UPLOADER   LINK FUNKCIJA *****************************
			require: '^form', // MIGOR  - NOVO DODAO 
			link: function (scope, elem, attrs,formCtrl) { //MIGOR NOVO
                        
                        
                                
                                //console.log("U post-link");
		  
                                //var element = elem[0].getElementsByClassName('fileElement');
                                 scope.fd.uiUploader = uiUploader;
                                 if (scope.fd.PresentationId!=undefined) scope.fd.uiUploader.createUploader(scope.fd.PresentationId);
                                
                                				
                                //MIGOR TODO - prilagoditi widgetdefinition za uploader da salje i povezani related dataset
                                var out_fields = ['resourceId'];
                                var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.LocalId,widgetId: scope.fd.PresentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
                                //var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':false}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.localId,widgetId: scope.fd.presentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
		  
                                scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition); //zamijeniti gdje se sve pojavljujue i staviti LOCAL TODO
                                scope.fd.LocalId=scope.localWidgetId;         
      
                                scope.fd.uiUploader.removeAll(scope.fd.PresentationId); //MIGOR TEMP- TREBA nekako obrisati inicijalne fajlove kod reigstracija ali ovdje ne radi !!!
                                //console.log(element.files);

                      
                                var element = elem[0].getElementsByClassName('fileElement');
            
                                element[0].addEventListener('change', function(e) {
                
                                        $timeout(function() {
                                                var files = e.target.files;
                                                scope.fd.uiUploader.addFiles(files,scope.fd.PresentationId);				
                                                scope.files =scope.fd.uiUploader.getFiles(scope.fd.PresentationId);  
                          
                                                var err=scope.testRules();
                                        });
                                });    
    	
        
        var fileCounter = 0;
			//scope.rules=[];
			if (scope.fd.MetaData==undefined)  scope.fd.MetaData=[];        
			scope.rules =  scope.fd.MetaData;
				
				// ADD RULE DEFINITION - poziva se iz ktUploader.html
				scope.addRuleDefinition=function(name,min,max,minTotal){
					
					if (min==undefined) min=0;			
					
					for (var i=1, l=scope.rules.length; i<l; i++) 
								if (scope.rules[i].name==name) name='';
							
					if (name!=undefined && name != '') {
						scope.rules.push({'name':name,'min':min,'max':max});
						//scope.rules.minTotal=minTotal;	
					}
				}
            
                scope.btn_remove = function(index,file) {
                                
                        //$log.info('deleting=' + file);
                        //var s=scope;
                        //var f=formCtrl;
                        scope.fd.uiUploader.removeFile(file,scope.fd.PresentationId);
                        var err=scope.testRules();
                                
                };      
			

                scope.btn_clean = function() {
                   scope.fd.uiUploader.removeAll(scope.fd.PresentationId);
                };


        scope.testRules = function(){
					
                var errMsg=null;
                for (var i=1; i < scope.rules.length; i++) { //search rules
                        var filesFound=0;
                        for(var j = 0; j < scope.files.length; j++ ) {//search files
                                if (scope.files[j].fileResourceID == scope.rules[i].name) filesFound=filesFound+1;
                        }
                        
                        if (filesFound < scope.rules[i].min) {formCtrl.uploaderForm.$setValidity('Not enough file types', false);
                        }	 else formCtrl.uploaderForm.$setValidity('Not enough file types', true);
                        
                        if (filesFound > scope.rules[i].max) {formCtrl.uploaderForm.$setValidity('Too many file types', false);
                                }	 else formCtrl.uploaderForm.$setValidity('Too many file types', true);
                 
                }
					
		if (scope.rules.length>0) {
                        if (scope.files.length < scope.rules[0].min) formCtrl.uploaderForm.$setValidity('Minimum files needed', false); 
                        else formCtrl.uploaderForm.$setValidity('Minimum files needed', true); }
  
					//errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
                return errMsg;
					
         }//test_RULES
               
		
     	//*******************************************************************************************************
		// 											 kt-UPLOADER BTN_UPLOAD
		//*******************************************************************************************************
        scope.btn_upload = function() {
            				
        // CHECK THE RULES FIRST
		var errMsg=scope.testRules();
                errMsg=null; // samo za test !!!     MAKNUTI KASNIJEEEE !!!!     <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
					
		if (errMsg==null) {
	
        		var csrf_token = $cookies.get('csrftoken'); //'miro';//$cookieStore.get('csrftoken');
				
        		// ZA svaki FAJL pojedinaèno !
        		scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
				url: '../api/file-upload/', 
				headers: {'X-CSRFToken' : csrf_token },
					concurrency: 3,
					// u data napuniti podatke vezane za fajl - fileType , ID resursa
					data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
					onProgress: function(file) {
						//$log.info(file.name + '=' + file.humanSize);
                                                $timeout(function() { file.status='Uploading...'; });
                                        },
					onCompleted: function(file, response,status) {

                                                //$log.info(file + 'response' + response);
                                                response=JSON.parse(response); //convertiram string u JSON objekt
								
						if (status==201) {// NAKON SMO USPJESNO UPLOADALI FILE , POTREBAN METADATA UPLOAD

                                                        // response.... ID fajla
                                                        // file.fileResourceID ... je file_type 
                                                        // scope.resourceData .. spremljeni meta podaci
								
                                                        $timeout(function() { file.uploadSuccess=true;  });
									

                        				//OUTPUT: data.savedResourceId .. ID meta-resursa koji je pridruen fajlu (unutar 11-ice ili 12-ice)
									
                                        		 file.resourceData={};
									
                                                        //MessagingService.addMessage("File upload successful! "+response,'success');
									
                                                        //PRIPREMA scope.resourceData  ZA UPLOAD 
                                                        if (file.dashboard!=undefined)
                                                        {
                                                                //code
                                                                var fieldId="";
                                                                var sc=scope;
                                                                          
                                                                for (var i=0;i<file.dashboard.widgets.length;i++) {//idem po gridROW
                                                                        for (var j=0;j<file.dashboard.widgets[i].layout.length;j++)
                                                                                for (var k=0;k<file.dashboard.widgets[i].layout[j].layout.length;k++)	
                                                                                {
                                                                                        fieldId='Field'+file.dashboard.widgets[i].layout[j].layout[k].itemId;
                                                                                        if (file.dashboard.widgets[i].layout[j].layout[k].dbtype=='id') {
                                                                                                fieldId=fieldId+'_id'//code
                                                                                                fieldId='id'//code
                                                                                        }
                                                                                        file.resourceData[fieldId] = file.dashboard.widgets[i].layout[j].layout[k].sItemValue	
                                                                                }
                                                                }//for
                                                                
                                                                                                                 
                                                                //  ********************************* METAUPLOAD ************************
                                        
                                                                if (file.resourceData)
                                                                {
                                                                        // ovdje je sve i update modela i insert meta pddataka - napravljena posebna DRF funkcija
                                                                        file.metaStatus='Saving metadata...'
                                                                        //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId},
                                                                        //ResourcesDataService.fileMetaUpload(response,file.fileResourceID,scope.fd.linkedResourceId,scope.fd.linkedResourceDefId, file.resourceData).then(
                                                                        ResourcesDataService.fileMetaUpload(response,file.fileResourceID,scope.fd.linkedResourceId,scope.fd.linkedResourceDefId, file.dashboard.widgets).then(
                                                                                                
                                                                        // service.fileMetaUpload= function (fileId,fileMetaId,resourceId,resourceDefId,fileResourceData) {
                                                                                function(data) {
                                                                                                                                                        
                                                                                // MessagingService.addMessage(data.msg,'success');
                                                                                                file.metaSuccess=true;
                                                                                                scope.showFileMetaData=false;
                                                                    
                                                                                                //$log.info('data savedresourceid:' + data.savedResourceId);
                                                                                                                                 
                                                                                },function(error){
                                                                                        //MessagingService.addMessage(error.msg,'error');
                                                                                        file.metaError=true;
                                                                                        file.metaStatus = error.msg;
                                                                                                                                                        
                                                                                                                                                                         
                                                                                });
                                                                } //IF
                                                        }
                                                        else
                                                        {
                                                                $timeout(function() {
                                                                        file.noMeta = true;
                                                                        //file.metaSuccess=true;
                                                                });
                                                        }
                                                                                                         // });
                                                        fileCounter++;
                                                        if (scope.files.length == fileCounter){ //MIGOR -Ovaj se okida a onaj drugi na 123 izgleda na
                                                           $rootScope.$broadcast('InitiateTaskFilesUploaded',{'resource_id':scope.fd.linkedResourceId,'resource_def_id': scope.fd.linkedResourceDefId})
                                                        }
                                                
                                                }        
                                                else { 
                                                        //if file upload error
                                                        $timeout(function() {
                                                                file.uploadError=true;
                                                                file.status=response;
                                                        });
                                                                                                                 
                                                }
                                                                   
                                                        
                                        }//on_completed
                                }); //startUpload
		} else {
                        //scope.ac.alerts = 'Min Total!!';
			//$log.info(errMsg);
		}
        }; // FUNCTION b.n_up1oad

       
        scope.processWidgetDependencies = function() { //-----  ktUploader  -----
              
           if (scope.fd.tItemValue!=undefined) 
            for (var i=0;i< scope.fd.tItemValue.length;i++) {
                var linkedWidgetId=scope.fd.tItemValue[i].widgetId;  // linkedWidgetId= WidgetDataExchangeService.getLocalWidgetId(linkedWidgetId);//MIGOR - moram dobiti localwidgetId od vezanog WidgetId 
                var linkedItem = 'resourceLink'                      //var linkedItem = scope.fd.tItemValue[i].name;
                  
                if (linkedWidgetId!=undefined && linkedWidgetId!=null ) {
                    for (var j=0;j<scope.fd.tItemValue[i].DEI.length;j++) {
                        if ((scope.fd.tItemValue[i].DEI[j].name=='resourceLink') && (scope.fd.tItemValue[i].DEI[j].value==true)) { //SCOPE.ON samo kad je DEI value = true
                             var linkedItem = scope.fd.tItemValue[i].DEI[j].name;  
                             //console.log("uploader "+scope.fd.PresentationId+" se veze na serverski " + linkedWidgetId); 
                             
                             scope.$on('Event'+linkedWidgetId+linkedItem,function(event, data){  //ide po svim vezanim widgetima i dodaj scope.on   //MIGOR TODO - DODATI SAMO U SLUCAJU DA JE DEI VALUE = TRUE !!!!     <<<<<<<<<<<<< !!!!!!!!!
                                
                                //console.log("uploader "+ scope.fd.PresentationId+" dobio event " + event.name);
                                scope.ProcessEvent(data);
                               
                                    //	data: {resource_def_id:scope.fd.linkedResourceDefId,resource_id:scope.fd.linkedResourceId}
                                    
                              }) //on_END
                             var data = WidgetDataExchangeService.getDataByWidgetId(scope.taskDefinition.task_execute_id,scope.taskDefinition.task_initiate_id,scope.taskDefinition.prev_task_id,linkedWidgetId,linkedItem);
                             scope.ProcessEvent(data);
                        }//if
                    }//for j
                }//if

             // else {  scope.fd.tItemValue.splice(i,1);  } // nije mi jasno zasto sam radio SPLICE
            } //for i
      }//fn  pr0cessWidgetDependecies -------------    ktUploader
      scope.ProcessEvent=function(data)
      {
         for (var k=0;k<data.length;k++) {
                                  if (data[k].name=='resourceRecordId') scope.fd.linkedResourceId = data[k].value; //TODO - ILJ - ovo bi isto trebala biti varijabla - sta ako promjenim interface odnosno naziv polja!
                                  if (data[k].name=='resourceId') scope.fd.linkedResourceDefId = data[k].value;  //TODO- ILJ - ovo bi isto trebala biti varijabla
                                  if (scope.fd.linkedResourceDefId>0 && scope.fd.linkedResourceId>0) scope.fd.uploadReady = true;
                                }
                          
         
         if (scope.files.length>0 && scope.fd.uploadReady) scope.btn_upload();  // poziva UPLOAD - MIGOR TODO - upload treba samo ako ima fajl !!!
                                
        
      };
            
        
        	
      			
	
     	  // ne znam da li ce u ovoj link funkciji widget vec imati resource_id
          //ILJU treba dohvatit sa servera tItemValue
          
          scope.formType=scope.taskDefinition.form_type;
          if (scope.fd.PresentationId!=undefined && scope.fd.PresentationId!=null)
          {
          TaskDataService.getWidgetDependencies(scope.taskId,scope.fd.PresentationId,scope.formType).then(function(data) {
                               
                                scope.fd.tItemValue=data.data;

                                  //ovo je da trenutno radi
                               // WidgetDataExchangeService.setData(scope.fd.tItemValue);
                                scope.processWidgetDependencies();
                                },function(error){
                                   MessagingService.addMessage(error.msg,'error');
                                
                                });
                              
    
          }
          //MIGOR - pocisti fajlove kad dobijes InitateTask event
		  scope.$on('ProcessTaskWidgets',function(event, data){
           //scope.btn_clean(); // MIGOR - PRIVREMENO MAKNUO JER CE BITI VISAK KAD PRORADI OVO GORE
           if (scope.files.length>0 && scope.fd.uploadReady) scope.btn_upload();
          });

		  
		  
		  //MIGOR NOVO TODO
		  scope.interfaceHandler= function (event,data) {
							scope.test=0;
				
			 // scope.fd.linkedResourceId = data.resource_id;
			   //scope.fd.linkedResourceDefId = data.resource_def_id;
			  
			   //scope.btn_upload();  
		  }
		  
                        
        
                               
       
     } //link directive 'ktUploader'
    };
};
'use strict';

export function ktUploadFile ($timeout,uiUploader,MessagingService,WidgetDataExchangeService,ResourcesDataService,TaskDataService,$cookies,$rootScope) {
        return {
        restrict: 'A', 
             templateUrl: 'ktdirectivetemplates/ktUploadFile.html',
             controller: function ($scope, $element,$rootScope,$uibModal,MessagingService,ProcessingService,$log,GridsterService,WidgetDataExchangeService,$timeout,$stateParams) {

                //console.log("U kontroleru");
                $scope.gsrvc = GridsterService;
                $scope.fd.ReadOnly=false;
                $scope.animationsEnabled = true;
                $scope.showFileMetaData=false;
                $scope.taskId=$scope.taskDefinition.ResourceDefId;
                if ($scope.taskId==undefined)  $scope.taskId=$scope.taskDefinition.ResourceDefId_id;
                if ($scope.taskId==undefined) $scope.taskId=0;  
                if ($scope.localVars==undefined)  $scope.localVars = {datasetMapperType:0};
                $scope.files = [];
                
                $scope.localVars.showProperties=function(datasetMapperType)
                {
                 
                        if ($scope.localVars.datasetMapperType==undefined)
                        {
                           $scope.localVars.datasetMapperType = datasetMapperType;
                        }else
                        {
                           if ($scope.localVars.datasetMapperType==0 || $scope.localVars.datasetMapperType!=datasetMapperType) $scope.localVars.datasetMapperType = datasetMapperType;
                           else $scope.localVars.datasetMapperType=0;
                        }
                 
                };
            
		  $scope.okModal = function (windex,index) {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };

		  $scope.cancelModal = function () {
			$timeout(function() {$scope.showFileMetaData=false; });
		  };
		  
               
        
		 $scope.showMetadata = function(fileIndex,fileId){ 
		 
				var lang=$rootScope.globals.currentUser.lang;
				var file_resource_type = "file";
				//$scope.taskId=$stateParams.id;
				$scope.files[fileIndex].gridsterType='resource';   
				   	
				ResourcesDataService.getResourceForm(fileId,"i",lang).then(function(data) {
                               
                                        $scope.files[fileIndex].dashboard={widgets:{layout:data.data.widgets}};
                                        $scope.files[fileIndex].dashboard.formData=[{}];
					$scope.files[fileIndex].formLoaded = true;
                                        $scope.files[fileIndex].formParams = {formViewType:2};
                                        
                                },function(error){    
                                MessagingService.addMessage(error.msg,'error');
						});
                            
		

			  };
     
           
			// OPEN MODAL filehelper
			 $scope.openModal = function (size,fileIndex) {
                  var modalInstance = $uibModal.open({
                  animation: $scope.animationsEnabled,
                  templateUrl: 'filehelper.html',
                  controller: 'FileModalInstanceCtrl',
                  size: size,
                  resolve: {
                    retValue: function () {
                      return {resourceId:$scope.resourceId,fileIndex:fileIndex,files:$scope.files,headline:'Enter file metadata'};
                    }
                  }
            });
			
			
            modalInstance.result.then(function (retValue,windex,index) {
             // $scope.getResourceForm ();
             
         
          }, function () {
          //$log.info('Modal dismissed at: ' + new Date());
          });
       
		};
        
      
      				
                        // FUNCTION ONSELECT CALLBACK II
                $scope.fd.onSelectCallback2 = function (item, model,fileIndex){
                        var eventResultId=item.id;
                        $scope.eventResultName=item.Name;
                        
                         //console.log("onSelectCallback II:" +  $scope.eventResultName+ ' ' + eventResultId);

                          $scope.resourceId=eventResultId;
                          $scope.isResourceSelected=true;
                                
                                        $scope.fd.filetype=$scope.resourceId; 						
                }//onSelectCallback II
                 
				 
				 
				 
                // FUNCTION - ON_SELECT_FILETYPE 
                // NAKON sTO SE ZA POJEDINAcNI FILE ODABERE FILE-TYPE  --> $scope.resourceId
                
                $scope.fd.onSelectFileType = function (item,fileIndex){
                        var selectedFileTypeId=item.id;
                        $scope.resourceId=selectedFileTypeId;
                         $scope.isResourceSelected=true;
                        if ($scope.files[fileIndex].fileResourceID!=selectedFileTypeId) {
                         $scope.files[fileIndex].fileResourceID = selectedFileTypeId;
                         $scope.files[fileIndex].widgetId = $scope.fd.PresentationId;
                         $scope.files[fileIndex].formLoaded = false;
                         $scope.files[fileIndex].fileTypeSelected = true;
                        }
                
                        $scope.fileIndex=fileIndex;
                        
                                        
                        
                        $scope.showMetadata(fileIndex,$scope.files[fileIndex].fileResourceID );
                        
                        var err=$scope.fd.testRules();
        
                }//onSelectFileType
				 
				 
				    
				var lang = $rootScope.globals.currentUser.lang;
				var type="file"; // PROMJENITI - ZASAD JE HARD-CODED !!!!! MIGOR
					 
					 
					// poziva se iz ktUploadFile.html
					$scope.fd.remove = function (index) {
						
						$scope.fd.Parameters.rules.splice(index,1);
						$scope.isOpen=true;
						var err=$scope.fd.testRules();	
					}
					 
					 
			// POPUNI LISTU  lIST OF FILE TYPES
                        ResourcesDataService.getResourceDefListByType(lang,type).then(function(data) {
                                $scope.fd.listOfFileTypes = data.data;
                                                         
                        },function(error){
                                MessagingService.addMessage(error.msg,'error');
                        
                });
                	            
     $scope.fd.getPreviousTaskWidget  = function(deiType)
    {
      var pTaskPkg = WidgetDataExchangeService.getPrevTaskData($scope.taskDefinition.prev_task_id);
             var datasetId=0,datasetRecordId=0,pTaskData,pTaskDataArray;
             if (!Array.isArray(pTaskPkg))
             {
                          pTaskDataArray = [pTaskPkg];
             }else
             {
                          pTaskDataArray = pTaskPkg;        
             }
             for (let l=0;l<pTaskDataArray.length;l++)
             {
                          pTaskData = pTaskDataArray[l];
                          if (pTaskData.DEI!=undefined && pTaskData.DEI!=null)
                          {
                          for (var i=0;i<pTaskData.DEI.length;i++)
                          {
                            if (pTaskData.DEI[i].name==deiType)
                            {
                              if (pTaskData.DEI[i].value!=undefined && pTaskData.DEI[i].value!=null)
                              {
                                for (var j=0;j<pTaskData.DEI[i].value.length;j++)
                                {
                                 if (pTaskData.DEI[i].value[j].name=="resourceId" && pTaskData.DEI[i].value[j].value!=undefined) datasetId=pTaskData.DEI[i].value[j].value;
                                 if (pTaskData.DEI[i].value[j].name=="resourceRecordId" && pTaskData.DEI[i].value[j].value!=undefined) datasetRecordId=pTaskData.DEI[i].value[j].value;
                                 
                                  
                                }
                                   
                                  
                              }
                                
                            }
                              
                            }
                          }
             }
            
    return {'datasetId':datasetId,'datasetRecordId':datasetRecordId};
    };
	
      
     
			 },// controler_ktUploadFile_END
			

			//  ***************************************************  KT-UPLOAD-FILE   LINK FUNKCIJA *****************************
			require: '^form', 
			link: function (scope, elem, attrs,formCtrl) { 
                        
                        
                                if (scope.fd.Parameters==undefined || scope.fd.Parameters==null) scope.fd.Parameters={};
                                if (scope.fd.Parameters.rules==undefined || scope.fd.Parameters.rules==null) scope.fd.Parameters.rules=[];
                                
                                scope.fd.uiUploader = uiUploader;
                                if (scope.fd.PresentationId!=undefined) scope.fd.uiUploader.createUploader(scope.fd.PresentationId);
                                
                                				
                                //MIGOR TODO - prilagoditi widgetdefinition za uploader da salje i povezani related dataset
                                var out_fields = ['resourceId'];
                                var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':[{name:'resourceId',value:scope.fd.Related},{name:'resourceRecordId',value:''}]}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.LocalId,widgetId: scope.fd.PresentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
                                //var widgetDefinition = {DEI: [{'name':'resourceLinkR','value':false}],actions: [{name:'PrepareData',status:false}],name: 'ktUploader',localWidgetId:scope.fd.localId,widgetId: scope.fd.presentationId,taskId:  scope.lTaskId,resourceDefId : scope.selectedResource, output:out_fields, };
		  
                                scope.localWidgetId = WidgetDataExchangeService.registerWidget(widgetDefinition); //zamijeniti gdje se sve pojavljujue i staviti LOCAL TODO
                                scope.fd.LocalId=scope.localWidgetId;         
      
                                scope.fd.uiUploader.removeAll(scope.fd.PresentationId); //MIGOR TEMP- TREBA nekako obrisati inicijalne fajlove kod reigstracija ali ovdje ne radi !!!
                                //console.log(element.files);

                      
                                var element = elem[0].getElementsByClassName('fileElement');
            
                                element[0].addEventListener('change', function(e) {
                
                                        $timeout(function() {
                                                var files = e.target.files;
                                                scope.fd.uiUploader.addFiles(files,scope.fd.PresentationId);				
                                                scope.files =scope.fd.uiUploader.getFiles(scope.fd.PresentationId);  
                          
                                                var err=scope.fd.testRules();
                                        });
                                });    
    	
        
                        var fileCounter = 0;
			//scope.fd.Parameters.rules=[];
			if (scope.fd.MetaData==undefined)  scope.fd.MetaData=[];        
			
				
				// ADD RULE DEFINITION - poziva se iz ktUploader.html
				scope.fd.addRuleDefinition=function(name,min,max,minTotal){
					
					if (min==undefined) min=0;			
					
					for (var i=1, l=scope.fd.Parameters.rules.length; i<l; i++) 
								if (scope.fd.Parameters.rules[i].name==name) name='';
							
					if (name!=undefined && name != '') {
						scope.fd.Parameters.rules.push({'name':name,'min':min,'max':max});
						//scope.fd.Parameters.rules.minTotal=minTotal;	
					}
				}
            
                scope.btn_remove = function(index,file) {
                       
                        scope.fd.uiUploader.removeFile(file,scope.fd.PresentationId);
                        var err=scope.fd.testRules();
                                
                };      
			

                scope.btn_clean = function() {
                   scope.fd.uiUploader.removeAll(scope.fd.PresentationId);
                };


        scope.fd.testRules = function(){
					
                var errMsg=null;
                for (var i=1; i < scope.fd.Parameters.rules.length; i++) { //search rules
                        var filesFound=0;
                        for(var j = 0; j < scope.files.length; j++ ) {//search files
                                if (scope.files[j].fileResourceID == scope.fd.Parameters.rules[i].name) filesFound=filesFound+1;
                        }
                        
                        if (filesFound < scope.fd.Parameters.rules[i].min) {formCtrl.uploaderForm.$setValidity('Not enough file types', false);
                        }	 else formCtrl.uploaderForm.$setValidity('Not enough file types', true);
                        
                        if (filesFound > scope.fd.Parameters.rules[i].max) {formCtrl.uploaderForm.$setValidity('Too many file types', false);
                                }	 else formCtrl.uploaderForm.$setValidity('Too many file types', true);
                 
                }
					
		if (scope.fd.Parameters.rules.length>0) {
                        if (scope.files.length < scope.fd.Parameters.rules[0].min) formCtrl.uploaderForm.$setValidity('Minimum files needed', false); 
                        else formCtrl.uploaderForm.$setValidity('Minimum files needed', true); }
  
		
                return errMsg;
					
         }//test_RULES
               
	scope.verify_files = function(){
        
                                 
                var csrf_token = $cookies.get('csrftoken'); 
			
                // ZA svaki FAJL pojedinaèno !
                scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
                        url: '../api/verify-file/', 
                        headers: {'X-CSRFToken' : csrf_token },
                                concurrency: 3,
                                // u data napuniti podatke vezane za fajl - fileType , ID resursa
                                //data: {form_data:file.form_data,resource_id:file.fileResourceID},
                                //data: {form_data:scope.form_data},
                                onProgress: function(file) {
                                        //$log.info(file.name + '=' + file.humanSize);
                                        $timeout(function() { file.status='Uploading...'; });
                                },
                                onCompleted: function(file, response,status) {
                                        
                                       response = JSON.parse(response);
                                       if (status==200) {
                                                file.uploadSuccess=true;
                                                if (response.jsonResponseEOS.rows.length>0)
                                                {
                                                        file.blockchainHash = response.jsonResponseEOS.rows[0].hash;
                                                        file.fileFound=true;
                                                }
                                                
                                                else
                                                {
                                                        MessagingService.addMessage("File not found!",'warning');
                                                        file.blockchainHash="";
                                                }
                                                file.eosResponse2 = JSON.stringify(response.jsonResponseEOS,null,2);
                                                file.fileHash = response.fileHash;
                                                
                                                
                                                    
                                        }
                                        else file.uploadSuccess=false;
                                }//on_completed
                        }); //startUpload                                                
                                                              
        }
     	//*******************************************************************************************************
	// 				kt-upload-file BTN_UPLOAD
	//*******************************************************************************************************
        scope.btn_upload = function() {
            				
        // CHECK THE RULES FIRST
		var errMsg=scope.fd.testRules();
                			
		if (errMsg==null) {
	
        		var csrf_token = $cookies.get('csrftoken'); //'miro';//$cookieStore.get('csrftoken');
			
        		// ZA svaki FAJL pojedinaèno !
        		scope.fd.uiUploader.startUpload(scope.fd.PresentationId,{  
				url: '../api/upload-file/', 
				headers: {'X-CSRFToken' : csrf_token },
					concurrency: 3,
					// u data napuniti podatke vezane za fajl - fileType , ID resursa
					//data: {form_data:file.form_data,resource_id:file.fileResourceID},
                                        //data: {form_data:scope.form_data},
					onProgress: function(file) {
						//$log.info(file.name + '=' + file.humanSize);
                                                $timeout(function() { file.status='Uploading...'; });
                                        },
					onCompleted: function(file, response,status) {
                                                
                                                response = JSON.parse(response);
                                               if (status==201) {
                                                
                                                       
                                                        let file_id=response.file_id; 
                                                        
                                                        $timeout(function() { file.uploadSuccess=true;  });
                                                        file.eosResponse = JSON.stringify(response.jsonResponseEOS,null,2);
                                                        file.eosResponse2 = JSON.stringify(response.jsonResponseEOS2,null,2);
                                                        
                                                        if (file.dashboard.formData)
                                                        {
                                                                var parentDataset=scope.fd.getPreviousTaskWidget("resourceLinkDatasetList");
      
                                                                if (parentDataset['datasetId']==undefined || parentDataset['datasetId']=="") parentDataset['datasetId'] = 0;
                                                                if (parentDataset['datasetRecordId']==undefined || parentDataset['datasetRecordId']=="") parentDataset['datasetRecordId'] = 0;
                                                                file.metaStatus='Saving metadata...'
                                                                ResourcesDataService.fileMetaUpdate(file_id,file.fileResourceID,scope.fd.taskInstanceId,file.widgetId,scope.taskDefinition.prev_task_id,parentDataset['datasetId'],parentDataset['datasetRecordId'],file.dashboard.formData).then(
                                                                                        
                                                                        function(data) {
                                                                                                                                                
                                                                                MessagingService.addMessage(data.data.msg,'success');
                                                                                file.metaSuccess=true;
                                                                                //scope.showFileMetaData=false;
                                                                        },function(error){
                                                                                MessagingService.addMessage(error.msg,'error');
                                                                                file.metaError=true;
                                                                                file.metaStatus = error.msg;
                                                                                                                                                
                                                                                                                                                                 
                                                                        });
                                                        } //IF
                                                            
                                                }        
                                        }//on_completed
                                }); //startUpload
		} else {
                        //scope.ac.alerts = 'Min Total!!';
			//$log.info(errMsg);
		}
        }; // FUNCTION b.n_up1oad
        
        
        scope.$on('InitiateTaskPostProcess'+scope.taskDefinition.transaction_id,function(event, data){
           
           if (scope.taskDefinition.form_type=='i')
           {
                scope.fd.taskInstanceId = data.task_initiate_id;
           }else
           {
                scope.fd.taskInstanceId = data.task_execute_id;  
           }
           if (scope.files.length>0 && scope.fd.Parameters.VerifyOnly) scope.verify_files();
           else scope.btn_upload();
          });
        /*
         scope.$on('ProcessTaskWidgets',function(event, data){
           
           $scope.fd.taskInstanceId = data.task_instance_id;
           
           if (scope.files.length>0) scope.btn_upload();
          });
       */
     } //link directive 'ktUploadFile'
    };
};
'use strict';

export function ktUser () {

        return {
            restrict: 'A',
            templateUrl: 'ktdirectivetemplates/ktUser.html',
            controller: function ($scope, $element,UserService,ResourcesDataService,$rootScope,ProcessingService,GridsterService){
                $scope.gsrvc = GridsterService;
                if ($scope.localVars==undefined) $scope.localVars={};
          
                $scope.search=[
                                {id:1,filter:'onlist',name:"On list:",icon:"fa fa-chevron-right"},
                                {id:2,filter:'notonlist',name:"Not on list:",icon:"fa fa-expand"},
                               ];
                    
                if ($scope.fd!=undefined) {
                      if ($scope.fd.Search==undefined) {
                        $scope.fd.Search=$scope.search[0]; //MIGOR TODO - greska kod incijacije za multiple , mozda treba kod promjene na multiple ovo jos jednom okinuti
                      }
                   } 

                $scope.applyListFilters = function(index) {
                       
                      $scope.fd.Search=$scope.search[index];
                      if( typeof $scope.fd.sItemValue === 'string' ) {
                                //$scope.fd.search.value = [ $scope.fd.sItemValue ];
                                $scope.fd.Search.value = [ {'id':$scope.fd.sItemValue} ];
                      }
                      //if ($scope.fd.search.name=="Equals") $scope.fd.search=null;
                      $scope.isOpen=false;		
                };
                    
                    
                $scope.showProperties = function(event) {
                      $scope.gsrvc.setFieldProperties($scope.fd,event);
                }; 
                
                $scope.colLength=[];
                for (var i=0;i<24;i++) $scope.colLength.push('col-lg-'+(i+1));
                
                if ($scope.fd.PopulateType==null) {$scope.fd.PopulateType=1;}    
                $scope.selectedUsr={};
                $scope.userItem = {selectedUser : null};
              
                  
                $scope.setCurrentUser = function () { 
                   
                    UserService.getUserObjectById($rootScope.globals.currentUser.userid).then(function(data){
                      $scope.selectedUsr = data;
                      $scope.userItem.selectedUser=$scope.selectedUsr;
                      $scope.formData[0]['Field'+$scope.fd.ItemId]=$scope.selectedUsr.id;
                      $scope.fd.Search.value = [ {'id':$scope.formData[0]['Field'+$scope.fd.ItemId]} ]; //MIGOR TODO - vidjeti da li ovjde siTemValue ( provjeriti i ostale sluèajeve u onselect funkciji)
                    });
                      
                };   
              
                $scope.populateUser = function (item,model) {
                   
                  // if ($scope.fd.populateType==1) {
                      $scope.selectedUsr = item;
                      $scope.fd.CodeId = item.id;
                      $scope.formData[0]['Field'+$scope.fd.ItemId]=item.id;
                  // }
                   /*
                   if ($scope.fd.populateType==2) {
                     $scope.setCurrentUser();
                   }
                   */
                   $scope.fd.Search.value = [ {'id':$scope.formData[0]['Field'+$scope.fd.ItemId]} ]; //MIGOR TODO - vidjeti da li ovjde siTemValue ( provjeriti i ostale sluèajeve u onselect funkciji)

                };

                  
                $scope.getUsers = function () {

                  UserService.getUsersGroups('users').then(function(data){
                  $scope.userList = data.data;
                  $scope.usersLoaded=true;
                  if ($scope.formData!=undefined && $scope.formData.length>0) {
                        if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=null) {
                           UserService.getUserObjectById($scope.formData[0]['Field'+$scope.fd.ItemId]).then(function(data){
                              $scope.selectedUsr = data;
                              $scope.userItem.selectedUser=$scope.selectedUsr;
                            });   
                        }
                        else if ($scope.formData[0]['Field'+$scope.fd.ItemId]!=null) {

                            if ($scope.formData[0]['Field'+$scope.fd.ItemId].length>0)
                              {
                                
                               UserService.getUserObjectById($scope.formData[0]['Field'+$scope.fd.ItemId][0]).then(function(data){
                                  $scope.selectedUsr = data;
                                  $scope.userItem.selectedUser=$scope.selectedUsr;
                                  $scope.formData[0]['Field'+$scope.fd.ItemId]=$scope.selectedUsr.id;
                                });
                             
                              
                            }
                        }
                  }
                 });

                }//GetUsers
          
                $scope.clear = function(event,select) 
                {
                  $scope.formData[0]['Field'+$scope.fd.ItemId] = null;
                  $scope.fd.Search.value = null;
                  $scope.userItem.selectedUser = null;
                }
                
                $scope.$watch('userItem.selectedUser', function(newValue,oldValue){
                    //debugger
                    if ($scope.formData && newValue)  $scope.formData[0]['Field'+$scope.fd.ItemId]=newValue.id;
                });
                
                
        
  				$scope.getUsers();
          

            },
       link: function (scope, elem, attrs) {
          

           }
        }
  
};
'use strict';

export function ktUsersGroupsSelect () {
  
  return {
            restrict: 'A',
             scope:{
              selectedUsers:'=',
              selectedGroups:'=',
              headerLabel:'=',
              usersLabel:'=',
              groupsLabel:'=',
                         
             },
             templateUrl: 'ktdirectivetemplates/ktUsersGroupsSelect.html',
           controller: function($rootScope){},
             link: function (scope, elem, attrs) {
              
              var sUsers = scope.selectedUsers;
                
            scope.selected = {users:scope.selectedUsers,groups:scope.selectedGroups};
         
            
             scope.$watch('selected.users',function(newValue,oldValue){
              
              if (newValue!=oldValue)
              {
               scope.selectedUsers=newValue;
              }
            });
             
              
             scope.$watch('selected.groups',function(newValue,oldValue){
              if (newValue!=oldValue)
              {
                scope.selectedGroups=newValue;
              }
            });
             
             scope.$watch('selectedUsers',function(newValue,oldValue){
              if (newValue!=oldValue)
              {
                 scope.selected.users=newValue;
              }
            });
             
              scope.$watch('selectedGroups',function(newValue,oldValue){
              if (newValue!=oldValue)
              {
                 scope.selected.groups=newValue;
              }
            });
                        
    
      }
    }
  
};